import {
  ArrayList3it5z8td81qkl as ArrayList,
  StringBuildermazzzhj6kkai as StringBuilder,
  println2shhhgwwt4c61 as println,
  Unit_instanceat14thlj150z as Unit_instance,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  toString30pk9tzaqopn as toString,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  KtMap140uvy3s5zad8 as KtMap,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  plus310ted5e4i90h as plus,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  emptyMapr06gerzljqtm as emptyMap,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  Long2qws0ah9gnpki as Long,
  Paire9pteg33gng7 as Pair,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  contains3ue2qo8xhmpf1 as contains,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  removeAll3cm9rh0qak2y6 as removeAll,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  first58ocm7j58k3q as first,
  Enum3alwj03lh1n41 as Enum,
  joinToString1cxrrlmo0chqs as joinToString,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  emptyList1g2z5xcrvp2zy as emptyList,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  rangeToeizvz34h11nd as rangeTo,
  toMutableList20rdgwi7d3cwi as toMutableList,
  Error3ofk6owajcepa as Error_0,
  roundToInt1ue8x8yshtznx as roundToInt,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  listOf1jh22dvmctj1r as listOf,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  compareTo3ankvs086tmwq as compareTo,
  contains1tccixv8iwdcq as contains_0,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  removeLast3759euu1xvfa3 as removeLast,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random3bgrvtipfs9sh as random,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  isFloatArrayjjscnqphw92j as isFloatArray,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  substringAfter1hku067gwr5ve as substringAfter,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_gridPos37aquento5ou5 as get_gridPos,
  readLDTKWorld3amu50q42pjqj as readLDTKWorld,
} from './korge-fleks-hello-world-korge-ldtk.mjs';
import {
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  FloatSerializer_getInstance3n1kixy3l1peh as FloatSerializer_getInstance,
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
  PolymorphicSerializer3p3fzpdobi8hh as PolymorphicSerializer,
  ObjectSerializer2kjkucmygguwd as ObjectSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  SerializersModuleBuilderfxsfdohcdipc as SerializersModuleBuilder,
  PolymorphicModuleBuilder1c33fhfru2id5 as PolymorphicModuleBuilder,
  serializer1hwzc6m64v1op as serializer_0,
  plus1c7xncg0dvi6w as plus_0,
  INT_getInstancety325w3vt74z as INT_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  DOUBLE_getInstance15940a49743iy as DOUBLE_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  TileMapData285v3okd3krdh as TileMapData,
  Companion_getInstance3ctl2vl10i40x as Companion_getInstance,
  Companion_getInstance1xsohje9yg2sq as Companion_getInstance_0,
  _Tile___get_raw__impl__kp6cq829wdyvsj2ufu1 as _Tile___get_raw__impl__kp6cq8,
  readBitmapFont83t9y5crcd59 as readBitmapFont,
  ASE_getInstanceocshgtiexxqz as ASE_getInstance,
  toPropsuld7zaezrb2a as toProps,
  readImageDataContainer2lprlqcbjs9rp as readImageDataContainer,
  MutableAtlas41tbjanvwcb0 as MutableAtlas,
  Companion_instance2dz6ggjmyv23a as Companion_instance,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  packInMutableAtlasrmu7ot63k72n as packInMutableAtlas,
  packInMutableAtlas1obu6aohcwnbg as packInMutableAtlas_0,
  _Tile___get_tile__impl__nfq1aw1gqd94vgk0ayk as _Tile___get_tile__impl__nfq1aw,
  _Tile___get_offsetX__impl__qwhdsd1rggj0on9yzfy as _Tile___get_offsetX__impl__qwhdsd,
  _Tile___get_offsetY__impl__1x539u1dbavim42f9wo as _Tile___get_offsetY__impl__1x539u,
  valuesqjo9iwejchbd as values,
  Direction_REVERSE_getInstance1vyfjipij2sd as Direction_REVERSE_getInstance,
  Direction_ONCE_REVERSE_getInstance23nmrkk0oltbk as Direction_ONCE_REVERSE_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _RGBA___get_r__impl__duz7mojwqekabyzvum as _RGBA___get_r__impl__duz7mo,
  _RGBA___get_g__impl__o8pukr1q8mr1galt839 as _RGBA___get_g__impl__o8pukr,
  _RGBA___get_b__impl__m6tl80qg881mr99i7e as _RGBA___get_b__impl__m6tl80,
  RGBA__withAf_impl_dpdu32g4ua5xko755s as RGBA__withAf_impl_dpdu32,
  RGBA__withRGB_impl_scofdy1vl1fsxm1vhyf as RGBA__withRGB_impl_scofdy,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  ImageFrame1n3b6yvrbbt3z as ImageFrame,
  _RGBA___get_a__impl__6msvu7bgji1ly0wy68 as _RGBA___get_a__impl__6msvu7,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  HorizontalAlignngoyss7iwb4p as HorizontalAlign,
  Companion_getInstance1fkxm1hmgpvgy as Companion_getInstance_1,
  VerticalAlign3haa5uafdkdst as VerticalAlign,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_2,
  HorizontalAlign__toString_impl_toflc02g25ounfaowz6 as HorizontalAlign__toString_impl_toflc0,
  VerticalAlign__toString_impl_hcpnn21fyiif9yt4pio as VerticalAlign__toString_impl_hcpnn2,
  HorizontalAlign__hashCode_impl_7x9oj53lm7edsae0frk as HorizontalAlign__hashCode_impl_7x9oj5,
  VerticalAlign__hashCode_impl_vx8hj7r7mt6hnnkjo9 as VerticalAlign__hashCode_impl_vx8hj7,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratio__impl__b3ilr836byhppoe4oz1 as _VerticalAlign___get_ratio__impl__b3ilr8,
  get_bmpevghw2zw2fa7 as get_bmp,
  RichTextData1m4oei1jdcuz5 as RichTextData,
  TextAlignment3ini4ufbvmn40 as TextAlignment,
  placem8wpiy4fm4tw as place,
  get_lazyBitmap3pyj425xl7cp4 as get_lazyBitmap,
  Directionr5it5sg7m2hk as Direction,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  _RGBA___init__impl__lqpay52mmt2z5w8x6du as _RGBA___init__impl__lqpay5,
  _HorizontalAlign___init__impl__ad654o328mfz7v8v6wh as _HorizontalAlign___init__impl__ad654o,
  _VerticalAlign___init__impl__f42kfqeutpzsxwen37 as _VerticalAlign___init__impl__f42kfq,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  hasBitSet141smdymg86x0 as hasBitSet,
  max329dnql9l08bp as max,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_3,
  umod164hvijxhfi8p as umod,
  Easing3266vfl8a4o75 as Easing,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Kind_MODIFIED_getInstance160cow5c5cqx7 as Kind_MODIFIED_getInstance,
  get_fullName2a2vm7nxze3wi as get_fullName,
  FileEvent3ttxpvowuoy72 as FileEvent,
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { delay1f60wyf8ua1gc as delay } from './kotlinx-coroutines-core.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  ExtraTypeCreate3a0hrg4tu0473 as ExtraTypeCreate,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import { Stopwatch1guqi4xl0rpfb as Stopwatch } from './korlibs-time-root-korlibs-time.mjs';
import {
  AudioDecodingProps3opb5jdts7txo as AudioDecodingProps,
  readSoundcwkqnndcldwa as readSound,
  get_paused1g95gdg2lui5k as get_paused,
} from './korlibs-audio-root-korlibs-audio.mjs';
import {
  ComponentTypexyjrw68h3mkw as ComponentType,
  $serializer_getInstance1csrkprdkpiwp as $serializer_getInstance,
  Companion_getInstancecux5rh543dlh as Companion_getInstance_4,
  ComponentsHolder3q340rvi7bl8z as ComponentsHolder,
  FleksNoSuchInjectableException38hdhcbiqafml as FleksNoSuchInjectableException,
  FleksNoSuchSystemException2ayar60lwtokj as FleksNoSuchSystemException,
  BitArraytmxppw7kahiv as BitArray,
  compareEntity3htp4uiiyzpay as compareEntity,
  IteratingSystem3a6t5fwjqjqys as IteratingSystem,
  Companion_instance30dlkjl07rtbp as Companion_instance_0,
  EachFrame_instance3v9fuozm77djs as EachFrame_instance,
  Entityn8ai25fppvib as Entity,
  Snapshot20levc42dqnix as Snapshot,
  IntervalSystemkg47nrqbxzr9 as IntervalSystem,
  Fixed1qeb78bwjzy3z as Fixed,
  wildcardSnapshotOfp6v73r7o9811 as wildcardSnapshotOf,
  entityTagOf37yyn22q9vdbj as entityTagOf,
  UniqueId1lkie4p3b7cfv as UniqueId,
  onAdd3w32ndo60fp45 as onAdd,
  onRemove1dlc2ri522bcn as onRemove,
  Component2zk71ruxtvbyc as Component,
} from './korge-fleks-hello-world-fleks.mjs';
import { format1w6w3fsj4lh0e as format } from './korlibs-string-root-korlibs-string.mjs';
import {
  get_secondsjblpw5qd4dzj as get_seconds,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  get_EASE_OUT_QUAD2mpgddt0aepte as get_EASE_OUT_QUAD,
  get_EASE_IN_QUAD2lehtmi3y9ekj as get_EASE_IN_QUAD,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  get_ALL2kw5hdxomut5y as get_ALL,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  View11ybmmoof9vue as View,
  drawText3hdhgn63dhvlg as drawText,
} from './korge-root-korge.mjs';
import {
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_5,
  TEXTURED_ARRAY_quadIndices1vrv67jygypre as TEXTURED_ARRAY_quadIndices,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
} from './korge-root-korge-core.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_7,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_8,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Size2Dum5ayuyhhau7 as Size2D,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  SingleLineStringStyle_DoubleQuoted_getInstance8300f2c5a36k as SingleLineStringStyle_DoubleQuoted_getInstance,
  MultiLineStringStyle_DoubleQuoted_getInstance12oe3v2grr0jt as MultiLineStringStyle_DoubleQuoted_getInstance,
  PolymorphismStyle_Property_getInstance16g9b3ph2m4l0 as PolymorphismStyle_Property_getInstance,
  YamlConfiguration3kgm4apcoewiu as YamlConfiguration,
  Yaml1rldhjqe94g1k as Yaml,
} from './kaml.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class AssetLevelData {
  constructor() {
    this.yeg_1 = new WorldData();
    this.zeg_1 = 0;
    this.aeh_1 = 0;
    this.beh_1 = 0;
  }
  seh(ldtkWorld) {
    var tmp = this;
    var tmp0_elvis_lhs = ldtkWorld.pdb_1.sd5_1;
    tmp.aeh_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp1_elvis_lhs = ldtkWorld.pdb_1.rd5_1;
    tmp_0.beh_1 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    var maxLevelOffsetX = 0;
    var maxLevelOffsetY = 0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = ldtkWorld.pdb_1.ld5_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevelData.<anonymous>' call
      if (maxLevelOffsetX < element.td6_1)
        maxLevelOffsetX = element.td6_1;
      if (maxLevelOffsetY < element.ud6_1)
        maxLevelOffsetY = element.ud6_1;
    }
    var gridWidth = (maxLevelOffsetX / this.aeh_1 | 0) + 1 | 0;
    var gridHeight = (maxLevelOffsetY / this.beh_1 | 0) + 1 | 0;
    this.yeg_1.jeh_1 = imul(gridWidth, this.aeh_1);
    this.yeg_1.keh_1 = imul(gridHeight, this.beh_1);
    this.yeg_1.neh_1 = ldtkWorld.pdb_1.xd4_1;
    this.yeg_1.leh_1 = this.aeh_1 / this.yeg_1.neh_1 | 0;
    this.yeg_1.meh_1 = this.beh_1 / this.yeg_1.neh_1 | 0;
    if (maxLevelOffsetX === 0) {
      println('WARNING: Level width is 0!');
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = ldtkWorld.pdb_1.ld5_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevelData.<anonymous>' call
      var levelX = element_0.td6_1 / this.aeh_1 | 0;
      var levelY = element_0.ud6_1 / this.beh_1 | 0;
      loadLevel(this, this.yeg_1, levelX, levelY, ldtkWorld, element_0);
    }
    println('Gridvania size: ' + gridWidth + ' x ' + gridHeight + ')');
  }
  teh(ldtkWorld) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = ldtkWorld.pdb_1.ld5_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.reloadAsset.<anonymous>' call
      var levelX = element.td6_1 / this.aeh_1 | 0;
      var levelY = element.ud6_1 / this.beh_1 | 0;
      loadLevel(this, this.yeg_1, levelX, levelY, ldtkWorld, element);
    }
  }
}
class Companion {}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ImageDataConfig', this, 2);
    tmp0_serialDesc.m16('fileName', true);
    tmp0_serialDesc.m16('layers', true);
    this.ueh_1 = tmp0_serialDesc;
  }
  veh(encoder, value) {
    var tmp0_desc = this.ueh_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.weh_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.weh_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.xeh_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, StringSerializer_getInstance(), value.xeh_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.veh(encoder, value instanceof ImageDataConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ueh_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return ImageDataConfig.yeh(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.ueh_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  }
}
class Companion_0 {}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TileMapConfig', this, 3);
    tmp0_serialDesc.m16('fileName', false);
    tmp0_serialDesc.m16('levels', true);
    tmp0_serialDesc.m16('hasParallax', true);
    this.zeh_1 = tmp0_serialDesc;
  }
  aei(encoder, value) {
    var tmp0_desc = this.zeh_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.bei_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.cei_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, StringSerializer_getInstance(), value.cei_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.dei_1 === true)) {
      tmp1_output.f10(tmp0_desc, 2, value.dei_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.aei(encoder, value instanceof TileMapConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.zeh_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.lz(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return TileMapConfig.eei(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.zeh_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  }
}
class ImageDataConfig {
  constructor(fileName, layers) {
    fileName = fileName === VOID ? '' : fileName;
    layers = layers === VOID ? null : layers;
    this.weh_1 = fileName;
    this.xeh_1 = layers;
  }
  toString() {
    return 'ImageDataConfig(fileName=' + this.weh_1 + ', layers=' + this.xeh_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.weh_1);
    result = imul(result, 31) + (this.xeh_1 == null ? 0 : getStringHashCode(this.xeh_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDataConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDataConfig ? other : THROW_CCE();
    if (!(this.weh_1 === tmp0_other_with_cast.weh_1))
      return false;
    if (!(this.xeh_1 == tmp0_other_with_cast.xeh_1))
      return false;
    return true;
  }
  static yeh(seen0, fileName, layers, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_0().ueh_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.weh_1 = '';
    else
      $this.weh_1 = fileName;
    if (0 === (seen0 & 2))
      $this.xeh_1 = null;
    else
      $this.xeh_1 = layers;
    return $this;
  }
}
class TileMapConfig {
  toString() {
    return 'TileMapConfig(fileName=' + this.bei_1 + ', levels=' + this.cei_1 + ', hasParallax=' + this.dei_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.bei_1);
    result = imul(result, 31) + (this.cei_1 == null ? 0 : getStringHashCode(this.cei_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dei_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileMapConfig))
      return false;
    var tmp0_other_with_cast = other instanceof TileMapConfig ? other : THROW_CCE();
    if (!(this.bei_1 === tmp0_other_with_cast.bei_1))
      return false;
    if (!(this.cei_1 == tmp0_other_with_cast.cei_1))
      return false;
    if (!(this.dei_1 === tmp0_other_with_cast.dei_1))
      return false;
    return true;
  }
  static eei(seen0, fileName, levels, hasParallax, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().zeh_1);
    }
    var $this = createThis(this);
    $this.bei_1 = fileName;
    if (0 === (seen0 & 2))
      $this.cei_1 = null;
    else
      $this.cei_1 = levels;
    if (0 === (seen0 & 4))
      $this.dei_1 = true;
    else
      $this.dei_1 = hasParallax;
    return $this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.fei_1 = [null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_3()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_0()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_1())];
  }
}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AssetModel', this, 7);
    tmp0_serialDesc.m16('folder', true);
    tmp0_serialDesc.m16('hotReloading', true);
    tmp0_serialDesc.m16('sounds', true);
    tmp0_serialDesc.m16('backgrounds', true);
    tmp0_serialDesc.m16('images', true);
    tmp0_serialDesc.m16('fonts', true);
    tmp0_serialDesc.m16('tileMaps', true);
    this.gei_1 = tmp0_serialDesc;
  }
  hei(encoder, value) {
    var tmp0_desc = this.gei_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().fei_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.iei_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.iei_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.jei_1 === false)) {
      tmp1_output.f10(tmp0_desc, 1, value.jei_1);
    }
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 2)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$0 = emptyMap();
      tmp = !equals(value.kei_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.kei_1);
    }
    var tmp_0;
    if (tmp1_output.v10(tmp0_desc, 3)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$1 = emptyMap();
      tmp_0 = !equals(value.lei_1, tmp$ret$1);
    }
    if (tmp_0) {
      tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.lei_1);
    }
    var tmp_1;
    if (tmp1_output.v10(tmp0_desc, 4)) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$2 = emptyMap();
      tmp_1 = !equals(value.mei_1, tmp$ret$2);
    }
    if (tmp_1) {
      tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.mei_1);
    }
    var tmp_2;
    if (tmp1_output.v10(tmp0_desc, 5)) {
      tmp_2 = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$3 = emptyMap();
      tmp_2 = !equals(value.nei_1, tmp$ret$3);
    }
    if (tmp_2) {
      tmp1_output.p10(tmp0_desc, 5, tmp2_cached[5], value.nei_1);
    }
    var tmp_3;
    if (tmp1_output.v10(tmp0_desc, 6)) {
      tmp_3 = true;
    } else {
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$4 = emptyMap();
      tmp_3 = !equals(value.oei_1, tmp$ret$4);
    }
    if (tmp_3) {
      tmp1_output.p10(tmp0_desc, 6, tmp2_cached[6], value.oei_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.hei(encoder, value instanceof AssetModel ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.gei_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    var tmp12_cached = Companion_getInstance_11().fei_1;
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.jz(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.jz(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.jz(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.jz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.jz(tmp0_desc, 2, tmp12_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.jz(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.jz(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.jz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return AssetModel.pei(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.gei_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_11().fei_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3], tmp0_cached[4], tmp0_cached[5], tmp0_cached[6]];
  }
}
class AssetModel {
  constructor(folder, hotReloading, sounds, backgrounds, images, fonts, tileMaps) {
    Companion_getInstance_11();
    folder = folder === VOID ? '' : folder;
    hotReloading = hotReloading === VOID ? false : hotReloading;
    var tmp;
    if (sounds === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = sounds;
    }
    sounds = tmp;
    var tmp_0;
    if (backgrounds === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = backgrounds;
    }
    backgrounds = tmp_0;
    var tmp_1;
    if (images === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_1 = emptyMap();
    } else {
      tmp_1 = images;
    }
    images = tmp_1;
    var tmp_2;
    if (fonts === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_2 = emptyMap();
    } else {
      tmp_2 = fonts;
    }
    fonts = tmp_2;
    var tmp_3;
    if (tileMaps === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_3 = emptyMap();
    } else {
      tmp_3 = tileMaps;
    }
    tileMaps = tmp_3;
    this.iei_1 = folder;
    this.jei_1 = hotReloading;
    this.kei_1 = sounds;
    this.lei_1 = backgrounds;
    this.mei_1 = images;
    this.nei_1 = fonts;
    this.oei_1 = tileMaps;
  }
  toString() {
    return 'AssetModel(folder=' + this.iei_1 + ', hotReloading=' + this.jei_1 + ', sounds=' + toString_0(this.kei_1) + ', backgrounds=' + toString_0(this.lei_1) + ', images=' + toString_0(this.mei_1) + ', fonts=' + toString_0(this.nei_1) + ', tileMaps=' + toString_0(this.oei_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.iei_1);
    result = imul(result, 31) + getBooleanHashCode(this.jei_1) | 0;
    result = imul(result, 31) + hashCode(this.kei_1) | 0;
    result = imul(result, 31) + hashCode(this.lei_1) | 0;
    result = imul(result, 31) + hashCode(this.mei_1) | 0;
    result = imul(result, 31) + hashCode(this.nei_1) | 0;
    result = imul(result, 31) + hashCode(this.oei_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AssetModel))
      return false;
    var tmp0_other_with_cast = other instanceof AssetModel ? other : THROW_CCE();
    if (!(this.iei_1 === tmp0_other_with_cast.iei_1))
      return false;
    if (!(this.jei_1 === tmp0_other_with_cast.jei_1))
      return false;
    if (!equals(this.kei_1, tmp0_other_with_cast.kei_1))
      return false;
    if (!equals(this.lei_1, tmp0_other_with_cast.lei_1))
      return false;
    if (!equals(this.mei_1, tmp0_other_with_cast.mei_1))
      return false;
    if (!equals(this.nei_1, tmp0_other_with_cast.nei_1))
      return false;
    if (!equals(this.oei_1, tmp0_other_with_cast.oei_1))
      return false;
    return true;
  }
  static pei(seen0, folder, hotReloading, sounds, backgrounds, images, fonts, tileMaps, serializationConstructorMarker) {
    Companion_getInstance_11();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().gei_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.iei_1 = '';
    else
      $this.iei_1 = folder;
    if (0 === (seen0 & 2))
      $this.jei_1 = false;
    else
      $this.jei_1 = hotReloading;
    if (0 === (seen0 & 4)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp.kei_1 = emptyMap();
    } else
      $this.kei_1 = sounds;
    if (0 === (seen0 & 8)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0.lei_1 = emptyMap();
    } else
      $this.lei_1 = backgrounds;
    if (0 === (seen0 & 16)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_1.mei_1 = emptyMap();
    } else
      $this.mei_1 = images;
    if (0 === (seen0 & 32)) {
      var tmp_2 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_2.nei_1 = emptyMap();
    } else
      $this.nei_1 = fonts;
    if (0 === (seen0 & 64)) {
      var tmp_3 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_3.oei_1 = emptyMap();
    } else
      $this.oei_1 = tileMaps;
    return $this;
  }
}
class Companion_2 {
  constructor() {
    this.qei_1 = null;
  }
}
class ResourceDirWatcherConfiguration$enableAssetWatcher$slambda {
  constructor(this$0, $assetStore, $assetUpdater, $assetConfig) {
    this.xei_1 = this$0;
    this.yei_1 = $assetStore;
    this.zei_1 = $assetUpdater;
    this.aej_1 = $assetConfig;
  }
  h3g(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
  }
  le(p1, $completion) {
    return this.h3g(p1 instanceof FileEvent ? p1 : THROW_CCE(), $completion);
  }
}
class ResourceDirWatcherConfiguration$checkAssetFolders$slambda {
  constructor($config, $assetStore, $assetUpdater, $assetConfig) {
    this.bej_1 = $config;
    this.cej_1 = $assetStore;
    this.dej_1 = $assetUpdater;
    this.eej_1 = $assetConfig;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class ResourceDirWatcherConfiguration$checkAssetFolders$slambda_0 {
  constructor($config, $assetStore, $assetUpdater, $assetConfig, this$0) {
    this.zej_1 = $config;
    this.aek_1 = $assetStore;
    this.bek_1 = $assetUpdater;
    this.cek_1 = $assetConfig;
    this.dek_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class ResourceDirWatcherConfiguration$checkAssetFolders$slambda_1 {
  constructor($config, $assetStore, $assetUpdater, $assetConfig, this$0) {
    this.eek_1 = $config;
    this.fek_1 = $assetStore;
    this.gek_1 = $assetUpdater;
    this.hek_1 = $assetConfig;
    this.iek_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class ResourceDirWatcherConfiguration$checkAssetFolders$slambda_2 {
  constructor($assetConfig, $config, $assetStore, this$0, $assetUpdater) {
    this.pek_1 = $assetConfig;
    this.qek_1 = $config;
    this.rek_1 = $assetStore;
    this.sek_1 = this$0;
    this.tek_1 = $assetUpdater;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
  }
}
class ResourceDirWatcherConfiguration {
  constructor(commonAssetUpdater, worldAssetUpdater, levelAssetUpdater, specialAssetUpdater) {
    commonAssetUpdater = commonAssetUpdater === VOID ? new AssetUpdaterConfiguration(AssetType_COMMON_getInstance()) : commonAssetUpdater;
    worldAssetUpdater = worldAssetUpdater === VOID ? new AssetUpdaterConfiguration(AssetType_WORLD_getInstance()) : worldAssetUpdater;
    levelAssetUpdater = levelAssetUpdater === VOID ? new AssetUpdaterConfiguration(AssetType_LEVEL_getInstance()) : levelAssetUpdater;
    specialAssetUpdater = specialAssetUpdater === VOID ? new AssetUpdaterConfiguration(AssetType_SPECIAL_getInstance()) : specialAssetUpdater;
    this.rei_1 = commonAssetUpdater;
    this.sei_1 = worldAssetUpdater;
    this.tei_1 = levelAssetUpdater;
    this.uei_1 = specialAssetUpdater;
    this.vei_1 = false;
  }
  uek(type, callback) {
    switch (type.p3_1) {
      case 0:
        this.rei_1.tej_1 = true;
        // Inline function 'kotlin.apply' call

        // Inline function 'kotlin.contracts.contract' call

        callback(this.rei_1);
        break;
      case 1:
        this.sei_1.tej_1 = true;
        // Inline function 'kotlin.apply' call

        // Inline function 'kotlin.contracts.contract' call

        callback(this.sei_1);
        break;
      case 2:
        this.tei_1.tej_1 = true;
        // Inline function 'kotlin.apply' call

        // Inline function 'kotlin.contracts.contract' call

        callback(this.tei_1);
        break;
      case 3:
        this.uei_1.tej_1 = true;
        // Inline function 'kotlin.apply' call

        // Inline function 'kotlin.contracts.contract' call

        callback(this.uei_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  wei(assetStore, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_configure__qaq7w2.bind(VOID, this, assetStore), $completion);
  }
}
class AssetUpdaterConfiguration {
  constructor(type, toBeEnabled, enabled, imageChangedCallback, fontChangedCallback, backgroundCallback, ldtkLevelMapCallback) {
    toBeEnabled = toBeEnabled === VOID ? false : toBeEnabled;
    enabled = enabled === VOID ? false : enabled;
    var tmp;
    if (imageChangedCallback === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList.z();
    } else {
      tmp = imageChangedCallback;
    }
    imageChangedCallback = tmp;
    var tmp_0;
    if (fontChangedCallback === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0 = ArrayList.z();
    } else {
      tmp_0 = fontChangedCallback;
    }
    fontChangedCallback = tmp_0;
    var tmp_1;
    if (backgroundCallback === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_1 = ArrayList.z();
    } else {
      tmp_1 = backgroundCallback;
    }
    backgroundCallback = tmp_1;
    var tmp_2;
    if (ldtkLevelMapCallback === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_2 = ArrayList.z();
    } else {
      tmp_2 = ldtkLevelMapCallback;
    }
    ldtkLevelMapCallback = tmp_2;
    this.sej_1 = type;
    this.tej_1 = toBeEnabled;
    this.uej_1 = enabled;
    this.vej_1 = imageChangedCallback;
    this.wej_1 = fontChangedCallback;
    this.xej_1 = backgroundCallback;
    this.yej_1 = ldtkLevelMapCallback;
  }
}
class AssetStore {
  constructor() {
    this.fej_1 = MutableAtlas.n56(1024, 2048, 1);
    this.gej_1 = MutableAtlas.n56(1024, 2048, 1);
    this.hej_1 = MutableAtlas.n56(1024, 2048, 1);
    this.iej_1 = MutableAtlas.n56(1024, 2048, 1);
    this.jej_1 = new AssetModel();
    this.kej_1 = new AssetModel();
    this.lej_1 = new AssetModel();
    this.mej_1 = new AssetModel();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.nej_1 = LinkedHashMap.wc();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.oej_1 = LinkedHashMap.wc();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.pej_1 = LinkedHashMap.wc();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.qej_1 = LinkedHashMap.wc();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.rej_1 = LinkedHashMap.wc();
  }
  vek(name) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.rej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      tmp = ensureNotNull(this.rej_1.e3(name)).om_1;
    } else {
      var message = "AssetStore: Sound '" + name + "' not found!";
      throw IllegalStateException.h5(toString_0(message));
    }
    return tmp;
  }
  wek(name, slice) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.pej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      var tmp_0;
      if (slice == null) {
        tmp_0 = ensureNotNull(this.pej_1.e3(name)).om_1.e6o();
      } else {
        var tmp_1;
        if (!(ensureNotNull(this.pej_1.e3(name)).om_1.f6o(slice) == null)) {
          tmp_1 = ensureNotNull(ensureNotNull(this.pej_1.e3(name)).om_1.f6o(slice));
        } else {
          println("WARNING - AssetStore: Slice '" + slice + "' of image '" + name + "' not found!");
          tmp_1 = Companion_instance.g6n();
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      println("WARNING - AssetStore: Image '" + name + "' not found!");
      tmp = Companion_instance.g6n();
    }
    return tmp;
  }
  xek(name, slice, $super) {
    slice = slice === VOID ? null : slice;
    return $super === VOID ? this.wek(name, slice) : $super.wek.call(this, name, slice);
  }
  yek(name) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.nej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      tmp = ensureNotNull(this.nej_1.e3(name)).om_1.yeg_1;
    } else {
      var message = "AssetStore: World data '" + name + "' not found!";
      throw IllegalStateException.h5(toString_0(message));
    }
    return tmp;
  }
  zek(name) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.pej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      var layerData = first(first(ensureNotNull(this.pej_1.e3(name)).om_1.y6n_1).l6n_1).t6l_1;
      var tmp_0;
      if (!(layerData == null)) {
        var ninePatch = layerData.c6m_1;
        var tmp_1;
        if (ninePatch == null) {
          var message = "AssetStore: Image '" + name + "' does not contain nine-patch data!";
          throw IllegalStateException.h5(toString_0(message));
        } else {
          tmp_1 = ninePatch;
        }
        tmp_0 = tmp_1;
      } else {
        var message_0 = "AssetStore: Image layer of '" + name + "' not found!";
        throw IllegalStateException.h5(toString_0(message_0));
      }
      tmp = tmp_0;
    } else {
      var message_1 = "AssetStore: Image '" + name + "' not found!";
      throw IllegalStateException.h5(toString_0(message_1));
    }
    return tmp;
  }
  ael(name) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.oej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      tmp = ensureNotNull(this.oej_1.e3(name)).om_1;
    } else {
      var message = "AssetStore: Parallax background '" + name + "' not found!";
      throw IllegalStateException.h5(toString_0(message));
    }
    return tmp;
  }
  bel(name) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.qej_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      tmp = ensureNotNull(this.qej_1.e3(name)).om_1;
    } else {
      var message = "AssetStore: Cannot find font '" + name + "'!";
      throw IllegalStateException.h5(toString_0(message));
    }
    return tmp;
  }
  cel(type, assetConfig, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadAssets__gde0f3.bind(VOID, this, type, assetConfig), $completion);
  }
}
class AssetType extends Enum {}
class ParallaxDataContainer {
  constructor(config, backgroundLayers, foregroundLayers, attachedLayersFront, attachedLayersRear, parallaxPlane) {
    this.del_1 = config;
    this.eel_1 = backgroundLayers;
    this.fel_1 = foregroundLayers;
    this.gel_1 = attachedLayersFront;
    this.hel_1 = attachedLayersRear;
    this.iel_1 = parallaxPlane;
  }
  toString() {
    return 'ParallaxDataContainer(config=' + this.del_1.toString() + ', backgroundLayers=' + toString(this.eel_1) + ', foregroundLayers=' + toString(this.fel_1) + ', attachedLayersFront=' + toString(this.gel_1) + ', attachedLayersRear=' + toString(this.hel_1) + ', parallaxPlane=' + toString(this.iel_1) + ')';
  }
  hashCode() {
    var result = this.del_1.hashCode();
    result = imul(result, 31) + (this.eel_1 == null ? 0 : hashCode(this.eel_1)) | 0;
    result = imul(result, 31) + (this.fel_1 == null ? 0 : hashCode(this.fel_1)) | 0;
    result = imul(result, 31) + (this.gel_1 == null ? 0 : hashCode(this.gel_1)) | 0;
    result = imul(result, 31) + (this.hel_1 == null ? 0 : hashCode(this.hel_1)) | 0;
    result = imul(result, 31) + (this.iel_1 == null ? 0 : hashCode(this.iel_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxDataContainer))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxDataContainer ? other : THROW_CCE();
    if (!this.del_1.equals(tmp0_other_with_cast.del_1))
      return false;
    if (!equals(this.eel_1, tmp0_other_with_cast.eel_1))
      return false;
    if (!equals(this.fel_1, tmp0_other_with_cast.fel_1))
      return false;
    if (!equals(this.gel_1, tmp0_other_with_cast.gel_1))
      return false;
    if (!equals(this.hel_1, tmp0_other_with_cast.hel_1))
      return false;
    if (!equals(this.iel_1, tmp0_other_with_cast.iel_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class Companion_3 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.jel_1 = [null, null, createSimpleEnumSerializer('korlibs.korge.fleks.assets.ParallaxConfig.Mode', values_0()), new ArrayListSerializer($serializer_getInstance_4()), null, new ArrayListSerializer($serializer_getInstance_4())];
  }
}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallaxConfig', this, 6);
    tmp0_serialDesc.m16('aseName', false);
    tmp0_serialDesc.m16('offset', true);
    tmp0_serialDesc.m16('mode', true);
    tmp0_serialDesc.m16('backgroundLayers', true);
    tmp0_serialDesc.m16('parallaxPlane', true);
    tmp0_serialDesc.m16('foregroundLayers', true);
    this.kel_1 = tmp0_serialDesc;
  }
  lel(encoder, value) {
    var tmp0_desc = this.kel_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().jel_1;
    tmp1_output.n10(tmp0_desc, 0, value.jek_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.kek_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 1, value.kek_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.lek_1.equals(Mode_HORIZONTAL_PLANE_getInstance())) {
      tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.lek_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.mek_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, tmp2_cached[3], value.mek_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.nek_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, $serializer_getInstance_5(), value.nek_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.oek_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, tmp2_cached[5], value.oek_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.lel(encoder, value instanceof ParallaxConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kel_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_13().jel_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, $serializer_getInstance_5(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return ParallaxConfig.mel(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.kel_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_13().jel_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[2], get_nullable(tmp0_cached[3]), get_nullable($serializer_getInstance_5()), get_nullable(tmp0_cached[5])];
  }
}
class ParallaxConfig {
  toString() {
    return 'ParallaxConfig(aseName=' + this.jek_1 + ', offset=' + this.kek_1 + ', mode=' + this.lek_1.toString() + ', backgroundLayers=' + toString(this.mek_1) + ', parallaxPlane=' + toString(this.nek_1) + ', foregroundLayers=' + toString(this.oek_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.jek_1);
    result = imul(result, 31) + this.kek_1 | 0;
    result = imul(result, 31) + this.lek_1.hashCode() | 0;
    result = imul(result, 31) + (this.mek_1 == null ? 0 : this.mek_1.hashCode()) | 0;
    result = imul(result, 31) + (this.nek_1 == null ? 0 : this.nek_1.hashCode()) | 0;
    result = imul(result, 31) + (this.oek_1 == null ? 0 : this.oek_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxConfig ? other : THROW_CCE();
    if (!(this.jek_1 === tmp0_other_with_cast.jek_1))
      return false;
    if (!(this.kek_1 === tmp0_other_with_cast.kek_1))
      return false;
    if (!this.lek_1.equals(tmp0_other_with_cast.lek_1))
      return false;
    if (!equals(this.mek_1, tmp0_other_with_cast.mek_1))
      return false;
    if (!equals(this.nek_1, tmp0_other_with_cast.nek_1))
      return false;
    if (!equals(this.oek_1, tmp0_other_with_cast.oek_1))
      return false;
    return true;
  }
  static mel(seen0, aseName, offset, mode, backgroundLayers, parallaxPlane, foregroundLayers, serializationConstructorMarker) {
    Companion_getInstance_13();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().kel_1);
    }
    var $this = createThis(this);
    $this.jek_1 = aseName;
    if (0 === (seen0 & 2))
      $this.kek_1 = 0;
    else
      $this.kek_1 = offset;
    if (0 === (seen0 & 4))
      $this.lek_1 = Mode_HORIZONTAL_PLANE_getInstance();
    else
      $this.lek_1 = mode;
    if (0 === (seen0 & 8))
      $this.mek_1 = null;
    else
      $this.mek_1 = backgroundLayers;
    if (0 === (seen0 & 16))
      $this.nek_1 = null;
    else
      $this.nek_1 = parallaxPlane;
    if (0 === (seen0 & 32))
      $this.oek_1 = null;
    else
      $this.oek_1 = foregroundLayers;
    return $this;
  }
}
class Companion_4 {}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallaxLayerConfig', this, 6);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('repeatX', true);
    tmp0_serialDesc.m16('repeatY', true);
    tmp0_serialDesc.m16('speedFactor', true);
    tmp0_serialDesc.m16('selfSpeedX', true);
    tmp0_serialDesc.m16('selfSpeedY', true);
    this.cem_1 = tmp0_serialDesc;
  }
  dem(encoder, value) {
    var tmp0_desc = this.cem_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.tel_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.uel_1 === false)) {
      tmp1_output.f10(tmp0_desc, 1, value.uel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.vel_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.vel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.wel_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.wel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.xel_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.xel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.yel_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.yel_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.dem(encoder, value instanceof ParallaxLayerConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.cem_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_input = decoder.xy(tmp0_desc);
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return ParallaxLayerConfig.eem(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.cem_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(FloatSerializer_getInstance()), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class ParallaxLayerConfig {
  toString() {
    return 'ParallaxLayerConfig(name=' + this.tel_1 + ', repeatX=' + this.uel_1 + ', repeatY=' + this.vel_1 + ', speedFactor=' + this.wel_1 + ', selfSpeedX=' + this.xel_1 + ', selfSpeedY=' + this.yel_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.tel_1);
    result = imul(result, 31) + getBooleanHashCode(this.uel_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vel_1) | 0;
    result = imul(result, 31) + (this.wel_1 == null ? 0 : getNumberHashCode(this.wel_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xel_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yel_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxLayerConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxLayerConfig ? other : THROW_CCE();
    if (!(this.tel_1 === tmp0_other_with_cast.tel_1))
      return false;
    if (!(this.uel_1 === tmp0_other_with_cast.uel_1))
      return false;
    if (!(this.vel_1 === tmp0_other_with_cast.vel_1))
      return false;
    if (!equals(this.wel_1, tmp0_other_with_cast.wel_1))
      return false;
    if (!equals(this.xel_1, tmp0_other_with_cast.xel_1))
      return false;
    if (!equals(this.yel_1, tmp0_other_with_cast.yel_1))
      return false;
    return true;
  }
  static eem(seen0, name, repeatX, repeatY, speedFactor, selfSpeedX, selfSpeedY, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().cem_1);
    }
    var $this = createThis(this);
    $this.tel_1 = name;
    if (0 === (seen0 & 2))
      $this.uel_1 = false;
    else
      $this.uel_1 = repeatX;
    if (0 === (seen0 & 4))
      $this.vel_1 = false;
    else
      $this.vel_1 = repeatY;
    if (0 === (seen0 & 8))
      $this.wel_1 = null;
    else
      $this.wel_1 = speedFactor;
    if (0 === (seen0 & 16))
      $this.xel_1 = 0.0;
    else
      $this.xel_1 = selfSpeedX;
    if (0 === (seen0 & 32))
      $this.yel_1 = 0.0;
    else
      $this.yel_1 = selfSpeedY;
    return $this;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_7 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.fem_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_6()), new ArrayListSerializer($serializer_getInstance_6()), null];
  }
}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallaxPlaneConfig', this, 6);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('speedFactor', true);
    tmp0_serialDesc.m16('selfSpeed', true);
    tmp0_serialDesc.m16('attachedLayersFront', true);
    tmp0_serialDesc.m16('attachedLayersRear', true);
    tmp0_serialDesc.m16('parallaxPlaneSpeedFactors', false);
    this.gem_1 = tmp0_serialDesc;
  }
  hem(encoder, value) {
    var tmp0_desc = this.gem_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().fem_1;
    tmp1_output.n10(tmp0_desc, 0, value.nel_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.oel_1, 1.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.oel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.pel_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.pel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.qel_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, tmp2_cached[3], value.qel_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.rel_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, tmp2_cached[4], value.rel_1);
    }
    tmp1_output.p10(tmp0_desc, 5, ParallaxSpeedFactors_getInstance(), value.iem());
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.hem(encoder, value instanceof ParallaxPlaneConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.gem_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_15().fem_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, ParallaxSpeedFactors_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, ParallaxSpeedFactors_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return ParallaxPlaneConfig.jem(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.gem_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_15().fem_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), ParallaxSpeedFactors_getInstance()];
  }
}
class ParallaxPlaneConfig {
  iem() {
    var tmp = this.sel_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('parallaxPlaneSpeedFactors');
    }
  }
  toString() {
    return 'ParallaxPlaneConfig(name=' + this.nel_1 + ', speedFactor=' + this.oel_1 + ', selfSpeed=' + this.pel_1 + ', attachedLayersFront=' + toString(this.qel_1) + ', attachedLayersRear=' + toString(this.rel_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.nel_1);
    result = imul(result, 31) + getNumberHashCode(this.oel_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pel_1) | 0;
    result = imul(result, 31) + (this.qel_1 == null ? 0 : this.qel_1.hashCode()) | 0;
    result = imul(result, 31) + (this.rel_1 == null ? 0 : this.rel_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxPlaneConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxPlaneConfig ? other : THROW_CCE();
    if (!(this.nel_1 === tmp0_other_with_cast.nel_1))
      return false;
    if (!equals(this.oel_1, tmp0_other_with_cast.oel_1))
      return false;
    if (!equals(this.pel_1, tmp0_other_with_cast.pel_1))
      return false;
    if (!equals(this.qel_1, tmp0_other_with_cast.qel_1))
      return false;
    if (!equals(this.rel_1, tmp0_other_with_cast.rel_1))
      return false;
    return true;
  }
  static jem(seen0, name, speedFactor, selfSpeed, attachedLayersFront, attachedLayersRear, parallaxPlaneSpeedFactors, serializationConstructorMarker) {
    Companion_getInstance_15();
    if (!(33 === (33 & seen0))) {
      throwMissingFieldException(seen0, 33, $serializer_getInstance_5().gem_1);
    }
    var $this = createThis(this);
    $this.nel_1 = name;
    if (0 === (seen0 & 2))
      $this.oel_1 = 1.0;
    else
      $this.oel_1 = speedFactor;
    if (0 === (seen0 & 4))
      $this.pel_1 = 0.0;
    else
      $this.pel_1 = selfSpeed;
    if (0 === (seen0 & 8))
      $this.qel_1 = null;
    else
      $this.qel_1 = attachedLayersFront;
    if (0 === (seen0 & 16))
      $this.rel_1 = null;
    else
      $this.rel_1 = attachedLayersRear;
    $this.sel_1 = parallaxPlaneSpeedFactors;
    return $this;
  }
}
class Companion_6 {}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallaxAttachedLayerConfig', this, 3);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('repeat', true);
    tmp0_serialDesc.m16('attachBottomRight', true);
    this.kem_1 = tmp0_serialDesc;
  }
  lem(encoder, value) {
    var tmp0_desc = this.kem_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.zel_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.aem_1 === false)) {
      tmp1_output.f10(tmp0_desc, 1, value.aem_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.bem_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.bem_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.lem(encoder, value instanceof ParallaxAttachedLayerConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kem_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return ParallaxAttachedLayerConfig.mem(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.kem_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class ParallaxAttachedLayerConfig {
  toString() {
    return 'ParallaxAttachedLayerConfig(name=' + this.zel_1 + ', repeat=' + this.aem_1 + ', attachBottomRight=' + this.bem_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.zel_1);
    result = imul(result, 31) + getBooleanHashCode(this.aem_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bem_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxAttachedLayerConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxAttachedLayerConfig ? other : THROW_CCE();
    if (!(this.zel_1 === tmp0_other_with_cast.zel_1))
      return false;
    if (!(this.aem_1 === tmp0_other_with_cast.aem_1))
      return false;
    if (!(this.bem_1 === tmp0_other_with_cast.bem_1))
      return false;
    return true;
  }
  static mem(seen0, name, repeat, attachBottomRight, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().kem_1);
    }
    var $this = createThis(this);
    $this.zel_1 = name;
    if (0 === (seen0 & 2))
      $this.aem_1 = false;
    else
      $this.aem_1 = repeat;
    if (0 === (seen0 & 4))
      $this.bem_1 = false;
    else
      $this.bem_1 = attachBottomRight;
    return $this;
  }
}
class LevelMap {
  constructor(levelGridVania) {
    var tmp;
    if (levelGridVania === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = levelGridVania;
    }
    levelGridVania = tmp;
    this.peh_1 = levelGridVania;
  }
  nem(x, y, width, height, levelWidth, levelHeight, renderCall) {
    var gridX = x / levelWidth | 0;
    var gridY = y / levelHeight | 0;
    var gridX2 = (x + width | 0) / levelWidth | 0;
    var gridY2 = (y + height | 0) / levelHeight | 0;
    var xStart = x % levelWidth | 0;
    var yStart = y % levelHeight | 0;
    if (gridX === gridX2) {
      if (gridY === gridY2) {
        processTiles(this, gridX, gridY, xStart, yStart, xStart + width | 0, yStart + height | 0, levelWidth, levelHeight, renderCall);
      } else {
        processTiles(this, gridX, gridY, xStart, yStart, xStart + width | 0, levelHeight, levelWidth, levelHeight, renderCall);
        processTiles(this, gridX, gridY2, xStart, 0, xStart + width | 0, (yStart + height | 0) % levelHeight | 0, levelWidth, levelHeight, renderCall);
      }
    } else {
      if (gridY === gridY2) {
        processTiles(this, gridX, gridY, xStart, yStart, levelWidth, yStart + height | 0, levelWidth, levelHeight, renderCall);
        processTiles(this, gridX2, gridY, 0, yStart, (xStart + width | 0) % levelWidth | 0, yStart + height | 0, levelWidth, levelHeight, renderCall);
      } else {
        processTiles(this, gridX, gridY, xStart, yStart, levelWidth, levelHeight, levelWidth, levelHeight, renderCall);
        processTiles(this, gridX2, gridY, 0, yStart, (xStart + width | 0) % levelWidth | 0, levelHeight, levelWidth, levelHeight, renderCall);
        processTiles(this, gridX, gridY2, xStart, 0, levelWidth, (yStart + height | 0) % levelHeight | 0, levelWidth, levelHeight, renderCall);
        processTiles(this, gridX2, gridY2, 0, 0, (xStart + width | 0) % levelWidth | 0, (yStart + height | 0) % levelHeight | 0, levelWidth, levelHeight, renderCall);
      }
    }
  }
  toString() {
    return 'LevelMap(levelGridVania=' + toString_0(this.peh_1) + ')';
  }
  hashCode() {
    return hashCode(this.peh_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelMap))
      return false;
    var tmp0_other_with_cast = other instanceof LevelMap ? other : THROW_CCE();
    if (!equals(this.peh_1, tmp0_other_with_cast.peh_1))
      return false;
    return true;
  }
}
class LevelData {
  constructor(entities, tileMapData) {
    var tmp;
    if (entities === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = entities;
    }
    entities = tmp;
    tileMapData = tileMapData === VOID ? null : tileMapData;
    this.qeh_1 = entities;
    this.reh_1 = tileMapData;
  }
  toString() {
    return 'LevelData(entities=' + toString_0(this.qeh_1) + ', tileMapData=' + toString(this.reh_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.qeh_1);
    result = imul(result, 31) + (this.reh_1 == null ? 0 : this.reh_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelData))
      return false;
    var tmp0_other_with_cast = other instanceof LevelData ? other : THROW_CCE();
    if (!equals(this.qeh_1, tmp0_other_with_cast.qeh_1))
      return false;
    if (!equals(this.reh_1, tmp0_other_with_cast.reh_1))
      return false;
    return true;
  }
}
class WorldData {
  constructor(width, height, levelWidth, levelHeight, gridSize, layerlevelMaps) {
    width = width === VOID ? 0.0 : width;
    height = height === VOID ? 0.0 : height;
    levelWidth = levelWidth === VOID ? 0 : levelWidth;
    levelHeight = levelHeight === VOID ? 0 : levelHeight;
    gridSize = gridSize === VOID ? 1 : gridSize;
    var tmp;
    if (layerlevelMaps === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap.wc();
    } else {
      tmp = layerlevelMaps;
    }
    layerlevelMaps = tmp;
    this.jeh_1 = width;
    this.keh_1 = height;
    this.leh_1 = levelWidth;
    this.meh_1 = levelHeight;
    this.neh_1 = gridSize;
    this.oeh_1 = layerlevelMaps;
  }
  oem(layerName) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.oeh_1;
    if (!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(layerName)) {
      println("WARNING: Level map for layer '" + layerName + "' does not exist!");
    }
    var tmp0_elvis_lhs = this.oeh_1.e3(layerName);
    return tmp0_elvis_lhs == null ? new LevelMap() : tmp0_elvis_lhs;
  }
  toString() {
    return 'WorldData(width=' + this.jeh_1 + ', height=' + this.keh_1 + ', levelWidth=' + this.leh_1 + ', levelHeight=' + this.meh_1 + ', gridSize=' + this.neh_1 + ', layerlevelMaps=' + toString_0(this.oeh_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.jeh_1);
    result = imul(result, 31) + getNumberHashCode(this.keh_1) | 0;
    result = imul(result, 31) + this.leh_1 | 0;
    result = imul(result, 31) + this.meh_1 | 0;
    result = imul(result, 31) + this.neh_1 | 0;
    result = imul(result, 31) + hashCode(this.oeh_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WorldData))
      return false;
    var tmp0_other_with_cast = other instanceof WorldData ? other : THROW_CCE();
    if (!equals(this.jeh_1, tmp0_other_with_cast.jeh_1))
      return false;
    if (!equals(this.keh_1, tmp0_other_with_cast.keh_1))
      return false;
    if (!(this.leh_1 === tmp0_other_with_cast.leh_1))
      return false;
    if (!(this.meh_1 === tmp0_other_with_cast.meh_1))
      return false;
    if (!(this.neh_1 === tmp0_other_with_cast.neh_1))
      return false;
    if (!equals(this.oeh_1, tmp0_other_with_cast.oeh_1))
      return false;
    return true;
  }
}
class Companion_7 extends ComponentType {
  constructor() {
    Companion_instance_9 = null;
    super();
    Companion_instance_9 = this;
  }
}
class $serializer_6 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DebugComponent', this, 1);
    tmp0_serialDesc.m16('name', true);
    this.pem_1 = tmp0_serialDesc;
  }
  qem(encoder, value) {
    var tmp0_desc = this.pem_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.rem_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.rem_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.qem(encoder, value instanceof DebugComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.pem_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return DebugComponent.sem(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.pem_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class CloneableComponent {
  static uem() {
    return createThis(this);
  }
}
class DebugComponent extends CloneableComponent {
  static tem(name) {
    Companion_getInstance_17();
    name = name === VOID ? '' : name;
    var $this = this.uem();
    $this.rem_1 = name;
    return $this;
  }
  q1t() {
    return Companion_getInstance_17();
  }
  z27() {
    return this.vem();
  }
  wem(name) {
    return DebugComponent.tem(name);
  }
  vem(name, $super) {
    name = name === VOID ? this.rem_1 : name;
    return $super === VOID ? this.wem(name) : $super.wem.call(this, name);
  }
  toString() {
    return 'DebugComponent(name=' + this.rem_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.rem_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DebugComponent))
      return false;
    var tmp0_other_with_cast = other instanceof DebugComponent ? other : THROW_CCE();
    if (!(this.rem_1 === tmp0_other_with_cast.rem_1))
      return false;
    return true;
  }
  static sem(seen0, name, serializationConstructorMarker) {
    Companion_getInstance_17();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_7().pem_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.rem_1 = '';
    else
      $this.rem_1 = name;
    return $this;
  }
}
class Companion_8 extends ComponentType {
  constructor() {
    Companion_instance_10 = null;
    super();
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.yem_1 = [new ArrayListSerializer($serializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance()), null];
  }
}
class $serializer_7 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SubEntities', this, 3);
    tmp0_serialDesc.m16('subEntities', true);
    tmp0_serialDesc.m16('subEntitiesByName', true);
    tmp0_serialDesc.m16('moveWith', true);
    this.zem_1 = tmp0_serialDesc;
  }
  aen(encoder, value) {
    var tmp0_desc = this.zem_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().yem_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      var tmp_0 = value.ben_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.ben_1);
    }
    var tmp_1;
    if (tmp1_output.v10(tmp0_desc, 1)) {
      tmp_1 = true;
    } else {
      var tmp_2 = value.cen_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$1 = emptyMap();
      tmp_1 = !equals(tmp_2, tmp$ret$1);
    }
    if (tmp_1) {
      tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.cen_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.den_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.den_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.aen(encoder, value instanceof SubEntitiesComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.zem_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.xy(tmp0_desc);
    var tmp8_cached = Companion_getInstance_18().yem_1;
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return SubEntitiesComponent.een(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.zem_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_18().yem_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], BooleanSerializer_getInstance()];
  }
}
class SubEntitiesComponent extends CloneableComponent {
  static fen(subEntities, subEntitiesByName, moveWith) {
    Companion_getInstance_18();
    var tmp;
    if (subEntities === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = subEntities;
    }
    subEntities = tmp;
    var tmp_0;
    if (subEntitiesByName === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = subEntitiesByName;
    }
    subEntitiesByName = tmp_0;
    moveWith = moveWith === VOID ? false : moveWith;
    var $this = this.uem();
    $this.ben_1 = subEntities;
    $this.cen_1 = subEntitiesByName;
    $this.den_1 = moveWith;
    return $this;
  }
  q1t() {
    return Companion_getInstance_18();
  }
  z27() {
    return this.gen(clone_3(this.ben_1));
  }
  hen(subEntities, subEntitiesByName, moveWith) {
    return SubEntitiesComponent.fen(subEntities, subEntitiesByName, moveWith);
  }
  gen(subEntities, subEntitiesByName, moveWith, $super) {
    subEntities = subEntities === VOID ? this.ben_1 : subEntities;
    subEntitiesByName = subEntitiesByName === VOID ? this.cen_1 : subEntitiesByName;
    moveWith = moveWith === VOID ? this.den_1 : moveWith;
    return $super === VOID ? this.hen(subEntities, subEntitiesByName, moveWith) : $super.hen.call(this, subEntities, subEntitiesByName, moveWith);
  }
  toString() {
    return 'SubEntitiesComponent(subEntities=' + toString_0(this.ben_1) + ', subEntitiesByName=' + toString_0(this.cen_1) + ', moveWith=' + this.den_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ben_1);
    result = imul(result, 31) + hashCode(this.cen_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.den_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SubEntitiesComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SubEntitiesComponent ? other : THROW_CCE();
    if (!equals(this.ben_1, tmp0_other_with_cast.ben_1))
      return false;
    if (!equals(this.cen_1, tmp0_other_with_cast.cen_1))
      return false;
    if (!(this.den_1 === tmp0_other_with_cast.den_1))
      return false;
    return true;
  }
  static een(seen0, subEntities, subEntitiesByName, moveWith, serializationConstructorMarker) {
    Companion_getInstance_18();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_8().zem_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.ben_1 = emptyList();
    } else
      $this.ben_1 = subEntities;
    if (0 === (seen0 & 2)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0.cen_1 = emptyMap();
    } else
      $this.cen_1 = subEntitiesByName;
    if (0 === (seen0 & 4))
      $this.den_1 = false;
    else
      $this.den_1 = moveWith;
    return $this;
  }
}
class Companion_9 extends ComponentType {
  constructor() {
    Companion_instance_11 = null;
    super();
    Companion_instance_11 = this;
  }
}
class $serializer_8 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('EntityLink', this, 2);
    tmp0_serialDesc.m16('linkedEntity', true);
    tmp0_serialDesc.m16('moveWith', true);
    this.ien_1 = tmp0_serialDesc;
  }
  jen(encoder, value) {
    var tmp0_desc = this.ien_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !value.ken_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 0, $serializer_getInstance(), value.ken_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.len_1 === true)) {
      tmp1_output.f10(tmp0_desc, 1, value.len_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.jen(encoder, value instanceof EntityLinkComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ien_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return EntityLinkComponent.men(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.ien_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class EntityLinkComponent extends CloneableComponent {
  static nen(linkedEntity, moveWith) {
    Companion_getInstance_19();
    linkedEntity = linkedEntity === VOID ? Companion_getInstance_4().x1s_1 : linkedEntity;
    moveWith = moveWith === VOID ? true : moveWith;
    var $this = this.uem();
    $this.ken_1 = linkedEntity;
    $this.len_1 = moveWith;
    return $this;
  }
  q1t() {
    return Companion_getInstance_19();
  }
  z27() {
    return this.oen(clone(this.ken_1));
  }
  em() {
    return this.ken_1;
  }
  fm() {
    return this.len_1;
  }
  pen(linkedEntity, moveWith) {
    return EntityLinkComponent.nen(linkedEntity, moveWith);
  }
  oen(linkedEntity, moveWith, $super) {
    linkedEntity = linkedEntity === VOID ? this.ken_1 : linkedEntity;
    moveWith = moveWith === VOID ? this.len_1 : moveWith;
    return $super === VOID ? this.pen(linkedEntity, moveWith) : $super.pen.call(this, linkedEntity, moveWith);
  }
  toString() {
    return 'EntityLinkComponent(linkedEntity=' + this.ken_1.toString() + ', moveWith=' + this.len_1 + ')';
  }
  hashCode() {
    var result = this.ken_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.len_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityLinkComponent))
      return false;
    var tmp0_other_with_cast = other instanceof EntityLinkComponent ? other : THROW_CCE();
    if (!this.ken_1.equals(tmp0_other_with_cast.ken_1))
      return false;
    if (!(this.len_1 === tmp0_other_with_cast.len_1))
      return false;
    return true;
  }
  static men(seen0, linkedEntity, moveWith, serializationConstructorMarker) {
    Companion_getInstance_19();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_9().ien_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.ken_1 = Companion_getInstance_4().x1s_1;
    else
      $this.ken_1 = linkedEntity;
    if (0 === (seen0 & 2))
      $this.len_1 = true;
    else
      $this.len_1 = moveWith;
    return $this;
  }
}
class Companion_10 extends ComponentType {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class Companion_11 extends ComponentType {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class $serializer_9 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Info', this, 3);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('entityId', true);
    tmp0_serialDesc.m16('initialized', true);
    this.qen_1 = tmp0_serialDesc;
  }
  ren(encoder, value) {
    var tmp0_desc = this.qen_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.sen_1 === 'noName')) {
      tmp1_output.n10(tmp0_desc, 0, value.sen_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.ten_1 === -1)) {
      tmp1_output.i10(tmp0_desc, 1, value.ten_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.uen_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.uen_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ren(encoder, value instanceof InfoComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qen_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return InfoComponent.ven(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.qen_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class InfoComponent extends CloneableComponent {
  static wen(name, entityId, initialized) {
    Companion_getInstance_21();
    name = name === VOID ? 'noName' : name;
    entityId = entityId === VOID ? -1 : entityId;
    initialized = initialized === VOID ? false : initialized;
    var $this = this.uem();
    $this.sen_1 = name;
    $this.ten_1 = entityId;
    $this.uen_1 = initialized;
    return $this;
  }
  q1t() {
    return Companion_getInstance_21();
  }
  r1t(_this__u8e3s4, entity) {
    if (this.uen_1)
      return Unit_instance;
    else
      this.uen_1 = true;
    this.ten_1 = entity.m1u_1;
    EntityByName_getInstance().yen(this.sen_1, entity);
  }
  s1t(_this__u8e3s4, entity) {
    EntityByName_getInstance().zen(this.sen_1);
  }
  z27() {
    return this.aeo();
  }
  beo(name, entityId, initialized) {
    return InfoComponent.wen(name, entityId, initialized);
  }
  aeo(name, entityId, initialized, $super) {
    name = name === VOID ? this.sen_1 : name;
    entityId = entityId === VOID ? this.ten_1 : entityId;
    initialized = initialized === VOID ? this.uen_1 : initialized;
    return $super === VOID ? this.beo(name, entityId, initialized) : $super.beo.call(this, name, entityId, initialized);
  }
  toString() {
    return 'InfoComponent(name=' + this.sen_1 + ', entityId=' + this.ten_1 + ', initialized=' + this.uen_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.sen_1);
    result = imul(result, 31) + this.ten_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.uen_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InfoComponent))
      return false;
    var tmp0_other_with_cast = other instanceof InfoComponent ? other : THROW_CCE();
    if (!(this.sen_1 === tmp0_other_with_cast.sen_1))
      return false;
    if (!(this.ten_1 === tmp0_other_with_cast.ten_1))
      return false;
    if (!(this.uen_1 === tmp0_other_with_cast.uen_1))
      return false;
    return true;
  }
  static ven(seen0, name, entityId, initialized, serializationConstructorMarker) {
    Companion_getInstance_21();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_10().qen_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.sen_1 = 'noName';
    else
      $this.sen_1 = name;
    if (0 === (seen0 & 2))
      $this.ten_1 = -1;
    else
      $this.ten_1 = entityId;
    if (0 === (seen0 & 4))
      $this.uen_1 = false;
    else
      $this.uen_1 = initialized;
    return $this;
  }
}
class Companion_12 extends ComponentType {
  constructor() {
    Companion_instance_14 = null;
    super();
    Companion_instance_14 = this;
  }
}
class $serializer_10 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Layer', this, 1);
    tmp0_serialDesc.m16('layerIndex', true);
    this.ceo_1 = tmp0_serialDesc;
  }
  deo(encoder, value) {
    var tmp0_desc = this.ceo_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.eeo_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 0, value.eeo_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.deo(encoder, value instanceof LayerComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ceo_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return LayerComponent.feo(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.ceo_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class LayerComponent extends CloneableComponent {
  static geo(layerIndex) {
    Companion_getInstance_22();
    layerIndex = layerIndex === VOID ? 0 : layerIndex;
    var $this = this.uem();
    $this.eeo_1 = layerIndex;
    return $this;
  }
  q1t() {
    return Companion_getInstance_22();
  }
  z27() {
    return this.heo();
  }
  ieo(layerIndex) {
    return LayerComponent.geo(layerIndex);
  }
  heo(layerIndex, $super) {
    layerIndex = layerIndex === VOID ? this.eeo_1 : layerIndex;
    return $super === VOID ? this.ieo(layerIndex) : $super.ieo.call(this, layerIndex);
  }
  toString() {
    return 'LayerComponent(layerIndex=' + this.eeo_1 + ')';
  }
  hashCode() {
    return this.eeo_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LayerComponent ? other : THROW_CCE();
    if (!(this.eeo_1 === tmp0_other_with_cast.eeo_1))
      return false;
    return true;
  }
  static feo(seen0, layerIndex, serializationConstructorMarker) {
    Companion_getInstance_22();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_11().ceo_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.eeo_1 = 0;
    else
      $this.eeo_1 = layerIndex;
    return $this;
  }
}
class Companion_13 {}
class $serializer_11 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LayeredSprite.Layer', this, 4);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('position', true);
    tmp0_serialDesc.m16('rgba', true);
    this.jeo_1 = tmp0_serialDesc;
  }
  keo(encoder, value) {
    var tmp0_desc = this.jeo_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.leo_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.meo_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.meo_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.neo_1.equals(PositionComponent.teo())) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance_25(), value.neo_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !value.oeo_1.equals(RgbaComponent.xeo())) {
      tmp1_output.p10(tmp0_desc, 3, $serializer_getInstance_27(), value.oeo_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.keo(encoder, value instanceof Layer ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.jeo_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.jz(tmp0_desc, 2, $serializer_getInstance_25(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.jz(tmp0_desc, 3, $serializer_getInstance_27(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.jz(tmp0_desc, 2, $serializer_getInstance_25(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.jz(tmp0_desc, 3, $serializer_getInstance_27(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return Layer.yeo(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.jeo_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance_25(), $serializer_getInstance_27()];
  }
}
class CloneableData {}
class Layer {
  constructor(name, entity, position, rgba) {
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    position = position === VOID ? PositionComponent.teo() : position;
    rgba = rgba === VOID ? RgbaComponent.xeo() : rgba;
    this.leo_1 = name;
    this.meo_1 = entity;
    this.neo_1 = position;
    this.oeo_1 = rgba;
  }
  z27() {
    return this.zeo(VOID, clone(this.meo_1), this.neo_1.z27(), this.oeo_1.z27());
  }
  aep(name, entity, position, rgba) {
    return new Layer(name, entity, position, rgba);
  }
  zeo(name, entity, position, rgba, $super) {
    name = name === VOID ? this.leo_1 : name;
    entity = entity === VOID ? this.meo_1 : entity;
    position = position === VOID ? this.neo_1 : position;
    rgba = rgba === VOID ? this.oeo_1 : rgba;
    return $super === VOID ? this.aep(name, entity, position, rgba) : $super.aep.call(this, name, entity, position, rgba);
  }
  toString() {
    return 'Layer(name=' + this.leo_1 + ', entity=' + this.meo_1.toString() + ', position=' + this.neo_1.toString() + ', rgba=' + this.oeo_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.leo_1);
    result = imul(result, 31) + this.meo_1.hashCode() | 0;
    result = imul(result, 31) + this.neo_1.hashCode() | 0;
    result = imul(result, 31) + this.oeo_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Layer))
      return false;
    var tmp0_other_with_cast = other instanceof Layer ? other : THROW_CCE();
    if (!(this.leo_1 === tmp0_other_with_cast.leo_1))
      return false;
    if (!this.meo_1.equals(tmp0_other_with_cast.meo_1))
      return false;
    if (!this.neo_1.equals(tmp0_other_with_cast.neo_1))
      return false;
    if (!this.oeo_1.equals(tmp0_other_with_cast.oeo_1))
      return false;
    return true;
  }
  static yeo(seen0, name, entity, position, rgba, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_12().jeo_1);
    }
    var $this = createThis(this);
    $this.leo_1 = name;
    if (0 === (seen0 & 2))
      $this.meo_1 = Companion_getInstance_4().x1s_1;
    else
      $this.meo_1 = entity;
    if (0 === (seen0 & 4))
      $this.neo_1 = PositionComponent.teo();
    else
      $this.neo_1 = position;
    if (0 === (seen0 & 8))
      $this.oeo_1 = RgbaComponent.xeo();
    else
      $this.oeo_1 = rgba;
    return $this;
  }
}
class Companion_14 extends ComponentType {
  constructor() {
    Companion_instance_16 = null;
    super();
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cep_1 = [null, null, null, null, null, null, createSimpleEnumSerializer('korlibs.image.format.ImageAnimation.Direction', values()), null, null, null, null, new ArrayListSerializer($serializer_getInstance_12()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12())];
  }
}
class $serializer_12 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LayeredSprite', this, 13);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('anchorX', true);
    tmp0_serialDesc.m16('anchorY', true);
    tmp0_serialDesc.m16('animation', true);
    tmp0_serialDesc.m16('frameIndex', true);
    tmp0_serialDesc.m16('running', true);
    tmp0_serialDesc.m16('direction', true);
    tmp0_serialDesc.m16('destroyOnAnimationFinished', true);
    tmp0_serialDesc.m16('increment', true);
    tmp0_serialDesc.m16('nextFrameIn', true);
    tmp0_serialDesc.m16('initialized', true);
    tmp0_serialDesc.m16('layerList', true);
    tmp0_serialDesc.m16('layerMap', true);
    this.dep_1 = tmp0_serialDesc;
  }
  eep(encoder, value) {
    var tmp0_desc = this.dep_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_24().cep_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.fep_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.fep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.gep_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.gep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.hep_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.hep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.iep_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, StringSerializer_getInstance(), value.iep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.jep_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 4, value.jep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.kep_1 === false)) {
      tmp1_output.f10(tmp0_desc, 5, value.kep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.lep_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, tmp2_cached[6], value.lep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.mep_1 === false)) {
      tmp1_output.f10(tmp0_desc, 7, value.mep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.nep_1 === -2)) {
      tmp1_output.i10(tmp0_desc, 8, value.nep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !equals(value.oep_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 9, value.oep_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !(value.pep_1 === false)) {
      tmp1_output.f10(tmp0_desc, 10, value.pep_1);
    }
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 11)) {
      tmp = true;
    } else {
      var tmp_0 = value.qep_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 11, tmp2_cached[11], value.qep_1);
    }
    var tmp_1;
    if (tmp1_output.v10(tmp0_desc, 12)) {
      tmp_1 = true;
    } else {
      var tmp_2 = value.rep_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$1 = emptyMap();
      tmp_1 = !equals(tmp_2, tmp$ret$1);
    }
    if (tmp_1) {
      tmp1_output.p10(tmp0_desc, 12, tmp2_cached[12], value.rep_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.eep(encoder, value instanceof LayeredSpriteComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.dep_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = 0;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = false;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.xy(tmp0_desc);
    var tmp18_cached = Companion_getInstance_24().cep_1;
    if (tmp17_input.nz()) {
      tmp4_local0 = tmp17_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.cz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.zy(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.lz(tmp0_desc, 6, tmp18_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.zy(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.ez(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.zy(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.jz(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.jz(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.cz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.zy(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.lz(tmp0_desc, 6, tmp18_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.zy(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.ez(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.zy(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.jz(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.jz(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp17_input.yy(tmp0_desc);
    return LayeredSpriteComponent.sep(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  }
  yu() {
    return this.dep_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_24().cep_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[6]), BooleanSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[11], tmp0_cached[12]];
  }
}
class LayeredSpriteComponent extends CloneableComponent {
  static tep(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap) {
    Companion_getInstance_24();
    name = name === VOID ? '' : name;
    anchorX = anchorX === VOID ? 0.0 : anchorX;
    anchorY = anchorY === VOID ? 0.0 : anchorY;
    animation = animation === VOID ? null : animation;
    frameIndex = frameIndex === VOID ? 0 : frameIndex;
    running = running === VOID ? false : running;
    direction = direction === VOID ? null : direction;
    destroyOnAnimationFinished = destroyOnAnimationFinished === VOID ? false : destroyOnAnimationFinished;
    increment = increment === VOID ? -2 : increment;
    nextFrameIn = nextFrameIn === VOID ? 0.0 : nextFrameIn;
    initialized = initialized === VOID ? false : initialized;
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (layerMap === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = layerMap;
    }
    layerMap = tmp_0;
    var $this = this.uem();
    $this.fep_1 = name;
    $this.gep_1 = anchorX;
    $this.hep_1 = anchorY;
    $this.iep_1 = animation;
    $this.jep_1 = frameIndex;
    $this.kep_1 = running;
    $this.lep_1 = direction;
    $this.mep_1 = destroyOnAnimationFinished;
    $this.nep_1 = increment;
    $this.oep_1 = nextFrameIn;
    $this.pep_1 = initialized;
    $this.qep_1 = layerList;
    $this.rep_1 = layerMap;
    return $this;
  }
  uep(assetStore) {
    this.jep_1 = equals(this.lep_1, Direction_REVERSE_getInstance()) || equals(this.lep_1, Direction_ONCE_REVERSE_getInstance()) ? getAnimationNumberOfFrames(assetStore, this.fep_1, this.iep_1) - 1 | 0 : 0;
  }
  vep(assetStore) {
    this.oep_1 = getAnimationFrameDuration(assetStore, this.fep_1, this.iep_1, this.jep_1);
  }
  wep() {
    var tmp = this;
    var tmp0_subject = this.lep_1;
    var tmp_0;
    switch (tmp0_subject == null ? -1 : tmp0_subject.p3_1) {
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = -1;
        break;
      case 4:
        tmp_0 = 1;
        break;
      case 0:
        tmp_0 = 1;
        break;
      case 1:
        tmp_0 = -1;
        break;
      case -1:
        var message = 'SpriteAnimationFamily: direction shall not be null!';
        throw IllegalStateException.h5(toString_0(message));
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.nep_1 = tmp_0;
  }
  r1t(_this__u8e3s4, entity_0) {
    if (this.pep_1)
      return Unit_instance;
    else
      this.pep_1 = true;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = _this__u8e3s4.y1t_1.e3(name);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var injectable = tmp;
    injectable.p21_1 = true;
    var tmp_0 = injectable.o21_1;
    var assetStore = tmp_0 instanceof AssetStore ? tmp_0 : THROW_CCE();
    if (this.lep_1 == null) {
      this.lep_1 = getAnimationDirection(assetStore, this.fep_1, this.iep_1);
    }
    this.uep(assetStore);
    this.vep(assetStore);
    this.wep();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var map = LinkedHashMap.wc();
    // Inline function 'kotlin.collections.mutableListOf' call
    var list = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = getImageAnimation(assetStore, this.fep_1, this.iep_1).c6n_1.s6l_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.LayeredSpriteComponent.onAdd.<anonymous>' call
      if (!(element.w6l_1.n6l_1 == null)) {
        var layer = new Layer(ensureNotNull(element.w6l_1.n6l_1));
        // Inline function 'kotlin.collections.set' call
        var key = ensureNotNull(element.w6l_1.n6l_1);
        map.k3(key, layer);
        list.h(layer);
      }
    }
    this.rep_1 = map;
    this.qep_1 = list;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.qep_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.components.LayeredSpriteComponent.onAdd.<anonymous>' call
      var tmp_1 = element_0;
      var tmp_2 = "Sprite layer '" + element_0.leo_1 + "' of entity '" + entity_0.m1u_1 + "'";
      tmp_1.meo_1 = entity(_this__u8e3s4, tmp_2, LayeredSpriteComponent$onAdd$lambda(element_0));
      println("create entity '" + element_0.meo_1.m1u_1 + "' for layer '" + element_0.leo_1 + "'");
    }
  }
  xep(_this__u8e3s4) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var newMap = LinkedHashMap.wc();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.qep_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.LayeredSpriteComponent.updateLayerEntities.<anonymous>' call
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      var this_0 = element.meo_1;
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === this_0.m1u_1 || this_1.q1v_1 === this_0.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = this_0.m1u_1;
        // Inline function 'korlibs.korge.fleks.components.LayeredSpriteComponent.updateLayerEntities.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component = element.neo_1;
        var compType = component.q1t();
        $this$configure.f1v_1.h1(this_0.m1u_1).p1s(compType.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(compType.m1t())) {
          var tmp = compType.m1t();
          var tmp_0 = this_2.v1t();
          var tmp_1 = 0;
          var tmp_2 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = null;
            tmp_1 = tmp_1 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
        }
        var tmp_4 = this_2.u1t_1.h1(compType.m1t());
        var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
        holder.l1u(this_0, component);
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component_0 = element.oeo_1;
        var compType_0 = component_0.q1t();
        $this$configure.f1v_1.h1(this_0.m1u_1).p1s(compType_0.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_3 = $this$configure.i1v_1;
        if (this_3.u1t_1.j1s(compType_0.m1t())) {
          var tmp_5 = compType_0.m1t();
          var tmp_6 = this_3.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_3.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_3.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
        }
        var tmp_10 = this_3.u1t_1.h1(compType_0.m1t());
        var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
        holder_0.l1u(this_0, component_0);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(this_0.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element_0 = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element_0.p1w(this_0, compMask);
        }
      }
      // Inline function 'kotlin.collections.set' call
      var key = element.leo_1;
      newMap.k3(key, element);
    }
    this.rep_1 = newMap;
  }
  q1t() {
    return Companion_getInstance_24();
  }
  z27() {
    return this.yep(VOID, VOID, VOID, VOID, VOID, VOID, this.lep_1, VOID, VOID, VOID, VOID, clone_4(this.qep_1), clone_5(this.rep_1));
  }
  em() {
    return this.fep_1;
  }
  fm() {
    return this.gep_1;
  }
  jt() {
    return this.hep_1;
  }
  zep() {
    return this.iep_1;
  }
  aeq() {
    return this.jep_1;
  }
  beq() {
    return this.qep_1;
  }
  ceq(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap) {
    return LayeredSpriteComponent.tep(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap);
  }
  yep(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap, $super) {
    name = name === VOID ? this.fep_1 : name;
    anchorX = anchorX === VOID ? this.gep_1 : anchorX;
    anchorY = anchorY === VOID ? this.hep_1 : anchorY;
    animation = animation === VOID ? this.iep_1 : animation;
    frameIndex = frameIndex === VOID ? this.jep_1 : frameIndex;
    running = running === VOID ? this.kep_1 : running;
    direction = direction === VOID ? this.lep_1 : direction;
    destroyOnAnimationFinished = destroyOnAnimationFinished === VOID ? this.mep_1 : destroyOnAnimationFinished;
    increment = increment === VOID ? this.nep_1 : increment;
    nextFrameIn = nextFrameIn === VOID ? this.oep_1 : nextFrameIn;
    initialized = initialized === VOID ? this.pep_1 : initialized;
    layerList = layerList === VOID ? this.qep_1 : layerList;
    layerMap = layerMap === VOID ? this.rep_1 : layerMap;
    return $super === VOID ? this.ceq(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap) : $super.ceq.call(this, name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap);
  }
  toString() {
    return 'LayeredSpriteComponent(name=' + this.fep_1 + ', anchorX=' + this.gep_1 + ', anchorY=' + this.hep_1 + ', animation=' + this.iep_1 + ', frameIndex=' + this.jep_1 + ', running=' + this.kep_1 + ', direction=' + toString(this.lep_1) + ', destroyOnAnimationFinished=' + this.mep_1 + ', increment=' + this.nep_1 + ', nextFrameIn=' + this.oep_1 + ', initialized=' + this.pep_1 + ', layerList=' + toString_0(this.qep_1) + ', layerMap=' + toString_0(this.rep_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.fep_1);
    result = imul(result, 31) + getNumberHashCode(this.gep_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.hep_1) | 0;
    result = imul(result, 31) + (this.iep_1 == null ? 0 : getStringHashCode(this.iep_1)) | 0;
    result = imul(result, 31) + this.jep_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kep_1) | 0;
    result = imul(result, 31) + (this.lep_1 == null ? 0 : this.lep_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mep_1) | 0;
    result = imul(result, 31) + this.nep_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.oep_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pep_1) | 0;
    result = imul(result, 31) + hashCode(this.qep_1) | 0;
    result = imul(result, 31) + hashCode(this.rep_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayeredSpriteComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LayeredSpriteComponent ? other : THROW_CCE();
    if (!(this.fep_1 === tmp0_other_with_cast.fep_1))
      return false;
    if (!equals(this.gep_1, tmp0_other_with_cast.gep_1))
      return false;
    if (!equals(this.hep_1, tmp0_other_with_cast.hep_1))
      return false;
    if (!(this.iep_1 == tmp0_other_with_cast.iep_1))
      return false;
    if (!(this.jep_1 === tmp0_other_with_cast.jep_1))
      return false;
    if (!(this.kep_1 === tmp0_other_with_cast.kep_1))
      return false;
    if (!equals(this.lep_1, tmp0_other_with_cast.lep_1))
      return false;
    if (!(this.mep_1 === tmp0_other_with_cast.mep_1))
      return false;
    if (!(this.nep_1 === tmp0_other_with_cast.nep_1))
      return false;
    if (!equals(this.oep_1, tmp0_other_with_cast.oep_1))
      return false;
    if (!(this.pep_1 === tmp0_other_with_cast.pep_1))
      return false;
    if (!equals(this.qep_1, tmp0_other_with_cast.qep_1))
      return false;
    if (!equals(this.rep_1, tmp0_other_with_cast.rep_1))
      return false;
    return true;
  }
  static sep(seen0, name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, layerList, layerMap, serializationConstructorMarker) {
    Companion_getInstance_24();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_13().dep_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.fep_1 = '';
    else
      $this.fep_1 = name;
    if (0 === (seen0 & 2))
      $this.gep_1 = 0.0;
    else
      $this.gep_1 = anchorX;
    if (0 === (seen0 & 4))
      $this.hep_1 = 0.0;
    else
      $this.hep_1 = anchorY;
    if (0 === (seen0 & 8))
      $this.iep_1 = null;
    else
      $this.iep_1 = animation;
    if (0 === (seen0 & 16))
      $this.jep_1 = 0;
    else
      $this.jep_1 = frameIndex;
    if (0 === (seen0 & 32))
      $this.kep_1 = false;
    else
      $this.kep_1 = running;
    if (0 === (seen0 & 64))
      $this.lep_1 = null;
    else
      $this.lep_1 = direction;
    if (0 === (seen0 & 128))
      $this.mep_1 = false;
    else
      $this.mep_1 = destroyOnAnimationFinished;
    if (0 === (seen0 & 256))
      $this.nep_1 = -2;
    else
      $this.nep_1 = increment;
    if (0 === (seen0 & 512))
      $this.oep_1 = 0.0;
    else
      $this.oep_1 = nextFrameIn;
    if (0 === (seen0 & 1024))
      $this.pep_1 = false;
    else
      $this.pep_1 = initialized;
    if (0 === (seen0 & 2048)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.qep_1 = emptyList();
    } else
      $this.qep_1 = layerList;
    if (0 === (seen0 & 4096)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0.rep_1 = emptyMap();
    } else
      $this.rep_1 = layerMap;
    return $this;
  }
}
class Companion_15 extends ComponentType {
  constructor() {
    Companion_instance_17 = null;
    super();
    Companion_instance_17 = this;
  }
}
class $serializer_13 {
  constructor() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Layout', this, 4);
    tmp0_serialDesc.m16('centerX', true);
    tmp0_serialDesc.m16('centerY', true);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    this.deq_1 = tmp0_serialDesc;
  }
  eeq(encoder, value) {
    var tmp0_desc = this.deq_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.feq_1 === false)) {
      tmp1_output.f10(tmp0_desc, 0, value.feq_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.geq_1 === false)) {
      tmp1_output.f10(tmp0_desc, 1, value.geq_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.heq_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.heq_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.ieq_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.ieq_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.eeq(encoder, value instanceof LayoutComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.deq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = false;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.zy(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zy(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return LayoutComponent.jeq(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.deq_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class LayoutComponent extends CloneableComponent {
  static keq(centerX, centerY, offsetX, offsetY) {
    Companion_getInstance_25();
    centerX = centerX === VOID ? false : centerX;
    centerY = centerY === VOID ? false : centerY;
    offsetX = offsetX === VOID ? 0.0 : offsetX;
    offsetY = offsetY === VOID ? 0.0 : offsetY;
    var $this = this.uem();
    $this.feq_1 = centerX;
    $this.geq_1 = centerY;
    $this.heq_1 = offsetX;
    $this.ieq_1 = offsetY;
    return $this;
  }
  q1t() {
    return Companion_getInstance_25();
  }
  z27() {
    return this.leq();
  }
  meq(centerX, centerY, offsetX, offsetY) {
    return LayoutComponent.keq(centerX, centerY, offsetX, offsetY);
  }
  leq(centerX, centerY, offsetX, offsetY, $super) {
    centerX = centerX === VOID ? this.feq_1 : centerX;
    centerY = centerY === VOID ? this.geq_1 : centerY;
    offsetX = offsetX === VOID ? this.heq_1 : offsetX;
    offsetY = offsetY === VOID ? this.ieq_1 : offsetY;
    return $super === VOID ? this.meq(centerX, centerY, offsetX, offsetY) : $super.meq.call(this, centerX, centerY, offsetX, offsetY);
  }
  toString() {
    return 'LayoutComponent(centerX=' + this.feq_1 + ', centerY=' + this.geq_1 + ', offsetX=' + this.heq_1 + ', offsetY=' + this.ieq_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.feq_1);
    result = imul(result, 31) + getBooleanHashCode(this.geq_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.heq_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ieq_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayoutComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LayoutComponent ? other : THROW_CCE();
    if (!(this.feq_1 === tmp0_other_with_cast.feq_1))
      return false;
    if (!(this.geq_1 === tmp0_other_with_cast.geq_1))
      return false;
    if (!equals(this.heq_1, tmp0_other_with_cast.heq_1))
      return false;
    if (!equals(this.ieq_1, tmp0_other_with_cast.ieq_1))
      return false;
    return true;
  }
  static jeq(seen0, centerX, centerY, offsetX, offsetY, serializationConstructorMarker) {
    Companion_getInstance_25();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_14().deq_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.feq_1 = false;
    else
      $this.feq_1 = centerX;
    if (0 === (seen0 & 2))
      $this.geq_1 = false;
    else
      $this.geq_1 = centerY;
    if (0 === (seen0 & 4))
      $this.heq_1 = 0.0;
    else
      $this.heq_1 = offsetX;
    if (0 === (seen0 & 8))
      $this.ieq_1 = 0.0;
    else
      $this.ieq_1 = offsetY;
    return $this;
  }
}
class Companion_16 extends ComponentType {
  constructor() {
    Companion_instance_18 = null;
    super();
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.oeq_1 = [null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
}
class $serializer_14 {
  constructor() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LevelMap', this, 2);
    tmp0_serialDesc.m16('levelName', true);
    tmp0_serialDesc.m16('layerNames', true);
    this.peq_1 = tmp0_serialDesc;
  }
  qeq(encoder, value) {
    var tmp0_desc = this.peq_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_26().oeq_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.req_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.req_1);
    }
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 1)) {
      tmp = true;
    } else {
      var tmp_0 = value.seq_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.seq_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.qeq(encoder, value instanceof LevelMapComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.peq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    var tmp7_cached = Companion_getInstance_26().oeq_1;
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return LevelMapComponent.teq(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.peq_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_26().oeq_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1]];
  }
}
class LevelMapComponent extends CloneableComponent {
  static ueq(levelName, layerNames) {
    Companion_getInstance_26();
    levelName = levelName === VOID ? '' : levelName;
    var tmp;
    if (layerNames === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = layerNames;
    }
    layerNames = tmp;
    var $this = this.uem();
    $this.req_1 = levelName;
    $this.seq_1 = layerNames;
    return $this;
  }
  q1t() {
    return Companion_getInstance_26();
  }
  z27() {
    return LevelMapComponent.ueq(this.req_1, clone_6(this.seq_1));
  }
  em() {
    return this.req_1;
  }
  fm() {
    return this.seq_1;
  }
  toString() {
    return 'LevelMapComponent(levelName=' + this.req_1 + ', layerNames=' + toString_0(this.seq_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.req_1);
    result = imul(result, 31) + hashCode(this.seq_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelMapComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LevelMapComponent ? other : THROW_CCE();
    if (!(this.req_1 === tmp0_other_with_cast.req_1))
      return false;
    if (!equals(this.seq_1, tmp0_other_with_cast.seq_1))
      return false;
    return true;
  }
  static teq(seen0, levelName, layerNames, serializationConstructorMarker) {
    Companion_getInstance_26();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_15().peq_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.req_1 = '';
    else
      $this.req_1 = levelName;
    if (0 === (seen0 & 2)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.seq_1 = emptyList();
    } else
      $this.seq_1 = layerNames;
    return $this;
  }
}
class Companion_17 extends ComponentType {
  constructor() {
    Companion_instance_19 = null;
    super();
    Companion_instance_19 = this;
  }
}
class $serializer_15 {
  constructor() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LifeCycle', this, 1);
    tmp0_serialDesc.m16('healthCounter', true);
    this.veq_1 = tmp0_serialDesc;
  }
  weq(encoder, value) {
    var tmp0_desc = this.veq_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.xeq_1 === 100)) {
      tmp1_output.i10(tmp0_desc, 0, value.xeq_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.weq(encoder, value instanceof LifeCycleComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.veq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return LifeCycleComponent.yeq(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.veq_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class LifeCycleComponent extends CloneableComponent {
  static zeq(healthCounter) {
    Companion_getInstance_27();
    healthCounter = healthCounter === VOID ? 100 : healthCounter;
    var $this = this.uem();
    $this.xeq_1 = healthCounter;
    return $this;
  }
  q1t() {
    return Companion_getInstance_27();
  }
  z27() {
    return this.aer();
  }
  ieo(healthCounter) {
    return LifeCycleComponent.zeq(healthCounter);
  }
  aer(healthCounter, $super) {
    healthCounter = healthCounter === VOID ? this.xeq_1 : healthCounter;
    return $super === VOID ? this.ieo(healthCounter) : $super.ieo.call(this, healthCounter);
  }
  toString() {
    return 'LifeCycleComponent(healthCounter=' + this.xeq_1 + ')';
  }
  hashCode() {
    return this.xeq_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LifeCycleComponent))
      return false;
    var tmp0_other_with_cast = other instanceof LifeCycleComponent ? other : THROW_CCE();
    if (!(this.xeq_1 === tmp0_other_with_cast.xeq_1))
      return false;
    return true;
  }
  static yeq(seen0, healthCounter, serializationConstructorMarker) {
    Companion_getInstance_27();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_16().veq_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.xeq_1 = 100;
    else
      $this.xeq_1 = healthCounter;
    return $this;
  }
}
class Companion_18 extends ComponentType {
  constructor() {
    Companion_instance_20 = null;
    super();
    Companion_instance_20 = this;
  }
}
class $serializer_16 {
  constructor() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Motion', this, 4);
    tmp0_serialDesc.m16('accelX', true);
    tmp0_serialDesc.m16('accelY', true);
    tmp0_serialDesc.m16('velocityX', true);
    tmp0_serialDesc.m16('velocityY', true);
    this.ber_1 = tmp0_serialDesc;
  }
  cer(encoder, value) {
    var tmp0_desc = this.ber_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.der_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.der_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.eer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.eer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.fer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.fer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.ger_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.ger_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.cer(encoder, value instanceof MotionComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ber_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return MotionComponent.her(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.ber_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class MotionComponent extends CloneableComponent {
  static ier(accelX, accelY, velocityX, velocityY) {
    Companion_getInstance_28();
    accelX = accelX === VOID ? 0.0 : accelX;
    accelY = accelY === VOID ? 0.0 : accelY;
    velocityX = velocityX === VOID ? 0.0 : velocityX;
    velocityY = velocityY === VOID ? 0.0 : velocityY;
    var $this = this.uem();
    $this.der_1 = accelX;
    $this.eer_1 = accelY;
    $this.fer_1 = velocityX;
    $this.ger_1 = velocityY;
    return $this;
  }
  q1t() {
    return Companion_getInstance_28();
  }
  z27() {
    return this.jer();
  }
  jt() {
    return this.fer_1;
  }
  zep() {
    return this.ger_1;
  }
  ker(accelX, accelY, velocityX, velocityY) {
    return MotionComponent.ier(accelX, accelY, velocityX, velocityY);
  }
  jer(accelX, accelY, velocityX, velocityY, $super) {
    accelX = accelX === VOID ? this.der_1 : accelX;
    accelY = accelY === VOID ? this.eer_1 : accelY;
    velocityX = velocityX === VOID ? this.fer_1 : velocityX;
    velocityY = velocityY === VOID ? this.ger_1 : velocityY;
    return $super === VOID ? this.ker(accelX, accelY, velocityX, velocityY) : $super.ker.call(this, accelX, accelY, velocityX, velocityY);
  }
  toString() {
    return 'MotionComponent(accelX=' + this.der_1 + ', accelY=' + this.eer_1 + ', velocityX=' + this.fer_1 + ', velocityY=' + this.ger_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.der_1);
    result = imul(result, 31) + getNumberHashCode(this.eer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ger_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MotionComponent))
      return false;
    var tmp0_other_with_cast = other instanceof MotionComponent ? other : THROW_CCE();
    if (!equals(this.der_1, tmp0_other_with_cast.der_1))
      return false;
    if (!equals(this.eer_1, tmp0_other_with_cast.eer_1))
      return false;
    if (!equals(this.fer_1, tmp0_other_with_cast.fer_1))
      return false;
    if (!equals(this.ger_1, tmp0_other_with_cast.ger_1))
      return false;
    return true;
  }
  static her(seen0, accelX, accelY, velocityX, velocityY, serializationConstructorMarker) {
    Companion_getInstance_28();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_17().ber_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.der_1 = 0.0;
    else
      $this.der_1 = accelX;
    if (0 === (seen0 & 2))
      $this.eer_1 = 0.0;
    else
      $this.eer_1 = accelY;
    if (0 === (seen0 & 4))
      $this.fer_1 = 0.0;
    else
      $this.fer_1 = velocityX;
    if (0 === (seen0 & 8))
      $this.ger_1 = 0.0;
    else
      $this.ger_1 = velocityY;
    return $this;
  }
}
class Companion_19 extends ComponentType {
  constructor() {
    Companion_instance_21 = null;
    super();
    Companion_instance_21 = this;
  }
}
class $serializer_17 {
  constructor() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('NinePatchComponent', this, 3);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('width', true);
    tmp0_serialDesc.m16('height', true);
    this.ler_1 = tmp0_serialDesc;
  }
  mer(encoder, value) {
    var tmp0_desc = this.ler_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.ner_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.ner_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.oer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.oer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.per_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.per_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.mer(encoder, value instanceof NinePatchComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ler_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return NinePatchComponent.qer(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.ler_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class NinePatchComponent extends CloneableComponent {
  static rer(name, width, height) {
    Companion_getInstance_29();
    name = name === VOID ? '' : name;
    width = width === VOID ? 0.0 : width;
    height = height === VOID ? 0.0 : height;
    var $this = this.uem();
    $this.ner_1 = name;
    $this.oer_1 = width;
    $this.per_1 = height;
    return $this;
  }
  q1t() {
    return Companion_getInstance_29();
  }
  z27() {
    return this.ser();
  }
  em() {
    return this.ner_1;
  }
  fm() {
    return this.oer_1;
  }
  jt() {
    return this.per_1;
  }
  ter(name, width, height) {
    return NinePatchComponent.rer(name, width, height);
  }
  ser(name, width, height, $super) {
    name = name === VOID ? this.ner_1 : name;
    width = width === VOID ? this.oer_1 : width;
    height = height === VOID ? this.per_1 : height;
    return $super === VOID ? this.ter(name, width, height) : $super.ter.call(this, name, width, height);
  }
  toString() {
    return 'NinePatchComponent(name=' + this.ner_1 + ', width=' + this.oer_1 + ', height=' + this.per_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ner_1);
    result = imul(result, 31) + getNumberHashCode(this.oer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.per_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NinePatchComponent))
      return false;
    var tmp0_other_with_cast = other instanceof NinePatchComponent ? other : THROW_CCE();
    if (!(this.ner_1 === tmp0_other_with_cast.ner_1))
      return false;
    if (!equals(this.oer_1, tmp0_other_with_cast.oer_1))
      return false;
    if (!equals(this.per_1, tmp0_other_with_cast.per_1))
      return false;
    return true;
  }
  static qer(seen0, name, width, height, serializationConstructorMarker) {
    Companion_getInstance_29();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_18().ler_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.ner_1 = '';
    else
      $this.ner_1 = name;
    if (0 === (seen0 & 2))
      $this.oer_1 = 0.0;
    else
      $this.oer_1 = width;
    if (0 === (seen0 & 4))
      $this.per_1 = 0.0;
    else
      $this.per_1 = height;
    return $this;
  }
}
class Companion_20 extends ComponentType {
  constructor() {
    Companion_instance_22 = null;
    super();
    Companion_instance_22 = this;
  }
}
class $serializer_18 {
  constructor() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('NoisyMove', this, 14);
    tmp0_serialDesc.m16('triggerVariance', true);
    tmp0_serialDesc.m16('terminateVariance', true);
    tmp0_serialDesc.m16('interval', true);
    tmp0_serialDesc.m16('intervalVariance', true);
    tmp0_serialDesc.m16('xTarget', true);
    tmp0_serialDesc.m16('yTarget', true);
    tmp0_serialDesc.m16('xVariance', true);
    tmp0_serialDesc.m16('yVariance', true);
    tmp0_serialDesc.m16('triggered', true);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('timeProgress', true);
    tmp0_serialDesc.m16('waitTime', true);
    tmp0_serialDesc.m16('initialized', true);
    this.uer_1 = tmp0_serialDesc;
  }
  ver(encoder, value) {
    var tmp0_desc = this.uer_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.wer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.wer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.xer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.xer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.yer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.yer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.zer_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.zer_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.aes_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.aes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.bes_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.bes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !equals(value.ces_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 6, value.ces_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.des_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 7, value.des_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.ees_1 === false)) {
      tmp1_output.f10(tmp0_desc, 8, value.ees_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !equals(value.fes_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 9, value.fes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !equals(value.ges_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 10, value.ges_1);
    }
    if (tmp1_output.v10(tmp0_desc, 11) ? true : !equals(value.hes_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 11, value.hes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 12) ? true : !equals(value.ies_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 12, value.ies_1);
    }
    if (tmp1_output.v10(tmp0_desc, 13) ? true : !(value.jes_1 === false)) {
      tmp1_output.f10(tmp0_desc, 13, value.jes_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ver(encoder, value instanceof NoisyMoveComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.uer_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = 0.0;
    var tmp12_local8 = false;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = false;
    var tmp18_input = decoder.xy(tmp0_desc);
    if (tmp18_input.nz()) {
      tmp4_local0 = tmp18_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp18_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp18_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp18_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp18_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp18_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp18_input.ez(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp18_input.ez(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp18_input.zy(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp18_input.ez(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp18_input.ez(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp18_input.ez(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp18_input.ez(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp18_input.zy(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp18_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp18_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp18_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp18_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp18_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp18_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp18_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp18_input.ez(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp18_input.ez(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp18_input.zy(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp18_input.ez(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp18_input.ez(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp18_input.ez(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp18_input.ez(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp18_input.zy(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp18_input.yy(tmp0_desc);
    return NoisyMoveComponent.kes(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
  }
  yu() {
    return this.uer_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class NoisyMoveComponent extends CloneableComponent {
  static les(triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized) {
    Companion_getInstance_30();
    triggerVariance = triggerVariance === VOID ? 0.0 : triggerVariance;
    terminateVariance = terminateVariance === VOID ? 0.0 : terminateVariance;
    interval = interval === VOID ? 0.0 : interval;
    intervalVariance = intervalVariance === VOID ? 0.0 : intervalVariance;
    xTarget = xTarget === VOID ? 0.0 : xTarget;
    yTarget = yTarget === VOID ? 0.0 : yTarget;
    xVariance = xVariance === VOID ? 0.0 : xVariance;
    yVariance = yVariance === VOID ? 0.0 : yVariance;
    triggered = triggered === VOID ? false : triggered;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    timeProgress = timeProgress === VOID ? 0.0 : timeProgress;
    waitTime = waitTime === VOID ? 0.0 : waitTime;
    initialized = initialized === VOID ? false : initialized;
    var $this = this.uem();
    $this.wer_1 = triggerVariance;
    $this.xer_1 = terminateVariance;
    $this.yer_1 = interval;
    $this.zer_1 = intervalVariance;
    $this.aes_1 = xTarget;
    $this.bes_1 = yTarget;
    $this.ces_1 = xVariance;
    $this.des_1 = yVariance;
    $this.ees_1 = triggered;
    $this.fes_1 = x;
    $this.ges_1 = y;
    $this.hes_1 = timeProgress;
    $this.ies_1 = waitTime;
    $this.jes_1 = initialized;
    return $this;
  }
  q1t() {
    return Companion_getInstance_30();
  }
  r1t(_this__u8e3s4, entity) {
    if (this.jes_1)
      return Unit_instance;
    else
      this.jes_1 = true;
    this.hes_1 = 0.0;
    this.ies_1 = this.yer_1 + (!(this.zer_1 === 0.0) ? random_0(rangeTo(-this.zer_1, this.zer_1)) : 0.0);
    var startX = this.fes_1;
    var startY = this.ges_1;
    var endX = this.aes_1 + (!(this.ces_1 === 0.0) ? random_0(rangeTo(-this.ces_1, this.ces_1)) : 0.0);
    var endY = this.bes_1 + (!(this.des_1 === 0.0) ? random_0(rangeTo(-this.des_1, this.des_1)) : 0.0);
  }
  z27() {
    return this.mes();
  }
  nes(triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized) {
    return NoisyMoveComponent.les(triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized);
  }
  mes(triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized, $super) {
    triggerVariance = triggerVariance === VOID ? this.wer_1 : triggerVariance;
    terminateVariance = terminateVariance === VOID ? this.xer_1 : terminateVariance;
    interval = interval === VOID ? this.yer_1 : interval;
    intervalVariance = intervalVariance === VOID ? this.zer_1 : intervalVariance;
    xTarget = xTarget === VOID ? this.aes_1 : xTarget;
    yTarget = yTarget === VOID ? this.bes_1 : yTarget;
    xVariance = xVariance === VOID ? this.ces_1 : xVariance;
    yVariance = yVariance === VOID ? this.des_1 : yVariance;
    triggered = triggered === VOID ? this.ees_1 : triggered;
    x = x === VOID ? this.fes_1 : x;
    y = y === VOID ? this.ges_1 : y;
    timeProgress = timeProgress === VOID ? this.hes_1 : timeProgress;
    waitTime = waitTime === VOID ? this.ies_1 : waitTime;
    initialized = initialized === VOID ? this.jes_1 : initialized;
    return $super === VOID ? this.nes(triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized) : $super.nes.call(this, triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized);
  }
  toString() {
    return 'NoisyMoveComponent(triggerVariance=' + this.wer_1 + ', terminateVariance=' + this.xer_1 + ', interval=' + this.yer_1 + ', intervalVariance=' + this.zer_1 + ', xTarget=' + this.aes_1 + ', yTarget=' + this.bes_1 + ', xVariance=' + this.ces_1 + ', yVariance=' + this.des_1 + ', triggered=' + this.ees_1 + ', x=' + this.fes_1 + ', y=' + this.ges_1 + ', timeProgress=' + this.hes_1 + ', waitTime=' + this.ies_1 + ', initialized=' + this.jes_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.wer_1);
    result = imul(result, 31) + getNumberHashCode(this.xer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zer_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.aes_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bes_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ces_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.des_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ees_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.fes_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ges_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.hes_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ies_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jes_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NoisyMoveComponent))
      return false;
    var tmp0_other_with_cast = other instanceof NoisyMoveComponent ? other : THROW_CCE();
    if (!equals(this.wer_1, tmp0_other_with_cast.wer_1))
      return false;
    if (!equals(this.xer_1, tmp0_other_with_cast.xer_1))
      return false;
    if (!equals(this.yer_1, tmp0_other_with_cast.yer_1))
      return false;
    if (!equals(this.zer_1, tmp0_other_with_cast.zer_1))
      return false;
    if (!equals(this.aes_1, tmp0_other_with_cast.aes_1))
      return false;
    if (!equals(this.bes_1, tmp0_other_with_cast.bes_1))
      return false;
    if (!equals(this.ces_1, tmp0_other_with_cast.ces_1))
      return false;
    if (!equals(this.des_1, tmp0_other_with_cast.des_1))
      return false;
    if (!(this.ees_1 === tmp0_other_with_cast.ees_1))
      return false;
    if (!equals(this.fes_1, tmp0_other_with_cast.fes_1))
      return false;
    if (!equals(this.ges_1, tmp0_other_with_cast.ges_1))
      return false;
    if (!equals(this.hes_1, tmp0_other_with_cast.hes_1))
      return false;
    if (!equals(this.ies_1, tmp0_other_with_cast.ies_1))
      return false;
    if (!(this.jes_1 === tmp0_other_with_cast.jes_1))
      return false;
    return true;
  }
  static kes(seen0, triggerVariance, terminateVariance, interval, intervalVariance, xTarget, yTarget, xVariance, yVariance, triggered, x, y, timeProgress, waitTime, initialized, serializationConstructorMarker) {
    Companion_getInstance_30();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_19().uer_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.wer_1 = 0.0;
    else
      $this.wer_1 = triggerVariance;
    if (0 === (seen0 & 2))
      $this.xer_1 = 0.0;
    else
      $this.xer_1 = terminateVariance;
    if (0 === (seen0 & 4))
      $this.yer_1 = 0.0;
    else
      $this.yer_1 = interval;
    if (0 === (seen0 & 8))
      $this.zer_1 = 0.0;
    else
      $this.zer_1 = intervalVariance;
    if (0 === (seen0 & 16))
      $this.aes_1 = 0.0;
    else
      $this.aes_1 = xTarget;
    if (0 === (seen0 & 32))
      $this.bes_1 = 0.0;
    else
      $this.bes_1 = yTarget;
    if (0 === (seen0 & 64))
      $this.ces_1 = 0.0;
    else
      $this.ces_1 = xVariance;
    if (0 === (seen0 & 128))
      $this.des_1 = 0.0;
    else
      $this.des_1 = yVariance;
    if (0 === (seen0 & 256))
      $this.ees_1 = false;
    else
      $this.ees_1 = triggered;
    if (0 === (seen0 & 512))
      $this.fes_1 = 0.0;
    else
      $this.fes_1 = x;
    if (0 === (seen0 & 1024))
      $this.ges_1 = 0.0;
    else
      $this.ges_1 = y;
    if (0 === (seen0 & 2048))
      $this.hes_1 = 0.0;
    else
      $this.hes_1 = timeProgress;
    if (0 === (seen0 & 4096))
      $this.ies_1 = 0.0;
    else
      $this.ies_1 = waitTime;
    if (0 === (seen0 & 8192))
      $this.jes_1 = false;
    else
      $this.jes_1 = initialized;
    return $this;
  }
}
class Companion_21 {}
class $serializer_19 {
  constructor() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Point', this, 2);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    this.oes_1 = tmp0_serialDesc;
  }
  pes(encoder, value) {
    var tmp0_desc = this.oes_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.qes_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.qes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.res_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.res_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.pes(encoder, value instanceof Point ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.oes_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return Point.ses(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.oes_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class Point {
  constructor(x, y) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    this.qes_1 = x;
    this.res_1 = y;
  }
  z27() {
    return this.tes();
  }
  ues(x, y) {
    return new Point(x, y);
  }
  tes(x, y, $super) {
    x = x === VOID ? this.qes_1 : x;
    y = y === VOID ? this.res_1 : y;
    return $super === VOID ? this.ues(x, y) : $super.ues.call(this, x, y);
  }
  toString() {
    return 'Point(x=' + this.qes_1 + ', y=' + this.res_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.qes_1);
    result = imul(result, 31) + getNumberHashCode(this.res_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Point))
      return false;
    var tmp0_other_with_cast = other instanceof Point ? other : THROW_CCE();
    if (!equals(this.qes_1, tmp0_other_with_cast.qes_1))
      return false;
    if (!equals(this.res_1, tmp0_other_with_cast.res_1))
      return false;
    return true;
  }
  static ses(seen0, x, y, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_20().oes_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.qes_1 = 0.0;
    else
      $this.qes_1 = x;
    if (0 === (seen0 & 2))
      $this.res_1 = 0.0;
    else
      $this.res_1 = y;
    return $this;
  }
}
class Companion_22 extends ComponentType {
  constructor() {
    Companion_instance_24 = null;
    super();
    Companion_instance_24 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.wes_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), new ArrayListSerializer($serializer_getInstance_20()))];
  }
}
class $serializer_20 {
  constructor() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OffsetByFrameIndex', this, 2);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('mapOfOffsetLists', true);
    this.xes_1 = tmp0_serialDesc;
  }
  yes(encoder, value) {
    var tmp0_desc = this.xes_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_32().wes_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !value.zes_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 0, $serializer_getInstance(), value.zes_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.aet_1, emptyMap())) {
      tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.aet_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yes(encoder, value instanceof OffsetByFrameIndexComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xes_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    var tmp7_cached = Companion_getInstance_32().wes_1;
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return OffsetByFrameIndexComponent.bet(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.xes_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_32().wes_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), tmp0_cached[1]];
  }
}
class OffsetByFrameIndexComponent extends CloneableComponent {
  static cet(entity, mapOfOffsetLists) {
    Companion_getInstance_32();
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    mapOfOffsetLists = mapOfOffsetLists === VOID ? emptyMap() : mapOfOffsetLists;
    var $this = this.uem();
    $this.zes_1 = entity;
    $this.aet_1 = mapOfOffsetLists;
    return $this;
  }
  q1t() {
    return Companion_getInstance_32();
  }
  z27() {
    return this.det(clone(this.zes_1), clone_0(this.aet_1));
  }
  det(entity, mapOfOffsetLists) {
    return OffsetByFrameIndexComponent.cet(entity, mapOfOffsetLists);
  }
  toString() {
    return 'OffsetByFrameIndexComponent(entity=' + this.zes_1.toString() + ', mapOfOffsetLists=' + toString_0(this.aet_1) + ')';
  }
  hashCode() {
    var result = this.zes_1.hashCode();
    result = imul(result, 31) + hashCode(this.aet_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OffsetByFrameIndexComponent))
      return false;
    var tmp0_other_with_cast = other instanceof OffsetByFrameIndexComponent ? other : THROW_CCE();
    if (!this.zes_1.equals(tmp0_other_with_cast.zes_1))
      return false;
    if (!equals(this.aet_1, tmp0_other_with_cast.aet_1))
      return false;
    return true;
  }
  static bet(seen0, entity, mapOfOffsetLists, serializationConstructorMarker) {
    Companion_getInstance_32();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_21().xes_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.zes_1 = Companion_getInstance_4().x1s_1;
    else
      $this.zes_1 = entity;
    if (0 === (seen0 & 2))
      $this.aet_1 = emptyMap();
    else
      $this.aet_1 = mapOfOffsetLists;
    return $this;
  }
}
class Companion_23 {}
class $serializer_21 {
  constructor() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Parallax.Layer', this, 3);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('position', true);
    tmp0_serialDesc.m16('rgba', true);
    this.eet_1 = tmp0_serialDesc;
  }
  fet(encoder, value) {
    var tmp0_desc = this.eet_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !value.get_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 0, $serializer_getInstance(), value.get_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.het_1.equals(PositionComponent.teo())) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance_25(), value.het_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.iet_1.equals(RgbaComponent.xeo())) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance_27(), value.iet_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.fet(encoder, value instanceof Layer_0 ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.eet_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, $serializer_getInstance_25(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, $serializer_getInstance_27(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.jz(tmp0_desc, 1, $serializer_getInstance_25(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, $serializer_getInstance_27(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return Layer_0.jet(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.eet_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_25(), $serializer_getInstance_27()];
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ket_1 = [null, null, null, new ArrayListSerializer(FloatSerializer_getInstance()), new ArrayListSerializer(FloatSerializer_getInstance()), new ArrayListSerializer(FloatSerializer_getInstance())];
  }
}
class $serializer_22 {
  constructor() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Parallax.Plane', this, 6);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('position', true);
    tmp0_serialDesc.m16('rgba', true);
    tmp0_serialDesc.m16('linePositions', true);
    tmp0_serialDesc.m16('attachedLayersRearPositions', true);
    tmp0_serialDesc.m16('attachedLayersFrontPositions', true);
    this.let_1 = tmp0_serialDesc;
  }
  met(encoder, value) {
    var tmp0_desc = this.let_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_34().ket_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !value.net_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 0, $serializer_getInstance(), value.net_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.oet_1.equals(PositionComponent.teo())) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance_25(), value.oet_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.pet_1.equals(RgbaComponent.xeo())) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance_27(), value.pet_1);
    }
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 3)) {
      tmp = true;
    } else {
      var tmp_0 = value.qet_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$0 = ArrayList.z();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.qet_1);
    }
    var tmp_1;
    if (tmp1_output.v10(tmp0_desc, 4)) {
      tmp_1 = true;
    } else {
      var tmp_2 = value.ret_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$1 = ArrayList.z();
      tmp_1 = !equals(tmp_2, tmp$ret$1);
    }
    if (tmp_1) {
      tmp1_output.p10(tmp0_desc, 4, tmp2_cached[4], value.ret_1);
    }
    var tmp_3;
    if (tmp1_output.v10(tmp0_desc, 5)) {
      tmp_3 = true;
    } else {
      var tmp_4 = value.set_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$2 = ArrayList.z();
      tmp_3 = !equals(tmp_4, tmp$ret$2);
    }
    if (tmp_3) {
      tmp1_output.p10(tmp0_desc, 5, tmp2_cached[5], value.set_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.met(encoder, value instanceof Plane ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.let_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_34().ket_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, $serializer_getInstance_25(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance_27(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.jz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, $serializer_getInstance_25(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance_27(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.jz(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.jz(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return Plane.tet(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.let_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_34().ket_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_25(), $serializer_getInstance_27(), tmp0_cached[3], tmp0_cached[4], tmp0_cached[5]];
  }
}
class Layer_0 {
  constructor(entity, position, rgba) {
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    position = position === VOID ? PositionComponent.teo() : position;
    rgba = rgba === VOID ? RgbaComponent.xeo() : rgba;
    this.get_1 = entity;
    this.het_1 = position;
    this.iet_1 = rgba;
  }
  z27() {
    return new Layer_0(clone(this.get_1), this.het_1.z27(), this.iet_1.z27());
  }
  toString() {
    return 'Layer(entity=' + this.get_1.toString() + ', position=' + this.het_1.toString() + ', rgba=' + this.iet_1.toString() + ')';
  }
  hashCode() {
    var result = this.get_1.hashCode();
    result = imul(result, 31) + this.het_1.hashCode() | 0;
    result = imul(result, 31) + this.iet_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Layer_0))
      return false;
    var tmp0_other_with_cast = other instanceof Layer_0 ? other : THROW_CCE();
    if (!this.get_1.equals(tmp0_other_with_cast.get_1))
      return false;
    if (!this.het_1.equals(tmp0_other_with_cast.het_1))
      return false;
    if (!this.iet_1.equals(tmp0_other_with_cast.iet_1))
      return false;
    return true;
  }
  static jet(seen0, entity, position, rgba, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_22().eet_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.get_1 = Companion_getInstance_4().x1s_1;
    else
      $this.get_1 = entity;
    if (0 === (seen0 & 2))
      $this.het_1 = PositionComponent.teo();
    else
      $this.het_1 = position;
    if (0 === (seen0 & 4))
      $this.iet_1 = RgbaComponent.xeo();
    else
      $this.iet_1 = rgba;
    return $this;
  }
}
class Plane {
  constructor(entity, position, rgba, linePositions, attachedLayersRearPositions, attachedLayersFrontPositions) {
    Companion_getInstance_34();
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    position = position === VOID ? PositionComponent.teo() : position;
    rgba = rgba === VOID ? RgbaComponent.xeo() : rgba;
    var tmp;
    if (linePositions === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList.z();
    } else {
      tmp = linePositions;
    }
    linePositions = tmp;
    var tmp_0;
    if (attachedLayersRearPositions === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0 = ArrayList.z();
    } else {
      tmp_0 = attachedLayersRearPositions;
    }
    attachedLayersRearPositions = tmp_0;
    var tmp_1;
    if (attachedLayersFrontPositions === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_1 = ArrayList.z();
    } else {
      tmp_1 = attachedLayersFrontPositions;
    }
    attachedLayersFrontPositions = tmp_1;
    this.net_1 = entity;
    this.oet_1 = position;
    this.pet_1 = rgba;
    this.qet_1 = linePositions;
    this.ret_1 = attachedLayersRearPositions;
    this.set_1 = attachedLayersFrontPositions;
  }
  z27() {
    return new Plane(clone(this.net_1), this.oet_1.z27(), this.pet_1.z27(), toMutableList(this.qet_1), toMutableList(this.ret_1), toMutableList(this.set_1));
  }
  toString() {
    return 'Plane(entity=' + this.net_1.toString() + ', position=' + this.oet_1.toString() + ', rgba=' + this.pet_1.toString() + ', linePositions=' + toString_0(this.qet_1) + ', attachedLayersRearPositions=' + toString_0(this.ret_1) + ', attachedLayersFrontPositions=' + toString_0(this.set_1) + ')';
  }
  hashCode() {
    var result = this.net_1.hashCode();
    result = imul(result, 31) + this.oet_1.hashCode() | 0;
    result = imul(result, 31) + this.pet_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.qet_1) | 0;
    result = imul(result, 31) + hashCode(this.ret_1) | 0;
    result = imul(result, 31) + hashCode(this.set_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Plane))
      return false;
    var tmp0_other_with_cast = other instanceof Plane ? other : THROW_CCE();
    if (!this.net_1.equals(tmp0_other_with_cast.net_1))
      return false;
    if (!this.oet_1.equals(tmp0_other_with_cast.oet_1))
      return false;
    if (!this.pet_1.equals(tmp0_other_with_cast.pet_1))
      return false;
    if (!equals(this.qet_1, tmp0_other_with_cast.qet_1))
      return false;
    if (!equals(this.ret_1, tmp0_other_with_cast.ret_1))
      return false;
    if (!equals(this.set_1, tmp0_other_with_cast.set_1))
      return false;
    return true;
  }
  static tet(seen0, entity, position, rgba, linePositions, attachedLayersRearPositions, attachedLayersFrontPositions, serializationConstructorMarker) {
    Companion_getInstance_34();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_23().let_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.net_1 = Companion_getInstance_4().x1s_1;
    else
      $this.net_1 = entity;
    if (0 === (seen0 & 2))
      $this.oet_1 = PositionComponent.teo();
    else
      $this.oet_1 = position;
    if (0 === (seen0 & 4))
      $this.pet_1 = RgbaComponent.xeo();
    else
      $this.pet_1 = rgba;
    if (0 === (seen0 & 8)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp.qet_1 = ArrayList.z();
    } else
      $this.qet_1 = linePositions;
    if (0 === (seen0 & 16)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_0.ret_1 = ArrayList.z();
    } else
      $this.ret_1 = attachedLayersRearPositions;
    if (0 === (seen0 & 32)) {
      var tmp_1 = $this;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_1.set_1 = ArrayList.z();
    } else
      $this.set_1 = attachedLayersFrontPositions;
    return $this;
  }
}
class Companion_25 extends ComponentType {
  constructor() {
    Companion_instance_27 = null;
    super();
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vet_1 = [null, new ArrayListSerializer($serializer_getInstance_22()), null, new ArrayListSerializer($serializer_getInstance_22()), null];
  }
}
class $serializer_23 {
  constructor() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Parallax', this, 5);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('backgroundLayers', true);
    tmp0_serialDesc.m16('parallaxPlane', true);
    tmp0_serialDesc.m16('foregroundLayers', true);
    tmp0_serialDesc.m16('initialized', true);
    this.wet_1 = tmp0_serialDesc;
  }
  xet(encoder, value) {
    var tmp0_desc = this.wet_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_35().vet_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.yet_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.yet_1);
    }
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 1)) {
      tmp = true;
    } else {
      var tmp_0 = value.zet_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.zet_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.aeu_1.equals(new Plane())) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance_23(), value.aeu_1);
    }
    var tmp_1;
    if (tmp1_output.v10(tmp0_desc, 3)) {
      tmp_1 = true;
    } else {
      var tmp_2 = value.beu_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$1 = emptyList();
      tmp_1 = !equals(tmp_2, tmp$ret$1);
    }
    if (tmp_1) {
      tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.beu_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.ceu_1 === false)) {
      tmp1_output.f10(tmp0_desc, 4, value.ceu_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.xet(encoder, value instanceof ParallaxComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.wet_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.xy(tmp0_desc);
    var tmp10_cached = Companion_getInstance_35().vet_1;
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, $serializer_getInstance_23(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.jz(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, $serializer_getInstance_23(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.jz(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return ParallaxComponent.deu(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.wet_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_35().vet_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], $serializer_getInstance_23(), tmp0_cached[3], BooleanSerializer_getInstance()];
  }
}
class ParallaxComponent extends CloneableComponent {
  static eeu(name, backgroundLayers, parallaxPlane, foregroundLayers, initialized) {
    Companion_getInstance_35();
    name = name === VOID ? '' : name;
    var tmp;
    if (backgroundLayers === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = backgroundLayers;
    }
    backgroundLayers = tmp;
    parallaxPlane = parallaxPlane === VOID ? new Plane() : parallaxPlane;
    var tmp_0;
    if (foregroundLayers === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = foregroundLayers;
    }
    foregroundLayers = tmp_0;
    initialized = initialized === VOID ? false : initialized;
    var $this = this.uem();
    $this.yet_1 = name;
    $this.zet_1 = backgroundLayers;
    $this.aeu_1 = parallaxPlane;
    $this.beu_1 = foregroundLayers;
    $this.ceu_1 = initialized;
    return $this;
  }
  r1t(_this__u8e3s4, entity_0) {
    if (this.ceu_1)
      return Unit_instance;
    else
      this.ceu_1 = true;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = _this__u8e3s4.y1t_1.e3(name);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var injectable = tmp;
    injectable.p21_1 = true;
    var tmp_0 = injectable.o21_1;
    var assetStore = tmp_0 instanceof AssetStore ? tmp_0 : THROW_CCE();
    var tmp0_safe_receiver = assetStore.ael(this.yet_1).del_1.mek_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1();
    var numberBackgroundLayers = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp2_safe_receiver = assetStore.ael(this.yet_1).del_1.nek_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.rel_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g1();
    var numberAttachedRearLayers = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
    var tmp5_safe_receiver = assetStore.ael(this.yet_1).iel_1;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.y6n_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.g1();
    var numberParallaxPlaneLines = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
    var tmp8_safe_receiver = assetStore.ael(this.yet_1).del_1.nek_1;
    var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.qel_1;
    var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.g1();
    var numberAttachedFrontLayers = tmp10_elvis_lhs == null ? 0 : tmp10_elvis_lhs;
    var tmp11_safe_receiver = assetStore.ael(this.yet_1).del_1.oek_1;
    var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.g1();
    var numberForegroundLayers = tmp12_elvis_lhs == null ? 0 : tmp12_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list = ArrayList.w(numberBackgroundLayers);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < numberBackgroundLayers)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
        var tmp$ret$1 = new Layer_0();
        list.h(tmp$ret$1);
      }
       while (inductionVariable < numberBackgroundLayers);
    tmp_1.zet_1 = list;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list_0 = ArrayList.w(numberForegroundLayers);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < numberForegroundLayers)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
        var tmp$ret$4 = new Layer_0();
        list_0.h(tmp$ret$4);
      }
       while (inductionVariable_0 < numberForegroundLayers);
    tmp_2.beu_1 = list_0;
    var tmp_3 = this.aeu_1;
    // Inline function 'kotlin.collections.MutableList' call
    var list_1 = ArrayList.w(numberAttachedRearLayers);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < numberAttachedRearLayers)
      do {
        var index_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
        list_1.h(0.0);
      }
       while (inductionVariable_1 < numberAttachedRearLayers);
    tmp_3.ret_1 = list_1;
    var tmp_4 = this.aeu_1;
    // Inline function 'kotlin.collections.MutableList' call
    var list_2 = ArrayList.w(numberParallaxPlaneLines);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable_2 = 0;
    if (inductionVariable_2 < numberParallaxPlaneLines)
      do {
        var index_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
        list_2.h(0.0);
      }
       while (inductionVariable_2 < numberParallaxPlaneLines);
    tmp_4.qet_1 = list_2;
    var tmp_5 = this.aeu_1;
    // Inline function 'kotlin.collections.MutableList' call
    var list_3 = ArrayList.w(numberAttachedFrontLayers);
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable_3 = 0;
    if (inductionVariable_3 < numberAttachedFrontLayers)
      do {
        var index_3 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'kotlin.collections.MutableList.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
        list_3.h(0.0);
      }
       while (inductionVariable_3 < numberAttachedFrontLayers);
    tmp_5.set_1 = list_3;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.zet_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
      var tmp_6 = element;
      var tmp_7 = "Parallax BG layer of entity '" + entity_0.m1u_1 + "'";
      tmp_6.get_1 = entity(_this__u8e3s4, tmp_7, ParallaxComponent$onAdd$lambda(element));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.beu_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.onAdd.<anonymous>' call
      var tmp_8 = element_0;
      var tmp_9 = "Parallax FG layer of entity '" + entity_0.m1u_1 + "'";
      tmp_8.get_1 = entity(_this__u8e3s4, tmp_9, ParallaxComponent$onAdd$lambda_0(element_0));
    }
    var tmp_10 = this.aeu_1;
    var tmp_11 = "Parallax plane of entity '" + entity_0.m1u_1 + "'";
    tmp_10.net_1 = entity(_this__u8e3s4, tmp_11, ParallaxComponent$onAdd$lambda_1(this));
    var parallaxDataContainer = assetStore.ael(this.yet_1);
    var tmp13_safe_receiver = parallaxDataContainer.eel_1;
    var tmp14_elvis_lhs = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.o6n_1;
    var tmp_12;
    if (tmp14_elvis_lhs == null) {
      var tmp15_safe_receiver = parallaxDataContainer.fel_1;
      tmp_12 = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.o6n_1;
    } else {
      tmp_12 = tmp14_elvis_lhs;
    }
    var tmp16_elvis_lhs = tmp_12;
    var tmp_13;
    if (tmp16_elvis_lhs == null) {
      var tmp17_safe_receiver = parallaxDataContainer.iel_1;
      var tmp18_safe_receiver = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.e6o();
      tmp_13 = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.o6n_1;
    } else {
      tmp_13 = tmp16_elvis_lhs;
    }
    var tmp19_elvis_lhs = tmp_13;
    var tmp_14;
    if (tmp19_elvis_lhs == null) {
      throw Error_0.df('ParallaxComponent: Parallax image data has no height!');
    } else {
      tmp_14 = tmp19_elvis_lhs;
    }
    var imageHeight = tmp_14;
    var parallaxLayerHeight = imageHeight;
    var tmp$ret$13;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = _this__u8e3s4.o20().b1();
      while (tmp0_iterator_1.c1()) {
        var element_1 = tmp0_iterator_1.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element_1 instanceof CameraSystem) {
          tmp$ret$13 = element_1;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(CameraSystem));
    }
    tmp$ret$13.teu_1 = parallaxLayerHeight - parallaxDataContainer.del_1.kek_1;
    var tmp$ret$14;
    $l$block_0: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_2 = _this__u8e3s4.o20().b1();
      while (tmp0_iterator_2.c1()) {
        var element_2 = tmp0_iterator_2.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element_2 instanceof CameraSystem) {
          tmp$ret$14 = element_2;
          break $l$block_0;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(CameraSystem));
    }
    tmp$ret$14.ueu_1 = parallaxDataContainer.del_1.kek_1;
  }
  xep(_this__u8e3s4) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.zet_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.updateLayerEntities.<anonymous>' call
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      var this_0 = element.get_1;
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === this_0.m1u_1 || this_1.q1v_1 === this_0.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = this_0.m1u_1;
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.updateLayerEntities.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component = element.het_1;
        var compType = component.q1t();
        $this$configure.f1v_1.h1(this_0.m1u_1).p1s(compType.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(compType.m1t())) {
          var tmp = compType.m1t();
          var tmp_0 = this_2.v1t();
          var tmp_1 = 0;
          var tmp_2 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = null;
            tmp_1 = tmp_1 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
        }
        var tmp_4 = this_2.u1t_1.h1(compType.m1t());
        var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
        holder.l1u(this_0, component);
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component_0 = element.iet_1;
        var compType_0 = component_0.q1t();
        $this$configure.f1v_1.h1(this_0.m1u_1).p1s(compType_0.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_3 = $this$configure.i1v_1;
        if (this_3.u1t_1.j1s(compType_0.m1t())) {
          var tmp_5 = compType_0.m1t();
          var tmp_6 = this_3.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_3.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_3.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
        }
        var tmp_10 = this_3.u1t_1.h1(compType_0.m1t());
        var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
        holder_0.l1u(this_0, component_0);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(this_0.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element_0 = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element_0.p1w(this_0, compMask);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.beu_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_1 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.updateLayerEntities.<anonymous>' call
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      var this_4 = element_1.get_1;
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_5 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify_0 = this_5.s1v_1 === this_4.m1u_1 || this_5.q1v_1 === this_4.m1u_1;
        var prevUpdateId_0 = this_5.s1v_1;
        this_5.s1v_1 = this_4.m1u_1;
        // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.updateLayerEntities.<anonymous>.<anonymous>' call
        var $this$configure_0 = this_5.r1v_1;
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component_1 = element_1.het_1;
        var compType_1 = component_1.q1t();
        $this$configure_0.f1v_1.h1(this_4.m1u_1).p1s(compType_1.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_6 = $this$configure_0.i1v_1;
        if (this_6.u1t_1.j1s(compType_1.m1t())) {
          var tmp_11 = compType_1.m1t();
          var tmp_12 = this_6.v1t();
          var tmp_13 = 0;
          var tmp_14 = this_6.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_15 = fillArrayVal(Array(tmp_14), null);
          while (tmp_13 < tmp_14) {
            tmp_15[tmp_13] = null;
            tmp_13 = tmp_13 + 1 | 0;
          }
          this_6.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, compType_1, tmp_15));
        }
        var tmp_16 = this_6.u1t_1.h1(compType_1.m1t());
        var holder_1 = tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE();
        holder_1.l1u(this_4, component_1);
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var component_2 = element_1.iet_1;
        var compType_2 = component_2.q1t();
        $this$configure_0.f1v_1.h1(this_4.m1u_1).p1s(compType_2.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_7 = $this$configure_0.i1v_1;
        if (this_7.u1t_1.j1s(compType_2.m1t())) {
          var tmp_17 = compType_2.m1t();
          var tmp_18 = this_7.v1t();
          var tmp_19 = 0;
          var tmp_20 = this_7.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_21 = fillArrayVal(Array(tmp_20), null);
          while (tmp_19 < tmp_20) {
            tmp_21[tmp_19] = null;
            tmp_19 = tmp_19 + 1 | 0;
          }
          this_7.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, compType_2, tmp_21));
        }
        var tmp_22 = this_7.u1t_1.h1(compType_2.m1t());
        var holder_2 = tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE();
        holder_2.l1u(this_4, component_2);
        this_5.s1v_1 = prevUpdateId_0;
        if (skipFamilyNotify_0) {
          break $l$block_0;
        }
        var compMask_0 = this_5.o1v_1.h1(this_4.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = this_5.l1v_1.b1u_1;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject_0.length;
        while (inductionVariable_0 < last_0) {
          var element_2 = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element_2.p1w(this_4, compMask_0);
        }
      }
    }
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    var this_8 = this.aeu_1.net_1;
    $l$block_1: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_9 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify_1 = this_9.s1v_1 === this_8.m1u_1 || this_9.q1v_1 === this_8.m1u_1;
      var prevUpdateId_1 = this_9.s1v_1;
      this_9.s1v_1 = this_8.m1u_1;
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.updateLayerEntities.<anonymous>' call
      var $this$configure_1 = this_9.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_3 = this.aeu_1.oet_1;
      var compType_3 = component_3.q1t();
      $this$configure_1.f1v_1.h1(this_8.m1u_1).p1s(compType_3.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_10 = $this$configure_1.i1v_1;
      if (this_10.u1t_1.j1s(compType_3.m1t())) {
        var tmp_23 = compType_3.m1t();
        var tmp_24 = this_10.v1t();
        var tmp_25 = 0;
        var tmp_26 = this_10.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_27 = fillArrayVal(Array(tmp_26), null);
        while (tmp_25 < tmp_26) {
          tmp_27[tmp_25] = null;
          tmp_25 = tmp_25 + 1 | 0;
        }
        this_10.u1t_1.h1s(tmp_23, new ComponentsHolder(tmp_24, compType_3, tmp_27));
      }
      var tmp_28 = this_10.u1t_1.h1(compType_3.m1t());
      var holder_3 = tmp_28 instanceof ComponentsHolder ? tmp_28 : THROW_CCE();
      holder_3.l1u(this_8, component_3);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_4 = this.aeu_1.pet_1;
      var compType_4 = component_4.q1t();
      $this$configure_1.f1v_1.h1(this_8.m1u_1).p1s(compType_4.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_11 = $this$configure_1.i1v_1;
      if (this_11.u1t_1.j1s(compType_4.m1t())) {
        var tmp_29 = compType_4.m1t();
        var tmp_30 = this_11.v1t();
        var tmp_31 = 0;
        var tmp_32 = this_11.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_33 = fillArrayVal(Array(tmp_32), null);
        while (tmp_31 < tmp_32) {
          tmp_33[tmp_31] = null;
          tmp_31 = tmp_31 + 1 | 0;
        }
        this_11.u1t_1.h1s(tmp_29, new ComponentsHolder(tmp_30, compType_4, tmp_33));
      }
      var tmp_34 = this_11.u1t_1.h1(compType_4.m1t());
      var holder_4 = tmp_34 instanceof ComponentsHolder ? tmp_34 : THROW_CCE();
      holder_4.l1u(this_8, component_4);
      this_9.s1v_1 = prevUpdateId_1;
      if (skipFamilyNotify_1) {
        break $l$block_1;
      }
      var compMask_1 = this_9.o1v_1.h1(this_8.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_1 = this_9.l1v_1.b1u_1;
      var inductionVariable_1 = 0;
      var last_1 = indexedObject_1.length;
      while (inductionVariable_1 < last_1) {
        var element_3 = indexedObject_1[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element_3.p1w(this_8, compMask_1);
      }
    }
  }
  q1t() {
    return Companion_getInstance_35();
  }
  z27() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var bgLayers = ArrayList.z();
    // Inline function 'kotlin.collections.mutableListOf' call
    var fgLayers = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.zet_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.clone.<anonymous>' call
      bgLayers.h(element.z27());
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.beu_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallaxComponent.clone.<anonymous>' call
      fgLayers.h(element_0.z27());
    }
    return this.veu(VOID, bgLayers, this.aeu_1.z27(), fgLayers);
  }
  em() {
    return this.yet_1;
  }
  fm() {
    return this.zet_1;
  }
  jt() {
    return this.aeu_1;
  }
  zep() {
    return this.beu_1;
  }
  weu(name, backgroundLayers, parallaxPlane, foregroundLayers, initialized) {
    return ParallaxComponent.eeu(name, backgroundLayers, parallaxPlane, foregroundLayers, initialized);
  }
  veu(name, backgroundLayers, parallaxPlane, foregroundLayers, initialized, $super) {
    name = name === VOID ? this.yet_1 : name;
    backgroundLayers = backgroundLayers === VOID ? this.zet_1 : backgroundLayers;
    parallaxPlane = parallaxPlane === VOID ? this.aeu_1 : parallaxPlane;
    foregroundLayers = foregroundLayers === VOID ? this.beu_1 : foregroundLayers;
    initialized = initialized === VOID ? this.ceu_1 : initialized;
    return $super === VOID ? this.weu(name, backgroundLayers, parallaxPlane, foregroundLayers, initialized) : $super.weu.call(this, name, backgroundLayers, parallaxPlane, foregroundLayers, initialized);
  }
  toString() {
    return 'ParallaxComponent(name=' + this.yet_1 + ', backgroundLayers=' + toString_0(this.zet_1) + ', parallaxPlane=' + this.aeu_1.toString() + ', foregroundLayers=' + toString_0(this.beu_1) + ', initialized=' + this.ceu_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.yet_1);
    result = imul(result, 31) + hashCode(this.zet_1) | 0;
    result = imul(result, 31) + this.aeu_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.beu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ceu_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxComponent ? other : THROW_CCE();
    if (!(this.yet_1 === tmp0_other_with_cast.yet_1))
      return false;
    if (!equals(this.zet_1, tmp0_other_with_cast.zet_1))
      return false;
    if (!this.aeu_1.equals(tmp0_other_with_cast.aeu_1))
      return false;
    if (!equals(this.beu_1, tmp0_other_with_cast.beu_1))
      return false;
    if (!(this.ceu_1 === tmp0_other_with_cast.ceu_1))
      return false;
    return true;
  }
  static deu(seen0, name, backgroundLayers, parallaxPlane, foregroundLayers, initialized, serializationConstructorMarker) {
    Companion_getInstance_35();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_24().wet_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.yet_1 = '';
    else
      $this.yet_1 = name;
    if (0 === (seen0 & 2)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.zet_1 = emptyList();
    } else
      $this.zet_1 = backgroundLayers;
    if (0 === (seen0 & 4))
      $this.aeu_1 = new Plane();
    else
      $this.aeu_1 = parallaxPlane;
    if (0 === (seen0 & 8)) {
      var tmp_0 = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp_0.beu_1 = emptyList();
    } else
      $this.beu_1 = foregroundLayers;
    if (0 === (seen0 & 16))
      $this.ceu_1 = false;
    else
      $this.ceu_1 = initialized;
    return $this;
  }
}
class Companion_26 extends ComponentType {
  constructor() {
    Companion_instance_28 = null;
    super();
    Companion_instance_28 = this;
  }
}
class $serializer_24 {
  constructor() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Position', this, 4);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    this.xeu_1 = tmp0_serialDesc;
  }
  yeu(encoder, value) {
    var tmp0_desc = this.xeu_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.peo_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.peo_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.qeo_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.qeo_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.reo_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.reo_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.seo_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.seo_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yeu(encoder, value instanceof PositionComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xeu_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return PositionComponent.zeu(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.xeu_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class PositionComponent extends CloneableComponent {
  static teo(x, y, offsetX, offsetY) {
    Companion_getInstance_36();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    offsetX = offsetX === VOID ? 0.0 : offsetX;
    offsetY = offsetY === VOID ? 0.0 : offsetY;
    var $this = this.uem();
    $this.peo_1 = x;
    $this.qeo_1 = y;
    $this.reo_1 = offsetX;
    $this.seo_1 = offsetY;
    return $this;
  }
  q1t() {
    return Companion_getInstance_36();
  }
  aev(_this__u8e3s4, camera) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = _this__u8e3s4.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var cameraPosition = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(camera);
    return PositionComponent.teo(this.peo_1 - cameraPosition.peo_1 + cameraPosition.reo_1 + AppConfig_getInstance().kev_1, this.qeo_1 - cameraPosition.qeo_1 + cameraPosition.seo_1 + AppConfig_getInstance().lev_1, this.reo_1, this.seo_1);
  }
  z27() {
    return this.qev();
  }
  em() {
    return this.peo_1;
  }
  fm() {
    return this.qeo_1;
  }
  ker(x, y, offsetX, offsetY) {
    return PositionComponent.teo(x, y, offsetX, offsetY);
  }
  qev(x, y, offsetX, offsetY, $super) {
    x = x === VOID ? this.peo_1 : x;
    y = y === VOID ? this.qeo_1 : y;
    offsetX = offsetX === VOID ? this.reo_1 : offsetX;
    offsetY = offsetY === VOID ? this.seo_1 : offsetY;
    return $super === VOID ? this.ker(x, y, offsetX, offsetY) : $super.ker.call(this, x, y, offsetX, offsetY);
  }
  toString() {
    return 'PositionComponent(x=' + this.peo_1 + ', y=' + this.qeo_1 + ', offsetX=' + this.reo_1 + ', offsetY=' + this.seo_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.peo_1);
    result = imul(result, 31) + getNumberHashCode(this.qeo_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.reo_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.seo_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionComponent))
      return false;
    var tmp0_other_with_cast = other instanceof PositionComponent ? other : THROW_CCE();
    if (!equals(this.peo_1, tmp0_other_with_cast.peo_1))
      return false;
    if (!equals(this.qeo_1, tmp0_other_with_cast.qeo_1))
      return false;
    if (!equals(this.reo_1, tmp0_other_with_cast.reo_1))
      return false;
    if (!equals(this.seo_1, tmp0_other_with_cast.seo_1))
      return false;
    return true;
  }
  static zeu(seen0, x, y, offsetX, offsetY, serializationConstructorMarker) {
    Companion_getInstance_36();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_25().xeu_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.peo_1 = 0.0;
    else
      $this.peo_1 = x;
    if (0 === (seen0 & 2))
      $this.qeo_1 = 0.0;
    else
      $this.qeo_1 = y;
    if (0 === (seen0 & 4))
      $this.reo_1 = 0.0;
    else
      $this.reo_1 = offsetX;
    if (0 === (seen0 & 8))
      $this.seo_1 = 0.0;
    else
      $this.seo_1 = offsetY;
    return $this;
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_29 = this;
    this.rev_1 = new Rgb(255, 255, 255);
    this.sev_1 = new Rgb(255, 0, 0);
    this.tev_1 = new Rgb(0, 0, 0);
    this.uev_1 = new Rgb(143, 143, 143);
  }
}
class $serializer_25 {
  constructor() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Rgb', this, 3);
    tmp0_serialDesc.m16('r', true);
    tmp0_serialDesc.m16('g', true);
    tmp0_serialDesc.m16('b', true);
    this.vev_1 = tmp0_serialDesc;
  }
  wev(encoder, value) {
    var tmp0_desc = this.vev_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.xev_1 === 255)) {
      tmp1_output.i10(tmp0_desc, 0, value.xev_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.yev_1 === 255)) {
      tmp1_output.i10(tmp0_desc, 1, value.yev_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.zev_1 === 255)) {
      tmp1_output.i10(tmp0_desc, 2, value.zev_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.wev(encoder, value instanceof Rgb ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.vev_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return Rgb.aew(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.vev_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class Rgb {
  constructor(r, g, b) {
    Companion_getInstance_37();
    r = r === VOID ? 255 : r;
    g = g === VOID ? 255 : g;
    b = b === VOID ? 255 : b;
    this.xev_1 = r;
    this.yev_1 = g;
    this.zev_1 = b;
  }
  bew(other) {
    return new Rgb(this.xev_1 + other.xev_1 | 0, this.yev_1 + other.yev_1 | 0, this.zev_1 + other.zev_1 | 0);
  }
  u3s(f) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = this.xev_1 * f;
    var tmp = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = this.yev_1 * f;
    var tmp_0 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = this.zev_1 * f;
    var tmp$ret$2 = roundToInt(this_2);
    return new Rgb(tmp, tmp_0, tmp$ret$2);
  }
  toString() {
    return format('#%02x%02x%02x', [this.xev_1, this.yev_1, this.zev_1]);
  }
  z27() {
    return this.cew();
  }
  sao(r, g, b) {
    return new Rgb(r, g, b);
  }
  cew(r, g, b, $super) {
    r = r === VOID ? this.xev_1 : r;
    g = g === VOID ? this.yev_1 : g;
    b = b === VOID ? this.zev_1 : b;
    return $super === VOID ? this.sao(r, g, b) : $super.sao.call(this, r, g, b);
  }
  hashCode() {
    var result = this.xev_1;
    result = imul(result, 31) + this.yev_1 | 0;
    result = imul(result, 31) + this.zev_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rgb))
      return false;
    var tmp0_other_with_cast = other instanceof Rgb ? other : THROW_CCE();
    if (!(this.xev_1 === tmp0_other_with_cast.xev_1))
      return false;
    if (!(this.yev_1 === tmp0_other_with_cast.yev_1))
      return false;
    if (!(this.zev_1 === tmp0_other_with_cast.zev_1))
      return false;
    return true;
  }
  static aew(seen0, r, g, b, serializationConstructorMarker) {
    Companion_getInstance_37();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_26().vev_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.xev_1 = 255;
    else
      $this.xev_1 = r;
    if (0 === (seen0 & 2))
      $this.yev_1 = 255;
    else
      $this.yev_1 = g;
    if (0 === (seen0 & 4))
      $this.zev_1 = 255;
    else
      $this.zev_1 = b;
    return $this;
  }
}
class Companion_28 extends ComponentType {
  constructor() {
    Companion_instance_30 = null;
    super();
    Companion_instance_30 = this;
  }
}
class $serializer_26 {
  constructor() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Rgba', this, 3);
    tmp0_serialDesc.m16('rgba', true);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('tint', true);
    this.dew_1 = tmp0_serialDesc;
  }
  eew(encoder, value) {
    var tmp0_desc = this.dew_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.ueo_1 === Colors_getInstance().y57_1)) {
      tmp1_output.p10(tmp0_desc, 0, RGBAAsInt_getInstance(), new RGBA(value.ueo_1));
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.few(), _RGBA___get_af__impl__vu36qv(value.ueo_1))) {
      tmp1_output.k10(tmp0_desc, 1, value.few());
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.gew().equals(new Rgb(_RGBA___get_r__impl__duz7mo(value.ueo_1), _RGBA___get_g__impl__o8pukr(value.ueo_1), _RGBA___get_b__impl__m6tl80(value.ueo_1)))) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance_26(), value.gew());
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.eew(encoder, value instanceof RgbaComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.dew_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      var tmp = RGBAAsInt_getInstance();
      var tmp_0 = tmp4_local0;
      var tmp_1 = tmp7_input.jz(tmp0_desc, 0, tmp, tmp_0 == null ? null : new RGBA(tmp_0));
      tmp4_local0 = tmp_1 == null ? null : tmp_1.o5p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, $serializer_getInstance_26(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            var tmp_2 = RGBAAsInt_getInstance();
            var tmp_3 = tmp4_local0;
            var tmp_4 = tmp7_input.jz(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new RGBA(tmp_3));
            tmp4_local0 = tmp_4 == null ? null : tmp_4.o5p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.jz(tmp0_desc, 2, $serializer_getInstance_26(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return RgbaComponent.hew(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.dew_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [RGBAAsInt_getInstance(), FloatSerializer_getInstance(), $serializer_getInstance_26()];
  }
}
class RgbaComponent extends CloneableComponent {
  static xeo(rgba) {
    Companion_getInstance_38();
    rgba = rgba === VOID ? Colors_getInstance().y57_1 : rgba;
    var $this = this.uem();
    $this.ueo_1 = rgba;
    $this.veo_1 = _RGBA___get_af__impl__vu36qv($this.ueo_1);
    $this.weo_1 = new Rgb(_RGBA___get_r__impl__duz7mo($this.ueo_1), _RGBA___get_g__impl__o8pukr($this.ueo_1), _RGBA___get_b__impl__m6tl80($this.ueo_1));
    return $this;
  }
  iew(value) {
    this.ueo_1 = RGBA__withAf_impl_dpdu32(this.ueo_1, value);
    this.veo_1 = value;
  }
  few() {
    return _RGBA___get_af__impl__vu36qv(this.ueo_1);
  }
  jew(value) {
    this.ueo_1 = RGBA__withRGB_impl_scofdy(this.ueo_1, value.xev_1, value.yev_1, value.zev_1);
    this.weo_1 = value;
  }
  gew() {
    return new Rgb(_RGBA___get_r__impl__duz7mo(this.ueo_1), _RGBA___get_g__impl__o8pukr(this.ueo_1), _RGBA___get_b__impl__m6tl80(this.ueo_1));
  }
  toString() {
    return 'RgbaComponent(rgba=' + _RGBA___get_hexString__impl__kocngm(this.ueo_1) + ')';
  }
  q1t() {
    return Companion_getInstance_38();
  }
  z27() {
    return this.kew(cloneRgba(this.ueo_1));
  }
  lew() {
    return this.ueo_1;
  }
  kew(rgba) {
    return RgbaComponent.xeo(rgba);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.ueo_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RgbaComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RgbaComponent ? other : THROW_CCE();
    if (!(this.ueo_1 === tmp0_other_with_cast.ueo_1))
      return false;
    return true;
  }
  static hew(seen0, rgba, alpha, tint, serializationConstructorMarker) {
    Companion_getInstance_38();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_27().dew_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.ueo_1 = Colors_getInstance().y57_1;
    else
      $this.ueo_1 = rgba;
    if (0 === (seen0 & 2))
      $this.veo_1 = _RGBA___get_af__impl__vu36qv($this.ueo_1);
    else
      $this.veo_1 = alpha;
    if (0 === (seen0 & 4))
      $this.weo_1 = new Rgb(_RGBA___get_r__impl__duz7mo($this.ueo_1), _RGBA___get_g__impl__o8pukr($this.ueo_1), _RGBA___get_b__impl__m6tl80($this.ueo_1));
    else
      $this.weo_1 = tint;
    return $this;
  }
}
class Companion_29 extends ComponentType {
  constructor() {
    Companion_instance_31 = null;
    super();
    Companion_instance_31 = this;
  }
}
class $serializer_27 {
  constructor() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Rigidbody', this, 3);
    tmp0_serialDesc.m16('mass', true);
    tmp0_serialDesc.m16('damping', true);
    tmp0_serialDesc.m16('friction', true);
    this.mew_1 = tmp0_serialDesc;
  }
  new(encoder, value) {
    var tmp0_desc = this.mew_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.oew_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.oew_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.pew_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.pew_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.qew_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.qew_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.new(encoder, value instanceof RigidbodyComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.mew_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.xy(tmp0_desc);
    if (tmp7_input.nz()) {
      tmp4_local0 = tmp7_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp7_input.yy(tmp0_desc);
    return RigidbodyComponent.rew(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  yu() {
    return this.mew_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class RigidbodyComponent extends CloneableComponent {
  static sew(mass, damping, friction) {
    Companion_getInstance_39();
    mass = mass === VOID ? 0.0 : mass;
    damping = damping === VOID ? 0.0 : damping;
    friction = friction === VOID ? 0.0 : friction;
    var $this = this.uem();
    $this.oew_1 = mass;
    $this.pew_1 = damping;
    $this.qew_1 = friction;
    return $this;
  }
  q1t() {
    return Companion_getInstance_39();
  }
  z27() {
    return this.tew();
  }
  uew(mass, damping, friction) {
    return RigidbodyComponent.sew(mass, damping, friction);
  }
  tew(mass, damping, friction, $super) {
    mass = mass === VOID ? this.oew_1 : mass;
    damping = damping === VOID ? this.pew_1 : damping;
    friction = friction === VOID ? this.qew_1 : friction;
    return $super === VOID ? this.uew(mass, damping, friction) : $super.uew.call(this, mass, damping, friction);
  }
  toString() {
    return 'RigidbodyComponent(mass=' + this.oew_1 + ', damping=' + this.pew_1 + ', friction=' + this.qew_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.oew_1);
    result = imul(result, 31) + getNumberHashCode(this.pew_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qew_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RigidbodyComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RigidbodyComponent ? other : THROW_CCE();
    if (!equals(this.oew_1, tmp0_other_with_cast.oew_1))
      return false;
    if (!equals(this.pew_1, tmp0_other_with_cast.pew_1))
      return false;
    if (!equals(this.qew_1, tmp0_other_with_cast.qew_1))
      return false;
    return true;
  }
  static rew(seen0, mass, damping, friction, serializationConstructorMarker) {
    Companion_getInstance_39();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_28().mew_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.oew_1 = 0.0;
    else
      $this.oew_1 = mass;
    if (0 === (seen0 & 2))
      $this.pew_1 = 0.0;
    else
      $this.pew_1 = damping;
    if (0 === (seen0 & 4))
      $this.qew_1 = 0.0;
    else
      $this.qew_1 = friction;
    return $this;
  }
}
class Companion_30 extends ComponentType {
  constructor() {
    Companion_instance_32 = null;
    super();
    Companion_instance_32 = this;
  }
}
class $serializer_28 {
  constructor() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Size', this, 2);
    tmp0_serialDesc.m16('width', true);
    tmp0_serialDesc.m16('height', true);
    this.vew_1 = tmp0_serialDesc;
  }
  wew(encoder, value) {
    var tmp0_desc = this.vew_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.xew_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.xew_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.yew_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.yew_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.wew(encoder, value instanceof SizeComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.vew_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return SizeComponent.zew(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.vew_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class SizeComponent extends CloneableComponent {
  static aex(width, height) {
    Companion_getInstance_40();
    width = width === VOID ? 0.0 : width;
    height = height === VOID ? 0.0 : height;
    var $this = this.uem();
    $this.xew_1 = width;
    $this.yew_1 = height;
    return $this;
  }
  q1t() {
    return Companion_getInstance_40();
  }
  z27() {
    return this.bex();
  }
  ues(width, height) {
    return SizeComponent.aex(width, height);
  }
  bex(width, height, $super) {
    width = width === VOID ? this.xew_1 : width;
    height = height === VOID ? this.yew_1 : height;
    return $super === VOID ? this.ues(width, height) : $super.ues.call(this, width, height);
  }
  toString() {
    return 'SizeComponent(width=' + this.xew_1 + ', height=' + this.yew_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.xew_1);
    result = imul(result, 31) + getNumberHashCode(this.yew_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SizeComponent ? other : THROW_CCE();
    if (!equals(this.xew_1, tmp0_other_with_cast.xew_1))
      return false;
    if (!equals(this.yew_1, tmp0_other_with_cast.yew_1))
      return false;
    return true;
  }
  static zew(seen0, width, height, serializationConstructorMarker) {
    Companion_getInstance_40();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_29().vew_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.xew_1 = 0.0;
    else
      $this.xew_1 = width;
    if (0 === (seen0 & 2))
      $this.yew_1 = 0.0;
    else
      $this.yew_1 = height;
    return $this;
  }
}
class Companion_31 extends ComponentType {
  constructor() {
    Companion_instance_33 = null;
    super();
    Companion_instance_33 = this;
  }
}
class $serializer_29 {
  constructor() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Sound', this, 7);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('startTrigger', true);
    tmp0_serialDesc.m16('stopTrigger', true);
    tmp0_serialDesc.m16('position', true);
    tmp0_serialDesc.m16('volume', true);
    tmp0_serialDesc.m16('isPlaying', true);
    tmp0_serialDesc.m16('loop', true);
    this.cex_1 = tmp0_serialDesc;
  }
  dex(encoder, value) {
    var tmp0_desc = this.cex_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.eex_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.eex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.fex_1 === false)) {
      tmp1_output.f10(tmp0_desc, 1, value.fex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.gex_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.gex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.hex_1, 0.0)) {
      tmp1_output.l10(tmp0_desc, 3, value.hex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.iex_1, 1.0)) {
      tmp1_output.l10(tmp0_desc, 4, value.iex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.jex_1 === false)) {
      tmp1_output.f10(tmp0_desc, 5, value.jex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.kex_1 === false)) {
      tmp1_output.f10(tmp0_desc, 6, value.kex_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.dex(encoder, value instanceof SoundComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.cex_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = false;
    var tmp10_local6 = false;
    var tmp11_input = decoder.xy(tmp0_desc);
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.zy(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.fz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.fz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.zy(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.zy(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.zy(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.fz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.fz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.zy(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.zy(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return SoundComponent.lex(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.cex_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class SoundComponent extends CloneableComponent {
  static mex(name, startTrigger, stopTrigger, position, volume, isPlaying, loop) {
    Companion_getInstance_41();
    name = name === VOID ? '' : name;
    startTrigger = startTrigger === VOID ? false : startTrigger;
    stopTrigger = stopTrigger === VOID ? false : stopTrigger;
    position = position === VOID ? 0.0 : position;
    volume = volume === VOID ? 1.0 : volume;
    isPlaying = isPlaying === VOID ? false : isPlaying;
    loop = loop === VOID ? false : loop;
    var $this = this.uem();
    $this.eex_1 = name;
    $this.fex_1 = startTrigger;
    $this.gex_1 = stopTrigger;
    $this.hex_1 = position;
    $this.iex_1 = volume;
    $this.jex_1 = isPlaying;
    $this.kex_1 = loop;
    return $this;
  }
  q1t() {
    return Companion_getInstance_41();
  }
  z27() {
    return this.nex();
  }
  oex(name, startTrigger, stopTrigger, position, volume, isPlaying, loop) {
    return SoundComponent.mex(name, startTrigger, stopTrigger, position, volume, isPlaying, loop);
  }
  nex(name, startTrigger, stopTrigger, position, volume, isPlaying, loop, $super) {
    name = name === VOID ? this.eex_1 : name;
    startTrigger = startTrigger === VOID ? this.fex_1 : startTrigger;
    stopTrigger = stopTrigger === VOID ? this.gex_1 : stopTrigger;
    position = position === VOID ? this.hex_1 : position;
    volume = volume === VOID ? this.iex_1 : volume;
    isPlaying = isPlaying === VOID ? this.jex_1 : isPlaying;
    loop = loop === VOID ? this.kex_1 : loop;
    return $super === VOID ? this.oex(name, startTrigger, stopTrigger, position, volume, isPlaying, loop) : $super.oex.call(this, name, startTrigger, stopTrigger, position, volume, isPlaying, loop);
  }
  toString() {
    return 'SoundComponent(name=' + this.eex_1 + ', startTrigger=' + this.fex_1 + ', stopTrigger=' + this.gex_1 + ', position=' + this.hex_1 + ', volume=' + this.iex_1 + ', isPlaying=' + this.jex_1 + ', loop=' + this.kex_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.eex_1);
    result = imul(result, 31) + getBooleanHashCode(this.fex_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gex_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.hex_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.iex_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jex_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kex_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoundComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SoundComponent ? other : THROW_CCE();
    if (!(this.eex_1 === tmp0_other_with_cast.eex_1))
      return false;
    if (!(this.fex_1 === tmp0_other_with_cast.fex_1))
      return false;
    if (!(this.gex_1 === tmp0_other_with_cast.gex_1))
      return false;
    if (!equals(this.hex_1, tmp0_other_with_cast.hex_1))
      return false;
    if (!equals(this.iex_1, tmp0_other_with_cast.iex_1))
      return false;
    if (!(this.jex_1 === tmp0_other_with_cast.jex_1))
      return false;
    if (!(this.kex_1 === tmp0_other_with_cast.kex_1))
      return false;
    return true;
  }
  static lex(seen0, name, startTrigger, stopTrigger, position, volume, isPlaying, loop, serializationConstructorMarker) {
    Companion_getInstance_41();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_30().cex_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.eex_1 = '';
    else
      $this.eex_1 = name;
    if (0 === (seen0 & 2))
      $this.fex_1 = false;
    else
      $this.fex_1 = startTrigger;
    if (0 === (seen0 & 4))
      $this.gex_1 = false;
    else
      $this.gex_1 = stopTrigger;
    if (0 === (seen0 & 8))
      $this.hex_1 = 0.0;
    else
      $this.hex_1 = position;
    if (0 === (seen0 & 16))
      $this.iex_1 = 1.0;
    else
      $this.iex_1 = volume;
    if (0 === (seen0 & 32))
      $this.jex_1 = false;
    else
      $this.jex_1 = isPlaying;
    if (0 === (seen0 & 64))
      $this.kex_1 = false;
    else
      $this.kex_1 = loop;
    return $this;
  }
}
class Companion_32 extends ComponentType {
  constructor() {
    Companion_instance_34 = null;
    super();
    Companion_instance_34 = this;
  }
}
class $serializer_30 {
  constructor() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Spawner', this, 9);
    tmp0_serialDesc.m16('numberOfObjects', true);
    tmp0_serialDesc.m16('interval', true);
    tmp0_serialDesc.m16('timeVariation', true);
    tmp0_serialDesc.m16('positionVariation', true);
    tmp0_serialDesc.m16('newEntity', true);
    tmp0_serialDesc.m16('entityConfig', true);
    tmp0_serialDesc.m16('totalNumberOfObjects', true);
    tmp0_serialDesc.m16('nextSpawnIn', true);
    tmp0_serialDesc.m16('numberOfObjectsSpawned', true);
    this.pex_1 = tmp0_serialDesc;
  }
  qex(encoder, value) {
    var tmp0_desc = this.pex_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.rex_1 === 1)) {
      tmp1_output.i10(tmp0_desc, 0, value.rex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.sex_1 === 1)) {
      tmp1_output.i10(tmp0_desc, 1, value.sex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.tex_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 2, value.tex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.uex_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.uex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !value.vex_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 4, $serializer_getInstance(), value.vex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.wex_1 === '')) {
      tmp1_output.n10(tmp0_desc, 5, value.wex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.xex_1 === -1)) {
      tmp1_output.i10(tmp0_desc, 6, value.xex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.yex_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 7, value.yex_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.zex_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 8, value.zex_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.qex(encoder, value instanceof SpawnerComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.pex_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_local7 = 0;
    var tmp12_local8 = 0;
    var tmp13_input = decoder.xy(tmp0_desc);
    if (tmp13_input.nz()) {
      tmp4_local0 = tmp13_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.cz(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.cz(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp13_input.yy(tmp0_desc);
    return SpawnerComponent.aey(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  }
  yu() {
    return this.pex_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), $serializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class SpawnerComponent extends CloneableComponent {
  static bey(numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned) {
    Companion_getInstance_42();
    numberOfObjects = numberOfObjects === VOID ? 1 : numberOfObjects;
    interval = interval === VOID ? 1 : interval;
    timeVariation = timeVariation === VOID ? 0 : timeVariation;
    positionVariation = positionVariation === VOID ? 0.0 : positionVariation;
    newEntity = newEntity === VOID ? Companion_getInstance_4().x1s_1 : newEntity;
    entityConfig = entityConfig === VOID ? '' : entityConfig;
    totalNumberOfObjects = totalNumberOfObjects === VOID ? -1 : totalNumberOfObjects;
    nextSpawnIn = nextSpawnIn === VOID ? 0 : nextSpawnIn;
    numberOfObjectsSpawned = numberOfObjectsSpawned === VOID ? 0 : numberOfObjectsSpawned;
    var $this = this.uem();
    $this.rex_1 = numberOfObjects;
    $this.sex_1 = interval;
    $this.tex_1 = timeVariation;
    $this.uex_1 = positionVariation;
    $this.vex_1 = newEntity;
    $this.wex_1 = entityConfig;
    $this.xex_1 = totalNumberOfObjects;
    $this.yex_1 = nextSpawnIn;
    $this.zex_1 = numberOfObjectsSpawned;
    return $this;
  }
  q1t() {
    return Companion_getInstance_42();
  }
  z27() {
    return this.cey(VOID, VOID, VOID, VOID, this.vex_1.a1v());
  }
  dey(numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned) {
    return SpawnerComponent.bey(numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned);
  }
  cey(numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned, $super) {
    numberOfObjects = numberOfObjects === VOID ? this.rex_1 : numberOfObjects;
    interval = interval === VOID ? this.sex_1 : interval;
    timeVariation = timeVariation === VOID ? this.tex_1 : timeVariation;
    positionVariation = positionVariation === VOID ? this.uex_1 : positionVariation;
    newEntity = newEntity === VOID ? this.vex_1 : newEntity;
    entityConfig = entityConfig === VOID ? this.wex_1 : entityConfig;
    totalNumberOfObjects = totalNumberOfObjects === VOID ? this.xex_1 : totalNumberOfObjects;
    nextSpawnIn = nextSpawnIn === VOID ? this.yex_1 : nextSpawnIn;
    numberOfObjectsSpawned = numberOfObjectsSpawned === VOID ? this.zex_1 : numberOfObjectsSpawned;
    return $super === VOID ? this.dey(numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned) : $super.dey.call(this, numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned);
  }
  toString() {
    return 'SpawnerComponent(numberOfObjects=' + this.rex_1 + ', interval=' + this.sex_1 + ', timeVariation=' + this.tex_1 + ', positionVariation=' + this.uex_1 + ', newEntity=' + this.vex_1.toString() + ', entityConfig=' + this.wex_1 + ', totalNumberOfObjects=' + this.xex_1 + ', nextSpawnIn=' + this.yex_1 + ', numberOfObjectsSpawned=' + this.zex_1 + ')';
  }
  hashCode() {
    var result = this.rex_1;
    result = imul(result, 31) + this.sex_1 | 0;
    result = imul(result, 31) + this.tex_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.uex_1) | 0;
    result = imul(result, 31) + this.vex_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.wex_1) | 0;
    result = imul(result, 31) + this.xex_1 | 0;
    result = imul(result, 31) + this.yex_1 | 0;
    result = imul(result, 31) + this.zex_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpawnerComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SpawnerComponent ? other : THROW_CCE();
    if (!(this.rex_1 === tmp0_other_with_cast.rex_1))
      return false;
    if (!(this.sex_1 === tmp0_other_with_cast.sex_1))
      return false;
    if (!(this.tex_1 === tmp0_other_with_cast.tex_1))
      return false;
    if (!equals(this.uex_1, tmp0_other_with_cast.uex_1))
      return false;
    if (!this.vex_1.equals(tmp0_other_with_cast.vex_1))
      return false;
    if (!(this.wex_1 === tmp0_other_with_cast.wex_1))
      return false;
    if (!(this.xex_1 === tmp0_other_with_cast.xex_1))
      return false;
    if (!(this.yex_1 === tmp0_other_with_cast.yex_1))
      return false;
    if (!(this.zex_1 === tmp0_other_with_cast.zex_1))
      return false;
    return true;
  }
  static aey(seen0, numberOfObjects, interval, timeVariation, positionVariation, newEntity, entityConfig, totalNumberOfObjects, nextSpawnIn, numberOfObjectsSpawned, serializationConstructorMarker) {
    Companion_getInstance_42();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_31().pex_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.rex_1 = 1;
    else
      $this.rex_1 = numberOfObjects;
    if (0 === (seen0 & 2))
      $this.sex_1 = 1;
    else
      $this.sex_1 = interval;
    if (0 === (seen0 & 4))
      $this.tex_1 = 0;
    else
      $this.tex_1 = timeVariation;
    if (0 === (seen0 & 8))
      $this.uex_1 = 0.0;
    else
      $this.uex_1 = positionVariation;
    if (0 === (seen0 & 16))
      $this.vex_1 = Companion_getInstance_4().x1s_1;
    else
      $this.vex_1 = newEntity;
    if (0 === (seen0 & 32))
      $this.wex_1 = '';
    else
      $this.wex_1 = entityConfig;
    if (0 === (seen0 & 64))
      $this.xex_1 = -1;
    else
      $this.xex_1 = totalNumberOfObjects;
    if (0 === (seen0 & 128))
      $this.yex_1 = 0;
    else
      $this.yex_1 = nextSpawnIn;
    if (0 === (seen0 & 256))
      $this.zex_1 = 0;
    else
      $this.zex_1 = numberOfObjectsSpawned;
    return $this;
  }
}
class Companion_33 extends ComponentType {
  constructor() {
    Companion_instance_35 = null;
    super();
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.fey_1 = [null, null, null, null, null, null, createSimpleEnumSerializer('korlibs.image.format.ImageAnimation.Direction', values()), null, null, null, null];
  }
}
class $serializer_31 {
  constructor() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Sprite', this, 11);
    tmp0_serialDesc.m16('name', true);
    tmp0_serialDesc.m16('anchorX', true);
    tmp0_serialDesc.m16('anchorY', true);
    tmp0_serialDesc.m16('animation', true);
    tmp0_serialDesc.m16('frameIndex', true);
    tmp0_serialDesc.m16('running', true);
    tmp0_serialDesc.m16('direction', true);
    tmp0_serialDesc.m16('destroyOnAnimationFinished', true);
    tmp0_serialDesc.m16('increment', true);
    tmp0_serialDesc.m16('nextFrameIn', true);
    tmp0_serialDesc.m16('initialized', true);
    this.gey_1 = tmp0_serialDesc;
  }
  hey(encoder, value) {
    var tmp0_desc = this.gey_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_43().fey_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.iey_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.iey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.jey_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.jey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.key_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.key_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.ley_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, StringSerializer_getInstance(), value.ley_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.mey_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 4, value.mey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.ney_1 === false)) {
      tmp1_output.f10(tmp0_desc, 5, value.ney_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.oey_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, tmp2_cached[6], value.oey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.pey_1 === false)) {
      tmp1_output.f10(tmp0_desc, 7, value.pey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !(value.qey_1 === -2)) {
      tmp1_output.i10(tmp0_desc, 8, value.qey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !equals(value.rey_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 9, value.rey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !(value.sey_1 === false)) {
      tmp1_output.f10(tmp0_desc, 10, value.sey_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.hey(encoder, value instanceof SpriteComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.gey_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = 0;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = false;
    var tmp15_input = decoder.xy(tmp0_desc);
    var tmp16_cached = Companion_getInstance_43().fey_1;
    if (tmp15_input.nz()) {
      tmp4_local0 = tmp15_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.cz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zy(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.lz(tmp0_desc, 6, tmp16_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.zy(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.ez(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.zy(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.cz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zy(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.lz(tmp0_desc, 6, tmp16_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.zy(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.ez(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.zy(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp15_input.yy(tmp0_desc);
    return SpriteComponent.tey(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  }
  yu() {
    return this.gey_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_43().fey_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[6]), BooleanSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class SpriteComponent extends CloneableComponent {
  static uey(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized) {
    Companion_getInstance_43();
    name = name === VOID ? '' : name;
    anchorX = anchorX === VOID ? 0.0 : anchorX;
    anchorY = anchorY === VOID ? 0.0 : anchorY;
    animation = animation === VOID ? null : animation;
    frameIndex = frameIndex === VOID ? 0 : frameIndex;
    running = running === VOID ? false : running;
    direction = direction === VOID ? null : direction;
    destroyOnAnimationFinished = destroyOnAnimationFinished === VOID ? false : destroyOnAnimationFinished;
    increment = increment === VOID ? -2 : increment;
    nextFrameIn = nextFrameIn === VOID ? 0.0 : nextFrameIn;
    initialized = initialized === VOID ? false : initialized;
    var $this = this.uem();
    $this.iey_1 = name;
    $this.jey_1 = anchorX;
    $this.key_1 = anchorY;
    $this.ley_1 = animation;
    $this.mey_1 = frameIndex;
    $this.ney_1 = running;
    $this.oey_1 = direction;
    $this.pey_1 = destroyOnAnimationFinished;
    $this.qey_1 = increment;
    $this.rey_1 = nextFrameIn;
    $this.sey_1 = initialized;
    return $this;
  }
  q1t() {
    return Companion_getInstance_43();
  }
  uep(assetStore) {
    this.mey_1 = equals(this.oey_1, Direction_REVERSE_getInstance()) || equals(this.oey_1, Direction_ONCE_REVERSE_getInstance()) ? getAnimationNumberOfFrames(assetStore, this.iey_1, this.ley_1) - 1 | 0 : 0;
  }
  vep(assetStore) {
    this.rey_1 = getAnimationFrameDuration(assetStore, this.iey_1, this.ley_1, this.mey_1);
  }
  wep() {
    var tmp = this;
    var tmp0_subject = this.oey_1;
    var tmp_0;
    switch (tmp0_subject == null ? -1 : tmp0_subject.p3_1) {
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = -1;
        break;
      case 4:
        tmp_0 = 1;
        break;
      case 0:
        tmp_0 = 1;
        break;
      case 1:
        tmp_0 = -1;
        break;
      case -1:
        var message = 'SpriteAnimationFamily: direction shall not be null!';
        throw IllegalStateException.h5(toString_0(message));
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.qey_1 = tmp_0;
  }
  r1t(_this__u8e3s4, entity) {
    if (this.sey_1)
      return Unit_instance;
    else
      this.sey_1 = true;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = _this__u8e3s4.y1t_1.e3(name);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var injectable = tmp;
    injectable.p21_1 = true;
    var tmp_0 = injectable.o21_1;
    var assetStore = tmp_0 instanceof AssetStore ? tmp_0 : THROW_CCE();
    if (this.oey_1 == null) {
      this.oey_1 = getAnimationDirection(assetStore, this.iey_1, this.ley_1);
    }
    this.uep(assetStore);
    this.vep(assetStore);
    this.wep();
  }
  z27() {
    return this.vey(VOID, VOID, VOID, VOID, VOID, VOID, this.oey_1);
  }
  em() {
    return this.iey_1;
  }
  fm() {
    return this.jey_1;
  }
  jt() {
    return this.key_1;
  }
  zep() {
    return this.ley_1;
  }
  aeq() {
    return this.mey_1;
  }
  wey(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized) {
    return SpriteComponent.uey(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized);
  }
  vey(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, $super) {
    name = name === VOID ? this.iey_1 : name;
    anchorX = anchorX === VOID ? this.jey_1 : anchorX;
    anchorY = anchorY === VOID ? this.key_1 : anchorY;
    animation = animation === VOID ? this.ley_1 : animation;
    frameIndex = frameIndex === VOID ? this.mey_1 : frameIndex;
    running = running === VOID ? this.ney_1 : running;
    direction = direction === VOID ? this.oey_1 : direction;
    destroyOnAnimationFinished = destroyOnAnimationFinished === VOID ? this.pey_1 : destroyOnAnimationFinished;
    increment = increment === VOID ? this.qey_1 : increment;
    nextFrameIn = nextFrameIn === VOID ? this.rey_1 : nextFrameIn;
    initialized = initialized === VOID ? this.sey_1 : initialized;
    return $super === VOID ? this.wey(name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized) : $super.wey.call(this, name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized);
  }
  toString() {
    return 'SpriteComponent(name=' + this.iey_1 + ', anchorX=' + this.jey_1 + ', anchorY=' + this.key_1 + ', animation=' + this.ley_1 + ', frameIndex=' + this.mey_1 + ', running=' + this.ney_1 + ', direction=' + toString(this.oey_1) + ', destroyOnAnimationFinished=' + this.pey_1 + ', increment=' + this.qey_1 + ', nextFrameIn=' + this.rey_1 + ', initialized=' + this.sey_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.iey_1);
    result = imul(result, 31) + getNumberHashCode(this.jey_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.key_1) | 0;
    result = imul(result, 31) + (this.ley_1 == null ? 0 : getStringHashCode(this.ley_1)) | 0;
    result = imul(result, 31) + this.mey_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ney_1) | 0;
    result = imul(result, 31) + (this.oey_1 == null ? 0 : this.oey_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pey_1) | 0;
    result = imul(result, 31) + this.qey_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.rey_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sey_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpriteComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SpriteComponent ? other : THROW_CCE();
    if (!(this.iey_1 === tmp0_other_with_cast.iey_1))
      return false;
    if (!equals(this.jey_1, tmp0_other_with_cast.jey_1))
      return false;
    if (!equals(this.key_1, tmp0_other_with_cast.key_1))
      return false;
    if (!(this.ley_1 == tmp0_other_with_cast.ley_1))
      return false;
    if (!(this.mey_1 === tmp0_other_with_cast.mey_1))
      return false;
    if (!(this.ney_1 === tmp0_other_with_cast.ney_1))
      return false;
    if (!equals(this.oey_1, tmp0_other_with_cast.oey_1))
      return false;
    if (!(this.pey_1 === tmp0_other_with_cast.pey_1))
      return false;
    if (!(this.qey_1 === tmp0_other_with_cast.qey_1))
      return false;
    if (!equals(this.rey_1, tmp0_other_with_cast.rey_1))
      return false;
    if (!(this.sey_1 === tmp0_other_with_cast.sey_1))
      return false;
    return true;
  }
  static tey(seen0, name, anchorX, anchorY, animation, frameIndex, running, direction, destroyOnAnimationFinished, increment, nextFrameIn, initialized, serializationConstructorMarker) {
    Companion_getInstance_43();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_32().gey_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.iey_1 = '';
    else
      $this.iey_1 = name;
    if (0 === (seen0 & 2))
      $this.jey_1 = 0.0;
    else
      $this.jey_1 = anchorX;
    if (0 === (seen0 & 4))
      $this.key_1 = 0.0;
    else
      $this.key_1 = anchorY;
    if (0 === (seen0 & 8))
      $this.ley_1 = null;
    else
      $this.ley_1 = animation;
    if (0 === (seen0 & 16))
      $this.mey_1 = 0;
    else
      $this.mey_1 = frameIndex;
    if (0 === (seen0 & 32))
      $this.ney_1 = false;
    else
      $this.ney_1 = running;
    if (0 === (seen0 & 64))
      $this.oey_1 = null;
    else
      $this.oey_1 = direction;
    if (0 === (seen0 & 128))
      $this.pey_1 = false;
    else
      $this.pey_1 = destroyOnAnimationFinished;
    if (0 === (seen0 & 256))
      $this.qey_1 = -2;
    else
      $this.qey_1 = increment;
    if (0 === (seen0 & 512))
      $this.rey_1 = 0.0;
    else
      $this.rey_1 = nextFrameIn;
    if (0 === (seen0 & 1024))
      $this.sey_1 = false;
    else
      $this.sey_1 = initialized;
    return $this;
  }
}
class Companion_34 {}
class $serializer_32 {
  constructor() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LayerVisibility', this, 4);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    tmp0_serialDesc.m16('rgba', true);
    tmp0_serialDesc.m16('visibility', true);
    this.xey_1 = tmp0_serialDesc;
  }
  yey(encoder, value) {
    var tmp0_desc = this.xey_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.zey_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.zey_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.aez_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.aez_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.bez_1 === Colors_getInstance().y57_1)) {
      tmp1_output.p10(tmp0_desc, 2, RGBAAsInt_getInstance(), new RGBA(value.bez_1));
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.dez() === !(_RGBA___get_a__impl__6msvu7(value.bez_1) === 0))) {
      tmp1_output.f10(tmp0_desc, 3, value.dez());
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yey(encoder, value instanceof LayerProperties ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xey_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = RGBAAsInt_getInstance();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp8_input.jz(tmp0_desc, 2, tmp, tmp_0 == null ? null : new RGBA(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.o5p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zy(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_2 = RGBAAsInt_getInstance();
            var tmp_3 = tmp6_local2;
            var tmp_4 = tmp8_input.jz(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new RGBA(tmp_3));
            tmp6_local2 = tmp_4 == null ? null : tmp_4.o5p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zy(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return LayerProperties.eez(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.xey_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), RGBAAsInt_getInstance(), BooleanSerializer_getInstance()];
  }
}
class LayerProperties {
  constructor(offsetX, offsetY, rgba) {
    offsetX = offsetX === VOID ? 0.0 : offsetX;
    offsetY = offsetY === VOID ? 0.0 : offsetY;
    rgba = rgba === VOID ? Colors_getInstance().y57_1 : rgba;
    this.zey_1 = offsetX;
    this.aez_1 = offsetY;
    this.bez_1 = rgba;
    this.cez_1 = !(_RGBA___get_a__impl__6msvu7(this.bez_1) === 0);
  }
  fez(value) {
    this.bez_1 = value ? RGBA__withAf_impl_dpdu32(this.bez_1, 1.0) : RGBA__withAf_impl_dpdu32(this.bez_1, 0.0);
    this.cez_1 = value;
  }
  dez() {
    return !(_RGBA___get_a__impl__6msvu7(this.bez_1) === 0);
  }
  z27() {
    return this.gez(VOID, VOID, cloneRgba(this.bez_1));
  }
  hez(offsetX, offsetY, rgba) {
    return new LayerProperties(offsetX, offsetY, rgba);
  }
  gez(offsetX, offsetY, rgba, $super) {
    offsetX = offsetX === VOID ? this.zey_1 : offsetX;
    offsetY = offsetY === VOID ? this.aez_1 : offsetY;
    rgba = rgba === VOID ? this.bez_1 : rgba;
    return $super === VOID ? this.hez(offsetX, offsetY, rgba) : $super.hez.call(this, offsetX, offsetY, new RGBA(rgba));
  }
  toString() {
    return 'LayerProperties(offsetX=' + this.zey_1 + ', offsetY=' + this.aez_1 + ', rgba=' + RGBA__toString_impl_4lw6dp(this.bez_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.zey_1);
    result = imul(result, 31) + getNumberHashCode(this.aez_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.bez_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerProperties))
      return false;
    var tmp0_other_with_cast = other instanceof LayerProperties ? other : THROW_CCE();
    if (!equals(this.zey_1, tmp0_other_with_cast.zey_1))
      return false;
    if (!equals(this.aez_1, tmp0_other_with_cast.aez_1))
      return false;
    if (!(this.bez_1 === tmp0_other_with_cast.bez_1))
      return false;
    return true;
  }
  static eez(seen0, offsetX, offsetY, rgba, visibility, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_33().xey_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.zey_1 = 0.0;
    else
      $this.zey_1 = offsetX;
    if (0 === (seen0 & 2))
      $this.aez_1 = 0.0;
    else
      $this.aez_1 = offsetY;
    if (0 === (seen0 & 4))
      $this.bez_1 = Colors_getInstance().y57_1;
    else
      $this.bez_1 = rgba;
    if (0 === (seen0 & 8))
      $this.cez_1 = !(_RGBA___get_a__impl__6msvu7($this.bez_1) === 0);
    else
      $this.cez_1 = visibility;
    return $this;
  }
}
class Companion_35 extends ComponentType {
  constructor() {
    Companion_instance_37 = null;
    super();
    Companion_instance_37 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.jez_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_33())];
  }
}
class $serializer_33 {
  constructor() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpecificLayer', this, 1);
    tmp0_serialDesc.m16('layerMap', true);
    this.kez_1 = tmp0_serialDesc;
  }
  lez(encoder, value) {
    var tmp0_desc = this.kez_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_45().jez_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      var tmp_0 = value.mez_1;
      // Inline function 'kotlin.collections.mapOf' call
      var tmp$ret$0 = emptyMap();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.mez_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.lez(encoder, value instanceof SpriteLayersComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kez_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    var tmp6_cached = Companion_getInstance_45().jez_1;
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.jz(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.jz(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return SpriteLayersComponent.nez(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.kez_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_45().jez_1[0]];
  }
}
class SpriteLayersComponent extends CloneableComponent {
  static oez(layerMap) {
    Companion_getInstance_45();
    var tmp;
    if (layerMap === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp = emptyMap();
    } else {
      tmp = layerMap;
    }
    layerMap = tmp;
    var $this = this.uem();
    $this.mez_1 = layerMap;
    return $this;
  }
  q1t() {
    return Companion_getInstance_45();
  }
  z27() {
    return this.pez(clone_5(this.mez_1));
  }
  em() {
    return this.mez_1;
  }
  pez(layerMap) {
    return SpriteLayersComponent.oez(layerMap);
  }
  toString() {
    return 'SpriteLayersComponent(layerMap=' + toString_0(this.mez_1) + ')';
  }
  hashCode() {
    return hashCode(this.mez_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpriteLayersComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SpriteLayersComponent ? other : THROW_CCE();
    if (!equals(this.mez_1, tmp0_other_with_cast.mez_1))
      return false;
    return true;
  }
  static nez(seen0, layerMap, serializationConstructorMarker) {
    Companion_getInstance_45();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_34().kez_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mapOf' call
      tmp.mez_1 = emptyMap();
    } else
      $this.mez_1 = layerMap;
    return $this;
  }
}
class Companion_36 extends ComponentType {
  constructor() {
    Companion_instance_38 = null;
    super();
    Companion_instance_38 = this;
  }
}
class $serializer_34 {
  constructor() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SwitchLayerVisibility', this, 2);
    tmp0_serialDesc.m16('offVariance', true);
    tmp0_serialDesc.m16('onVariance', true);
    this.qez_1 = tmp0_serialDesc;
  }
  rez(encoder, value) {
    var tmp0_desc = this.qez_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.sez_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 0, value.sez_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.tez_1, 1.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.tez_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.rez(encoder, value instanceof SwitchLayerVisibilityComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qez_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ez(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return SwitchLayerVisibilityComponent.uez(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.qez_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class SwitchLayerVisibilityComponent extends CloneableComponent {
  static vez(offVariance, onVariance) {
    Companion_getInstance_46();
    offVariance = offVariance === VOID ? 0.0 : offVariance;
    onVariance = onVariance === VOID ? 1.0 : onVariance;
    var $this = this.uem();
    $this.sez_1 = offVariance;
    $this.tez_1 = onVariance;
    return $this;
  }
  q1t() {
    return Companion_getInstance_46();
  }
  z27() {
    return this.wez();
  }
  em() {
    return this.sez_1;
  }
  fm() {
    return this.tez_1;
  }
  ues(offVariance, onVariance) {
    return SwitchLayerVisibilityComponent.vez(offVariance, onVariance);
  }
  wez(offVariance, onVariance, $super) {
    offVariance = offVariance === VOID ? this.sez_1 : offVariance;
    onVariance = onVariance === VOID ? this.tez_1 : onVariance;
    return $super === VOID ? this.ues(offVariance, onVariance) : $super.ues.call(this, offVariance, onVariance);
  }
  toString() {
    return 'SwitchLayerVisibilityComponent(offVariance=' + this.sez_1 + ', onVariance=' + this.tez_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.sez_1);
    result = imul(result, 31) + getNumberHashCode(this.tez_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SwitchLayerVisibilityComponent))
      return false;
    var tmp0_other_with_cast = other instanceof SwitchLayerVisibilityComponent ? other : THROW_CCE();
    if (!equals(this.sez_1, tmp0_other_with_cast.sez_1))
      return false;
    if (!equals(this.tez_1, tmp0_other_with_cast.tez_1))
      return false;
    return true;
  }
  static uez(seen0, offVariance, onVariance, serializationConstructorMarker) {
    Companion_getInstance_46();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_35().qez_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.sez_1 = 0.0;
    else
      $this.sez_1 = offVariance;
    if (0 === (seen0 & 2))
      $this.tez_1 = 1.0;
    else
      $this.tez_1 = onVariance;
    return $this;
  }
}
class Companion_37 extends ComponentType {
  constructor() {
    Companion_instance_39 = null;
    super();
    Companion_instance_39 = this;
  }
}
class $serializer_35 {
  constructor() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Text', this, 9);
    tmp0_serialDesc.m16('text', true);
    tmp0_serialDesc.m16('fontName', true);
    tmp0_serialDesc.m16('textRangeStart', true);
    tmp0_serialDesc.m16('textRangeEnd', true);
    tmp0_serialDesc.m16('width', true);
    tmp0_serialDesc.m16('height', true);
    tmp0_serialDesc.m16('wordWrap', true);
    tmp0_serialDesc.m16('horizontalAlign', true);
    tmp0_serialDesc.m16('verticalAlign', true);
    this.xez_1 = tmp0_serialDesc;
  }
  yez(encoder, value) {
    var tmp0_desc = this.xez_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.zez_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.zez_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.af0_1 === '')) {
      tmp1_output.n10(tmp0_desc, 1, value.af0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.bf0_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 2, value.bf0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.cf0_1 === 2147483647)) {
      tmp1_output.i10(tmp0_desc, 3, value.cf0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.df0_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.df0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.ef0_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.ef0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.ff0_1 === true)) {
      tmp1_output.f10(tmp0_desc, 6, value.ff0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.gf0_1, Companion_getInstance_1().j6w_1)) {
      tmp1_output.p10(tmp0_desc, 7, HorizontalAlignAsDouble_getInstance(), new HorizontalAlign(value.gf0_1));
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !equals(value.hf0_1, Companion_getInstance_2().o6w_1)) {
      tmp1_output.p10(tmp0_desc, 8, VerticalAlignAsDouble_getInstance(), new VerticalAlign(value.hf0_1));
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.yez(encoder, value instanceof TextFieldComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.xez_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.xy(tmp0_desc);
    if (tmp13_input.nz()) {
      tmp4_local0 = tmp13_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.cz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.zy(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      var tmp = HorizontalAlignAsDouble_getInstance();
      var tmp_0 = tmp11_local7;
      var tmp_1 = tmp13_input.jz(tmp0_desc, 7, tmp, tmp_0 == null ? null : new HorizontalAlign(tmp_0));
      tmp11_local7 = tmp_1 == null ? null : tmp_1.x6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      var tmp_2 = VerticalAlignAsDouble_getInstance();
      var tmp_3 = tmp12_local8;
      var tmp_4 = tmp13_input.jz(tmp0_desc, 8, tmp_2, tmp_3 == null ? null : new VerticalAlign(tmp_3));
      tmp12_local8 = tmp_4 == null ? null : tmp_4.v6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.cz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.zy(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            var tmp_5 = HorizontalAlignAsDouble_getInstance();
            var tmp_6 = tmp11_local7;
            var tmp_7 = tmp13_input.jz(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new HorizontalAlign(tmp_6));
            tmp11_local7 = tmp_7 == null ? null : tmp_7.x6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            var tmp_8 = VerticalAlignAsDouble_getInstance();
            var tmp_9 = tmp12_local8;
            var tmp_10 = tmp13_input.jz(tmp0_desc, 8, tmp_8, tmp_9 == null ? null : new VerticalAlign(tmp_9));
            tmp12_local8 = tmp_10 == null ? null : tmp_10.v6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp13_input.yy(tmp0_desc);
    return TextFieldComponent.if0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  }
  yu() {
    return this.xez_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), HorizontalAlignAsDouble_getInstance(), VerticalAlignAsDouble_getInstance()];
  }
}
class TextFieldComponent extends CloneableComponent {
  static jf0(text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign) {
    Companion_getInstance_47();
    text = text === VOID ? '' : text;
    fontName = fontName === VOID ? '' : fontName;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    width = width === VOID ? 0.0 : width;
    height = height === VOID ? 0.0 : height;
    wordWrap = wordWrap === VOID ? true : wordWrap;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_1().j6w_1 : horizontalAlign;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_2().o6w_1 : verticalAlign;
    var $this = this.uem();
    $this.zez_1 = text;
    $this.af0_1 = fontName;
    $this.bf0_1 = textRangeStart;
    $this.cf0_1 = textRangeEnd;
    $this.df0_1 = width;
    $this.ef0_1 = height;
    $this.ff0_1 = wordWrap;
    $this.gf0_1 = horizontalAlign;
    $this.hf0_1 = verticalAlign;
    return $this;
  }
  q1t() {
    return Companion_getInstance_47();
  }
  z27() {
    return this.kf0(VOID, VOID, VOID, VOID, VOID, VOID, VOID, clone_1(this.gf0_1), clone_2(this.hf0_1));
  }
  em() {
    return this.zez_1;
  }
  fm() {
    return this.af0_1;
  }
  jt() {
    return this.bf0_1;
  }
  zep() {
    return this.cf0_1;
  }
  aeq() {
    return this.df0_1;
  }
  lf0() {
    return this.ef0_1;
  }
  mf0() {
    return this.ff0_1;
  }
  nf0() {
    return this.gf0_1;
  }
  of0() {
    return this.hf0_1;
  }
  pf0(text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign) {
    return TextFieldComponent.jf0(text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign);
  }
  kf0(text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign, $super) {
    text = text === VOID ? this.zez_1 : text;
    fontName = fontName === VOID ? this.af0_1 : fontName;
    textRangeStart = textRangeStart === VOID ? this.bf0_1 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? this.cf0_1 : textRangeEnd;
    width = width === VOID ? this.df0_1 : width;
    height = height === VOID ? this.ef0_1 : height;
    wordWrap = wordWrap === VOID ? this.ff0_1 : wordWrap;
    horizontalAlign = horizontalAlign === VOID ? this.gf0_1 : horizontalAlign;
    verticalAlign = verticalAlign === VOID ? this.hf0_1 : verticalAlign;
    return $super === VOID ? this.pf0(text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign) : $super.pf0.call(this, text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, new HorizontalAlign(horizontalAlign), new VerticalAlign(verticalAlign));
  }
  toString() {
    return 'TextFieldComponent(text=' + this.zez_1 + ', fontName=' + this.af0_1 + ', textRangeStart=' + this.bf0_1 + ', textRangeEnd=' + this.cf0_1 + ', width=' + this.df0_1 + ', height=' + this.ef0_1 + ', wordWrap=' + this.ff0_1 + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.gf0_1) + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.hf0_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.zez_1);
    result = imul(result, 31) + getStringHashCode(this.af0_1) | 0;
    result = imul(result, 31) + this.bf0_1 | 0;
    result = imul(result, 31) + this.cf0_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.df0_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ef0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ff0_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.gf0_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.hf0_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFieldComponent))
      return false;
    var tmp0_other_with_cast = other instanceof TextFieldComponent ? other : THROW_CCE();
    if (!(this.zez_1 === tmp0_other_with_cast.zez_1))
      return false;
    if (!(this.af0_1 === tmp0_other_with_cast.af0_1))
      return false;
    if (!(this.bf0_1 === tmp0_other_with_cast.bf0_1))
      return false;
    if (!(this.cf0_1 === tmp0_other_with_cast.cf0_1))
      return false;
    if (!equals(this.df0_1, tmp0_other_with_cast.df0_1))
      return false;
    if (!equals(this.ef0_1, tmp0_other_with_cast.ef0_1))
      return false;
    if (!(this.ff0_1 === tmp0_other_with_cast.ff0_1))
      return false;
    if (!equals(this.gf0_1, tmp0_other_with_cast.gf0_1))
      return false;
    if (!equals(this.hf0_1, tmp0_other_with_cast.hf0_1))
      return false;
    return true;
  }
  static if0(seen0, text, fontName, textRangeStart, textRangeEnd, width, height, wordWrap, horizontalAlign, verticalAlign, serializationConstructorMarker) {
    Companion_getInstance_47();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_36().xez_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.zez_1 = '';
    else
      $this.zez_1 = text;
    if (0 === (seen0 & 2))
      $this.af0_1 = '';
    else
      $this.af0_1 = fontName;
    if (0 === (seen0 & 4))
      $this.bf0_1 = 0;
    else
      $this.bf0_1 = textRangeStart;
    if (0 === (seen0 & 8))
      $this.cf0_1 = 2147483647;
    else
      $this.cf0_1 = textRangeEnd;
    if (0 === (seen0 & 16))
      $this.df0_1 = 0.0;
    else
      $this.df0_1 = width;
    if (0 === (seen0 & 32))
      $this.ef0_1 = 0.0;
    else
      $this.ef0_1 = height;
    if (0 === (seen0 & 64))
      $this.ff0_1 = true;
    else
      $this.ff0_1 = wordWrap;
    if (0 === (seen0 & 128))
      $this.gf0_1 = Companion_getInstance_1().j6w_1;
    else
      $this.gf0_1 = horizontalAlign;
    if (0 === (seen0 & 256))
      $this.hf0_1 = Companion_getInstance_2().o6w_1;
    else
      $this.hf0_1 = verticalAlign;
    return $this;
  }
}
class Companion_38 extends ComponentType {
  constructor() {
    Companion_instance_40 = null;
    super();
    Companion_instance_40 = this;
  }
}
class $serializer_36 {
  constructor() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TiledLevelMap', this, 1);
    tmp0_serialDesc.m16('assetName', true);
    this.qf0_1 = tmp0_serialDesc;
  }
  rf0(encoder, value) {
    var tmp0_desc = this.qf0_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.sf0_1 === '')) {
      tmp1_output.n10(tmp0_desc, 0, value.sf0_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.rf0(encoder, value instanceof TiledLevelMapComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qf0_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return TiledLevelMapComponent.tf0(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.qf0_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class TiledLevelMapComponent extends CloneableComponent {
  static uf0(assetName) {
    Companion_getInstance_48();
    assetName = assetName === VOID ? '' : assetName;
    var $this = this.uem();
    $this.sf0_1 = assetName;
    return $this;
  }
  q1t() {
    return Companion_getInstance_48();
  }
  z27() {
    return this.vf0();
  }
  wem(assetName) {
    return TiledLevelMapComponent.uf0(assetName);
  }
  vf0(assetName, $super) {
    assetName = assetName === VOID ? this.sf0_1 : assetName;
    return $super === VOID ? this.wem(assetName) : $super.wem.call(this, assetName);
  }
  toString() {
    return 'TiledLevelMapComponent(assetName=' + this.sf0_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.sf0_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledLevelMapComponent))
      return false;
    var tmp0_other_with_cast = other instanceof TiledLevelMapComponent ? other : THROW_CCE();
    if (!(this.sf0_1 === tmp0_other_with_cast.sf0_1))
      return false;
    return true;
  }
  static tf0(seen0, assetName, serializationConstructorMarker) {
    Companion_getInstance_48();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_37().qf0_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.sf0_1 = '';
    else
      $this.sf0_1 = assetName;
    return $this;
  }
}
class Companion_39 extends ComponentType {
  constructor() {
    Companion_instance_41 = null;
    super();
    Companion_instance_41 = this;
  }
}
class $serializer_37 {
  constructor() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TouchInput', this, 5);
    tmp0_serialDesc.m16('enabled', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('entityConfig', true);
    tmp0_serialDesc.m16('passPositionToEntity', true);
    tmp0_serialDesc.m16('continuousTouch', true);
    this.wf0_1 = tmp0_serialDesc;
  }
  xf0(encoder, value) {
    var tmp0_desc = this.wf0_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.yf0_1 === true)) {
      tmp1_output.f10(tmp0_desc, 0, value.yf0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.zf0_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.zf0_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.af1_1 === '')) {
      tmp1_output.n10(tmp0_desc, 2, value.af1_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.bf1_1 === false)) {
      tmp1_output.f10(tmp0_desc, 3, value.bf1_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.cf1_1 === false)) {
      tmp1_output.f10(tmp0_desc, 4, value.cf1_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.xf0(encoder, value instanceof TouchInputComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.wf0_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.zy(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zy(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.zy(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zy(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return TouchInputComponent.df1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.wf0_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), $serializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class TouchInputComponent extends CloneableComponent {
  static ef1(enabled, entity, entityConfig, passPositionToEntity, continuousTouch) {
    Companion_getInstance_49();
    enabled = enabled === VOID ? true : enabled;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    entityConfig = entityConfig === VOID ? '' : entityConfig;
    passPositionToEntity = passPositionToEntity === VOID ? false : passPositionToEntity;
    continuousTouch = continuousTouch === VOID ? false : continuousTouch;
    var $this = this.uem();
    $this.yf0_1 = enabled;
    $this.zf0_1 = entity;
    $this.af1_1 = entityConfig;
    $this.bf1_1 = passPositionToEntity;
    $this.cf1_1 = continuousTouch;
    return $this;
  }
  q1t() {
    return Companion_getInstance_49();
  }
  z27() {
    return this.ff1(VOID, clone(this.zf0_1));
  }
  gf1(enabled, entity, entityConfig, passPositionToEntity, continuousTouch) {
    return TouchInputComponent.ef1(enabled, entity, entityConfig, passPositionToEntity, continuousTouch);
  }
  ff1(enabled, entity, entityConfig, passPositionToEntity, continuousTouch, $super) {
    enabled = enabled === VOID ? this.yf0_1 : enabled;
    entity = entity === VOID ? this.zf0_1 : entity;
    entityConfig = entityConfig === VOID ? this.af1_1 : entityConfig;
    passPositionToEntity = passPositionToEntity === VOID ? this.bf1_1 : passPositionToEntity;
    continuousTouch = continuousTouch === VOID ? this.cf1_1 : continuousTouch;
    return $super === VOID ? this.gf1(enabled, entity, entityConfig, passPositionToEntity, continuousTouch) : $super.gf1.call(this, enabled, entity, entityConfig, passPositionToEntity, continuousTouch);
  }
  toString() {
    return 'TouchInputComponent(enabled=' + this.yf0_1 + ', entity=' + this.zf0_1.toString() + ', entityConfig=' + this.af1_1 + ', passPositionToEntity=' + this.bf1_1 + ', continuousTouch=' + this.cf1_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.yf0_1);
    result = imul(result, 31) + this.zf0_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.af1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bf1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.cf1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchInputComponent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchInputComponent ? other : THROW_CCE();
    if (!(this.yf0_1 === tmp0_other_with_cast.yf0_1))
      return false;
    if (!this.zf0_1.equals(tmp0_other_with_cast.zf0_1))
      return false;
    if (!(this.af1_1 === tmp0_other_with_cast.af1_1))
      return false;
    if (!(this.bf1_1 === tmp0_other_with_cast.bf1_1))
      return false;
    if (!(this.cf1_1 === tmp0_other_with_cast.cf1_1))
      return false;
    return true;
  }
  static df1(seen0, enabled, entity, entityConfig, passPositionToEntity, continuousTouch, serializationConstructorMarker) {
    Companion_getInstance_49();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_38().wf0_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1))
      $this.yf0_1 = true;
    else
      $this.yf0_1 = enabled;
    if (0 === (seen0 & 2))
      $this.zf0_1 = Companion_getInstance_4().x1s_1;
    else
      $this.zf0_1 = entity;
    if (0 === (seen0 & 4))
      $this.af1_1 = '';
    else
      $this.af1_1 = entityConfig;
    if (0 === (seen0 & 8))
      $this.bf1_1 = false;
    else
      $this.bf1_1 = passPositionToEntity;
    if (0 === (seen0 & 16))
      $this.cf1_1 = false;
    else
      $this.cf1_1 = continuousTouch;
    return $this;
  }
}
class _no_name_provided__qut3iv extends ComponentType {}
class _no_name_provided__qut3iv_0 extends ComponentType {}
class _no_name_provided__qut3iv_1 extends ComponentType {}
class _no_name_provided__qut3iv_2 extends ComponentType {}
class _no_name_provided__qut3iv_3 extends ComponentType {}
class _no_name_provided__qut3iv_4 extends ComponentType {}
class _no_name_provided__qut3iv_5 extends ComponentType {}
class _no_name_provided__qut3iv_6 extends ComponentType {}
class _no_name_provided__qut3iv_7 extends ComponentType {}
class _no_name_provided__qut3iv_8 extends ComponentType {}
class _no_name_provided__qut3iv_9 extends ComponentType {}
class _no_name_provided__qut3iv_10 extends ComponentType {}
class _no_name_provided__qut3iv_11 extends ComponentType {}
class _no_name_provided__qut3iv_12 extends ComponentType {}
class _no_name_provided__qut3iv_13 extends ComponentType {}
class _no_name_provided__qut3iv_14 extends ComponentType {}
class _no_name_provided__qut3iv_15 extends ComponentType {}
class _no_name_provided__qut3iv_16 extends ComponentType {}
class _no_name_provided__qut3iv_17 extends ComponentType {}
class _no_name_provided__qut3iv_18 extends ComponentType {}
class _no_name_provided__qut3iv_19 extends ComponentType {}
class _no_name_provided__qut3iv_20 extends ComponentType {}
class _no_name_provided__qut3iv_21 extends ComponentType {}
class _no_name_provided__qut3iv_22 extends ComponentType {}
class _no_name_provided__qut3iv_23 extends ComponentType {}
class _no_name_provided__qut3iv_24 extends ComponentType {}
class _no_name_provided__qut3iv_25 extends ComponentType {}
class _no_name_provided__qut3iv_26 extends ComponentType {}
class TweenProperty extends Enum {
  constructor(name, ordinal, type) {
    super(name, ordinal);
    this.jf1_1 = type;
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_42 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.kf1_1 = [createSimpleEnumSerializer('korlibs.korge.fleks.components.TweenPropertyComponent.TweenProperty', values_1()), null, null, null, null, null];
    this.lf1_1 = TweenProperty_PositionOffsetX_getInstance().jf1_1;
    this.mf1_1 = TweenProperty_PositionOffsetY_getInstance().jf1_1;
    this.nf1_1 = TweenProperty_PositionX_getInstance().jf1_1;
    this.of1_1 = TweenProperty_PositionY_getInstance().jf1_1;
    this.pf1_1 = TweenProperty_MotionVelocityX_getInstance().jf1_1;
    this.qf1_1 = TweenProperty_RgbaAlpha_getInstance().jf1_1;
    this.rf1_1 = TweenProperty_RgbaTint_getInstance().jf1_1;
    this.sf1_1 = TweenProperty_SpawnerInterval_getInstance().jf1_1;
    this.tf1_1 = TweenProperty_SpawnerNumberOfObjects_getInstance().jf1_1;
    this.uf1_1 = TweenProperty_SpawnerPositionVariation_getInstance().jf1_1;
    this.vf1_1 = TweenProperty_SpawnerTimeVariation_getInstance().jf1_1;
    this.wf1_1 = TweenProperty_SpriteAnimation_getInstance().jf1_1;
    this.xf1_1 = TweenProperty_SpriteDirection_getInstance().jf1_1;
    this.yf1_1 = TweenProperty_SpriteDestroyOnPlayingFinished_getInstance().jf1_1;
    this.zf1_1 = TweenProperty_SpriteRunning_getInstance().jf1_1;
    this.af2_1 = TweenProperty_SwitchLayerVisibilityOnVariance_getInstance().jf1_1;
    this.bf2_1 = TweenProperty_SwitchLayerVisibilityOffVariance_getInstance().jf1_1;
    this.cf2_1 = TweenProperty_SoundStartTrigger_getInstance().jf1_1;
    this.df2_1 = TweenProperty_SoundStopTrigger_getInstance().jf1_1;
    this.ef2_1 = TweenProperty_SoundPosition_getInstance().jf1_1;
    this.ff2_1 = TweenProperty_SoundVolume_getInstance().jf1_1;
    this.gf2_1 = TweenProperty_TextFieldText_getInstance().jf1_1;
    this.hf2_1 = TweenProperty_TextFieldTextRangeStart_getInstance().jf1_1;
    this.if2_1 = TweenProperty_TextFieldTextRangeEnd_getInstance().jf1_1;
    this.jf2_1 = TweenProperty_EventPublish_getInstance().jf1_1;
    this.kf2_1 = TweenProperty_EventReset_getInstance().jf1_1;
    this.lf2_1 = TweenProperty_EventSubscribe_getInstance().jf1_1;
    this.mf2_1 = TweenProperty_TouchInputEnable_getInstance().jf1_1;
  }
}
class $serializer_38 {
  constructor() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenPropertyComponent', this, 6);
    tmp0_serialDesc.m16('property', false);
    tmp0_serialDesc.m16('change', true);
    tmp0_serialDesc.m16('value', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('timeProgress', true);
    tmp0_serialDesc.m16('easing', true);
    this.nf2_1 = tmp0_serialDesc;
  }
  of2(encoder, value) {
    var tmp0_desc = this.nf2_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_50().kf1_1;
    tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.pf2_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.qf2_1, Unit_instance)) {
      tmp1_output.p10(tmp0_desc, 1, AnySerializer_getInstance(), value.qf2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.rf2_1, Unit_instance)) {
      tmp1_output.p10(tmp0_desc, 2, AnySerializer_getInstance(), value.rf2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.sf2_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.sf2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.tf2_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.tf2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.uf2_1, Companion_getInstance_3().m27_1)) {
      tmp1_output.p10(tmp0_desc, 5, EasingAsString_getInstance(), value.uf2_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.of2(encoder, value instanceof TweenPropertyComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.nf2_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_50().kf1_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, AnySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, AnySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.jz(tmp0_desc, 1, AnySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, AnySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.jz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return TweenPropertyComponent.vf2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.nf2_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_50().kf1_1[0], AnySerializer_getInstance(), AnySerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), EasingAsString_getInstance()];
  }
}
class TweenPropertyComponent extends CloneableComponent {
  static wf2(property, change, value, duration, timeProgress, easing) {
    Companion_getInstance_50();
    change = change === VOID ? Unit_instance : change;
    value = value === VOID ? Unit_instance : value;
    duration = duration === VOID ? 0.0 : duration;
    timeProgress = timeProgress === VOID ? 0.0 : timeProgress;
    easing = easing === VOID ? Companion_getInstance_3().m27_1 : easing;
    var $this = this.uem();
    $this.pf2_1 = property;
    $this.qf2_1 = change;
    $this.rf2_1 = value;
    $this.sf2_1 = duration;
    $this.tf2_1 = timeProgress;
    $this.uf2_1 = easing;
    return $this;
  }
  q1t() {
    return this.pf2_1.jf1_1;
  }
  z27() {
    return this.xf2(VOID, this.qf2_1, this.rf2_1, VOID, VOID, this.uf2_1);
  }
  jt() {
    return this.rf2_1;
  }
  yf2(property, change, value, duration, timeProgress, easing) {
    return TweenPropertyComponent.wf2(property, change, value, duration, timeProgress, easing);
  }
  xf2(property, change, value, duration, timeProgress, easing, $super) {
    property = property === VOID ? this.pf2_1 : property;
    change = change === VOID ? this.qf2_1 : change;
    value = value === VOID ? this.rf2_1 : value;
    duration = duration === VOID ? this.sf2_1 : duration;
    timeProgress = timeProgress === VOID ? this.tf2_1 : timeProgress;
    easing = easing === VOID ? this.uf2_1 : easing;
    return $super === VOID ? this.yf2(property, change, value, duration, timeProgress, easing) : $super.yf2.call(this, property, change, value, duration, timeProgress, easing);
  }
  toString() {
    return 'TweenPropertyComponent(property=' + this.pf2_1.toString() + ', change=' + toString_0(this.qf2_1) + ', value=' + toString_0(this.rf2_1) + ', duration=' + this.sf2_1 + ', timeProgress=' + this.tf2_1 + ', easing=' + toString_0(this.uf2_1) + ')';
  }
  hashCode() {
    var result = this.pf2_1.hashCode();
    result = imul(result, 31) + hashCode(this.qf2_1) | 0;
    result = imul(result, 31) + hashCode(this.rf2_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sf2_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tf2_1) | 0;
    result = imul(result, 31) + hashCode(this.uf2_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenPropertyComponent))
      return false;
    var tmp0_other_with_cast = other instanceof TweenPropertyComponent ? other : THROW_CCE();
    if (!this.pf2_1.equals(tmp0_other_with_cast.pf2_1))
      return false;
    if (!equals(this.qf2_1, tmp0_other_with_cast.qf2_1))
      return false;
    if (!equals(this.rf2_1, tmp0_other_with_cast.rf2_1))
      return false;
    if (!equals(this.sf2_1, tmp0_other_with_cast.sf2_1))
      return false;
    if (!equals(this.tf2_1, tmp0_other_with_cast.tf2_1))
      return false;
    if (!equals(this.uf2_1, tmp0_other_with_cast.uf2_1))
      return false;
    return true;
  }
  static vf2(seen0, property, change, value, duration, timeProgress, easing, serializationConstructorMarker) {
    Companion_getInstance_50();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_39().nf2_1);
    }
    var $this = this.uem();
    $this.pf2_1 = property;
    if (0 === (seen0 & 2))
      $this.qf2_1 = Unit_instance;
    else
      $this.qf2_1 = change;
    if (0 === (seen0 & 4))
      $this.rf2_1 = Unit_instance;
    else
      $this.rf2_1 = value;
    if (0 === (seen0 & 8))
      $this.sf2_1 = 0.0;
    else
      $this.sf2_1 = duration;
    if (0 === (seen0 & 16))
      $this.tf2_1 = 0.0;
    else
      $this.tf2_1 = timeProgress;
    if (0 === (seen0 & 32))
      $this.uf2_1 = Companion_getInstance_3().m27_1;
    else
      $this.uf2_1 = easing;
    return $this;
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_43 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(TweenBase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.zf2_1 = [new ArrayListSerializer(PolymorphicSerializer.qv(tmp_0, tmp$ret$2)), null, null, null, null];
  }
}
class $serializer_39 {
  constructor() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpawnNewTweenSequence', this, 5);
    tmp0_serialDesc.m16('tweens', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.af3_1 = tmp0_serialDesc;
  }
  bf3(encoder, value) {
    var tmp0_desc = this.af3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_51().zf2_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.cf3_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.cf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.df3_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.df3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.ef3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.ef3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.ff3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.ff3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.gf3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.gf3_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.bf3(encoder, value instanceof SpawnNewTweenSequence ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.af3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    var tmp10_cached = Companion_getInstance_51().zf2_1;
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return SpawnNewTweenSequence.hf3(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.af3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_51().zf2_1[0], $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_44 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(TweenBase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.if3_1 = [new ArrayListSerializer(PolymorphicSerializer.qv(tmp_0, tmp$ret$2)), null, null, null, null];
  }
}
class $serializer_40 {
  constructor() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LoopTweens', this, 5);
    tmp0_serialDesc.m16('tweens', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.jf3_1 = tmp0_serialDesc;
  }
  kf3(encoder, value) {
    var tmp0_desc = this.jf3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_52().if3_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.lf3_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.lf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.mf3_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.mf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.nf3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.nf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.of3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.of3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.pf3_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.pf3_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.kf3(encoder, value instanceof LoopTweens ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.jf3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    var tmp10_cached = Companion_getInstance_52().if3_1;
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return LoopTweens.qf3(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.jf3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_52().if3_1[0], $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_45 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(TweenBase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.rf3_1 = [new ArrayListSerializer(PolymorphicSerializer.qv(tmp_0, tmp$ret$2)), null, null, null, null];
  }
}
class $serializer_41 {
  constructor() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallelTweens', this, 5);
    tmp0_serialDesc.m16('tweens', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.sf3_1 = tmp0_serialDesc;
  }
  tf3(encoder, value) {
    var tmp0_desc = this.sf3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_53().rf3_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.uf3_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.uf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.vf3_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.vf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.wf3_1, 0.0)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.wf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.xf3_1, 0.0)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.xf3_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.yf3_1, Companion_getInstance_3().m27_1)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.yf3_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.tf3(encoder, value instanceof ParallelTweens ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.sf3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    var tmp10_cached = Companion_getInstance_53().rf3_1;
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.jz(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return ParallelTweens.zf3(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.sf3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_53().rf3_1[0], $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_44 {}
class $serializer_42 {
  constructor() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SendEvent', this, 5);
    tmp0_serialDesc.m16('event', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.af4_1 = tmp0_serialDesc;
  }
  bf4(encoder, value) {
    var tmp0_desc = this.af4_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.cf4_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 0, value.cf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.df4_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.df4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.ef4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.ef4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.ff4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.ff4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.gf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.gf4_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.bf4(encoder, value instanceof SendEvent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.af4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return SendEvent.hf4(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.af4_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_45 {}
class $serializer_43 {
  constructor() {
    $serializer_instance_43 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ResetEvent', this, 5);
    tmp0_serialDesc.m16('event', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.if4_1 = tmp0_serialDesc;
  }
  jf4(encoder, value) {
    var tmp0_desc = this.if4_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.kf4_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 0, value.kf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.lf4_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.lf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.mf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.mf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.nf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.nf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.of4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.of4_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.jf4(encoder, value instanceof ResetEvent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.if4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return ResetEvent.pf4(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.if4_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_46 {}
class $serializer_44 {
  constructor() {
    $serializer_instance_44 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Wait', this, 5);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('event', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('easing', true);
    this.qf4_1 = tmp0_serialDesc;
  }
  rf4(encoder, value) {
    var tmp0_desc = this.qf4_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !equals(value.sf4_1, 3.4028235E38)) {
      tmp1_output.r10(tmp0_desc, 0, FloatSerializer_getInstance(), value.sf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.tf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, IntSerializer_getInstance(), value.tf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.uf4_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance(), value.uf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.vf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.vf4_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.wf4_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.wf4_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.rf4(encoder, value instanceof Wait ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qf4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return Wait.xf4(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.qf4_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(FloatSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_47 {}
class $serializer_45 {
  constructor() {
    $serializer_instance_45 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('Jump', this, 6);
    tmp0_serialDesc.m16('distance', false);
    tmp0_serialDesc.m16('event', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.yf4_1 = tmp0_serialDesc;
  }
  zf4(encoder, value) {
    var tmp0_desc = this.yf4_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.i10(tmp0_desc, 0, value.af5_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.bf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, IntSerializer_getInstance(), value.bf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !value.cf5_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance(), value.cf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.df5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.df5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.ef5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, FloatSerializer_getInstance(), value.ef5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.ff5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, EasingAsString_getInstance(), value.ff5_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.zf4(encoder, value instanceof Jump ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.yf4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return Jump.gf5(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.yf4_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_48 {}
class $serializer_46 {
  constructor() {
    $serializer_instance_46 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DeleteEntity', this, 4);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.hf5_1 = tmp0_serialDesc;
  }
  if5(encoder, value) {
    var tmp0_desc = this.hf5_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.p10(tmp0_desc, 0, $serializer_getInstance(), value.jf5_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.kf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, FloatSerializer_getInstance(), value.kf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.lf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.lf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.mf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, EasingAsString_getInstance(), value.mf5_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.if5(encoder, value instanceof DeleteEntity ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.hf5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.xy(tmp0_desc);
    if (tmp8_input.nz()) {
      tmp4_local0 = tmp8_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.lz(tmp0_desc, 3, EasingAsString_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.jz(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.lz(tmp0_desc, 3, EasingAsString_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp8_input.yy(tmp0_desc);
    return DeleteEntity.nf5(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  yu() {
    return this.hf5_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_49 {}
class $serializer_47 {
  constructor() {
    $serializer_instance_47 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SpawnEntity', this, 7);
    tmp0_serialDesc.m16('entityConfig', false);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.of5_1 = tmp0_serialDesc;
  }
  pf5(encoder, value) {
    var tmp0_desc = this.of5_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.qf5_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !equals(value.rf5_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 1, value.rf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.sf5_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.sf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !value.tf5_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 3, $serializer_getInstance(), value.tf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.uf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, FloatSerializer_getInstance(), value.uf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.vf5_1, 0.0)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.vf5_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.wf5_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, EasingAsString_getInstance(), value.wf5_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.pf5(encoder, value instanceof SpawnEntity ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.of5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return SpawnEntity.xf5(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.of5_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_50 {}
class $serializer_48 {
  constructor() {
    $serializer_instance_48 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ExecuteConfigFunction', this, 5);
    tmp0_serialDesc.m16('entityConfig', false);
    tmp0_serialDesc.m16('entity', true);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.yf5_1 = tmp0_serialDesc;
  }
  zf5(encoder, value) {
    var tmp0_desc = this.yf5_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.af6_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !value.bf6_1.equals(Companion_getInstance_4().x1s_1)) {
      tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.bf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.cf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.cf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.df6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.df6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.ef6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.ef6_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.zf5(encoder, value instanceof ExecuteConfigFunction ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.yf5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return ExecuteConfigFunction.ff6(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.yf5_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_51 {}
class $serializer_49 {
  constructor() {
    $serializer_instance_49 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenTextField', this, 7);
    tmp0_serialDesc.m16('text', true);
    tmp0_serialDesc.m16('textRangeStart', true);
    tmp0_serialDesc.m16('textRangeEnd', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.gf6_1 = tmp0_serialDesc;
  }
  hf6(encoder, value) {
    var tmp0_desc = this.gf6_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.if6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, StringSerializer_getInstance(), value.if6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.jf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, IntSerializer_getInstance(), value.jf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.kf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, IntSerializer_getInstance(), value.kf6_1);
    }
    tmp1_output.p10(tmp0_desc, 3, $serializer_getInstance(), value.lf6_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.mf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, FloatSerializer_getInstance(), value.mf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.nf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.nf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.of6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, EasingAsString_getInstance(), value.of6_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.hf6(encoder, value instanceof TweenTextField ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.gf6_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return TweenTextField.pf6(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.gf6_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_52 {}
class $serializer_50 {
  constructor() {
    $serializer_instance_50 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenRgba', this, 7);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('tint', true);
    tmp0_serialDesc.m16('visible', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.qf6_1 = tmp0_serialDesc;
  }
  rf6(encoder, value) {
    var tmp0_desc = this.qf6_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.sf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, FloatSerializer_getInstance(), value.sf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.tf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, $serializer_getInstance_26(), value.tf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.uf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, BooleanSerializer_getInstance(), value.uf6_1);
    }
    tmp1_output.p10(tmp0_desc, 3, $serializer_getInstance(), value.vf6_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.wf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, FloatSerializer_getInstance(), value.wf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.xf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.xf6_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.yf6_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, EasingAsString_getInstance(), value.yf6_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.rf6(encoder, value instanceof TweenRgba ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.qf6_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, $serializer_getInstance_26(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, $serializer_getInstance_26(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.jz(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, EasingAsString_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return TweenRgba.zf6(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.qf6_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(FloatSerializer_getInstance()), get_nullable($serializer_getInstance_26()), get_nullable(BooleanSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_53 {}
class $serializer_51 {
  constructor() {
    $serializer_instance_51 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenPosition', this, 8);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.af7_1 = tmp0_serialDesc;
  }
  bf7(encoder, value) {
    var tmp0_desc = this.af7_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.cf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, FloatSerializer_getInstance(), value.cf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.df7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, FloatSerializer_getInstance(), value.df7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.ef7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.ef7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.ff7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.ff7_1);
    }
    tmp1_output.p10(tmp0_desc, 4, $serializer_getInstance(), value.gf7_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.hf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.hf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.if7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, FloatSerializer_getInstance(), value.if7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.jf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, EasingAsString_getInstance(), value.jf7_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.bf7(encoder, value instanceof TweenPosition ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.af7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.xy(tmp0_desc);
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return TweenPosition.kf7(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.af7_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_54 {}
class $serializer_52 {
  constructor() {
    $serializer_instance_52 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenMotion', this, 5);
    tmp0_serialDesc.m16('velocityX', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.lf7_1 = tmp0_serialDesc;
  }
  mf7(encoder, value) {
    var tmp0_desc = this.lf7_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.nf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, FloatSerializer_getInstance(), value.nf7_1);
    }
    tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.of7_1);
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.pf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.pf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.qf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.qf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.rf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.rf7_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.mf7(encoder, value instanceof TweenMotion ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.lf7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return TweenMotion.sf7(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.lf7_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(FloatSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.tf7_1 = [null, null, createSimpleEnumSerializer('korlibs.image.format.ImageAnimation.Direction', values()), null, null, null, null, null];
  }
}
class $serializer_53 {
  constructor() {
    $serializer_instance_53 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenSprite', this, 8);
    tmp0_serialDesc.m16('animation', true);
    tmp0_serialDesc.m16('running', true);
    tmp0_serialDesc.m16('direction', true);
    tmp0_serialDesc.m16('destroyOnPlayingFinished', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.uf7_1 = tmp0_serialDesc;
  }
  vf7(encoder, value) {
    var tmp0_desc = this.uf7_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_65().tf7_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.wf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, StringSerializer_getInstance(), value.wf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.xf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, BooleanSerializer_getInstance(), value.xf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.yf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, tmp2_cached[2], value.yf7_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.zf7_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, BooleanSerializer_getInstance(), value.zf7_1);
    }
    tmp1_output.p10(tmp0_desc, 4, $serializer_getInstance(), value.af8_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.bf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.bf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.cf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, FloatSerializer_getInstance(), value.cf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.df8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, EasingAsString_getInstance(), value.df8_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.vf7(encoder, value instanceof TweenSprite ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.uf7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.xy(tmp0_desc);
    var tmp13_cached = Companion_getInstance_65().tf7_1;
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return TweenSprite.ef8(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.uf7_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_65().tf7_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[2]), get_nullable(BooleanSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_56 {}
class $serializer_54 {
  constructor() {
    $serializer_instance_54 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenSwitchLayerVisibility', this, 6);
    tmp0_serialDesc.m16('offVariance', true);
    tmp0_serialDesc.m16('onVariance', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.ff8_1 = tmp0_serialDesc;
  }
  gf8(encoder, value) {
    var tmp0_desc = this.ff8_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.hf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, FloatSerializer_getInstance(), value.hf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.if8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, FloatSerializer_getInstance(), value.if8_1);
    }
    tmp1_output.p10(tmp0_desc, 2, $serializer_getInstance(), value.jf8_1);
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.kf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.kf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.lf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, FloatSerializer_getInstance(), value.lf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.mf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, EasingAsString_getInstance(), value.mf8_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.gf8(encoder, value instanceof TweenSwitchLayerVisibility ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ff8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.xy(tmp0_desc);
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.lz(tmp0_desc, 0, FloatSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.jz(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.lz(tmp0_desc, 4, FloatSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.lz(tmp0_desc, 5, EasingAsString_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return TweenSwitchLayerVisibility.nf8(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.ff8_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_57 {}
class $serializer_55 {
  constructor() {
    $serializer_instance_55 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenSpawner', this, 8);
    tmp0_serialDesc.m16('numberOfObjects', true);
    tmp0_serialDesc.m16('interval', true);
    tmp0_serialDesc.m16('timeVariation', true);
    tmp0_serialDesc.m16('positionVariation', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.of8_1 = tmp0_serialDesc;
  }
  pf8(encoder, value) {
    var tmp0_desc = this.of8_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.qf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, IntSerializer_getInstance(), value.qf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.rf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, IntSerializer_getInstance(), value.rf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.sf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, IntSerializer_getInstance(), value.sf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.tf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.tf8_1);
    }
    tmp1_output.p10(tmp0_desc, 4, $serializer_getInstance(), value.uf8_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.vf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.vf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.wf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, FloatSerializer_getInstance(), value.wf8_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.xf8_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, EasingAsString_getInstance(), value.xf8_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.pf8(encoder, value instanceof TweenSpawner ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.of8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.xy(tmp0_desc);
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return TweenSpawner.yf8(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.of8_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_58 {}
class $serializer_56 {
  constructor() {
    $serializer_instance_56 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenSound', this, 8);
    tmp0_serialDesc.m16('startTrigger', true);
    tmp0_serialDesc.m16('stopTrigger', true);
    tmp0_serialDesc.m16('position', true);
    tmp0_serialDesc.m16('volume', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.zf8_1 = tmp0_serialDesc;
  }
  af9(encoder, value) {
    var tmp0_desc = this.zf8_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.bf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, BooleanSerializer_getInstance(), value.bf9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.cf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, BooleanSerializer_getInstance(), value.cf9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.df9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.df9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.ef9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.ef9_1);
    }
    tmp1_output.p10(tmp0_desc, 4, $serializer_getInstance(), value.ff9_1);
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.gf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, FloatSerializer_getInstance(), value.gf9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.hf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, FloatSerializer_getInstance(), value.hf9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.if9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 7, EasingAsString_getInstance(), value.if9_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.af9(encoder, value instanceof TweenSound ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.zf8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.xy(tmp0_desc);
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.lz(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.lz(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.jz(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.lz(tmp0_desc, 5, FloatSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.lz(tmp0_desc, 6, FloatSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.lz(tmp0_desc, 7, EasingAsString_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return TweenSound.jf9(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.zf8_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class Companion_59 {}
class $serializer_57 {
  constructor() {
    $serializer_instance_57 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenTouchInput', this, 5);
    tmp0_serialDesc.m16('enabled', true);
    tmp0_serialDesc.m16('entity', false);
    tmp0_serialDesc.m16('delay', true);
    tmp0_serialDesc.m16('duration', true);
    tmp0_serialDesc.m16('easing', true);
    this.kf9_1 = tmp0_serialDesc;
  }
  lf9(encoder, value) {
    var tmp0_desc = this.kf9_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.mf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, BooleanSerializer_getInstance(), value.mf9_1);
    }
    tmp1_output.p10(tmp0_desc, 1, $serializer_getInstance(), value.nf9_1);
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.of9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, FloatSerializer_getInstance(), value.of9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.pf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, FloatSerializer_getInstance(), value.pf9_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.qf9_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, EasingAsString_getInstance(), value.qf9_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.lf9(encoder, value instanceof TweenTouchInput ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kf9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.xy(tmp0_desc);
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.lz(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.jz(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.lz(tmp0_desc, 2, FloatSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.lz(tmp0_desc, 3, FloatSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lz(tmp0_desc, 4, EasingAsString_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return TweenTouchInput.rf9(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.kf9_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(BooleanSerializer_getInstance()), $serializer_getInstance(), get_nullable(FloatSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(EasingAsString_getInstance())];
  }
}
class TweenBase {}
class SpawnNewTweenSequence {
  constructor(tweens, entity, delay, duration, easing) {
    Companion_getInstance_51();
    var tmp;
    if (tweens === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = tweens;
    }
    tweens = tmp;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.cf3_1 = tweens;
    this.df3_1 = entity;
    this.ef3_1 = delay;
    this.ff3_1 = duration;
    this.gf3_1 = easing;
  }
  sf9(_set____db54di) {
    this.df3_1 = _set____db54di;
  }
  tf9() {
    return this.df3_1;
  }
  uf9() {
    return this.ef3_1;
  }
  vf9(_set____db54di) {
    this.ff3_1 = _set____db54di;
  }
  wf9() {
    return this.ff3_1;
  }
  xf9(_set____db54di) {
    this.gf3_1 = _set____db54di;
  }
  yf9() {
    return this.gf3_1;
  }
  z27() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var copyOfTweens = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.cf3_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.SpawnNewTweenSequence.clone.<anonymous>' call
      copyOfTweens.h(element.z27());
    }
    return this.zf9(copyOfTweens, clone(this.df3_1), VOID, VOID, this.gf3_1);
  }
  afa(tweens, entity, delay, duration, easing) {
    return new SpawnNewTweenSequence(tweens, entity, delay, duration, easing);
  }
  zf9(tweens, entity, delay, duration, easing, $super) {
    tweens = tweens === VOID ? this.cf3_1 : tweens;
    entity = entity === VOID ? this.df3_1 : entity;
    delay = delay === VOID ? this.ef3_1 : delay;
    duration = duration === VOID ? this.ff3_1 : duration;
    easing = easing === VOID ? this.gf3_1 : easing;
    return $super === VOID ? this.afa(tweens, entity, delay, duration, easing) : $super.afa.call(this, tweens, entity, delay, duration, easing);
  }
  toString() {
    return 'SpawnNewTweenSequence(tweens=' + toString_0(this.cf3_1) + ', entity=' + this.df3_1.toString() + ', delay=' + this.ef3_1 + ', duration=' + this.ff3_1 + ', easing=' + toString(this.gf3_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.cf3_1);
    result = imul(result, 31) + this.df3_1.hashCode() | 0;
    result = imul(result, 31) + (this.ef3_1 == null ? 0 : getNumberHashCode(this.ef3_1)) | 0;
    result = imul(result, 31) + (this.ff3_1 == null ? 0 : getNumberHashCode(this.ff3_1)) | 0;
    result = imul(result, 31) + (this.gf3_1 == null ? 0 : hashCode(this.gf3_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpawnNewTweenSequence))
      return false;
    var tmp0_other_with_cast = other instanceof SpawnNewTweenSequence ? other : THROW_CCE();
    if (!equals(this.cf3_1, tmp0_other_with_cast.cf3_1))
      return false;
    if (!this.df3_1.equals(tmp0_other_with_cast.df3_1))
      return false;
    if (!equals(this.ef3_1, tmp0_other_with_cast.ef3_1))
      return false;
    if (!equals(this.ff3_1, tmp0_other_with_cast.ff3_1))
      return false;
    if (!equals(this.gf3_1, tmp0_other_with_cast.gf3_1))
      return false;
    return true;
  }
  static hf3(seen0, tweens, entity, delay, duration, easing, serializationConstructorMarker) {
    Companion_getInstance_51();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_40().af3_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.cf3_1 = emptyList();
    } else
      $this.cf3_1 = tweens;
    if (0 === (seen0 & 2))
      $this.df3_1 = Companion_getInstance_4().x1s_1;
    else
      $this.df3_1 = entity;
    if (0 === (seen0 & 4))
      $this.ef3_1 = null;
    else
      $this.ef3_1 = delay;
    if (0 === (seen0 & 8))
      $this.ff3_1 = null;
    else
      $this.ff3_1 = duration;
    if (0 === (seen0 & 16))
      $this.gf3_1 = null;
    else
      $this.gf3_1 = easing;
    return $this;
  }
}
class LoopTweens {
  constructor(tweens, entity, delay, duration, easing) {
    Companion_getInstance_52();
    var tmp;
    if (tweens === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = tweens;
    }
    tweens = tmp;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.lf3_1 = tweens;
    this.mf3_1 = entity;
    this.nf3_1 = delay;
    this.of3_1 = duration;
    this.pf3_1 = easing;
  }
  sf9(_set____db54di) {
    this.mf3_1 = _set____db54di;
  }
  tf9() {
    return this.mf3_1;
  }
  uf9() {
    return this.nf3_1;
  }
  vf9(_set____db54di) {
    this.of3_1 = _set____db54di;
  }
  wf9() {
    return this.of3_1;
  }
  xf9(_set____db54di) {
    this.pf3_1 = _set____db54di;
  }
  yf9() {
    return this.pf3_1;
  }
  z27() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var copyOfTweens = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.lf3_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.LoopTweens.clone.<anonymous>' call
      copyOfTweens.h(element.z27());
    }
    return this.bfa(copyOfTweens, clone(this.mf3_1), VOID, VOID, this.pf3_1);
  }
  afa(tweens, entity, delay, duration, easing) {
    return new LoopTweens(tweens, entity, delay, duration, easing);
  }
  bfa(tweens, entity, delay, duration, easing, $super) {
    tweens = tweens === VOID ? this.lf3_1 : tweens;
    entity = entity === VOID ? this.mf3_1 : entity;
    delay = delay === VOID ? this.nf3_1 : delay;
    duration = duration === VOID ? this.of3_1 : duration;
    easing = easing === VOID ? this.pf3_1 : easing;
    return $super === VOID ? this.afa(tweens, entity, delay, duration, easing) : $super.afa.call(this, tweens, entity, delay, duration, easing);
  }
  toString() {
    return 'LoopTweens(tweens=' + toString_0(this.lf3_1) + ', entity=' + this.mf3_1.toString() + ', delay=' + this.nf3_1 + ', duration=' + this.of3_1 + ', easing=' + toString(this.pf3_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.lf3_1);
    result = imul(result, 31) + this.mf3_1.hashCode() | 0;
    result = imul(result, 31) + (this.nf3_1 == null ? 0 : getNumberHashCode(this.nf3_1)) | 0;
    result = imul(result, 31) + (this.of3_1 == null ? 0 : getNumberHashCode(this.of3_1)) | 0;
    result = imul(result, 31) + (this.pf3_1 == null ? 0 : hashCode(this.pf3_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LoopTweens))
      return false;
    var tmp0_other_with_cast = other instanceof LoopTweens ? other : THROW_CCE();
    if (!equals(this.lf3_1, tmp0_other_with_cast.lf3_1))
      return false;
    if (!this.mf3_1.equals(tmp0_other_with_cast.mf3_1))
      return false;
    if (!equals(this.nf3_1, tmp0_other_with_cast.nf3_1))
      return false;
    if (!equals(this.of3_1, tmp0_other_with_cast.of3_1))
      return false;
    if (!equals(this.pf3_1, tmp0_other_with_cast.pf3_1))
      return false;
    return true;
  }
  static qf3(seen0, tweens, entity, delay, duration, easing, serializationConstructorMarker) {
    Companion_getInstance_52();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_41().jf3_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.lf3_1 = emptyList();
    } else
      $this.lf3_1 = tweens;
    if (0 === (seen0 & 2))
      $this.mf3_1 = Companion_getInstance_4().x1s_1;
    else
      $this.mf3_1 = entity;
    if (0 === (seen0 & 4))
      $this.nf3_1 = null;
    else
      $this.nf3_1 = delay;
    if (0 === (seen0 & 8))
      $this.of3_1 = null;
    else
      $this.of3_1 = duration;
    if (0 === (seen0 & 16))
      $this.pf3_1 = null;
    else
      $this.pf3_1 = easing;
    return $this;
  }
}
class ParallelTweens {
  constructor(tweens, entity, delay, duration, easing) {
    Companion_getInstance_53();
    var tmp;
    if (tweens === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = tweens;
    }
    tweens = tmp;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? 0.0 : delay;
    duration = duration === VOID ? 0.0 : duration;
    easing = easing === VOID ? Companion_getInstance_3().m27_1 : easing;
    this.uf3_1 = tweens;
    this.vf3_1 = entity;
    this.wf3_1 = delay;
    this.xf3_1 = duration;
    this.yf3_1 = easing;
  }
  sf9(_set____db54di) {
    this.vf3_1 = _set____db54di;
  }
  tf9() {
    return this.vf3_1;
  }
  uf9() {
    return this.wf3_1;
  }
  vf9(_set____db54di) {
    this.xf3_1 = _set____db54di;
  }
  wf9() {
    return this.xf3_1;
  }
  xf9(_set____db54di) {
    this.yf3_1 = _set____db54di;
  }
  yf9() {
    return this.yf3_1;
  }
  z27() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var copyOfTweens = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.uf3_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.ParallelTweens.clone.<anonymous>' call
      copyOfTweens.h(element.z27());
    }
    return this.cfa(copyOfTweens, clone(this.vf3_1), VOID, VOID, this.yf3_1);
  }
  afa(tweens, entity, delay, duration, easing) {
    return new ParallelTweens(tweens, entity, delay, duration, easing);
  }
  cfa(tweens, entity, delay, duration, easing, $super) {
    tweens = tweens === VOID ? this.uf3_1 : tweens;
    entity = entity === VOID ? this.vf3_1 : entity;
    delay = delay === VOID ? this.wf3_1 : delay;
    duration = duration === VOID ? this.xf3_1 : duration;
    easing = easing === VOID ? this.yf3_1 : easing;
    return $super === VOID ? this.afa(tweens, entity, delay, duration, easing) : $super.afa.call(this, tweens, entity, delay, duration, easing);
  }
  toString() {
    return 'ParallelTweens(tweens=' + toString_0(this.uf3_1) + ', entity=' + this.vf3_1.toString() + ', delay=' + this.wf3_1 + ', duration=' + this.xf3_1 + ', easing=' + toString(this.yf3_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.uf3_1);
    result = imul(result, 31) + this.vf3_1.hashCode() | 0;
    result = imul(result, 31) + (this.wf3_1 == null ? 0 : getNumberHashCode(this.wf3_1)) | 0;
    result = imul(result, 31) + (this.xf3_1 == null ? 0 : getNumberHashCode(this.xf3_1)) | 0;
    result = imul(result, 31) + (this.yf3_1 == null ? 0 : hashCode(this.yf3_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallelTweens))
      return false;
    var tmp0_other_with_cast = other instanceof ParallelTweens ? other : THROW_CCE();
    if (!equals(this.uf3_1, tmp0_other_with_cast.uf3_1))
      return false;
    if (!this.vf3_1.equals(tmp0_other_with_cast.vf3_1))
      return false;
    if (!equals(this.wf3_1, tmp0_other_with_cast.wf3_1))
      return false;
    if (!equals(this.xf3_1, tmp0_other_with_cast.xf3_1))
      return false;
    if (!equals(this.yf3_1, tmp0_other_with_cast.yf3_1))
      return false;
    return true;
  }
  static zf3(seen0, tweens, entity, delay, duration, easing, serializationConstructorMarker) {
    Companion_getInstance_53();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_42().sf3_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.uf3_1 = emptyList();
    } else
      $this.uf3_1 = tweens;
    if (0 === (seen0 & 2))
      $this.vf3_1 = Companion_getInstance_4().x1s_1;
    else
      $this.vf3_1 = entity;
    if (0 === (seen0 & 4))
      $this.wf3_1 = 0.0;
    else
      $this.wf3_1 = delay;
    if (0 === (seen0 & 8))
      $this.xf3_1 = 0.0;
    else
      $this.xf3_1 = duration;
    if (0 === (seen0 & 16))
      $this.yf3_1 = Companion_getInstance_3().m27_1;
    else
      $this.yf3_1 = easing;
    return $this;
  }
}
class SendEvent {
  constructor(event, entity, delay, duration, easing) {
    event = event === VOID ? 0 : event;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.cf4_1 = event;
    this.df4_1 = entity;
    this.ef4_1 = delay;
    this.ff4_1 = duration;
    this.gf4_1 = easing;
  }
  sf9(_set____db54di) {
    this.df4_1 = _set____db54di;
  }
  tf9() {
    return this.df4_1;
  }
  uf9() {
    return this.ef4_1;
  }
  vf9(_set____db54di) {
    this.ff4_1 = _set____db54di;
  }
  wf9() {
    return this.ff4_1;
  }
  xf9(_set____db54di) {
    this.gf4_1 = _set____db54di;
  }
  yf9() {
    return this.gf4_1;
  }
  z27() {
    return this.dfa(VOID, clone(this.df4_1), VOID, VOID, this.gf4_1);
  }
  efa(event, entity, delay, duration, easing) {
    return new SendEvent(event, entity, delay, duration, easing);
  }
  dfa(event, entity, delay, duration, easing, $super) {
    event = event === VOID ? this.cf4_1 : event;
    entity = entity === VOID ? this.df4_1 : entity;
    delay = delay === VOID ? this.ef4_1 : delay;
    duration = duration === VOID ? this.ff4_1 : duration;
    easing = easing === VOID ? this.gf4_1 : easing;
    return $super === VOID ? this.efa(event, entity, delay, duration, easing) : $super.efa.call(this, event, entity, delay, duration, easing);
  }
  toString() {
    return 'SendEvent(event=' + this.cf4_1 + ', entity=' + this.df4_1.toString() + ', delay=' + this.ef4_1 + ', duration=' + this.ff4_1 + ', easing=' + toString(this.gf4_1) + ')';
  }
  hashCode() {
    var result = this.cf4_1;
    result = imul(result, 31) + this.df4_1.hashCode() | 0;
    result = imul(result, 31) + (this.ef4_1 == null ? 0 : getNumberHashCode(this.ef4_1)) | 0;
    result = imul(result, 31) + (this.ff4_1 == null ? 0 : getNumberHashCode(this.ff4_1)) | 0;
    result = imul(result, 31) + (this.gf4_1 == null ? 0 : hashCode(this.gf4_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SendEvent))
      return false;
    var tmp0_other_with_cast = other instanceof SendEvent ? other : THROW_CCE();
    if (!(this.cf4_1 === tmp0_other_with_cast.cf4_1))
      return false;
    if (!this.df4_1.equals(tmp0_other_with_cast.df4_1))
      return false;
    if (!equals(this.ef4_1, tmp0_other_with_cast.ef4_1))
      return false;
    if (!equals(this.ff4_1, tmp0_other_with_cast.ff4_1))
      return false;
    if (!equals(this.gf4_1, tmp0_other_with_cast.gf4_1))
      return false;
    return true;
  }
  static hf4(seen0, event, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_43().af4_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.cf4_1 = 0;
    else
      $this.cf4_1 = event;
    if (0 === (seen0 & 2))
      $this.df4_1 = Companion_getInstance_4().x1s_1;
    else
      $this.df4_1 = entity;
    if (0 === (seen0 & 4))
      $this.ef4_1 = null;
    else
      $this.ef4_1 = delay;
    if (0 === (seen0 & 8))
      $this.ff4_1 = null;
    else
      $this.ff4_1 = duration;
    if (0 === (seen0 & 16))
      $this.gf4_1 = null;
    else
      $this.gf4_1 = easing;
    return $this;
  }
}
class ResetEvent {
  constructor(event, entity, delay, duration, easing) {
    event = event === VOID ? 0 : event;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.kf4_1 = event;
    this.lf4_1 = entity;
    this.mf4_1 = delay;
    this.nf4_1 = duration;
    this.of4_1 = easing;
  }
  sf9(_set____db54di) {
    this.lf4_1 = _set____db54di;
  }
  tf9() {
    return this.lf4_1;
  }
  uf9() {
    return this.mf4_1;
  }
  vf9(_set____db54di) {
    this.nf4_1 = _set____db54di;
  }
  wf9() {
    return this.nf4_1;
  }
  xf9(_set____db54di) {
    this.of4_1 = _set____db54di;
  }
  yf9() {
    return this.of4_1;
  }
  z27() {
    return this.ffa(VOID, clone(this.lf4_1), VOID, VOID, this.of4_1);
  }
  efa(event, entity, delay, duration, easing) {
    return new ResetEvent(event, entity, delay, duration, easing);
  }
  ffa(event, entity, delay, duration, easing, $super) {
    event = event === VOID ? this.kf4_1 : event;
    entity = entity === VOID ? this.lf4_1 : entity;
    delay = delay === VOID ? this.mf4_1 : delay;
    duration = duration === VOID ? this.nf4_1 : duration;
    easing = easing === VOID ? this.of4_1 : easing;
    return $super === VOID ? this.efa(event, entity, delay, duration, easing) : $super.efa.call(this, event, entity, delay, duration, easing);
  }
  toString() {
    return 'ResetEvent(event=' + this.kf4_1 + ', entity=' + this.lf4_1.toString() + ', delay=' + this.mf4_1 + ', duration=' + this.nf4_1 + ', easing=' + toString(this.of4_1) + ')';
  }
  hashCode() {
    var result = this.kf4_1;
    result = imul(result, 31) + this.lf4_1.hashCode() | 0;
    result = imul(result, 31) + (this.mf4_1 == null ? 0 : getNumberHashCode(this.mf4_1)) | 0;
    result = imul(result, 31) + (this.nf4_1 == null ? 0 : getNumberHashCode(this.nf4_1)) | 0;
    result = imul(result, 31) + (this.of4_1 == null ? 0 : hashCode(this.of4_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResetEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ResetEvent ? other : THROW_CCE();
    if (!(this.kf4_1 === tmp0_other_with_cast.kf4_1))
      return false;
    if (!this.lf4_1.equals(tmp0_other_with_cast.lf4_1))
      return false;
    if (!equals(this.mf4_1, tmp0_other_with_cast.mf4_1))
      return false;
    if (!equals(this.nf4_1, tmp0_other_with_cast.nf4_1))
      return false;
    if (!equals(this.of4_1, tmp0_other_with_cast.of4_1))
      return false;
    return true;
  }
  static pf4(seen0, event, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_44().if4_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.kf4_1 = 0;
    else
      $this.kf4_1 = event;
    if (0 === (seen0 & 2))
      $this.lf4_1 = Companion_getInstance_4().x1s_1;
    else
      $this.lf4_1 = entity;
    if (0 === (seen0 & 4))
      $this.mf4_1 = null;
    else
      $this.mf4_1 = delay;
    if (0 === (seen0 & 8))
      $this.nf4_1 = null;
    else
      $this.nf4_1 = duration;
    if (0 === (seen0 & 16))
      $this.of4_1 = null;
    else
      $this.of4_1 = easing;
    return $this;
  }
}
class Wait {
  constructor(duration, event, entity, delay, easing) {
    duration = duration === VOID ? 3.4028235E38 : duration;
    event = event === VOID ? null : event;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    easing = easing === VOID ? null : easing;
    this.sf4_1 = duration;
    this.tf4_1 = event;
    this.uf4_1 = entity;
    this.vf4_1 = delay;
    this.wf4_1 = easing;
  }
  vf9(_set____db54di) {
    this.sf4_1 = _set____db54di;
  }
  wf9() {
    return this.sf4_1;
  }
  sf9(_set____db54di) {
    this.uf4_1 = _set____db54di;
  }
  tf9() {
    return this.uf4_1;
  }
  uf9() {
    return this.vf4_1;
  }
  xf9(_set____db54di) {
    this.wf4_1 = _set____db54di;
  }
  yf9() {
    return this.wf4_1;
  }
  z27() {
    return this.gfa(VOID, VOID, clone(this.uf4_1), VOID, this.wf4_1);
  }
  hfa(duration, event, entity, delay, easing) {
    return new Wait(duration, event, entity, delay, easing);
  }
  gfa(duration, event, entity, delay, easing, $super) {
    duration = duration === VOID ? this.sf4_1 : duration;
    event = event === VOID ? this.tf4_1 : event;
    entity = entity === VOID ? this.uf4_1 : entity;
    delay = delay === VOID ? this.vf4_1 : delay;
    easing = easing === VOID ? this.wf4_1 : easing;
    return $super === VOID ? this.hfa(duration, event, entity, delay, easing) : $super.hfa.call(this, duration, event, entity, delay, easing);
  }
  toString() {
    return 'Wait(duration=' + this.sf4_1 + ', event=' + this.tf4_1 + ', entity=' + this.uf4_1.toString() + ', delay=' + this.vf4_1 + ', easing=' + toString(this.wf4_1) + ')';
  }
  hashCode() {
    var result = this.sf4_1 == null ? 0 : getNumberHashCode(this.sf4_1);
    result = imul(result, 31) + (this.tf4_1 == null ? 0 : this.tf4_1) | 0;
    result = imul(result, 31) + this.uf4_1.hashCode() | 0;
    result = imul(result, 31) + (this.vf4_1 == null ? 0 : getNumberHashCode(this.vf4_1)) | 0;
    result = imul(result, 31) + (this.wf4_1 == null ? 0 : hashCode(this.wf4_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Wait))
      return false;
    var tmp0_other_with_cast = other instanceof Wait ? other : THROW_CCE();
    if (!equals(this.sf4_1, tmp0_other_with_cast.sf4_1))
      return false;
    if (!(this.tf4_1 == tmp0_other_with_cast.tf4_1))
      return false;
    if (!this.uf4_1.equals(tmp0_other_with_cast.uf4_1))
      return false;
    if (!equals(this.vf4_1, tmp0_other_with_cast.vf4_1))
      return false;
    if (!equals(this.wf4_1, tmp0_other_with_cast.wf4_1))
      return false;
    return true;
  }
  static xf4(seen0, duration, event, entity, delay, easing, serializationConstructorMarker) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_45().qf4_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.sf4_1 = 3.4028235E38;
    else
      $this.sf4_1 = duration;
    if (0 === (seen0 & 2))
      $this.tf4_1 = null;
    else
      $this.tf4_1 = event;
    if (0 === (seen0 & 4))
      $this.uf4_1 = Companion_getInstance_4().x1s_1;
    else
      $this.uf4_1 = entity;
    if (0 === (seen0 & 8))
      $this.vf4_1 = null;
    else
      $this.vf4_1 = delay;
    if (0 === (seen0 & 16))
      $this.wf4_1 = null;
    else
      $this.wf4_1 = easing;
    return $this;
  }
}
class Jump {
  constructor(distance, event, entity, delay, duration, easing) {
    event = event === VOID ? null : event;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.af5_1 = distance;
    this.bf5_1 = event;
    this.cf5_1 = entity;
    this.df5_1 = delay;
    this.ef5_1 = duration;
    this.ff5_1 = easing;
  }
  sf9(_set____db54di) {
    this.cf5_1 = _set____db54di;
  }
  tf9() {
    return this.cf5_1;
  }
  uf9() {
    return this.df5_1;
  }
  vf9(_set____db54di) {
    this.ef5_1 = _set____db54di;
  }
  wf9() {
    return this.ef5_1;
  }
  xf9(_set____db54di) {
    this.ff5_1 = _set____db54di;
  }
  yf9() {
    return this.ff5_1;
  }
  z27() {
    return this.ifa(VOID, VOID, clone(this.cf5_1), VOID, VOID, this.ff5_1);
  }
  jfa(distance, event, entity, delay, duration, easing) {
    return new Jump(distance, event, entity, delay, duration, easing);
  }
  ifa(distance, event, entity, delay, duration, easing, $super) {
    distance = distance === VOID ? this.af5_1 : distance;
    event = event === VOID ? this.bf5_1 : event;
    entity = entity === VOID ? this.cf5_1 : entity;
    delay = delay === VOID ? this.df5_1 : delay;
    duration = duration === VOID ? this.ef5_1 : duration;
    easing = easing === VOID ? this.ff5_1 : easing;
    return $super === VOID ? this.jfa(distance, event, entity, delay, duration, easing) : $super.jfa.call(this, distance, event, entity, delay, duration, easing);
  }
  toString() {
    return 'Jump(distance=' + this.af5_1 + ', event=' + this.bf5_1 + ', entity=' + this.cf5_1.toString() + ', delay=' + this.df5_1 + ', duration=' + this.ef5_1 + ', easing=' + toString(this.ff5_1) + ')';
  }
  hashCode() {
    var result = this.af5_1;
    result = imul(result, 31) + (this.bf5_1 == null ? 0 : this.bf5_1) | 0;
    result = imul(result, 31) + this.cf5_1.hashCode() | 0;
    result = imul(result, 31) + (this.df5_1 == null ? 0 : getNumberHashCode(this.df5_1)) | 0;
    result = imul(result, 31) + (this.ef5_1 == null ? 0 : getNumberHashCode(this.ef5_1)) | 0;
    result = imul(result, 31) + (this.ff5_1 == null ? 0 : hashCode(this.ff5_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Jump))
      return false;
    var tmp0_other_with_cast = other instanceof Jump ? other : THROW_CCE();
    if (!(this.af5_1 === tmp0_other_with_cast.af5_1))
      return false;
    if (!(this.bf5_1 == tmp0_other_with_cast.bf5_1))
      return false;
    if (!this.cf5_1.equals(tmp0_other_with_cast.cf5_1))
      return false;
    if (!equals(this.df5_1, tmp0_other_with_cast.df5_1))
      return false;
    if (!equals(this.ef5_1, tmp0_other_with_cast.ef5_1))
      return false;
    if (!equals(this.ff5_1, tmp0_other_with_cast.ff5_1))
      return false;
    return true;
  }
  static gf5(seen0, distance, event, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_46().yf4_1);
    }
    var $this = createThis(this);
    $this.af5_1 = distance;
    if (0 === (seen0 & 2))
      $this.bf5_1 = null;
    else
      $this.bf5_1 = event;
    if (0 === (seen0 & 4))
      $this.cf5_1 = Companion_getInstance_4().x1s_1;
    else
      $this.cf5_1 = entity;
    if (0 === (seen0 & 8))
      $this.df5_1 = null;
    else
      $this.df5_1 = delay;
    if (0 === (seen0 & 16))
      $this.ef5_1 = null;
    else
      $this.ef5_1 = duration;
    if (0 === (seen0 & 32))
      $this.ff5_1 = null;
    else
      $this.ff5_1 = easing;
    return $this;
  }
}
class DeleteEntity {
  constructor(entity, delay, duration, easing) {
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.jf5_1 = entity;
    this.kf5_1 = delay;
    this.lf5_1 = duration;
    this.mf5_1 = easing;
  }
  sf9(_set____db54di) {
    this.jf5_1 = _set____db54di;
  }
  tf9() {
    return this.jf5_1;
  }
  uf9() {
    return this.kf5_1;
  }
  vf9(_set____db54di) {
    this.lf5_1 = _set____db54di;
  }
  wf9() {
    return this.lf5_1;
  }
  xf9(_set____db54di) {
    this.mf5_1 = _set____db54di;
  }
  yf9() {
    return this.mf5_1;
  }
  z27() {
    return this.kfa(clone(this.jf5_1), VOID, VOID, this.mf5_1);
  }
  lfa(entity, delay, duration, easing) {
    return new DeleteEntity(entity, delay, duration, easing);
  }
  kfa(entity, delay, duration, easing, $super) {
    entity = entity === VOID ? this.jf5_1 : entity;
    delay = delay === VOID ? this.kf5_1 : delay;
    duration = duration === VOID ? this.lf5_1 : duration;
    easing = easing === VOID ? this.mf5_1 : easing;
    return $super === VOID ? this.lfa(entity, delay, duration, easing) : $super.lfa.call(this, entity, delay, duration, easing);
  }
  toString() {
    return 'DeleteEntity(entity=' + this.jf5_1.toString() + ', delay=' + this.kf5_1 + ', duration=' + this.lf5_1 + ', easing=' + toString(this.mf5_1) + ')';
  }
  hashCode() {
    var result = this.jf5_1.hashCode();
    result = imul(result, 31) + (this.kf5_1 == null ? 0 : getNumberHashCode(this.kf5_1)) | 0;
    result = imul(result, 31) + (this.lf5_1 == null ? 0 : getNumberHashCode(this.lf5_1)) | 0;
    result = imul(result, 31) + (this.mf5_1 == null ? 0 : hashCode(this.mf5_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteEntity))
      return false;
    var tmp0_other_with_cast = other instanceof DeleteEntity ? other : THROW_CCE();
    if (!this.jf5_1.equals(tmp0_other_with_cast.jf5_1))
      return false;
    if (!equals(this.kf5_1, tmp0_other_with_cast.kf5_1))
      return false;
    if (!equals(this.lf5_1, tmp0_other_with_cast.lf5_1))
      return false;
    if (!equals(this.mf5_1, tmp0_other_with_cast.mf5_1))
      return false;
    return true;
  }
  static nf5(seen0, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_47().hf5_1);
    }
    var $this = createThis(this);
    $this.jf5_1 = entity;
    if (0 === (seen0 & 2))
      $this.kf5_1 = null;
    else
      $this.kf5_1 = delay;
    if (0 === (seen0 & 4))
      $this.lf5_1 = null;
    else
      $this.lf5_1 = duration;
    if (0 === (seen0 & 8))
      $this.mf5_1 = null;
    else
      $this.mf5_1 = easing;
    return $this;
  }
}
class SpawnEntity {
  constructor(entityConfig, x, y, entity, delay, duration, easing) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? 0.0 : duration;
    easing = easing === VOID ? null : easing;
    this.qf5_1 = entityConfig;
    this.rf5_1 = x;
    this.sf5_1 = y;
    this.tf5_1 = entity;
    this.uf5_1 = delay;
    this.vf5_1 = duration;
    this.wf5_1 = easing;
  }
  sf9(_set____db54di) {
    this.tf5_1 = _set____db54di;
  }
  tf9() {
    return this.tf5_1;
  }
  uf9() {
    return this.uf5_1;
  }
  vf9(_set____db54di) {
    this.vf5_1 = _set____db54di;
  }
  wf9() {
    return this.vf5_1;
  }
  xf9(_set____db54di) {
    this.wf5_1 = _set____db54di;
  }
  yf9() {
    return this.wf5_1;
  }
  z27() {
    return this.mfa(VOID, VOID, VOID, clone(this.tf5_1), VOID, VOID, this.wf5_1);
  }
  nfa(entityConfig, x, y, entity, delay, duration, easing) {
    return new SpawnEntity(entityConfig, x, y, entity, delay, duration, easing);
  }
  mfa(entityConfig, x, y, entity, delay, duration, easing, $super) {
    entityConfig = entityConfig === VOID ? this.qf5_1 : entityConfig;
    x = x === VOID ? this.rf5_1 : x;
    y = y === VOID ? this.sf5_1 : y;
    entity = entity === VOID ? this.tf5_1 : entity;
    delay = delay === VOID ? this.uf5_1 : delay;
    duration = duration === VOID ? this.vf5_1 : duration;
    easing = easing === VOID ? this.wf5_1 : easing;
    return $super === VOID ? this.nfa(entityConfig, x, y, entity, delay, duration, easing) : $super.nfa.call(this, entityConfig, x, y, entity, delay, duration, easing);
  }
  toString() {
    return 'SpawnEntity(entityConfig=' + this.qf5_1 + ', x=' + this.rf5_1 + ', y=' + this.sf5_1 + ', entity=' + this.tf5_1.toString() + ', delay=' + this.uf5_1 + ', duration=' + this.vf5_1 + ', easing=' + toString(this.wf5_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.qf5_1);
    result = imul(result, 31) + getNumberHashCode(this.rf5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sf5_1) | 0;
    result = imul(result, 31) + this.tf5_1.hashCode() | 0;
    result = imul(result, 31) + (this.uf5_1 == null ? 0 : getNumberHashCode(this.uf5_1)) | 0;
    result = imul(result, 31) + (this.vf5_1 == null ? 0 : getNumberHashCode(this.vf5_1)) | 0;
    result = imul(result, 31) + (this.wf5_1 == null ? 0 : hashCode(this.wf5_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SpawnEntity))
      return false;
    var tmp0_other_with_cast = other instanceof SpawnEntity ? other : THROW_CCE();
    if (!(this.qf5_1 === tmp0_other_with_cast.qf5_1))
      return false;
    if (!equals(this.rf5_1, tmp0_other_with_cast.rf5_1))
      return false;
    if (!equals(this.sf5_1, tmp0_other_with_cast.sf5_1))
      return false;
    if (!this.tf5_1.equals(tmp0_other_with_cast.tf5_1))
      return false;
    if (!equals(this.uf5_1, tmp0_other_with_cast.uf5_1))
      return false;
    if (!equals(this.vf5_1, tmp0_other_with_cast.vf5_1))
      return false;
    if (!equals(this.wf5_1, tmp0_other_with_cast.wf5_1))
      return false;
    return true;
  }
  static xf5(seen0, entityConfig, x, y, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_48().of5_1);
    }
    var $this = createThis(this);
    $this.qf5_1 = entityConfig;
    if (0 === (seen0 & 2))
      $this.rf5_1 = 0.0;
    else
      $this.rf5_1 = x;
    if (0 === (seen0 & 4))
      $this.sf5_1 = 0.0;
    else
      $this.sf5_1 = y;
    if (0 === (seen0 & 8))
      $this.tf5_1 = Companion_getInstance_4().x1s_1;
    else
      $this.tf5_1 = entity;
    if (0 === (seen0 & 16))
      $this.uf5_1 = null;
    else
      $this.uf5_1 = delay;
    if (0 === (seen0 & 32))
      $this.vf5_1 = 0.0;
    else
      $this.vf5_1 = duration;
    if (0 === (seen0 & 64))
      $this.wf5_1 = null;
    else
      $this.wf5_1 = easing;
    return $this;
  }
}
class ExecuteConfigFunction {
  constructor(entityConfig, entity, delay, duration, easing) {
    entity = entity === VOID ? Companion_getInstance_4().x1s_1 : entity;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.af6_1 = entityConfig;
    this.bf6_1 = entity;
    this.cf6_1 = delay;
    this.df6_1 = duration;
    this.ef6_1 = easing;
  }
  sf9(_set____db54di) {
    this.bf6_1 = _set____db54di;
  }
  tf9() {
    return this.bf6_1;
  }
  uf9() {
    return this.cf6_1;
  }
  vf9(_set____db54di) {
    this.df6_1 = _set____db54di;
  }
  wf9() {
    return this.df6_1;
  }
  xf9(_set____db54di) {
    this.ef6_1 = _set____db54di;
  }
  yf9() {
    return this.ef6_1;
  }
  z27() {
    return this.ofa(VOID, clone(this.bf6_1), VOID, VOID, this.ef6_1);
  }
  pfa(entityConfig, entity, delay, duration, easing) {
    return new ExecuteConfigFunction(entityConfig, entity, delay, duration, easing);
  }
  ofa(entityConfig, entity, delay, duration, easing, $super) {
    entityConfig = entityConfig === VOID ? this.af6_1 : entityConfig;
    entity = entity === VOID ? this.bf6_1 : entity;
    delay = delay === VOID ? this.cf6_1 : delay;
    duration = duration === VOID ? this.df6_1 : duration;
    easing = easing === VOID ? this.ef6_1 : easing;
    return $super === VOID ? this.pfa(entityConfig, entity, delay, duration, easing) : $super.pfa.call(this, entityConfig, entity, delay, duration, easing);
  }
  toString() {
    return 'ExecuteConfigFunction(entityConfig=' + this.af6_1 + ', entity=' + this.bf6_1.toString() + ', delay=' + this.cf6_1 + ', duration=' + this.df6_1 + ', easing=' + toString(this.ef6_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.af6_1);
    result = imul(result, 31) + this.bf6_1.hashCode() | 0;
    result = imul(result, 31) + (this.cf6_1 == null ? 0 : getNumberHashCode(this.cf6_1)) | 0;
    result = imul(result, 31) + (this.df6_1 == null ? 0 : getNumberHashCode(this.df6_1)) | 0;
    result = imul(result, 31) + (this.ef6_1 == null ? 0 : hashCode(this.ef6_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExecuteConfigFunction))
      return false;
    var tmp0_other_with_cast = other instanceof ExecuteConfigFunction ? other : THROW_CCE();
    if (!(this.af6_1 === tmp0_other_with_cast.af6_1))
      return false;
    if (!this.bf6_1.equals(tmp0_other_with_cast.bf6_1))
      return false;
    if (!equals(this.cf6_1, tmp0_other_with_cast.cf6_1))
      return false;
    if (!equals(this.df6_1, tmp0_other_with_cast.df6_1))
      return false;
    if (!equals(this.ef6_1, tmp0_other_with_cast.ef6_1))
      return false;
    return true;
  }
  static ff6(seen0, entityConfig, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_49().yf5_1);
    }
    var $this = createThis(this);
    $this.af6_1 = entityConfig;
    if (0 === (seen0 & 2))
      $this.bf6_1 = Companion_getInstance_4().x1s_1;
    else
      $this.bf6_1 = entity;
    if (0 === (seen0 & 4))
      $this.cf6_1 = null;
    else
      $this.cf6_1 = delay;
    if (0 === (seen0 & 8))
      $this.df6_1 = null;
    else
      $this.df6_1 = duration;
    if (0 === (seen0 & 16))
      $this.ef6_1 = null;
    else
      $this.ef6_1 = easing;
    return $this;
  }
}
class TweenTextField {
  constructor(text, textRangeStart, textRangeEnd, entity, delay, duration, easing) {
    text = text === VOID ? null : text;
    textRangeStart = textRangeStart === VOID ? null : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? null : textRangeEnd;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.if6_1 = text;
    this.jf6_1 = textRangeStart;
    this.kf6_1 = textRangeEnd;
    this.lf6_1 = entity;
    this.mf6_1 = delay;
    this.nf6_1 = duration;
    this.of6_1 = easing;
  }
  sf9(_set____db54di) {
    this.lf6_1 = _set____db54di;
  }
  tf9() {
    return this.lf6_1;
  }
  uf9() {
    return this.mf6_1;
  }
  vf9(_set____db54di) {
    this.nf6_1 = _set____db54di;
  }
  wf9() {
    return this.nf6_1;
  }
  xf9(_set____db54di) {
    this.of6_1 = _set____db54di;
  }
  yf9() {
    return this.of6_1;
  }
  z27() {
    return this.qfa(VOID, VOID, VOID, clone(this.lf6_1), VOID, VOID, this.of6_1);
  }
  rfa(text, textRangeStart, textRangeEnd, entity, delay, duration, easing) {
    return new TweenTextField(text, textRangeStart, textRangeEnd, entity, delay, duration, easing);
  }
  qfa(text, textRangeStart, textRangeEnd, entity, delay, duration, easing, $super) {
    text = text === VOID ? this.if6_1 : text;
    textRangeStart = textRangeStart === VOID ? this.jf6_1 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? this.kf6_1 : textRangeEnd;
    entity = entity === VOID ? this.lf6_1 : entity;
    delay = delay === VOID ? this.mf6_1 : delay;
    duration = duration === VOID ? this.nf6_1 : duration;
    easing = easing === VOID ? this.of6_1 : easing;
    return $super === VOID ? this.rfa(text, textRangeStart, textRangeEnd, entity, delay, duration, easing) : $super.rfa.call(this, text, textRangeStart, textRangeEnd, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenTextField(text=' + this.if6_1 + ', textRangeStart=' + this.jf6_1 + ', textRangeEnd=' + this.kf6_1 + ', entity=' + this.lf6_1.toString() + ', delay=' + this.mf6_1 + ', duration=' + this.nf6_1 + ', easing=' + toString(this.of6_1) + ')';
  }
  hashCode() {
    var result = this.if6_1 == null ? 0 : getStringHashCode(this.if6_1);
    result = imul(result, 31) + (this.jf6_1 == null ? 0 : this.jf6_1) | 0;
    result = imul(result, 31) + (this.kf6_1 == null ? 0 : this.kf6_1) | 0;
    result = imul(result, 31) + this.lf6_1.hashCode() | 0;
    result = imul(result, 31) + (this.mf6_1 == null ? 0 : getNumberHashCode(this.mf6_1)) | 0;
    result = imul(result, 31) + (this.nf6_1 == null ? 0 : getNumberHashCode(this.nf6_1)) | 0;
    result = imul(result, 31) + (this.of6_1 == null ? 0 : hashCode(this.of6_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenTextField))
      return false;
    var tmp0_other_with_cast = other instanceof TweenTextField ? other : THROW_CCE();
    if (!(this.if6_1 == tmp0_other_with_cast.if6_1))
      return false;
    if (!(this.jf6_1 == tmp0_other_with_cast.jf6_1))
      return false;
    if (!(this.kf6_1 == tmp0_other_with_cast.kf6_1))
      return false;
    if (!this.lf6_1.equals(tmp0_other_with_cast.lf6_1))
      return false;
    if (!equals(this.mf6_1, tmp0_other_with_cast.mf6_1))
      return false;
    if (!equals(this.nf6_1, tmp0_other_with_cast.nf6_1))
      return false;
    if (!equals(this.of6_1, tmp0_other_with_cast.of6_1))
      return false;
    return true;
  }
  static pf6(seen0, text, textRangeStart, textRangeEnd, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(8 === (8 & seen0))) {
      throwMissingFieldException(seen0, 8, $serializer_getInstance_50().gf6_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.if6_1 = null;
    else
      $this.if6_1 = text;
    if (0 === (seen0 & 2))
      $this.jf6_1 = null;
    else
      $this.jf6_1 = textRangeStart;
    if (0 === (seen0 & 4))
      $this.kf6_1 = null;
    else
      $this.kf6_1 = textRangeEnd;
    $this.lf6_1 = entity;
    if (0 === (seen0 & 16))
      $this.mf6_1 = null;
    else
      $this.mf6_1 = delay;
    if (0 === (seen0 & 32))
      $this.nf6_1 = null;
    else
      $this.nf6_1 = duration;
    if (0 === (seen0 & 64))
      $this.of6_1 = null;
    else
      $this.of6_1 = easing;
    return $this;
  }
}
class TweenRgba {
  constructor(alpha, tint, visible, entity, delay, duration, easing) {
    alpha = alpha === VOID ? null : alpha;
    tint = tint === VOID ? null : tint;
    visible = visible === VOID ? null : visible;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.sf6_1 = alpha;
    this.tf6_1 = tint;
    this.uf6_1 = visible;
    this.vf6_1 = entity;
    this.wf6_1 = delay;
    this.xf6_1 = duration;
    this.yf6_1 = easing;
  }
  sf9(_set____db54di) {
    this.vf6_1 = _set____db54di;
  }
  tf9() {
    return this.vf6_1;
  }
  uf9() {
    return this.wf6_1;
  }
  vf9(_set____db54di) {
    this.xf6_1 = _set____db54di;
  }
  wf9() {
    return this.xf6_1;
  }
  xf9(_set____db54di) {
    this.yf6_1 = _set____db54di;
  }
  yf9() {
    return this.yf6_1;
  }
  z27() {
    var tmp0_safe_receiver = this.tf6_1;
    return this.sfa(VOID, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z27(), VOID, clone(this.vf6_1), VOID, VOID, this.yf6_1);
  }
  tfa(alpha, tint, visible, entity, delay, duration, easing) {
    return new TweenRgba(alpha, tint, visible, entity, delay, duration, easing);
  }
  sfa(alpha, tint, visible, entity, delay, duration, easing, $super) {
    alpha = alpha === VOID ? this.sf6_1 : alpha;
    tint = tint === VOID ? this.tf6_1 : tint;
    visible = visible === VOID ? this.uf6_1 : visible;
    entity = entity === VOID ? this.vf6_1 : entity;
    delay = delay === VOID ? this.wf6_1 : delay;
    duration = duration === VOID ? this.xf6_1 : duration;
    easing = easing === VOID ? this.yf6_1 : easing;
    return $super === VOID ? this.tfa(alpha, tint, visible, entity, delay, duration, easing) : $super.tfa.call(this, alpha, tint, visible, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenRgba(alpha=' + this.sf6_1 + ', tint=' + toString(this.tf6_1) + ', visible=' + this.uf6_1 + ', entity=' + this.vf6_1.toString() + ', delay=' + this.wf6_1 + ', duration=' + this.xf6_1 + ', easing=' + toString(this.yf6_1) + ')';
  }
  hashCode() {
    var result = this.sf6_1 == null ? 0 : getNumberHashCode(this.sf6_1);
    result = imul(result, 31) + (this.tf6_1 == null ? 0 : this.tf6_1.hashCode()) | 0;
    result = imul(result, 31) + (this.uf6_1 == null ? 0 : getBooleanHashCode(this.uf6_1)) | 0;
    result = imul(result, 31) + this.vf6_1.hashCode() | 0;
    result = imul(result, 31) + (this.wf6_1 == null ? 0 : getNumberHashCode(this.wf6_1)) | 0;
    result = imul(result, 31) + (this.xf6_1 == null ? 0 : getNumberHashCode(this.xf6_1)) | 0;
    result = imul(result, 31) + (this.yf6_1 == null ? 0 : hashCode(this.yf6_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenRgba))
      return false;
    var tmp0_other_with_cast = other instanceof TweenRgba ? other : THROW_CCE();
    if (!equals(this.sf6_1, tmp0_other_with_cast.sf6_1))
      return false;
    if (!equals(this.tf6_1, tmp0_other_with_cast.tf6_1))
      return false;
    if (!(this.uf6_1 == tmp0_other_with_cast.uf6_1))
      return false;
    if (!this.vf6_1.equals(tmp0_other_with_cast.vf6_1))
      return false;
    if (!equals(this.wf6_1, tmp0_other_with_cast.wf6_1))
      return false;
    if (!equals(this.xf6_1, tmp0_other_with_cast.xf6_1))
      return false;
    if (!equals(this.yf6_1, tmp0_other_with_cast.yf6_1))
      return false;
    return true;
  }
  static zf6(seen0, alpha, tint, visible, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(8 === (8 & seen0))) {
      throwMissingFieldException(seen0, 8, $serializer_getInstance_51().qf6_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.sf6_1 = null;
    else
      $this.sf6_1 = alpha;
    if (0 === (seen0 & 2))
      $this.tf6_1 = null;
    else
      $this.tf6_1 = tint;
    if (0 === (seen0 & 4))
      $this.uf6_1 = null;
    else
      $this.uf6_1 = visible;
    $this.vf6_1 = entity;
    if (0 === (seen0 & 16))
      $this.wf6_1 = null;
    else
      $this.wf6_1 = delay;
    if (0 === (seen0 & 32))
      $this.xf6_1 = null;
    else
      $this.xf6_1 = duration;
    if (0 === (seen0 & 64))
      $this.yf6_1 = null;
    else
      $this.yf6_1 = easing;
    return $this;
  }
}
class TweenPosition {
  constructor(x, y, offsetX, offsetY, entity, delay, duration, easing) {
    x = x === VOID ? null : x;
    y = y === VOID ? null : y;
    offsetX = offsetX === VOID ? null : offsetX;
    offsetY = offsetY === VOID ? null : offsetY;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.cf7_1 = x;
    this.df7_1 = y;
    this.ef7_1 = offsetX;
    this.ff7_1 = offsetY;
    this.gf7_1 = entity;
    this.hf7_1 = delay;
    this.if7_1 = duration;
    this.jf7_1 = easing;
  }
  sf9(_set____db54di) {
    this.gf7_1 = _set____db54di;
  }
  tf9() {
    return this.gf7_1;
  }
  uf9() {
    return this.hf7_1;
  }
  vf9(_set____db54di) {
    this.if7_1 = _set____db54di;
  }
  wf9() {
    return this.if7_1;
  }
  xf9(_set____db54di) {
    this.jf7_1 = _set____db54di;
  }
  yf9() {
    return this.jf7_1;
  }
  z27() {
    return this.ufa(VOID, VOID, VOID, VOID, clone(this.gf7_1), VOID, VOID, this.jf7_1);
  }
  vfa(x, y, offsetX, offsetY, entity, delay, duration, easing) {
    return new TweenPosition(x, y, offsetX, offsetY, entity, delay, duration, easing);
  }
  ufa(x, y, offsetX, offsetY, entity, delay, duration, easing, $super) {
    x = x === VOID ? this.cf7_1 : x;
    y = y === VOID ? this.df7_1 : y;
    offsetX = offsetX === VOID ? this.ef7_1 : offsetX;
    offsetY = offsetY === VOID ? this.ff7_1 : offsetY;
    entity = entity === VOID ? this.gf7_1 : entity;
    delay = delay === VOID ? this.hf7_1 : delay;
    duration = duration === VOID ? this.if7_1 : duration;
    easing = easing === VOID ? this.jf7_1 : easing;
    return $super === VOID ? this.vfa(x, y, offsetX, offsetY, entity, delay, duration, easing) : $super.vfa.call(this, x, y, offsetX, offsetY, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenPosition(x=' + this.cf7_1 + ', y=' + this.df7_1 + ', offsetX=' + this.ef7_1 + ', offsetY=' + this.ff7_1 + ', entity=' + this.gf7_1.toString() + ', delay=' + this.hf7_1 + ', duration=' + this.if7_1 + ', easing=' + toString(this.jf7_1) + ')';
  }
  hashCode() {
    var result = this.cf7_1 == null ? 0 : getNumberHashCode(this.cf7_1);
    result = imul(result, 31) + (this.df7_1 == null ? 0 : getNumberHashCode(this.df7_1)) | 0;
    result = imul(result, 31) + (this.ef7_1 == null ? 0 : getNumberHashCode(this.ef7_1)) | 0;
    result = imul(result, 31) + (this.ff7_1 == null ? 0 : getNumberHashCode(this.ff7_1)) | 0;
    result = imul(result, 31) + this.gf7_1.hashCode() | 0;
    result = imul(result, 31) + (this.hf7_1 == null ? 0 : getNumberHashCode(this.hf7_1)) | 0;
    result = imul(result, 31) + (this.if7_1 == null ? 0 : getNumberHashCode(this.if7_1)) | 0;
    result = imul(result, 31) + (this.jf7_1 == null ? 0 : hashCode(this.jf7_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenPosition))
      return false;
    var tmp0_other_with_cast = other instanceof TweenPosition ? other : THROW_CCE();
    if (!equals(this.cf7_1, tmp0_other_with_cast.cf7_1))
      return false;
    if (!equals(this.df7_1, tmp0_other_with_cast.df7_1))
      return false;
    if (!equals(this.ef7_1, tmp0_other_with_cast.ef7_1))
      return false;
    if (!equals(this.ff7_1, tmp0_other_with_cast.ff7_1))
      return false;
    if (!this.gf7_1.equals(tmp0_other_with_cast.gf7_1))
      return false;
    if (!equals(this.hf7_1, tmp0_other_with_cast.hf7_1))
      return false;
    if (!equals(this.if7_1, tmp0_other_with_cast.if7_1))
      return false;
    if (!equals(this.jf7_1, tmp0_other_with_cast.jf7_1))
      return false;
    return true;
  }
  static kf7(seen0, x, y, offsetX, offsetY, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(16 === (16 & seen0))) {
      throwMissingFieldException(seen0, 16, $serializer_getInstance_52().af7_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.cf7_1 = null;
    else
      $this.cf7_1 = x;
    if (0 === (seen0 & 2))
      $this.df7_1 = null;
    else
      $this.df7_1 = y;
    if (0 === (seen0 & 4))
      $this.ef7_1 = null;
    else
      $this.ef7_1 = offsetX;
    if (0 === (seen0 & 8))
      $this.ff7_1 = null;
    else
      $this.ff7_1 = offsetY;
    $this.gf7_1 = entity;
    if (0 === (seen0 & 32))
      $this.hf7_1 = null;
    else
      $this.hf7_1 = delay;
    if (0 === (seen0 & 64))
      $this.if7_1 = null;
    else
      $this.if7_1 = duration;
    if (0 === (seen0 & 128))
      $this.jf7_1 = null;
    else
      $this.jf7_1 = easing;
    return $this;
  }
}
class TweenMotion {
  constructor(velocityX, entity, delay, duration, easing) {
    velocityX = velocityX === VOID ? null : velocityX;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.nf7_1 = velocityX;
    this.of7_1 = entity;
    this.pf7_1 = delay;
    this.qf7_1 = duration;
    this.rf7_1 = easing;
  }
  sf9(_set____db54di) {
    this.of7_1 = _set____db54di;
  }
  tf9() {
    return this.of7_1;
  }
  uf9() {
    return this.pf7_1;
  }
  vf9(_set____db54di) {
    this.qf7_1 = _set____db54di;
  }
  wf9() {
    return this.qf7_1;
  }
  xf9(_set____db54di) {
    this.rf7_1 = _set____db54di;
  }
  yf9() {
    return this.rf7_1;
  }
  z27() {
    return this.wfa(VOID, clone(this.of7_1), VOID, VOID, this.rf7_1);
  }
  xfa(velocityX, entity, delay, duration, easing) {
    return new TweenMotion(velocityX, entity, delay, duration, easing);
  }
  wfa(velocityX, entity, delay, duration, easing, $super) {
    velocityX = velocityX === VOID ? this.nf7_1 : velocityX;
    entity = entity === VOID ? this.of7_1 : entity;
    delay = delay === VOID ? this.pf7_1 : delay;
    duration = duration === VOID ? this.qf7_1 : duration;
    easing = easing === VOID ? this.rf7_1 : easing;
    return $super === VOID ? this.xfa(velocityX, entity, delay, duration, easing) : $super.xfa.call(this, velocityX, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenMotion(velocityX=' + this.nf7_1 + ', entity=' + this.of7_1.toString() + ', delay=' + this.pf7_1 + ', duration=' + this.qf7_1 + ', easing=' + toString(this.rf7_1) + ')';
  }
  hashCode() {
    var result = this.nf7_1 == null ? 0 : getNumberHashCode(this.nf7_1);
    result = imul(result, 31) + this.of7_1.hashCode() | 0;
    result = imul(result, 31) + (this.pf7_1 == null ? 0 : getNumberHashCode(this.pf7_1)) | 0;
    result = imul(result, 31) + (this.qf7_1 == null ? 0 : getNumberHashCode(this.qf7_1)) | 0;
    result = imul(result, 31) + (this.rf7_1 == null ? 0 : hashCode(this.rf7_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenMotion))
      return false;
    var tmp0_other_with_cast = other instanceof TweenMotion ? other : THROW_CCE();
    if (!equals(this.nf7_1, tmp0_other_with_cast.nf7_1))
      return false;
    if (!this.of7_1.equals(tmp0_other_with_cast.of7_1))
      return false;
    if (!equals(this.pf7_1, tmp0_other_with_cast.pf7_1))
      return false;
    if (!equals(this.qf7_1, tmp0_other_with_cast.qf7_1))
      return false;
    if (!equals(this.rf7_1, tmp0_other_with_cast.rf7_1))
      return false;
    return true;
  }
  static sf7(seen0, velocityX, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_53().lf7_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.nf7_1 = null;
    else
      $this.nf7_1 = velocityX;
    $this.of7_1 = entity;
    if (0 === (seen0 & 4))
      $this.pf7_1 = null;
    else
      $this.pf7_1 = delay;
    if (0 === (seen0 & 8))
      $this.qf7_1 = null;
    else
      $this.qf7_1 = duration;
    if (0 === (seen0 & 16))
      $this.rf7_1 = null;
    else
      $this.rf7_1 = easing;
    return $this;
  }
}
class TweenSprite {
  constructor(animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing) {
    Companion_getInstance_65();
    animation = animation === VOID ? null : animation;
    running = running === VOID ? null : running;
    direction = direction === VOID ? null : direction;
    destroyOnPlayingFinished = destroyOnPlayingFinished === VOID ? null : destroyOnPlayingFinished;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.wf7_1 = animation;
    this.xf7_1 = running;
    this.yf7_1 = direction;
    this.zf7_1 = destroyOnPlayingFinished;
    this.af8_1 = entity;
    this.bf8_1 = delay;
    this.cf8_1 = duration;
    this.df8_1 = easing;
  }
  sf9(_set____db54di) {
    this.af8_1 = _set____db54di;
  }
  tf9() {
    return this.af8_1;
  }
  uf9() {
    return this.bf8_1;
  }
  vf9(_set____db54di) {
    this.cf8_1 = _set____db54di;
  }
  wf9() {
    return this.cf8_1;
  }
  xf9(_set____db54di) {
    this.df8_1 = _set____db54di;
  }
  yf9() {
    return this.df8_1;
  }
  z27() {
    return this.yfa(VOID, VOID, this.yf7_1, VOID, clone(this.af8_1), VOID, VOID, this.df8_1);
  }
  zfa(animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing) {
    return new TweenSprite(animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing);
  }
  yfa(animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing, $super) {
    animation = animation === VOID ? this.wf7_1 : animation;
    running = running === VOID ? this.xf7_1 : running;
    direction = direction === VOID ? this.yf7_1 : direction;
    destroyOnPlayingFinished = destroyOnPlayingFinished === VOID ? this.zf7_1 : destroyOnPlayingFinished;
    entity = entity === VOID ? this.af8_1 : entity;
    delay = delay === VOID ? this.bf8_1 : delay;
    duration = duration === VOID ? this.cf8_1 : duration;
    easing = easing === VOID ? this.df8_1 : easing;
    return $super === VOID ? this.zfa(animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing) : $super.zfa.call(this, animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenSprite(animation=' + this.wf7_1 + ', running=' + this.xf7_1 + ', direction=' + toString(this.yf7_1) + ', destroyOnPlayingFinished=' + this.zf7_1 + ', entity=' + this.af8_1.toString() + ', delay=' + this.bf8_1 + ', duration=' + this.cf8_1 + ', easing=' + toString(this.df8_1) + ')';
  }
  hashCode() {
    var result = this.wf7_1 == null ? 0 : getStringHashCode(this.wf7_1);
    result = imul(result, 31) + (this.xf7_1 == null ? 0 : getBooleanHashCode(this.xf7_1)) | 0;
    result = imul(result, 31) + (this.yf7_1 == null ? 0 : this.yf7_1.hashCode()) | 0;
    result = imul(result, 31) + (this.zf7_1 == null ? 0 : getBooleanHashCode(this.zf7_1)) | 0;
    result = imul(result, 31) + this.af8_1.hashCode() | 0;
    result = imul(result, 31) + (this.bf8_1 == null ? 0 : getNumberHashCode(this.bf8_1)) | 0;
    result = imul(result, 31) + (this.cf8_1 == null ? 0 : getNumberHashCode(this.cf8_1)) | 0;
    result = imul(result, 31) + (this.df8_1 == null ? 0 : hashCode(this.df8_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenSprite))
      return false;
    var tmp0_other_with_cast = other instanceof TweenSprite ? other : THROW_CCE();
    if (!(this.wf7_1 == tmp0_other_with_cast.wf7_1))
      return false;
    if (!(this.xf7_1 == tmp0_other_with_cast.xf7_1))
      return false;
    if (!equals(this.yf7_1, tmp0_other_with_cast.yf7_1))
      return false;
    if (!(this.zf7_1 == tmp0_other_with_cast.zf7_1))
      return false;
    if (!this.af8_1.equals(tmp0_other_with_cast.af8_1))
      return false;
    if (!equals(this.bf8_1, tmp0_other_with_cast.bf8_1))
      return false;
    if (!equals(this.cf8_1, tmp0_other_with_cast.cf8_1))
      return false;
    if (!equals(this.df8_1, tmp0_other_with_cast.df8_1))
      return false;
    return true;
  }
  static ef8(seen0, animation, running, direction, destroyOnPlayingFinished, entity, delay, duration, easing, serializationConstructorMarker) {
    Companion_getInstance_65();
    if (!(16 === (16 & seen0))) {
      throwMissingFieldException(seen0, 16, $serializer_getInstance_54().uf7_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.wf7_1 = null;
    else
      $this.wf7_1 = animation;
    if (0 === (seen0 & 2))
      $this.xf7_1 = null;
    else
      $this.xf7_1 = running;
    if (0 === (seen0 & 4))
      $this.yf7_1 = null;
    else
      $this.yf7_1 = direction;
    if (0 === (seen0 & 8))
      $this.zf7_1 = null;
    else
      $this.zf7_1 = destroyOnPlayingFinished;
    $this.af8_1 = entity;
    if (0 === (seen0 & 32))
      $this.bf8_1 = null;
    else
      $this.bf8_1 = delay;
    if (0 === (seen0 & 64))
      $this.cf8_1 = null;
    else
      $this.cf8_1 = duration;
    if (0 === (seen0 & 128))
      $this.df8_1 = null;
    else
      $this.df8_1 = easing;
    return $this;
  }
}
class TweenSwitchLayerVisibility {
  constructor(offVariance, onVariance, entity, delay, duration, easing) {
    offVariance = offVariance === VOID ? null : offVariance;
    onVariance = onVariance === VOID ? null : onVariance;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.hf8_1 = offVariance;
    this.if8_1 = onVariance;
    this.jf8_1 = entity;
    this.kf8_1 = delay;
    this.lf8_1 = duration;
    this.mf8_1 = easing;
  }
  sf9(_set____db54di) {
    this.jf8_1 = _set____db54di;
  }
  tf9() {
    return this.jf8_1;
  }
  uf9() {
    return this.kf8_1;
  }
  vf9(_set____db54di) {
    this.lf8_1 = _set____db54di;
  }
  wf9() {
    return this.lf8_1;
  }
  xf9(_set____db54di) {
    this.mf8_1 = _set____db54di;
  }
  yf9() {
    return this.mf8_1;
  }
  z27() {
    return this.afb(VOID, VOID, clone(this.jf8_1), VOID, VOID, this.mf8_1);
  }
  bfb(offVariance, onVariance, entity, delay, duration, easing) {
    return new TweenSwitchLayerVisibility(offVariance, onVariance, entity, delay, duration, easing);
  }
  afb(offVariance, onVariance, entity, delay, duration, easing, $super) {
    offVariance = offVariance === VOID ? this.hf8_1 : offVariance;
    onVariance = onVariance === VOID ? this.if8_1 : onVariance;
    entity = entity === VOID ? this.jf8_1 : entity;
    delay = delay === VOID ? this.kf8_1 : delay;
    duration = duration === VOID ? this.lf8_1 : duration;
    easing = easing === VOID ? this.mf8_1 : easing;
    return $super === VOID ? this.bfb(offVariance, onVariance, entity, delay, duration, easing) : $super.bfb.call(this, offVariance, onVariance, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenSwitchLayerVisibility(offVariance=' + this.hf8_1 + ', onVariance=' + this.if8_1 + ', entity=' + this.jf8_1.toString() + ', delay=' + this.kf8_1 + ', duration=' + this.lf8_1 + ', easing=' + toString(this.mf8_1) + ')';
  }
  hashCode() {
    var result = this.hf8_1 == null ? 0 : getNumberHashCode(this.hf8_1);
    result = imul(result, 31) + (this.if8_1 == null ? 0 : getNumberHashCode(this.if8_1)) | 0;
    result = imul(result, 31) + this.jf8_1.hashCode() | 0;
    result = imul(result, 31) + (this.kf8_1 == null ? 0 : getNumberHashCode(this.kf8_1)) | 0;
    result = imul(result, 31) + (this.lf8_1 == null ? 0 : getNumberHashCode(this.lf8_1)) | 0;
    result = imul(result, 31) + (this.mf8_1 == null ? 0 : hashCode(this.mf8_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenSwitchLayerVisibility))
      return false;
    var tmp0_other_with_cast = other instanceof TweenSwitchLayerVisibility ? other : THROW_CCE();
    if (!equals(this.hf8_1, tmp0_other_with_cast.hf8_1))
      return false;
    if (!equals(this.if8_1, tmp0_other_with_cast.if8_1))
      return false;
    if (!this.jf8_1.equals(tmp0_other_with_cast.jf8_1))
      return false;
    if (!equals(this.kf8_1, tmp0_other_with_cast.kf8_1))
      return false;
    if (!equals(this.lf8_1, tmp0_other_with_cast.lf8_1))
      return false;
    if (!equals(this.mf8_1, tmp0_other_with_cast.mf8_1))
      return false;
    return true;
  }
  static nf8(seen0, offVariance, onVariance, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(4 === (4 & seen0))) {
      throwMissingFieldException(seen0, 4, $serializer_getInstance_55().ff8_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.hf8_1 = null;
    else
      $this.hf8_1 = offVariance;
    if (0 === (seen0 & 2))
      $this.if8_1 = null;
    else
      $this.if8_1 = onVariance;
    $this.jf8_1 = entity;
    if (0 === (seen0 & 8))
      $this.kf8_1 = null;
    else
      $this.kf8_1 = delay;
    if (0 === (seen0 & 16))
      $this.lf8_1 = null;
    else
      $this.lf8_1 = duration;
    if (0 === (seen0 & 32))
      $this.mf8_1 = null;
    else
      $this.mf8_1 = easing;
    return $this;
  }
}
class TweenSpawner {
  constructor(numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing) {
    numberOfObjects = numberOfObjects === VOID ? null : numberOfObjects;
    interval = interval === VOID ? null : interval;
    timeVariation = timeVariation === VOID ? null : timeVariation;
    positionVariation = positionVariation === VOID ? null : positionVariation;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.qf8_1 = numberOfObjects;
    this.rf8_1 = interval;
    this.sf8_1 = timeVariation;
    this.tf8_1 = positionVariation;
    this.uf8_1 = entity;
    this.vf8_1 = delay;
    this.wf8_1 = duration;
    this.xf8_1 = easing;
  }
  sf9(_set____db54di) {
    this.uf8_1 = _set____db54di;
  }
  tf9() {
    return this.uf8_1;
  }
  uf9() {
    return this.vf8_1;
  }
  vf9(_set____db54di) {
    this.wf8_1 = _set____db54di;
  }
  wf9() {
    return this.wf8_1;
  }
  xf9(_set____db54di) {
    this.xf8_1 = _set____db54di;
  }
  yf9() {
    return this.xf8_1;
  }
  z27() {
    return this.cfb(VOID, VOID, VOID, VOID, clone(this.uf8_1), VOID, VOID, this.xf8_1);
  }
  dfb(numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing) {
    return new TweenSpawner(numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing);
  }
  cfb(numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing, $super) {
    numberOfObjects = numberOfObjects === VOID ? this.qf8_1 : numberOfObjects;
    interval = interval === VOID ? this.rf8_1 : interval;
    timeVariation = timeVariation === VOID ? this.sf8_1 : timeVariation;
    positionVariation = positionVariation === VOID ? this.tf8_1 : positionVariation;
    entity = entity === VOID ? this.uf8_1 : entity;
    delay = delay === VOID ? this.vf8_1 : delay;
    duration = duration === VOID ? this.wf8_1 : duration;
    easing = easing === VOID ? this.xf8_1 : easing;
    return $super === VOID ? this.dfb(numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing) : $super.dfb.call(this, numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenSpawner(numberOfObjects=' + this.qf8_1 + ', interval=' + this.rf8_1 + ', timeVariation=' + this.sf8_1 + ', positionVariation=' + this.tf8_1 + ', entity=' + this.uf8_1.toString() + ', delay=' + this.vf8_1 + ', duration=' + this.wf8_1 + ', easing=' + toString(this.xf8_1) + ')';
  }
  hashCode() {
    var result = this.qf8_1 == null ? 0 : this.qf8_1;
    result = imul(result, 31) + (this.rf8_1 == null ? 0 : this.rf8_1) | 0;
    result = imul(result, 31) + (this.sf8_1 == null ? 0 : this.sf8_1) | 0;
    result = imul(result, 31) + (this.tf8_1 == null ? 0 : getNumberHashCode(this.tf8_1)) | 0;
    result = imul(result, 31) + this.uf8_1.hashCode() | 0;
    result = imul(result, 31) + (this.vf8_1 == null ? 0 : getNumberHashCode(this.vf8_1)) | 0;
    result = imul(result, 31) + (this.wf8_1 == null ? 0 : getNumberHashCode(this.wf8_1)) | 0;
    result = imul(result, 31) + (this.xf8_1 == null ? 0 : hashCode(this.xf8_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenSpawner))
      return false;
    var tmp0_other_with_cast = other instanceof TweenSpawner ? other : THROW_CCE();
    if (!(this.qf8_1 == tmp0_other_with_cast.qf8_1))
      return false;
    if (!(this.rf8_1 == tmp0_other_with_cast.rf8_1))
      return false;
    if (!(this.sf8_1 == tmp0_other_with_cast.sf8_1))
      return false;
    if (!equals(this.tf8_1, tmp0_other_with_cast.tf8_1))
      return false;
    if (!this.uf8_1.equals(tmp0_other_with_cast.uf8_1))
      return false;
    if (!equals(this.vf8_1, tmp0_other_with_cast.vf8_1))
      return false;
    if (!equals(this.wf8_1, tmp0_other_with_cast.wf8_1))
      return false;
    if (!equals(this.xf8_1, tmp0_other_with_cast.xf8_1))
      return false;
    return true;
  }
  static yf8(seen0, numberOfObjects, interval, timeVariation, positionVariation, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(16 === (16 & seen0))) {
      throwMissingFieldException(seen0, 16, $serializer_getInstance_56().of8_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.qf8_1 = null;
    else
      $this.qf8_1 = numberOfObjects;
    if (0 === (seen0 & 2))
      $this.rf8_1 = null;
    else
      $this.rf8_1 = interval;
    if (0 === (seen0 & 4))
      $this.sf8_1 = null;
    else
      $this.sf8_1 = timeVariation;
    if (0 === (seen0 & 8))
      $this.tf8_1 = null;
    else
      $this.tf8_1 = positionVariation;
    $this.uf8_1 = entity;
    if (0 === (seen0 & 32))
      $this.vf8_1 = null;
    else
      $this.vf8_1 = delay;
    if (0 === (seen0 & 64))
      $this.wf8_1 = null;
    else
      $this.wf8_1 = duration;
    if (0 === (seen0 & 128))
      $this.xf8_1 = null;
    else
      $this.xf8_1 = easing;
    return $this;
  }
}
class TweenSound {
  constructor(startTrigger, stopTrigger, position, volume, entity, delay, duration, easing) {
    startTrigger = startTrigger === VOID ? null : startTrigger;
    stopTrigger = stopTrigger === VOID ? null : stopTrigger;
    position = position === VOID ? null : position;
    volume = volume === VOID ? null : volume;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.bf9_1 = startTrigger;
    this.cf9_1 = stopTrigger;
    this.df9_1 = position;
    this.ef9_1 = volume;
    this.ff9_1 = entity;
    this.gf9_1 = delay;
    this.hf9_1 = duration;
    this.if9_1 = easing;
  }
  sf9(_set____db54di) {
    this.ff9_1 = _set____db54di;
  }
  tf9() {
    return this.ff9_1;
  }
  uf9() {
    return this.gf9_1;
  }
  vf9(_set____db54di) {
    this.hf9_1 = _set____db54di;
  }
  wf9() {
    return this.hf9_1;
  }
  xf9(_set____db54di) {
    this.if9_1 = _set____db54di;
  }
  yf9() {
    return this.if9_1;
  }
  z27() {
    return this.efb(VOID, VOID, VOID, VOID, clone(this.ff9_1), VOID, VOID, this.if9_1);
  }
  ffb(startTrigger, stopTrigger, position, volume, entity, delay, duration, easing) {
    return new TweenSound(startTrigger, stopTrigger, position, volume, entity, delay, duration, easing);
  }
  efb(startTrigger, stopTrigger, position, volume, entity, delay, duration, easing, $super) {
    startTrigger = startTrigger === VOID ? this.bf9_1 : startTrigger;
    stopTrigger = stopTrigger === VOID ? this.cf9_1 : stopTrigger;
    position = position === VOID ? this.df9_1 : position;
    volume = volume === VOID ? this.ef9_1 : volume;
    entity = entity === VOID ? this.ff9_1 : entity;
    delay = delay === VOID ? this.gf9_1 : delay;
    duration = duration === VOID ? this.hf9_1 : duration;
    easing = easing === VOID ? this.if9_1 : easing;
    return $super === VOID ? this.ffb(startTrigger, stopTrigger, position, volume, entity, delay, duration, easing) : $super.ffb.call(this, startTrigger, stopTrigger, position, volume, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenSound(startTrigger=' + this.bf9_1 + ', stopTrigger=' + this.cf9_1 + ', position=' + this.df9_1 + ', volume=' + this.ef9_1 + ', entity=' + this.ff9_1.toString() + ', delay=' + this.gf9_1 + ', duration=' + this.hf9_1 + ', easing=' + toString(this.if9_1) + ')';
  }
  hashCode() {
    var result = this.bf9_1 == null ? 0 : getBooleanHashCode(this.bf9_1);
    result = imul(result, 31) + (this.cf9_1 == null ? 0 : getBooleanHashCode(this.cf9_1)) | 0;
    result = imul(result, 31) + (this.df9_1 == null ? 0 : getNumberHashCode(this.df9_1)) | 0;
    result = imul(result, 31) + (this.ef9_1 == null ? 0 : getNumberHashCode(this.ef9_1)) | 0;
    result = imul(result, 31) + this.ff9_1.hashCode() | 0;
    result = imul(result, 31) + (this.gf9_1 == null ? 0 : getNumberHashCode(this.gf9_1)) | 0;
    result = imul(result, 31) + (this.hf9_1 == null ? 0 : getNumberHashCode(this.hf9_1)) | 0;
    result = imul(result, 31) + (this.if9_1 == null ? 0 : hashCode(this.if9_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenSound))
      return false;
    var tmp0_other_with_cast = other instanceof TweenSound ? other : THROW_CCE();
    if (!(this.bf9_1 == tmp0_other_with_cast.bf9_1))
      return false;
    if (!(this.cf9_1 == tmp0_other_with_cast.cf9_1))
      return false;
    if (!equals(this.df9_1, tmp0_other_with_cast.df9_1))
      return false;
    if (!equals(this.ef9_1, tmp0_other_with_cast.ef9_1))
      return false;
    if (!this.ff9_1.equals(tmp0_other_with_cast.ff9_1))
      return false;
    if (!equals(this.gf9_1, tmp0_other_with_cast.gf9_1))
      return false;
    if (!equals(this.hf9_1, tmp0_other_with_cast.hf9_1))
      return false;
    if (!equals(this.if9_1, tmp0_other_with_cast.if9_1))
      return false;
    return true;
  }
  static jf9(seen0, startTrigger, stopTrigger, position, volume, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(16 === (16 & seen0))) {
      throwMissingFieldException(seen0, 16, $serializer_getInstance_57().zf8_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.bf9_1 = null;
    else
      $this.bf9_1 = startTrigger;
    if (0 === (seen0 & 2))
      $this.cf9_1 = null;
    else
      $this.cf9_1 = stopTrigger;
    if (0 === (seen0 & 4))
      $this.df9_1 = null;
    else
      $this.df9_1 = position;
    if (0 === (seen0 & 8))
      $this.ef9_1 = null;
    else
      $this.ef9_1 = volume;
    $this.ff9_1 = entity;
    if (0 === (seen0 & 32))
      $this.gf9_1 = null;
    else
      $this.gf9_1 = delay;
    if (0 === (seen0 & 64))
      $this.hf9_1 = null;
    else
      $this.hf9_1 = duration;
    if (0 === (seen0 & 128))
      $this.if9_1 = null;
    else
      $this.if9_1 = easing;
    return $this;
  }
}
class TweenTouchInput {
  constructor(enabled, entity, delay, duration, easing) {
    enabled = enabled === VOID ? null : enabled;
    delay = delay === VOID ? null : delay;
    duration = duration === VOID ? null : duration;
    easing = easing === VOID ? null : easing;
    this.mf9_1 = enabled;
    this.nf9_1 = entity;
    this.of9_1 = delay;
    this.pf9_1 = duration;
    this.qf9_1 = easing;
  }
  sf9(_set____db54di) {
    this.nf9_1 = _set____db54di;
  }
  tf9() {
    return this.nf9_1;
  }
  uf9() {
    return this.of9_1;
  }
  vf9(_set____db54di) {
    this.pf9_1 = _set____db54di;
  }
  wf9() {
    return this.pf9_1;
  }
  xf9(_set____db54di) {
    this.qf9_1 = _set____db54di;
  }
  yf9() {
    return this.qf9_1;
  }
  z27() {
    return this.gfb(VOID, clone(this.nf9_1), VOID, VOID, this.qf9_1);
  }
  hfb(enabled, entity, delay, duration, easing) {
    return new TweenTouchInput(enabled, entity, delay, duration, easing);
  }
  gfb(enabled, entity, delay, duration, easing, $super) {
    enabled = enabled === VOID ? this.mf9_1 : enabled;
    entity = entity === VOID ? this.nf9_1 : entity;
    delay = delay === VOID ? this.of9_1 : delay;
    duration = duration === VOID ? this.pf9_1 : duration;
    easing = easing === VOID ? this.qf9_1 : easing;
    return $super === VOID ? this.hfb(enabled, entity, delay, duration, easing) : $super.hfb.call(this, enabled, entity, delay, duration, easing);
  }
  toString() {
    return 'TweenTouchInput(enabled=' + this.mf9_1 + ', entity=' + this.nf9_1.toString() + ', delay=' + this.of9_1 + ', duration=' + this.pf9_1 + ', easing=' + toString(this.qf9_1) + ')';
  }
  hashCode() {
    var result = this.mf9_1 == null ? 0 : getBooleanHashCode(this.mf9_1);
    result = imul(result, 31) + this.nf9_1.hashCode() | 0;
    result = imul(result, 31) + (this.of9_1 == null ? 0 : getNumberHashCode(this.of9_1)) | 0;
    result = imul(result, 31) + (this.pf9_1 == null ? 0 : getNumberHashCode(this.pf9_1)) | 0;
    result = imul(result, 31) + (this.qf9_1 == null ? 0 : hashCode(this.qf9_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenTouchInput))
      return false;
    var tmp0_other_with_cast = other instanceof TweenTouchInput ? other : THROW_CCE();
    if (!(this.mf9_1 == tmp0_other_with_cast.mf9_1))
      return false;
    if (!this.nf9_1.equals(tmp0_other_with_cast.nf9_1))
      return false;
    if (!equals(this.of9_1, tmp0_other_with_cast.of9_1))
      return false;
    if (!equals(this.pf9_1, tmp0_other_with_cast.pf9_1))
      return false;
    if (!equals(this.qf9_1, tmp0_other_with_cast.qf9_1))
      return false;
    return true;
  }
  static rf9(seen0, enabled, entity, delay, duration, easing, serializationConstructorMarker) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_58().kf9_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.mf9_1 = null;
    else
      $this.mf9_1 = enabled;
    $this.nf9_1 = entity;
    if (0 === (seen0 & 4))
      $this.of9_1 = null;
    else
      $this.of9_1 = delay;
    if (0 === (seen0 & 8))
      $this.pf9_1 = null;
    else
      $this.pf9_1 = duration;
    if (0 === (seen0 & 16))
      $this.qf9_1 = null;
    else
      $this.qf9_1 = easing;
    return $this;
  }
}
class Companion_60 extends ComponentType {
  constructor() {
    Companion_instance_62 = null;
    super();
    Companion_instance_62 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(TweenBase);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.jfb_1 = [new ArrayListSerializer(PolymorphicSerializer.qv(tmp_0, tmp$ret$2)), null, null, null, null, null];
  }
}
class $serializer_58 {
  constructor() {
    $serializer_instance_58 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('TweenSequence', this, 6);
    tmp0_serialDesc.m16('tweens', true);
    tmp0_serialDesc.m16('index', true);
    tmp0_serialDesc.m16('timeProgress', true);
    tmp0_serialDesc.m16('waitTime', true);
    tmp0_serialDesc.m16('executed', true);
    tmp0_serialDesc.m16('initialized', true);
    this.kfb_1 = tmp0_serialDesc;
  }
  lfb(encoder, value) {
    var tmp0_desc = this.kfb_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_70().jfb_1;
    var tmp;
    if (tmp1_output.v10(tmp0_desc, 0)) {
      tmp = true;
    } else {
      var tmp_0 = value.mfb_1;
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(tmp_0, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.mfb_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.nfb_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 1, value.nfb_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !equals(value.ofb_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 2, value.ofb_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.pfb_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.pfb_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.qfb_1 === false)) {
      tmp1_output.f10(tmp0_desc, 4, value.qfb_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.rfb_1 === false)) {
      tmp1_output.f10(tmp0_desc, 5, value.rfb_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.lfb(encoder, value instanceof TweenSequenceComponent ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.kfb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_input = decoder.xy(tmp0_desc);
    var tmp11_cached = Companion_getInstance_70().jfb_1;
    if (tmp10_input.nz()) {
      tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.ez(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zy(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zy(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.jz(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.ez(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zy(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zy(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp10_input.yy(tmp0_desc);
    return TweenSequenceComponent.sfb(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  yu() {
    return this.kfb_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_70().jfb_1[0], IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class TweenSequenceComponent extends CloneableComponent {
  static tfb(tweens, index, timeProgress, waitTime, executed, initialized) {
    Companion_getInstance_70();
    var tmp;
    if (tweens === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = tweens;
    }
    tweens = tmp;
    index = index === VOID ? 0 : index;
    timeProgress = timeProgress === VOID ? 0.0 : timeProgress;
    waitTime = waitTime === VOID ? 0.0 : waitTime;
    executed = executed === VOID ? false : executed;
    initialized = initialized === VOID ? false : initialized;
    var $this = this.uem();
    $this.mfb_1 = tweens;
    $this.nfb_1 = index;
    $this.ofb_1 = timeProgress;
    $this.pfb_1 = waitTime;
    $this.qfb_1 = executed;
    $this.rfb_1 = initialized;
    return $this;
  }
  q1t() {
    return Companion_getInstance_70();
  }
  r1t(_this__u8e3s4, entity) {
    if (this.rfb_1)
      return Unit_instance;
    else
      this.rfb_1 = true;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.mfb_1.j1()) {
      var tmp = this;
      var tmp0_elvis_lhs = this.mfb_1.h1(this.nfb_1).uf9();
      tmp.pfb_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    }
  }
  z27() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var copyOfTweens = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.mfb_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.components.TweenSequenceComponent.clone.<anonymous>' call
      copyOfTweens.h(element.z27());
    }
    return this.ufb(copyOfTweens);
  }
  vfb(tweens, index, timeProgress, waitTime, executed, initialized) {
    return TweenSequenceComponent.tfb(tweens, index, timeProgress, waitTime, executed, initialized);
  }
  ufb(tweens, index, timeProgress, waitTime, executed, initialized, $super) {
    tweens = tweens === VOID ? this.mfb_1 : tweens;
    index = index === VOID ? this.nfb_1 : index;
    timeProgress = timeProgress === VOID ? this.ofb_1 : timeProgress;
    waitTime = waitTime === VOID ? this.pfb_1 : waitTime;
    executed = executed === VOID ? this.qfb_1 : executed;
    initialized = initialized === VOID ? this.rfb_1 : initialized;
    return $super === VOID ? this.vfb(tweens, index, timeProgress, waitTime, executed, initialized) : $super.vfb.call(this, tweens, index, timeProgress, waitTime, executed, initialized);
  }
  toString() {
    return 'TweenSequenceComponent(tweens=' + toString_0(this.mfb_1) + ', index=' + this.nfb_1 + ', timeProgress=' + this.ofb_1 + ', waitTime=' + this.pfb_1 + ', executed=' + this.qfb_1 + ', initialized=' + this.rfb_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.mfb_1);
    result = imul(result, 31) + this.nfb_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.ofb_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pfb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qfb_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rfb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TweenSequenceComponent))
      return false;
    var tmp0_other_with_cast = other instanceof TweenSequenceComponent ? other : THROW_CCE();
    if (!equals(this.mfb_1, tmp0_other_with_cast.mfb_1))
      return false;
    if (!(this.nfb_1 === tmp0_other_with_cast.nfb_1))
      return false;
    if (!equals(this.ofb_1, tmp0_other_with_cast.ofb_1))
      return false;
    if (!equals(this.pfb_1, tmp0_other_with_cast.pfb_1))
      return false;
    if (!(this.qfb_1 === tmp0_other_with_cast.qfb_1))
      return false;
    if (!(this.rfb_1 === tmp0_other_with_cast.rfb_1))
      return false;
    return true;
  }
  static sfb(seen0, tweens, index, timeProgress, waitTime, executed, initialized, serializationConstructorMarker) {
    Companion_getInstance_70();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_59().kfb_1);
    }
    var $this = this.uem();
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.mfb_1 = emptyList();
    } else
      $this.mfb_1 = tweens;
    if (0 === (seen0 & 2))
      $this.nfb_1 = 0;
    else
      $this.nfb_1 = index;
    if (0 === (seen0 & 4))
      $this.ofb_1 = 0.0;
    else
      $this.ofb_1 = timeProgress;
    if (0 === (seen0 & 8))
      $this.pfb_1 = 0.0;
    else
      $this.pfb_1 = waitTime;
    if (0 === (seen0 & 16))
      $this.qfb_1 = false;
    else
      $this.qfb_1 = executed;
    if (0 === (seen0 & 32))
      $this.rfb_1 = false;
    else
      $this.rfb_1 = initialized;
    return $this;
  }
}
class EntityFactory {
  constructor() {
    EntityFactory_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.wfb_1 = LinkedHashMap.wc();
  }
  xfb(entityConfig) {
    if (!this.wfb_1.c3(entityConfig.q3())) {
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.wfb_1;
      var key = entityConfig.q3();
      this_0.k3(key, entityConfig);
    }
  }
  n28(name) {
    return this.wfb_1.c3(name);
  }
  yfb(entityConfig, world) {
    return this.zfb(entityConfig, world, Companion_getInstance_4().x1s_1);
  }
  zfb(name, world, entity_0) {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (entity_0.equals(Companion_getInstance_4().x1s_1)) {
      tmp = entity(world, name);
    } else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.EntityFactory.configure.<anonymous>.<anonymous>' call
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_0 = world.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_0.s1v_1 === entity_0.m1u_1 || this_0.q1v_1 === entity_0.m1u_1;
        var prevUpdateId = this_0.s1v_1;
        this_0.s1v_1 = entity_0.m1u_1;
        // Inline function 'korlibs.korge.fleks.entity.EntityFactory.configure.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
        var this_1 = this_0.r1v_1;
        var component = InfoComponent.wen(name);
        var compType = component.q1t();
        this_1.f1v_1.h1(entity_0.m1u_1).p1s(compType.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this_1.i1v_1;
        if (this_2.u1t_1.j1s(compType.m1t())) {
          var tmp_0 = compType.m1t();
          var tmp_1 = this_2.v1t();
          var tmp_2 = 0;
          var tmp_3 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_4 = fillArrayVal(Array(tmp_3), null);
          while (tmp_2 < tmp_3) {
            tmp_4[tmp_2] = null;
            tmp_2 = tmp_2 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, compType, tmp_4));
        }
        var tmp_5 = this_2.u1t_1.h1(compType.m1t());
        var holder = tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE();
        holder.l1u(entity_0, component);
        this_0.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_0.o1v_1.h1(entity_0.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_0.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity_0, compMask);
        }
      }
      tmp = entity_0;
    }
    var baseEntity = tmp;
    var entityConfig = EntityFactory_getInstance().wfb_1.e3(name);
    var tmp_6;
    if (!(entityConfig == null)) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.EntityFactory.configure.<anonymous>.<anonymous>' call
      tmp_6 = entityConfig.afc(world, baseEntity);
    } else {
      println("WARNING: Cannot invoke! EntityConfig with name '" + name + "' not registered in EntityFactory!");
      tmp_6 = entity_0;
    }
    return tmp_6;
  }
}
class Companion_61 {}
class $serializer_59 {
  constructor() {
    $serializer_instance_59 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MainCameraConfig', this, 1);
    tmp0_serialDesc.m16('name', false);
    this.bfc_1 = tmp0_serialDesc;
  }
  cfc(encoder, value) {
    var tmp0_desc = this.bfc_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.dfc_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.cfc(encoder, value instanceof MainCameraConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.bfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return MainCameraConfig.efc(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.bfc_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class EntityConfig {}
class MainCameraConfig {
  constructor(name) {
    this.dfc_1 = name;
    EntityFactory_getInstance().xfb(this);
  }
  q3() {
    return this.dfc_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.MainCameraConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = PositionComponent.teo();
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp = compType.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      holder.l1u(entity, component);
      $this$configure.h1v(entity, MainCameraTag_getInstance());
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'MainCameraConfig(name=' + this.dfc_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.dfc_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MainCameraConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MainCameraConfig ? other : THROW_CCE();
    if (!(this.dfc_1 === tmp0_other_with_cast.dfc_1))
      return false;
    return true;
  }
  static efc(seen0, name, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_60().bfc_1);
    }
    var $this = createThis(this);
    $this.dfc_1 = name;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class AvatarPosition extends Enum {}
class Companion_62 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ffc_1 = [null, null, null, null, null, null, null, null, null, null, createSimpleEnumSerializer('korlibs.korge.fleks.entity.config.DialogBoxConfig.AvatarPosition', values_2()), null, null, null, null, null, null, null, null, null];
  }
}
class $serializer_60 {
  constructor() {
    $serializer_instance_60 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('DialogBoxConfig', this, 20);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('duration', false);
    tmp0_serialDesc.m16('positionHAlign', false);
    tmp0_serialDesc.m16('positionVAlign', false);
    tmp0_serialDesc.m16('width', false);
    tmp0_serialDesc.m16('numberOfLines', false);
    tmp0_serialDesc.m16('tint', true);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('avatarMoveX', true);
    tmp0_serialDesc.m16('avatarName', false);
    tmp0_serialDesc.m16('avatarPosition', false);
    tmp0_serialDesc.m16('textFieldName', false);
    tmp0_serialDesc.m16('text', false);
    tmp0_serialDesc.m16('textFontName', false);
    tmp0_serialDesc.m16('textRangeEnd', true);
    tmp0_serialDesc.m16('textWritingFactor', true);
    tmp0_serialDesc.m16('textHAlign', true);
    tmp0_serialDesc.m16('textVAlign', true);
    tmp0_serialDesc.m16('textSize', true);
    tmp0_serialDesc.m16('height', true);
    this.gfc_1 = tmp0_serialDesc;
  }
  hfc(encoder, value) {
    var tmp0_desc = this.gfc_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_72().ffc_1;
    tmp1_output.n10(tmp0_desc, 0, value.ifc_1);
    tmp1_output.k10(tmp0_desc, 1, value.jfc_1);
    tmp1_output.p10(tmp0_desc, 2, HAlignAsString_getInstance(), new HorizontalAlign(value.kfc_1));
    tmp1_output.p10(tmp0_desc, 3, VAlignAsString_getInstance(), new VerticalAlign(value.lfc_1));
    tmp1_output.k10(tmp0_desc, 4, value.mfc_1);
    tmp1_output.i10(tmp0_desc, 5, value.nfc_1);
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !value.ofc_1.equals(Companion_getInstance_37().rev_1)) {
      tmp1_output.p10(tmp0_desc, 6, $serializer_getInstance_26(), value.ofc_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.pfc_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 7, value.pfc_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !equals(value.qfc_1, 10.0)) {
      tmp1_output.k10(tmp0_desc, 8, value.qfc_1);
    }
    tmp1_output.n10(tmp0_desc, 9, value.rfc_1);
    tmp1_output.p10(tmp0_desc, 10, tmp2_cached[10], value.sfc_1);
    tmp1_output.n10(tmp0_desc, 11, value.tfc_1);
    tmp1_output.n10(tmp0_desc, 12, value.ufc_1);
    tmp1_output.n10(tmp0_desc, 13, value.vfc_1);
    if (tmp1_output.v10(tmp0_desc, 14) ? true : !(value.wfc_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 14, value.wfc_1);
    }
    if (tmp1_output.v10(tmp0_desc, 15) ? true : !equals(value.xfc_1, 0.035)) {
      tmp1_output.k10(tmp0_desc, 15, value.xfc_1);
    }
    if (tmp1_output.v10(tmp0_desc, 16) ? true : !equals(value.yfc_1, Companion_getInstance_1().j6w_1)) {
      tmp1_output.p10(tmp0_desc, 16, HAlignAsString_getInstance(), new HorizontalAlign(value.yfc_1));
    }
    if (tmp1_output.v10(tmp0_desc, 17) ? true : !equals(value.zfc_1, Companion_getInstance_2().o6w_1)) {
      tmp1_output.p10(tmp0_desc, 17, VAlignAsString_getInstance(), new VerticalAlign(value.zfc_1));
    }
    if (tmp1_output.v10(tmp0_desc, 18) ? true : !equals(value.afd_1, 13.0)) {
      tmp1_output.k10(tmp0_desc, 18, value.afd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 19) ? true : !equals(value.bfd_1, value.afd_1 * value.nfc_1 + 2)) {
      tmp1_output.k10(tmp0_desc, 19, value.bfd_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.hfc(encoder, value instanceof DialogBoxConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.gfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = 0.0;
    var tmp12_local8 = 0.0;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = 0;
    var tmp19_local15 = 0.0;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = 0.0;
    var tmp23_local19 = 0.0;
    var tmp24_input = decoder.xy(tmp0_desc);
    var tmp25_cached = Companion_getInstance_72().ffc_1;
    if (tmp24_input.nz()) {
      tmp4_local0 = tmp24_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp24_input.ez(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = HAlignAsString_getInstance();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp24_input.jz(tmp0_desc, 2, tmp, tmp_0 == null ? null : new HorizontalAlign(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.x6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp_2 = VAlignAsString_getInstance();
      var tmp_3 = tmp7_local3;
      var tmp_4 = tmp24_input.jz(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new VerticalAlign(tmp_3));
      tmp7_local3 = tmp_4 == null ? null : tmp_4.v6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp24_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp24_input.cz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp24_input.jz(tmp0_desc, 6, $serializer_getInstance_26(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp24_input.ez(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp24_input.ez(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp24_input.hz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp24_input.jz(tmp0_desc, 10, tmp25_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp24_input.hz(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp24_input.hz(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp24_input.hz(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp24_input.cz(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp24_input.ez(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      var tmp_5 = HAlignAsString_getInstance();
      var tmp_6 = tmp20_local16;
      var tmp_7 = tmp24_input.jz(tmp0_desc, 16, tmp_5, tmp_6 == null ? null : new HorizontalAlign(tmp_6));
      tmp20_local16 = tmp_7 == null ? null : tmp_7.x6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      var tmp_8 = VAlignAsString_getInstance();
      var tmp_9 = tmp21_local17;
      var tmp_10 = tmp24_input.jz(tmp0_desc, 17, tmp_8, tmp_9 == null ? null : new VerticalAlign(tmp_9));
      tmp21_local17 = tmp_10 == null ? null : tmp_10.v6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp24_input.ez(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp24_input.ez(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp24_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp24_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp24_input.ez(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_11 = HAlignAsString_getInstance();
            var tmp_12 = tmp6_local2;
            var tmp_13 = tmp24_input.jz(tmp0_desc, 2, tmp_11, tmp_12 == null ? null : new HorizontalAlign(tmp_12));
            tmp6_local2 = tmp_13 == null ? null : tmp_13.x6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_14 = VAlignAsString_getInstance();
            var tmp_15 = tmp7_local3;
            var tmp_16 = tmp24_input.jz(tmp0_desc, 3, tmp_14, tmp_15 == null ? null : new VerticalAlign(tmp_15));
            tmp7_local3 = tmp_16 == null ? null : tmp_16.v6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp24_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp24_input.cz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp24_input.jz(tmp0_desc, 6, $serializer_getInstance_26(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp24_input.ez(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp24_input.ez(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp24_input.hz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp24_input.jz(tmp0_desc, 10, tmp25_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp24_input.hz(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp24_input.hz(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp24_input.hz(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp24_input.cz(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp24_input.ez(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            var tmp_17 = HAlignAsString_getInstance();
            var tmp_18 = tmp20_local16;
            var tmp_19 = tmp24_input.jz(tmp0_desc, 16, tmp_17, tmp_18 == null ? null : new HorizontalAlign(tmp_18));
            tmp20_local16 = tmp_19 == null ? null : tmp_19.x6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            var tmp_20 = VAlignAsString_getInstance();
            var tmp_21 = tmp21_local17;
            var tmp_22 = tmp24_input.jz(tmp0_desc, 17, tmp_20, tmp_21 == null ? null : new VerticalAlign(tmp_21));
            tmp21_local17 = tmp_22 == null ? null : tmp_22.v6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp24_input.ez(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp24_input.ez(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp24_input.yy(tmp0_desc);
    return DialogBoxConfig.cfd(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, null);
  }
  yu() {
    return this.gfc_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_72().ffc_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), HAlignAsString_getInstance(), VAlignAsString_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_26(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[10], StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), HAlignAsString_getInstance(), VAlignAsString_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class DialogBoxConfig {
  q3() {
    return this.ifc_1;
  }
  afc(_this__u8e3s4, entity) {
    var viewPortWidth = AppConfig_getInstance().iev_1;
    var viewPortHeight = AppConfig_getInstance().jev_1;
    var textBoxWidth = this.mfc_1 + 14;
    var textBoxHeight = this.bfd_1 + 8;
    var textBoxX = hAlign(this, this.kfc_1, textBoxWidth, viewPortWidth);
    var textBoxY = vAlign(this, this.lfc_1, textBoxHeight, viewPortHeight);
    var textFieldX = textBoxX + 7;
    var textFieldY = textBoxY + 4;
    var textFieldWidth = this.mfc_1;
    var textFieldHeight = this.bfd_1;
    var avatarLeftInitialX = textBoxX + 10.0;
    var avatarRightInitialX = viewPortWidth - 20.0 - 38.0;
    var tmp;
    switch (this.sfc_1.p3_1) {
      case 0:
        tmp = avatarLeftInitialX - this.qfc_1;
        break;
      case 1:
        tmp = avatarRightInitialX + this.qfc_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var avatarInitialX = tmp;
    var tmp_0;
    switch (this.sfc_1.p3_1) {
      case 0:
        tmp_0 = avatarLeftInitialX;
        break;
      case 1:
        tmp_0 = avatarRightInitialX;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var avatarTweenX = tmp_0;
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var this_0 = _this__u8e3s4.a1u_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var entity_0 = this_0.m1v_1.a1x();
    if (entity_0.m1u_1 >= this_0.o1v_1.f1s_1) {
      this_0.o1v_1.h1s(entity_0.m1u_1, new BitArray(64));
    }
    var prevCreateId = this_0.q1v_1;
    this_0.q1v_1 = entity_0.m1u_1;
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>' call
    var $this$entity = this_0.p1v_1;
    $this$entity.h1v(entity_0, ScreenCoordinatesTag_getInstance());
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component = PositionComponent.teo(avatarInitialX, textBoxY - 24.0);
    var compType = component.q1t();
    $this$entity.f1v_1.h1(entity_0.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType.m1t())) {
      var tmp_1 = compType.m1t();
      var tmp_2 = this_1.v1t();
      var tmp_3 = 0;
      var tmp_4 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_5 = fillArrayVal(Array(tmp_4), null);
      while (tmp_3 < tmp_4) {
        tmp_5[tmp_3] = null;
        tmp_3 = tmp_3 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_1, new ComponentsHolder(tmp_2, compType, tmp_5));
    }
    var tmp_6 = this_1.u1t_1.h1(compType.m1t());
    var holder = tmp_6 instanceof ComponentsHolder ? tmp_6 : THROW_CCE();
    holder.l1u(entity_0, component);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_0 = SpriteComponent.uey(this.rfc_1);
    var compType_0 = component_0.q1t();
    $this$entity.f1v_1.h1(entity_0.m1u_1).p1s(compType_0.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_2 = $this$entity.i1v_1;
    if (this_2.u1t_1.j1s(compType_0.m1t())) {
      var tmp_7 = compType_0.m1t();
      var tmp_8 = this_2.v1t();
      var tmp_9 = 0;
      var tmp_10 = this_2.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_11 = fillArrayVal(Array(tmp_10), null);
      while (tmp_9 < tmp_10) {
        tmp_11[tmp_9] = null;
        tmp_9 = tmp_9 + 1 | 0;
      }
      this_2.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, compType_0, tmp_11));
    }
    var tmp_12 = this_2.u1t_1.h1(compType_0.m1t());
    var holder_0 = tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE();
    holder_0.l1u(entity_0, component_0);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    // Inline function 'kotlin.apply' call
    var this_3 = RgbaComponent.xeo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>.<anonymous>' call
    this_3.jew(this.ofc_1);
    this_3.iew(this.pfc_1);
    var compType_1 = this_3.q1t();
    $this$entity.f1v_1.h1(entity_0.m1u_1).p1s(compType_1.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_4 = $this$entity.i1v_1;
    if (this_4.u1t_1.j1s(compType_1.m1t())) {
      var tmp_13 = compType_1.m1t();
      var tmp_14 = this_4.v1t();
      var tmp_15 = 0;
      var tmp_16 = this_4.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_17 = fillArrayVal(Array(tmp_16), null);
      while (tmp_15 < tmp_16) {
        tmp_17[tmp_15] = null;
        tmp_15 = tmp_15 + 1 | 0;
      }
      this_4.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, compType_1, tmp_17));
    }
    var tmp_18 = this_4.u1t_1.h1(compType_1.m1t());
    var holder_1 = tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE();
    holder_1.l1u(entity_0, this_3);
    $this$entity.h1v(entity_0, RenderLayerTag_FG_DIALOGS_getInstance());
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_1 = LayerComponent.geo(102);
    var compType_2 = component_1.q1t();
    $this$entity.f1v_1.h1(entity_0.m1u_1).p1s(compType_2.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_5 = $this$entity.i1v_1;
    if (this_5.u1t_1.j1s(compType_2.m1t())) {
      var tmp_19 = compType_2.m1t();
      var tmp_20 = this_5.v1t();
      var tmp_21 = 0;
      var tmp_22 = this_5.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_23 = fillArrayVal(Array(tmp_22), null);
      while (tmp_21 < tmp_22) {
        tmp_23[tmp_21] = null;
        tmp_21 = tmp_21 + 1 | 0;
      }
      this_5.u1t_1.h1s(tmp_19, new ComponentsHolder(tmp_20, compType_2, tmp_23));
    }
    var tmp_24 = this_5.u1t_1.h1(compType_2.m1t());
    var holder_2 = tmp_24 instanceof ComponentsHolder ? tmp_24 : THROW_CCE();
    holder_2.l1u(entity_0, component_1);
    this_0.q1v_1 = prevCreateId;
    var compMask = this_0.o1v_1.h1(entity_0.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this_0.l1v_1.b1u_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element.w1y(entity_0, compMask);
    }
    var tmp0_safe_receiver = this_0.v1v_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(this_0.l1v_1, entity_0);
    var avatar = entity_0;
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var this_6 = _this__u8e3s4.a1u_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var entity_1 = this_6.m1v_1.a1x();
    if (entity_1.m1u_1 >= this_6.o1v_1.f1s_1) {
      this_6.o1v_1.h1s(entity_1.m1u_1, new BitArray(64));
    }
    var prevCreateId_0 = this_6.q1v_1;
    this_6.q1v_1 = entity_1.m1u_1;
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>' call
    var $this$entity_0 = this_6.p1v_1;
    $this$entity_0.h1v(entity_1, ScreenCoordinatesTag_getInstance());
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_2 = PositionComponent.teo(textBoxX, textBoxY);
    var compType_3 = component_2.q1t();
    $this$entity_0.f1v_1.h1(entity_1.m1u_1).p1s(compType_3.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_7 = $this$entity_0.i1v_1;
    if (this_7.u1t_1.j1s(compType_3.m1t())) {
      var tmp_25 = compType_3.m1t();
      var tmp_26 = this_7.v1t();
      var tmp_27 = 0;
      var tmp_28 = this_7.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_29 = fillArrayVal(Array(tmp_28), null);
      while (tmp_27 < tmp_28) {
        tmp_29[tmp_27] = null;
        tmp_27 = tmp_27 + 1 | 0;
      }
      this_7.u1t_1.h1s(tmp_25, new ComponentsHolder(tmp_26, compType_3, tmp_29));
    }
    var tmp_30 = this_7.u1t_1.h1(compType_3.m1t());
    var holder_3 = tmp_30 instanceof ComponentsHolder ? tmp_30 : THROW_CCE();
    holder_3.l1u(entity_1, component_2);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_3 = NinePatchComponent.rer(this.tfc_1, textBoxWidth, textBoxHeight);
    var compType_4 = component_3.q1t();
    $this$entity_0.f1v_1.h1(entity_1.m1u_1).p1s(compType_4.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_8 = $this$entity_0.i1v_1;
    if (this_8.u1t_1.j1s(compType_4.m1t())) {
      var tmp_31 = compType_4.m1t();
      var tmp_32 = this_8.v1t();
      var tmp_33 = 0;
      var tmp_34 = this_8.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_35 = fillArrayVal(Array(tmp_34), null);
      while (tmp_33 < tmp_34) {
        tmp_35[tmp_33] = null;
        tmp_33 = tmp_33 + 1 | 0;
      }
      this_8.u1t_1.h1s(tmp_31, new ComponentsHolder(tmp_32, compType_4, tmp_35));
    }
    var tmp_36 = this_8.u1t_1.h1(compType_4.m1t());
    var holder_4 = tmp_36 instanceof ComponentsHolder ? tmp_36 : THROW_CCE();
    holder_4.l1u(entity_1, component_3);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    // Inline function 'kotlin.apply' call
    var this_9 = RgbaComponent.xeo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>.<anonymous>' call
    this_9.jew(this.ofc_1);
    this_9.iew(this.pfc_1);
    var compType_5 = this_9.q1t();
    $this$entity_0.f1v_1.h1(entity_1.m1u_1).p1s(compType_5.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_10 = $this$entity_0.i1v_1;
    if (this_10.u1t_1.j1s(compType_5.m1t())) {
      var tmp_37 = compType_5.m1t();
      var tmp_38 = this_10.v1t();
      var tmp_39 = 0;
      var tmp_40 = this_10.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_41 = fillArrayVal(Array(tmp_40), null);
      while (tmp_39 < tmp_40) {
        tmp_41[tmp_39] = null;
        tmp_39 = tmp_39 + 1 | 0;
      }
      this_10.u1t_1.h1s(tmp_37, new ComponentsHolder(tmp_38, compType_5, tmp_41));
    }
    var tmp_42 = this_10.u1t_1.h1(compType_5.m1t());
    var holder_5 = tmp_42 instanceof ComponentsHolder ? tmp_42 : THROW_CCE();
    holder_5.l1u(entity_1, this_9);
    $this$entity_0.h1v(entity_1, RenderLayerTag_FG_DIALOGS_getInstance());
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_4 = LayerComponent.geo(100);
    var compType_6 = component_4.q1t();
    $this$entity_0.f1v_1.h1(entity_1.m1u_1).p1s(compType_6.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_11 = $this$entity_0.i1v_1;
    if (this_11.u1t_1.j1s(compType_6.m1t())) {
      var tmp_43 = compType_6.m1t();
      var tmp_44 = this_11.v1t();
      var tmp_45 = 0;
      var tmp_46 = this_11.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_47 = fillArrayVal(Array(tmp_46), null);
      while (tmp_45 < tmp_46) {
        tmp_47[tmp_45] = null;
        tmp_45 = tmp_45 + 1 | 0;
      }
      this_11.u1t_1.h1s(tmp_43, new ComponentsHolder(tmp_44, compType_6, tmp_47));
    }
    var tmp_48 = this_11.u1t_1.h1(compType_6.m1t());
    var holder_6 = tmp_48 instanceof ComponentsHolder ? tmp_48 : THROW_CCE();
    holder_6.l1u(entity_1, component_4);
    this_6.q1v_1 = prevCreateId_0;
    var compMask_0 = this_6.o1v_1.h1(entity_1.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = this_6.l1v_1.b1u_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element_0.w1y(entity_1, compMask_0);
    }
    var tmp0_safe_receiver_0 = this_6.v1v_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else
      tmp0_safe_receiver_0(this_6.l1v_1, entity_1);
    var textBox = entity_1;
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var this_12 = _this__u8e3s4.a1u_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var entity_2 = this_12.m1v_1.a1x();
    if (entity_2.m1u_1 >= this_12.o1v_1.f1s_1) {
      this_12.o1v_1.h1s(entity_2.m1u_1, new BitArray(64));
    }
    var prevCreateId_1 = this_12.q1v_1;
    this_12.q1v_1 = entity_2.m1u_1;
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>' call
    var $this$entity_1 = this_12.p1v_1;
    $this$entity_1.h1v(entity_2, ScreenCoordinatesTag_getInstance());
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_5 = PositionComponent.teo(textFieldX, textFieldY);
    var compType_7 = component_5.q1t();
    $this$entity_1.f1v_1.h1(entity_2.m1u_1).p1s(compType_7.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_13 = $this$entity_1.i1v_1;
    if (this_13.u1t_1.j1s(compType_7.m1t())) {
      var tmp_49 = compType_7.m1t();
      var tmp_50 = this_13.v1t();
      var tmp_51 = 0;
      var tmp_52 = this_13.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_53 = fillArrayVal(Array(tmp_52), null);
      while (tmp_51 < tmp_52) {
        tmp_53[tmp_51] = null;
        tmp_51 = tmp_51 + 1 | 0;
      }
      this_13.u1t_1.h1s(tmp_49, new ComponentsHolder(tmp_50, compType_7, tmp_53));
    }
    var tmp_54 = this_13.u1t_1.h1(compType_7.m1t());
    var holder_7 = tmp_54 instanceof ComponentsHolder ? tmp_54 : THROW_CCE();
    holder_7.l1u(entity_2, component_5);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_6 = TextFieldComponent.jf0(this.ufc_1, this.vfc_1, VOID, this.wfc_1, textFieldWidth, textFieldHeight, VOID, this.yfc_1, this.zfc_1);
    var compType_8 = component_6.q1t();
    $this$entity_1.f1v_1.h1(entity_2.m1u_1).p1s(compType_8.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_14 = $this$entity_1.i1v_1;
    if (this_14.u1t_1.j1s(compType_8.m1t())) {
      var tmp_55 = compType_8.m1t();
      var tmp_56 = this_14.v1t();
      var tmp_57 = 0;
      var tmp_58 = this_14.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_59 = fillArrayVal(Array(tmp_58), null);
      while (tmp_57 < tmp_58) {
        tmp_59[tmp_57] = null;
        tmp_57 = tmp_57 + 1 | 0;
      }
      this_14.u1t_1.h1s(tmp_55, new ComponentsHolder(tmp_56, compType_8, tmp_59));
    }
    var tmp_60 = this_14.u1t_1.h1(compType_8.m1t());
    var holder_8 = tmp_60 instanceof ComponentsHolder ? tmp_60 : THROW_CCE();
    holder_8.l1u(entity_2, component_6);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var component_7 = LayerComponent.geo(101);
    var compType_9 = component_7.q1t();
    $this$entity_1.f1v_1.h1(entity_2.m1u_1).p1s(compType_9.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_15 = $this$entity_1.i1v_1;
    if (this_15.u1t_1.j1s(compType_9.m1t())) {
      var tmp_61 = compType_9.m1t();
      var tmp_62 = this_15.v1t();
      var tmp_63 = 0;
      var tmp_64 = this_15.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_65 = fillArrayVal(Array(tmp_64), null);
      while (tmp_63 < tmp_64) {
        tmp_65[tmp_63] = null;
        tmp_63 = tmp_63 + 1 | 0;
      }
      this_15.u1t_1.h1s(tmp_61, new ComponentsHolder(tmp_62, compType_9, tmp_65));
    }
    var tmp_66 = this_15.u1t_1.h1(compType_9.m1t());
    var holder_9 = tmp_66 instanceof ComponentsHolder ? tmp_66 : THROW_CCE();
    holder_9.l1u(entity_2, component_7);
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    // Inline function 'kotlin.apply' call
    var this_16 = RgbaComponent.xeo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>.<anonymous>' call
    this_16.jew(this.ofc_1);
    this_16.iew(1.0);
    var compType_10 = this_16.q1t();
    $this$entity_1.f1v_1.h1(entity_2.m1u_1).p1s(compType_10.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_17 = $this$entity_1.i1v_1;
    if (this_17.u1t_1.j1s(compType_10.m1t())) {
      var tmp_67 = compType_10.m1t();
      var tmp_68 = this_17.v1t();
      var tmp_69 = 0;
      var tmp_70 = this_17.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_71 = fillArrayVal(Array(tmp_70), null);
      while (tmp_69 < tmp_70) {
        tmp_71[tmp_69] = null;
        tmp_69 = tmp_69 + 1 | 0;
      }
      this_17.u1t_1.h1s(tmp_67, new ComponentsHolder(tmp_68, compType_10, tmp_71));
    }
    var tmp_72 = this_17.u1t_1.h1(compType_10.m1t());
    var holder_10 = tmp_72 instanceof ComponentsHolder ? tmp_72 : THROW_CCE();
    holder_10.l1u(entity_2, this_16);
    $this$entity_1.h1v(entity_2, RenderLayerTag_FG_DIALOGS_getInstance());
    this_12.q1v_1 = prevCreateId_1;
    var compMask_1 = this_12.o1v_1.h1(entity_2.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_1 = this_12.l1v_1.b1u_1;
    var inductionVariable_1 = 0;
    var last_1 = indexedObject_1.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = indexedObject_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element_1.w1y(entity_2, compMask_1);
    }
    var tmp0_safe_receiver_1 = this_12.v1v_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else
      tmp0_safe_receiver_1(this_12.l1v_1, entity_2);
    var textField = entity_2;
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_18 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_18.s1v_1 === entity.m1u_1 || this_18.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_18.s1v_1;
      this_18.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.DialogBoxConfig.entityConfigure.<anonymous>' call
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var this_19 = this_18.r1v_1;
      var tmp0_easing = get_EASE_OUT_QUAD(Companion_getInstance_3());
      var tmp_73 = new TweenRgba(1.0, VOID, VOID, avatar, VOID, 0.5, tmp0_easing);
      var tmp1_easing = get_EASE_OUT_QUAD(Companion_getInstance_3());
      var tmp_74 = new TweenPosition(avatarTweenX, VOID, VOID, VOID, avatar, VOID, 0.5, tmp1_easing);
      var tmp2_easing = get_EASE_OUT_QUAD(Companion_getInstance_3());
      var tmp_75 = new TweenRgba(1.0, VOID, VOID, textBox, 0.3, 0.3, tmp2_easing);
      var tmp3_textRangeEnd = this.ufc_1.length;
      var tmp4_delay = 0.3 + 0.8;
      var tmp5_duration = this.ufc_1.length * this.xfc_1;
      var tmp_76 = new ParallelTweens(listOf([tmp_73, tmp_74, tmp_75, new TweenTextField(VOID, VOID, tmp3_textRangeEnd, textField, tmp4_delay, tmp5_duration)]));
      var tmp_77 = new Wait(this.jfc_1);
      var tmp6_easing = get_EASE_IN_QUAD(Companion_getInstance_3());
      var tmp_78 = new TweenRgba(0.0, VOID, VOID, avatar, VOID, 0.5, tmp6_easing);
      var tmp7_easing = get_EASE_IN_QUAD(Companion_getInstance_3());
      var tmp_79 = new TweenPosition(avatarInitialX, VOID, VOID, VOID, avatar, VOID, 0.5, tmp7_easing);
      var tmp8_easing = get_EASE_IN_QUAD(Companion_getInstance_3());
      var tmp_80 = new TweenRgba(0.0, VOID, VOID, textBox, VOID, 0.3, tmp8_easing);
      var tmp9_easing = get_EASE_IN_QUAD(Companion_getInstance_3());
      var tmp10_tweens = listOf([tmp_78, tmp_79, tmp_80, new TweenRgba(0.0, VOID, VOID, textField, VOID, 0.3, tmp9_easing)]);
      var component_8 = TweenSequenceComponent.tfb(listOf([tmp_76, tmp_77, new ParallelTweens(tmp10_tweens, VOID, VOID, 1.0), new DeleteEntity(avatar), new DeleteEntity(textBox), new DeleteEntity(textField), new DeleteEntity(entity)]));
      var compType_11 = component_8.q1t();
      this_19.f1v_1.h1(entity.m1u_1).p1s(compType_11.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_20 = this_19.i1v_1;
      if (this_20.u1t_1.j1s(compType_11.m1t())) {
        var tmp_81 = compType_11.m1t();
        var tmp_82 = this_20.v1t();
        var tmp_83 = 0;
        var tmp_84 = this_20.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_85 = fillArrayVal(Array(tmp_84), null);
        while (tmp_83 < tmp_84) {
          tmp_85[tmp_83] = null;
          tmp_83 = tmp_83 + 1 | 0;
        }
        this_20.u1t_1.h1s(tmp_81, new ComponentsHolder(tmp_82, compType_11, tmp_85));
      }
      var tmp_86 = this_20.u1t_1.h1(compType_11.m1t());
      var holder_11 = tmp_86 instanceof ComponentsHolder ? tmp_86 : THROW_CCE();
      holder_11.l1u(entity, component_8);
      this_18.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask_2 = this_18.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_2 = this_18.l1v_1.b1u_1;
      var inductionVariable_2 = 0;
      var last_2 = indexedObject_2.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = indexedObject_2[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element_2.p1w(entity, compMask_2);
      }
    }
    return entity;
  }
  toString() {
    return 'DialogBoxConfig(name=' + this.ifc_1 + ', duration=' + this.jfc_1 + ', positionHAlign=' + HorizontalAlign__toString_impl_toflc0(this.kfc_1) + ', positionVAlign=' + VerticalAlign__toString_impl_hcpnn2(this.lfc_1) + ', width=' + this.mfc_1 + ', numberOfLines=' + this.nfc_1 + ', tint=' + this.ofc_1.toString() + ', alpha=' + this.pfc_1 + ', avatarMoveX=' + this.qfc_1 + ', avatarName=' + this.rfc_1 + ', avatarPosition=' + this.sfc_1.toString() + ', textFieldName=' + this.tfc_1 + ', text=' + this.ufc_1 + ', textFontName=' + this.vfc_1 + ', textRangeEnd=' + this.wfc_1 + ', textWritingFactor=' + this.xfc_1 + ', textHAlign=' + HorizontalAlign__toString_impl_toflc0(this.yfc_1) + ', textVAlign=' + VerticalAlign__toString_impl_hcpnn2(this.zfc_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ifc_1);
    result = imul(result, 31) + getNumberHashCode(this.jfc_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.kfc_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.lfc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.mfc_1) | 0;
    result = imul(result, 31) + this.nfc_1 | 0;
    result = imul(result, 31) + this.ofc_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.pfc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qfc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rfc_1) | 0;
    result = imul(result, 31) + this.sfc_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.tfc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ufc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vfc_1) | 0;
    result = imul(result, 31) + this.wfc_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.xfc_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.yfc_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.zfc_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DialogBoxConfig))
      return false;
    var tmp0_other_with_cast = other instanceof DialogBoxConfig ? other : THROW_CCE();
    if (!(this.ifc_1 === tmp0_other_with_cast.ifc_1))
      return false;
    if (!equals(this.jfc_1, tmp0_other_with_cast.jfc_1))
      return false;
    if (!equals(this.kfc_1, tmp0_other_with_cast.kfc_1))
      return false;
    if (!equals(this.lfc_1, tmp0_other_with_cast.lfc_1))
      return false;
    if (!equals(this.mfc_1, tmp0_other_with_cast.mfc_1))
      return false;
    if (!(this.nfc_1 === tmp0_other_with_cast.nfc_1))
      return false;
    if (!this.ofc_1.equals(tmp0_other_with_cast.ofc_1))
      return false;
    if (!equals(this.pfc_1, tmp0_other_with_cast.pfc_1))
      return false;
    if (!equals(this.qfc_1, tmp0_other_with_cast.qfc_1))
      return false;
    if (!(this.rfc_1 === tmp0_other_with_cast.rfc_1))
      return false;
    if (!this.sfc_1.equals(tmp0_other_with_cast.sfc_1))
      return false;
    if (!(this.tfc_1 === tmp0_other_with_cast.tfc_1))
      return false;
    if (!(this.ufc_1 === tmp0_other_with_cast.ufc_1))
      return false;
    if (!(this.vfc_1 === tmp0_other_with_cast.vfc_1))
      return false;
    if (!(this.wfc_1 === tmp0_other_with_cast.wfc_1))
      return false;
    if (!equals(this.xfc_1, tmp0_other_with_cast.xfc_1))
      return false;
    if (!equals(this.yfc_1, tmp0_other_with_cast.yfc_1))
      return false;
    if (!equals(this.zfc_1, tmp0_other_with_cast.zfc_1))
      return false;
    return true;
  }
  static cfd(seen0, name, duration, positionHAlign, positionVAlign, width, numberOfLines, tint, alpha, avatarMoveX, avatarName, avatarPosition, textFieldName, text, textFontName, textRangeEnd, textWritingFactor, textHAlign, textVAlign, textSize, height, serializationConstructorMarker) {
    Companion_getInstance_72();
    if (!(15935 === (15935 & seen0))) {
      throwMissingFieldException(seen0, 15935, $serializer_getInstance_61().gfc_1);
    }
    var $this = createThis(this);
    $this.ifc_1 = name;
    $this.jfc_1 = duration;
    $this.kfc_1 = positionHAlign;
    $this.lfc_1 = positionVAlign;
    $this.mfc_1 = width;
    $this.nfc_1 = numberOfLines;
    if (0 === (seen0 & 64))
      $this.ofc_1 = Companion_getInstance_37().rev_1;
    else
      $this.ofc_1 = tint;
    if (0 === (seen0 & 128))
      $this.pfc_1 = 0.0;
    else
      $this.pfc_1 = alpha;
    if (0 === (seen0 & 256))
      $this.qfc_1 = 10.0;
    else
      $this.qfc_1 = avatarMoveX;
    $this.rfc_1 = avatarName;
    $this.sfc_1 = avatarPosition;
    $this.tfc_1 = textFieldName;
    $this.ufc_1 = text;
    $this.vfc_1 = textFontName;
    if (0 === (seen0 & 16384))
      $this.wfc_1 = 0;
    else
      $this.wfc_1 = textRangeEnd;
    if (0 === (seen0 & 32768))
      $this.xfc_1 = 0.035;
    else
      $this.xfc_1 = textWritingFactor;
    if (0 === (seen0 & 65536))
      $this.yfc_1 = Companion_getInstance_1().j6w_1;
    else
      $this.yfc_1 = textHAlign;
    if (0 === (seen0 & 131072))
      $this.zfc_1 = Companion_getInstance_2().o6w_1;
    else
      $this.zfc_1 = textVAlign;
    if (0 === (seen0 & 262144))
      $this.afd_1 = 13.0;
    else
      $this.afd_1 = textSize;
    if (0 === (seen0 & 524288))
      $this.bfd_1 = $this.afd_1 * $this.nfc_1 + 2;
    else
      $this.bfd_1 = height;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_63 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.efd_1 = [null, null, new ArrayListSerializer(StringSerializer_getInstance()), Companion_getInstance_79().q1j(), null, null, null, null];
  }
}
class $serializer_61 {
  constructor() {
    $serializer_instance_61 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LevelMapConfig', this, 8);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('levelName', false);
    tmp0_serialDesc.m16('layerNames', false);
    tmp0_serialDesc.m16('layerTag', false);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('enableParallax', true);
    this.ffd_1 = tmp0_serialDesc;
  }
  gfd(encoder, value) {
    var tmp0_desc = this.ffd_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_73().efd_1;
    tmp1_output.n10(tmp0_desc, 0, value.hfd_1);
    tmp1_output.n10(tmp0_desc, 1, value.ifd_1);
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.jfd_1);
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.kfd_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.lfd_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.lfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.mfd_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.mfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !equals(value.nfd_1, 1.0)) {
      tmp1_output.k10(tmp0_desc, 6, value.nfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !(value.ofd_1 === true)) {
      tmp1_output.f10(tmp0_desc, 7, value.ofd_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.gfd(encoder, value instanceof LevelMapConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ffd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = false;
    var tmp12_input = decoder.xy(tmp0_desc);
    var tmp13_cached = Companion_getInstance_73().efd_1;
    if (tmp12_input.nz()) {
      tmp4_local0 = tmp12_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.jz(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.jz(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.ez(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.zy(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.jz(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.jz(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.ez(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.zy(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp12_input.yy(tmp0_desc);
    return LevelMapConfig.pfd(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  }
  yu() {
    return this.ffd_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_73().efd_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3], FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class LevelMapConfig {
  q3() {
    return this.hfd_1;
  }
  afc(_this__u8e3s4, entity) {
    if (this.ofd_1) {
      // Inline function 'com.github.quillraven.fleks.World.inject' call
      var name = 'AssetStore';
      var tmp1_elvis_lhs = _this__u8e3s4.y1t_1.e3(name);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        throw FleksNoSuchInjectableException.f1x(name);
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var injectable = tmp;
      injectable.p21_1 = true;
      var tmp_0 = injectable.o21_1;
      var worldData = (tmp_0 instanceof AssetStore ? tmp_0 : THROW_CCE()).yek(this.ifd_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.World.system' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = _this__u8e3s4.o20().b1();
        while (tmp0_iterator.c1()) {
          var element = tmp0_iterator.d1();
          // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
          if (element instanceof CameraSystem) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        throw FleksNoSuchSystemException.o1x(getKClass(CameraSystem));
      }
      tmp$ret$1.seu_1 = worldData.jeh_1;
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.World.system' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = _this__u8e3s4.o20().b1();
        while (tmp0_iterator_0.c1()) {
          var element_0 = tmp0_iterator_0.d1();
          // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
          if (element_0 instanceof CameraSystem) {
            tmp$ret$2 = element_0;
            break $l$block_0;
          }
        }
        throw FleksNoSuchSystemException.o1x(getKClass(CameraSystem));
      }
      tmp$ret$2.reu_1 = worldData.keh_1;
    }
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block_1: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.LevelMapConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = LevelMapComponent.ueq(this.ifd_1, this.jfd_1);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp_1 = compType.m1t();
        var tmp_2 = this_1.v1t();
        var tmp_3 = 0;
        var tmp_4 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_5 = fillArrayVal(Array(tmp_4), null);
        while (tmp_3 < tmp_4) {
          tmp_5[tmp_3] = null;
          tmp_3 = tmp_3 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp_1, new ComponentsHolder(tmp_2, compType, tmp_5));
      }
      var tmp_6 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_6 instanceof ComponentsHolder ? tmp_6 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      // Inline function 'kotlin.apply' call
      var this_2 = RgbaComponent.xeo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.config.LevelMapConfig.entityConfigure.<anonymous>.<anonymous>' call
      this_2.iew(this.nfd_1);
      var compType_0 = this_2.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_3 = $this$configure.i1v_1;
      if (this_3.u1t_1.j1s(compType_0.m1t())) {
        var tmp_7 = compType_0.m1t();
        var tmp_8 = this_3.v1t();
        var tmp_9 = 0;
        var tmp_10 = this_3.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_11 = fillArrayVal(Array(tmp_10), null);
        while (tmp_9 < tmp_10) {
          tmp_11[tmp_9] = null;
          tmp_9 = tmp_9 + 1 | 0;
        }
        this_3.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, compType_0, tmp_11));
      }
      var tmp_12 = this_3.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE();
      holder_0.l1u(entity, this_2);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = LayerComponent.geo();
      var compType_1 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_1.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_4 = $this$configure.i1v_1;
      if (this_4.u1t_1.j1s(compType_1.m1t())) {
        var tmp_13 = compType_1.m1t();
        var tmp_14 = this_4.v1t();
        var tmp_15 = 0;
        var tmp_16 = this_4.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_17 = fillArrayVal(Array(tmp_16), null);
        while (tmp_15 < tmp_16) {
          tmp_17[tmp_15] = null;
          tmp_15 = tmp_15 + 1 | 0;
        }
        this_4.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, compType_1, tmp_17));
      }
      var tmp_18 = this_4.u1t_1.h1(compType_1.m1t());
      var holder_1 = tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE();
      holder_1.l1u(entity, component_0);
      $this$configure.h1v(entity, this.kfd_1);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block_1;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element_1 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element_1.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'LevelMapConfig(name=' + this.hfd_1 + ', levelName=' + this.ifd_1 + ', layerNames=' + toString_0(this.jfd_1) + ', layerTag=' + toString_0(this.kfd_1) + ', x=' + this.lfd_1 + ', y=' + this.mfd_1 + ', alpha=' + this.nfd_1 + ', enableParallax=' + this.ofd_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.hfd_1);
    result = imul(result, 31) + getStringHashCode(this.ifd_1) | 0;
    result = imul(result, 31) + hashCode(this.jfd_1) | 0;
    result = imul(result, 31) + this.kfd_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.lfd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.mfd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.nfd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ofd_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelMapConfig))
      return false;
    var tmp0_other_with_cast = other instanceof LevelMapConfig ? other : THROW_CCE();
    if (!(this.hfd_1 === tmp0_other_with_cast.hfd_1))
      return false;
    if (!(this.ifd_1 === tmp0_other_with_cast.ifd_1))
      return false;
    if (!equals(this.jfd_1, tmp0_other_with_cast.jfd_1))
      return false;
    if (!this.kfd_1.equals(tmp0_other_with_cast.kfd_1))
      return false;
    if (!equals(this.lfd_1, tmp0_other_with_cast.lfd_1))
      return false;
    if (!equals(this.mfd_1, tmp0_other_with_cast.mfd_1))
      return false;
    if (!equals(this.nfd_1, tmp0_other_with_cast.nfd_1))
      return false;
    if (!(this.ofd_1 === tmp0_other_with_cast.ofd_1))
      return false;
    return true;
  }
  static pfd(seen0, name, levelName, layerNames, layerTag, x, y, alpha, enableParallax, serializationConstructorMarker) {
    Companion_getInstance_73();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_62().ffd_1);
    }
    var $this = createThis(this);
    $this.hfd_1 = name;
    $this.ifd_1 = levelName;
    $this.jfd_1 = layerNames;
    $this.kfd_1 = layerTag;
    if (0 === (seen0 & 16))
      $this.lfd_1 = 0.0;
    else
      $this.lfd_1 = x;
    if (0 === (seen0 & 32))
      $this.mfd_1 = 0.0;
    else
      $this.mfd_1 = y;
    if (0 === (seen0 & 64))
      $this.nfd_1 = 1.0;
    else
      $this.nfd_1 = alpha;
    if (0 === (seen0 & 128))
      $this.ofd_1 = true;
    else
      $this.ofd_1 = enableParallax;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_64 {
  constructor() {
    Companion_instance_66 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.qfd_1 = [null, null, null, null, null, null, null, null, null, Companion_getInstance_79().q1j()];
  }
}
class $serializer_62 {
  constructor() {
    $serializer_instance_62 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LogoEntityConfig', this, 10);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('assetName', false);
    tmp0_serialDesc.m16('centerX', true);
    tmp0_serialDesc.m16('centerY', true);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    tmp0_serialDesc.m16('tint', true);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('layerIndex', false);
    tmp0_serialDesc.m16('layerTag', false);
    this.rfd_1 = tmp0_serialDesc;
  }
  sfd(encoder, value) {
    var tmp0_desc = this.rfd_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_74().qfd_1;
    tmp1_output.n10(tmp0_desc, 0, value.tfd_1);
    tmp1_output.n10(tmp0_desc, 1, value.ufd_1);
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.vfd_1 === false)) {
      tmp1_output.f10(tmp0_desc, 2, value.vfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.wfd_1 === false)) {
      tmp1_output.f10(tmp0_desc, 3, value.wfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.xfd_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.xfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.yfd_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.yfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !value.zfd_1.equals(Companion_getInstance_37().rev_1)) {
      tmp1_output.p10(tmp0_desc, 6, $serializer_getInstance_26(), value.zfd_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.afe_1, 1.0)) {
      tmp1_output.k10(tmp0_desc, 7, value.afe_1);
    }
    tmp1_output.i10(tmp0_desc, 8, value.bfe_1);
    tmp1_output.p10(tmp0_desc, 9, tmp2_cached[9], value.cfe_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.sfd(encoder, value instanceof LogoEntityConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.rfd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = false;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = null;
    var tmp11_local7 = 0.0;
    var tmp12_local8 = 0;
    var tmp13_local9 = null;
    var tmp14_input = decoder.xy(tmp0_desc);
    var tmp15_cached = Companion_getInstance_74().qfd_1;
    if (tmp14_input.nz()) {
      tmp4_local0 = tmp14_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.zy(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.jz(tmp0_desc, 6, $serializer_getInstance_26(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.ez(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.cz(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.jz(tmp0_desc, 9, tmp15_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.zy(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.jz(tmp0_desc, 6, $serializer_getInstance_26(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.ez(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.cz(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.jz(tmp0_desc, 9, tmp15_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp14_input.yy(tmp0_desc);
    return LogoEntityConfig.dfe(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  }
  yu() {
    return this.rfd_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_74().qfd_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), $serializer_getInstance_26(), FloatSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[9]];
  }
}
class LogoEntityConfig {
  q3() {
    return this.tfd_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = _this__u8e3s4.y1t_1.e3(name);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var injectable = tmp;
    injectable.p21_1 = true;
    var tmp_0 = injectable.o21_1;
    var assetStore = tmp_0 instanceof AssetStore ? tmp_0 : THROW_CCE();
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.LogoEntityConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = PositionComponent.teo(this.xfd_1 + (this.vfd_1 ? (AppConfig_getInstance().iev_1 - assetStore.xek(this.ufd_1).n6n_1 | 0) * 0.5 : 0.0), this.yfd_1 + (this.wfd_1 ? (AppConfig_getInstance().jev_1 - assetStore.xek(this.ufd_1).o6n_1 | 0) * 0.5 : 0.0));
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp_1 = compType.m1t();
        var tmp_2 = this_1.v1t();
        var tmp_3 = 0;
        var tmp_4 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_5 = fillArrayVal(Array(tmp_4), null);
        while (tmp_3 < tmp_4) {
          tmp_5[tmp_3] = null;
          tmp_3 = tmp_3 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp_1, new ComponentsHolder(tmp_2, compType, tmp_5));
      }
      var tmp_6 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_6 instanceof ComponentsHolder ? tmp_6 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = LayeredSpriteComponent.tep(this.ufd_1);
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = $this$configure.i1v_1;
      if (this_2.u1t_1.j1s(compType_0.m1t())) {
        var tmp_7 = compType_0.m1t();
        var tmp_8 = this_2.v1t();
        var tmp_9 = 0;
        var tmp_10 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_11 = fillArrayVal(Array(tmp_10), null);
        while (tmp_9 < tmp_10) {
          tmp_11[tmp_9] = null;
          tmp_9 = tmp_9 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, compType_0, tmp_11));
      }
      var tmp_12 = this_2.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      // Inline function 'kotlin.apply' call
      var this_3 = RgbaComponent.xeo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.config.LogoEntityConfig.entityConfigure.<anonymous>.<anonymous>' call
      this_3.jew(this.zfd_1);
      this_3.iew(this.afe_1);
      var compType_1 = this_3.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_1.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_4 = $this$configure.i1v_1;
      if (this_4.u1t_1.j1s(compType_1.m1t())) {
        var tmp_13 = compType_1.m1t();
        var tmp_14 = this_4.v1t();
        var tmp_15 = 0;
        var tmp_16 = this_4.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_17 = fillArrayVal(Array(tmp_16), null);
        while (tmp_15 < tmp_16) {
          tmp_17[tmp_15] = null;
          tmp_15 = tmp_15 + 1 | 0;
        }
        this_4.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, compType_1, tmp_17));
      }
      var tmp_18 = this_4.u1t_1.h1(compType_1.m1t());
      var holder_1 = tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE();
      holder_1.l1u(entity, this_3);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_1 = LayerComponent.geo(this.bfe_1);
      var compType_2 = component_1.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_2.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_5 = $this$configure.i1v_1;
      if (this_5.u1t_1.j1s(compType_2.m1t())) {
        var tmp_19 = compType_2.m1t();
        var tmp_20 = this_5.v1t();
        var tmp_21 = 0;
        var tmp_22 = this_5.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_23 = fillArrayVal(Array(tmp_22), null);
        while (tmp_21 < tmp_22) {
          tmp_23[tmp_21] = null;
          tmp_21 = tmp_21 + 1 | 0;
        }
        this_5.u1t_1.h1s(tmp_19, new ComponentsHolder(tmp_20, compType_2, tmp_23));
      }
      var tmp_24 = this_5.u1t_1.h1(compType_2.m1t());
      var holder_2 = tmp_24 instanceof ComponentsHolder ? tmp_24 : THROW_CCE();
      holder_2.l1u(entity, component_1);
      $this$configure.h1v(entity, this.cfe_1);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_2 = LifeCycleComponent.zeq();
      var compType_3 = component_2.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_3.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_6 = $this$configure.i1v_1;
      if (this_6.u1t_1.j1s(compType_3.m1t())) {
        var tmp_25 = compType_3.m1t();
        var tmp_26 = this_6.v1t();
        var tmp_27 = 0;
        var tmp_28 = this_6.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_29 = fillArrayVal(Array(tmp_28), null);
        while (tmp_27 < tmp_28) {
          tmp_29[tmp_27] = null;
          tmp_27 = tmp_27 + 1 | 0;
        }
        this_6.u1t_1.h1s(tmp_25, new ComponentsHolder(tmp_26, compType_3, tmp_29));
      }
      var tmp_30 = this_6.u1t_1.h1(compType_3.m1t());
      var holder_3 = tmp_30 instanceof ComponentsHolder ? tmp_30 : THROW_CCE();
      holder_3.l1u(entity, component_2);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'LogoEntityConfig(name=' + this.tfd_1 + ', assetName=' + this.ufd_1 + ', centerX=' + this.vfd_1 + ', centerY=' + this.wfd_1 + ', offsetX=' + this.xfd_1 + ', offsetY=' + this.yfd_1 + ', tint=' + this.zfd_1.toString() + ', alpha=' + this.afe_1 + ', layerIndex=' + this.bfe_1 + ', layerTag=' + toString_0(this.cfe_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.tfd_1);
    result = imul(result, 31) + getStringHashCode(this.ufd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vfd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wfd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xfd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yfd_1) | 0;
    result = imul(result, 31) + this.zfd_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.afe_1) | 0;
    result = imul(result, 31) + this.bfe_1 | 0;
    result = imul(result, 31) + this.cfe_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LogoEntityConfig))
      return false;
    var tmp0_other_with_cast = other instanceof LogoEntityConfig ? other : THROW_CCE();
    if (!(this.tfd_1 === tmp0_other_with_cast.tfd_1))
      return false;
    if (!(this.ufd_1 === tmp0_other_with_cast.ufd_1))
      return false;
    if (!(this.vfd_1 === tmp0_other_with_cast.vfd_1))
      return false;
    if (!(this.wfd_1 === tmp0_other_with_cast.wfd_1))
      return false;
    if (!equals(this.xfd_1, tmp0_other_with_cast.xfd_1))
      return false;
    if (!equals(this.yfd_1, tmp0_other_with_cast.yfd_1))
      return false;
    if (!this.zfd_1.equals(tmp0_other_with_cast.zfd_1))
      return false;
    if (!equals(this.afe_1, tmp0_other_with_cast.afe_1))
      return false;
    if (!(this.bfe_1 === tmp0_other_with_cast.bfe_1))
      return false;
    if (!this.cfe_1.equals(tmp0_other_with_cast.cfe_1))
      return false;
    return true;
  }
  static dfe(seen0, name, assetName, centerX, centerY, offsetX, offsetY, tint, alpha, layerIndex, layerTag, serializationConstructorMarker) {
    Companion_getInstance_74();
    if (!(771 === (771 & seen0))) {
      throwMissingFieldException(seen0, 771, $serializer_getInstance_63().rfd_1);
    }
    var $this = createThis(this);
    $this.tfd_1 = name;
    $this.ufd_1 = assetName;
    if (0 === (seen0 & 4))
      $this.vfd_1 = false;
    else
      $this.vfd_1 = centerX;
    if (0 === (seen0 & 8))
      $this.wfd_1 = false;
    else
      $this.wfd_1 = centerY;
    if (0 === (seen0 & 16))
      $this.xfd_1 = 0.0;
    else
      $this.xfd_1 = offsetX;
    if (0 === (seen0 & 32))
      $this.yfd_1 = 0.0;
    else
      $this.yfd_1 = offsetY;
    if (0 === (seen0 & 64))
      $this.zfd_1 = Companion_getInstance_37().rev_1;
    else
      $this.zfd_1 = tint;
    if (0 === (seen0 & 128))
      $this.afe_1 = 1.0;
    else
      $this.afe_1 = alpha;
    $this.bfe_1 = layerIndex;
    $this.cfe_1 = layerTag;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_65 {}
class $serializer_63 {
  constructor() {
    $serializer_instance_63 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MovedSpawnerObjectConfig', this, 13);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('numberOfObjects', true);
    tmp0_serialDesc.m16('interval', true);
    tmp0_serialDesc.m16('timeVariation', true);
    tmp0_serialDesc.m16('positionVariation', true);
    tmp0_serialDesc.m16('entityConfig', true);
    tmp0_serialDesc.m16('totalNumberOfObjects', true);
    tmp0_serialDesc.m16('offsetX', true);
    tmp0_serialDesc.m16('offsetY', true);
    tmp0_serialDesc.m16('velocityX', true);
    tmp0_serialDesc.m16('velocityY', true);
    tmp0_serialDesc.m16('velocityVariationX', true);
    tmp0_serialDesc.m16('velocityVariationY', true);
    this.efe_1 = tmp0_serialDesc;
  }
  ffe(encoder, value) {
    var tmp0_desc = this.efe_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.gfe_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.hfe_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 1, value.hfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.ife_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 2, value.ife_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.jfe_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 3, value.jfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.kfe_1, 0.0)) {
      tmp1_output.l10(tmp0_desc, 4, value.kfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.lfe_1 === '')) {
      tmp1_output.n10(tmp0_desc, 5, value.lfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.mfe_1 === -1)) {
      tmp1_output.i10(tmp0_desc, 6, value.mfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.nfe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 7, value.nfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !equals(value.ofe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 8, value.ofe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !equals(value.pfe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 9, value.pfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !equals(value.qfe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 10, value.qfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 11) ? true : !equals(value.rfe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 11, value.rfe_1);
    }
    if (tmp1_output.v10(tmp0_desc, 12) ? true : !equals(value.sfe_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 12, value.sfe_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ffe(encoder, value instanceof MovedSpawnerObjectConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.efe_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_local7 = 0.0;
    var tmp12_local8 = 0.0;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = 0.0;
    var tmp17_input = decoder.xy(tmp0_desc);
    if (tmp17_input.nz()) {
      tmp4_local0 = tmp17_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.cz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.cz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.fz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.hz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.cz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.ez(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.ez(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.ez(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.ez(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.ez(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.ez(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.cz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.cz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.fz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.hz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.cz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.ez(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.ez(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.ez(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.ez(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.ez(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.ez(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp17_input.yy(tmp0_desc);
    return MovedSpawnerObjectConfig.tfe(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  }
  yu() {
    return this.efe_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), DoubleSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class MovedSpawnerObjectConfig {
  q3() {
    return this.gfe_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block_1: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.MovedSpawnerObjectConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'kotlin.also' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.getOrAdd' call
        var type = Companion_getInstance_28();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_1 = $this$configure.i1v_1;
        if (this_1.u1t_1.j1s(type.m1t())) {
          var tmp = type.m1t();
          var tmp_0 = this_1.v1t();
          var tmp_1 = 0;
          var tmp_2 = this_1.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = null;
            tmp_1 = tmp_1 + 1 | 0;
          }
          this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
        }
        var tmp_4 = this_1.u1t_1.h1(type.m1t());
        var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
        var existingCmp = holder.v1u(entity);
        if (!(existingCmp == null)) {
          tmp$ret$3 = existingCmp;
          break $l$block;
        }
        $this$configure.f1v_1.h1(entity.m1u_1).p1s(type.m1t());
        // Inline function 'korlibs.korge.fleks.entity.config.MovedSpawnerObjectConfig.entityConfigure.<anonymous>.<anonymous>' call
        var newCmp = MotionComponent.ier();
        holder.l1u(entity, newCmp);
        tmp$ret$3 = newCmp;
      }
      var this_2 = tmp$ret$3;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.config.MovedSpawnerObjectConfig.entityConfigure.<anonymous>.<anonymous>' call
      var velocityXX = this.pfe_1;
      var velocityYY = this.qfe_1;
      if (!(this.rfe_1 === 0.0)) {
        velocityXX = velocityXX + random_0(rangeTo(-this.rfe_1, this.rfe_1));
      }
      if (!(this.sfe_1 === 0.0)) {
        velocityYY = velocityYY + random_0(rangeTo(-this.sfe_1, this.sfe_1));
      }
      this_2.fer_1 = velocityXX;
      this_2.ger_1 = velocityYY;
      // Inline function 'kotlin.also' call
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.getOrAdd' call
        var type_0 = Companion_getInstance_42();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_3 = $this$configure.i1v_1;
        if (this_3.u1t_1.j1s(type_0.m1t())) {
          var tmp_5 = type_0.m1t();
          var tmp_6 = this_3.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_3.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_3.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
        }
        var tmp_10 = this_3.u1t_1.h1(type_0.m1t());
        var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
        var existingCmp_0 = holder_0.v1u(entity);
        if (!(existingCmp_0 == null)) {
          break $l$block_0;
        }
        $this$configure.f1v_1.h1(entity.m1u_1).p1s(type_0.m1t());
        // Inline function 'korlibs.korge.fleks.entity.config.MovedSpawnerObjectConfig.entityConfigure.<anonymous>.<anonymous>' call
        var newCmp_0 = SpawnerComponent.bey();
        holder_0.l1u(entity, newCmp_0);
      }
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.config.MovedSpawnerObjectConfig.entityConfigure.<anonymous>.<anonymous>' call
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block_1;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'MovedSpawnerObjectConfig(name=' + this.gfe_1 + ', numberOfObjects=' + this.hfe_1 + ', interval=' + this.ife_1 + ', timeVariation=' + this.jfe_1 + ', positionVariation=' + this.kfe_1 + ', entityConfig=' + this.lfe_1 + ', totalNumberOfObjects=' + this.mfe_1 + ', offsetX=' + this.nfe_1 + ', offsetY=' + this.ofe_1 + ', velocityX=' + this.pfe_1 + ', velocityY=' + this.qfe_1 + ', velocityVariationX=' + this.rfe_1 + ', velocityVariationY=' + this.sfe_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.gfe_1);
    result = imul(result, 31) + this.hfe_1 | 0;
    result = imul(result, 31) + this.ife_1 | 0;
    result = imul(result, 31) + this.jfe_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.kfe_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lfe_1) | 0;
    result = imul(result, 31) + this.mfe_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.nfe_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ofe_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pfe_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qfe_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rfe_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sfe_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovedSpawnerObjectConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MovedSpawnerObjectConfig ? other : THROW_CCE();
    if (!(this.gfe_1 === tmp0_other_with_cast.gfe_1))
      return false;
    if (!(this.hfe_1 === tmp0_other_with_cast.hfe_1))
      return false;
    if (!(this.ife_1 === tmp0_other_with_cast.ife_1))
      return false;
    if (!(this.jfe_1 === tmp0_other_with_cast.jfe_1))
      return false;
    if (!equals(this.kfe_1, tmp0_other_with_cast.kfe_1))
      return false;
    if (!(this.lfe_1 === tmp0_other_with_cast.lfe_1))
      return false;
    if (!(this.mfe_1 === tmp0_other_with_cast.mfe_1))
      return false;
    if (!equals(this.nfe_1, tmp0_other_with_cast.nfe_1))
      return false;
    if (!equals(this.ofe_1, tmp0_other_with_cast.ofe_1))
      return false;
    if (!equals(this.pfe_1, tmp0_other_with_cast.pfe_1))
      return false;
    if (!equals(this.qfe_1, tmp0_other_with_cast.qfe_1))
      return false;
    if (!equals(this.rfe_1, tmp0_other_with_cast.rfe_1))
      return false;
    if (!equals(this.sfe_1, tmp0_other_with_cast.sfe_1))
      return false;
    return true;
  }
  static tfe(seen0, name, numberOfObjects, interval, timeVariation, positionVariation, entityConfig, totalNumberOfObjects, offsetX, offsetY, velocityX, velocityY, velocityVariationX, velocityVariationY, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_64().efe_1);
    }
    var $this = createThis(this);
    $this.gfe_1 = name;
    if (0 === (seen0 & 2))
      $this.hfe_1 = 0;
    else
      $this.hfe_1 = numberOfObjects;
    if (0 === (seen0 & 4))
      $this.ife_1 = 0;
    else
      $this.ife_1 = interval;
    if (0 === (seen0 & 8))
      $this.jfe_1 = 0;
    else
      $this.jfe_1 = timeVariation;
    if (0 === (seen0 & 16))
      $this.kfe_1 = 0.0;
    else
      $this.kfe_1 = positionVariation;
    if (0 === (seen0 & 32))
      $this.lfe_1 = '';
    else
      $this.lfe_1 = entityConfig;
    if (0 === (seen0 & 64))
      $this.mfe_1 = -1;
    else
      $this.mfe_1 = totalNumberOfObjects;
    if (0 === (seen0 & 128))
      $this.nfe_1 = 0.0;
    else
      $this.nfe_1 = offsetX;
    if (0 === (seen0 & 256))
      $this.ofe_1 = 0.0;
    else
      $this.ofe_1 = offsetY;
    if (0 === (seen0 & 512))
      $this.pfe_1 = 0.0;
    else
      $this.pfe_1 = velocityX;
    if (0 === (seen0 & 1024))
      $this.qfe_1 = 0.0;
    else
      $this.qfe_1 = velocityY;
    if (0 === (seen0 & 2048))
      $this.rfe_1 = 0.0;
    else
      $this.rfe_1 = velocityVariationX;
    if (0 === (seen0 & 4096))
      $this.sfe_1 = 0.0;
    else
      $this.sfe_1 = velocityVariationY;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_66 {
  constructor() {
    Companion_instance_68 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ufe_1 = [null, null, Companion_getInstance_79().q1j(), null, null];
  }
}
class $serializer_64 {
  constructor() {
    $serializer_instance_64 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ParallaxEffectConfig', this, 5);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('assetName', false);
    tmp0_serialDesc.m16('layerTag', false);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    this.vfe_1 = tmp0_serialDesc;
  }
  wfe(encoder, value) {
    var tmp0_desc = this.vfe_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_76().ufe_1;
    tmp1_output.n10(tmp0_desc, 0, value.xfe_1);
    tmp1_output.n10(tmp0_desc, 1, value.yfe_1);
    tmp1_output.p10(tmp0_desc, 2, tmp2_cached[2], value.zfe_1);
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !equals(value.aff_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 3, value.aff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.bff_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.bff_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.wfe(encoder, value instanceof ParallaxEffectConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.vfe_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_input = decoder.xy(tmp0_desc);
    var tmp10_cached = Companion_getInstance_76().ufe_1;
    if (tmp9_input.nz()) {
      tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.ez(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.jz(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.ez(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp9_input.yy(tmp0_desc);
    return ParallaxEffectConfig.cff(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  yu() {
    return this.vfe_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_76().ufe_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class ParallaxEffectConfig {
  q3() {
    return this.xfe_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.ParallaxEffectConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = PositionComponent.teo(this.aff_1, this.bff_1);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp = compType.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = MotionComponent.ier(VOID, VOID, -12.0);
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = $this$configure.i1v_1;
      if (this_2.u1t_1.j1s(compType_0.m1t())) {
        var tmp_5 = compType_0.m1t();
        var tmp_6 = this_2.v1t();
        var tmp_7 = 0;
        var tmp_8 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_9 = fillArrayVal(Array(tmp_8), null);
        while (tmp_7 < tmp_8) {
          tmp_9[tmp_7] = null;
          tmp_7 = tmp_7 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
      }
      var tmp_10 = this_2.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_1 = ParallaxComponent.eeu(this.yfe_1);
      var compType_1 = component_1.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_1.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_3 = $this$configure.i1v_1;
      if (this_3.u1t_1.j1s(compType_1.m1t())) {
        var tmp_11 = compType_1.m1t();
        var tmp_12 = this_3.v1t();
        var tmp_13 = 0;
        var tmp_14 = this_3.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_15 = fillArrayVal(Array(tmp_14), null);
        while (tmp_13 < tmp_14) {
          tmp_15[tmp_13] = null;
          tmp_13 = tmp_13 + 1 | 0;
        }
        this_3.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, compType_1, tmp_15));
      }
      var tmp_16 = this_3.u1t_1.h1(compType_1.m1t());
      var holder_1 = tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE();
      holder_1.l1u(entity, component_1);
      $this$configure.h1v(entity, this.zfe_1);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'ParallaxEffectConfig(name=' + this.xfe_1 + ', assetName=' + this.yfe_1 + ', layerTag=' + toString_0(this.zfe_1) + ', x=' + this.aff_1 + ', y=' + this.bff_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.xfe_1);
    result = imul(result, 31) + getStringHashCode(this.yfe_1) | 0;
    result = imul(result, 31) + this.zfe_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.aff_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bff_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParallaxEffectConfig))
      return false;
    var tmp0_other_with_cast = other instanceof ParallaxEffectConfig ? other : THROW_CCE();
    if (!(this.xfe_1 === tmp0_other_with_cast.xfe_1))
      return false;
    if (!(this.yfe_1 === tmp0_other_with_cast.yfe_1))
      return false;
    if (!this.zfe_1.equals(tmp0_other_with_cast.zfe_1))
      return false;
    if (!equals(this.aff_1, tmp0_other_with_cast.aff_1))
      return false;
    if (!equals(this.bff_1, tmp0_other_with_cast.bff_1))
      return false;
    return true;
  }
  static cff(seen0, name, assetName, layerTag, x, y, serializationConstructorMarker) {
    Companion_getInstance_76();
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_65().vfe_1);
    }
    var $this = createThis(this);
    $this.xfe_1 = name;
    $this.yfe_1 = assetName;
    $this.zfe_1 = layerTag;
    if (0 === (seen0 & 8))
      $this.aff_1 = 0.0;
    else
      $this.aff_1 = x;
    if (0 === (seen0 & 16))
      $this.bff_1 = 0.0;
    else
      $this.bff_1 = y;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_67 {
  constructor() {
    Companion_instance_69 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.dff_1 = [null, null, null, Companion_getInstance_79().q1j(), null, null, null, null, null, null, null, null, null, null, null];
  }
}
class $serializer_65 {
  constructor() {
    $serializer_instance_65 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RichTextConfig', this, 15);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('text', false);
    tmp0_serialDesc.m16('fontName', false);
    tmp0_serialDesc.m16('layerTag', false);
    tmp0_serialDesc.m16('x', true);
    tmp0_serialDesc.m16('y', true);
    tmp0_serialDesc.m16('screenCoordinates', true);
    tmp0_serialDesc.m16('width', true);
    tmp0_serialDesc.m16('height', true);
    tmp0_serialDesc.m16('textRangeEnd', true);
    tmp0_serialDesc.m16('layerIndex', true);
    tmp0_serialDesc.m16('tint', true);
    tmp0_serialDesc.m16('alpha', true);
    tmp0_serialDesc.m16('horizontalAlign', true);
    tmp0_serialDesc.m16('verticalAlign', true);
    this.eff_1 = tmp0_serialDesc;
  }
  fff(encoder, value) {
    var tmp0_desc = this.eff_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_77().dff_1;
    tmp1_output.n10(tmp0_desc, 0, value.gff_1);
    tmp1_output.n10(tmp0_desc, 1, value.hff_1);
    tmp1_output.n10(tmp0_desc, 2, value.iff_1);
    tmp1_output.p10(tmp0_desc, 3, tmp2_cached[3], value.jff_1);
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !equals(value.kff_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 4, value.kff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !equals(value.lff_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 5, value.lff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.mff_1 === false)) {
      tmp1_output.f10(tmp0_desc, 6, value.mff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 7) ? true : !equals(value.nff_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 7, value.nff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 8) ? true : !equals(value.off_1, 0.0)) {
      tmp1_output.k10(tmp0_desc, 8, value.off_1);
    }
    if (tmp1_output.v10(tmp0_desc, 9) ? true : !(value.pff_1 === 2147483647)) {
      tmp1_output.i10(tmp0_desc, 9, value.pff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 10) ? true : !(value.qff_1 === 1)) {
      tmp1_output.i10(tmp0_desc, 10, value.qff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 11) ? true : !value.rff_1.equals(Companion_getInstance_37().rev_1)) {
      tmp1_output.p10(tmp0_desc, 11, $serializer_getInstance_26(), value.rff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 12) ? true : !equals(value.sff_1, 1.0)) {
      tmp1_output.k10(tmp0_desc, 12, value.sff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 13) ? true : !equals(value.tff_1, Companion_getInstance_1().j6w_1)) {
      tmp1_output.p10(tmp0_desc, 13, HorizontalAlignAsDouble_getInstance(), new HorizontalAlign(value.tff_1));
    }
    if (tmp1_output.v10(tmp0_desc, 14) ? true : !equals(value.uff_1, Companion_getInstance_2().o6w_1)) {
      tmp1_output.p10(tmp0_desc, 14, VerticalAlignAsDouble_getInstance(), new VerticalAlign(value.uff_1));
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.fff(encoder, value instanceof RichTextConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.eff_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = false;
    var tmp11_local7 = 0.0;
    var tmp12_local8 = 0.0;
    var tmp13_local9 = 0;
    var tmp14_local10 = 0;
    var tmp15_local11 = null;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_input = decoder.xy(tmp0_desc);
    var tmp20_cached = Companion_getInstance_77().dff_1;
    if (tmp19_input.nz()) {
      tmp4_local0 = tmp19_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.hz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.hz(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.jz(tmp0_desc, 3, tmp20_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.ez(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.ez(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.zy(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.ez(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.ez(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.cz(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp19_input.cz(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp19_input.jz(tmp0_desc, 11, $serializer_getInstance_26(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp19_input.ez(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      var tmp = HorizontalAlignAsDouble_getInstance();
      var tmp_0 = tmp17_local13;
      var tmp_1 = tmp19_input.jz(tmp0_desc, 13, tmp, tmp_0 == null ? null : new HorizontalAlign(tmp_0));
      tmp17_local13 = tmp_1 == null ? null : tmp_1.x6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      var tmp_2 = VerticalAlignAsDouble_getInstance();
      var tmp_3 = tmp18_local14;
      var tmp_4 = tmp19_input.jz(tmp0_desc, 14, tmp_2, tmp_3 == null ? null : new VerticalAlign(tmp_3));
      tmp18_local14 = tmp_4 == null ? null : tmp_4.v6w_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.hz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.hz(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.jz(tmp0_desc, 3, tmp20_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.ez(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.ez(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.zy(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.ez(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.ez(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.cz(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp19_input.cz(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp19_input.jz(tmp0_desc, 11, $serializer_getInstance_26(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp19_input.ez(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            var tmp_5 = HorizontalAlignAsDouble_getInstance();
            var tmp_6 = tmp17_local13;
            var tmp_7 = tmp19_input.jz(tmp0_desc, 13, tmp_5, tmp_6 == null ? null : new HorizontalAlign(tmp_6));
            tmp17_local13 = tmp_7 == null ? null : tmp_7.x6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            var tmp_8 = VerticalAlignAsDouble_getInstance();
            var tmp_9 = tmp18_local14;
            var tmp_10 = tmp19_input.jz(tmp0_desc, 14, tmp_8, tmp_9 == null ? null : new VerticalAlign(tmp_9));
            tmp18_local14 = tmp_10 == null ? null : tmp_10.v6w_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp19_input.yy(tmp0_desc);
    return RichTextConfig.vff(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
  }
  yu() {
    return this.eff_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_77().dff_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], FloatSerializer_getInstance(), FloatSerializer_getInstance(), BooleanSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_26(), FloatSerializer_getInstance(), HorizontalAlignAsDouble_getInstance(), VerticalAlignAsDouble_getInstance()];
  }
}
class RichTextConfig {
  q3() {
    return this.gff_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'korlibs.korge.fleks.entity.config.RichTextConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      if (this.mff_1) {
        $this$configure.h1v(entity, ScreenCoordinatesTag_getInstance());
      }
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = PositionComponent.teo(this.kff_1, this.lff_1);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp = compType.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = TextFieldComponent.jf0(this.hff_1, this.iff_1, VOID, this.pff_1, this.nff_1, this.off_1, VOID, this.tff_1, this.uff_1);
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = $this$configure.i1v_1;
      if (this_2.u1t_1.j1s(compType_0.m1t())) {
        var tmp_5 = compType_0.m1t();
        var tmp_6 = this_2.v1t();
        var tmp_7 = 0;
        var tmp_8 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_9 = fillArrayVal(Array(tmp_8), null);
        while (tmp_7 < tmp_8) {
          tmp_9[tmp_7] = null;
          tmp_7 = tmp_7 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
      }
      var tmp_10 = this_2.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_1 = LayerComponent.geo(this.qff_1);
      var compType_1 = component_1.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_1.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_3 = $this$configure.i1v_1;
      if (this_3.u1t_1.j1s(compType_1.m1t())) {
        var tmp_11 = compType_1.m1t();
        var tmp_12 = this_3.v1t();
        var tmp_13 = 0;
        var tmp_14 = this_3.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_15 = fillArrayVal(Array(tmp_14), null);
        while (tmp_13 < tmp_14) {
          tmp_15[tmp_13] = null;
          tmp_13 = tmp_13 + 1 | 0;
        }
        this_3.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, compType_1, tmp_15));
      }
      var tmp_16 = this_3.u1t_1.h1(compType_1.m1t());
      var holder_1 = tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE();
      holder_1.l1u(entity, component_1);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      // Inline function 'kotlin.apply' call
      var this_4 = RgbaComponent.xeo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.entity.config.RichTextConfig.entityConfigure.<anonymous>.<anonymous>' call
      this_4.jew(this.rff_1);
      this_4.iew(this.sff_1);
      var compType_2 = this_4.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_2.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_5 = $this$configure.i1v_1;
      if (this_5.u1t_1.j1s(compType_2.m1t())) {
        var tmp_17 = compType_2.m1t();
        var tmp_18 = this_5.v1t();
        var tmp_19 = 0;
        var tmp_20 = this_5.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_21 = fillArrayVal(Array(tmp_20), null);
        while (tmp_19 < tmp_20) {
          tmp_21[tmp_19] = null;
          tmp_19 = tmp_19 + 1 | 0;
        }
        this_5.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, compType_2, tmp_21));
      }
      var tmp_22 = this_5.u1t_1.h1(compType_2.m1t());
      var holder_2 = tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE();
      holder_2.l1u(entity, this_4);
      $this$configure.h1v(entity, this.jff_1);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'RichTextConfig(name=' + this.gff_1 + ', text=' + this.hff_1 + ', fontName=' + this.iff_1 + ', layerTag=' + toString_0(this.jff_1) + ', x=' + this.kff_1 + ', y=' + this.lff_1 + ', screenCoordinates=' + this.mff_1 + ', width=' + this.nff_1 + ', height=' + this.off_1 + ', textRangeEnd=' + this.pff_1 + ', layerIndex=' + this.qff_1 + ', tint=' + this.rff_1.toString() + ', alpha=' + this.sff_1 + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.tff_1) + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.uff_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.gff_1);
    result = imul(result, 31) + getStringHashCode(this.hff_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.iff_1) | 0;
    result = imul(result, 31) + this.jff_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.kff_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lff_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mff_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.nff_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.off_1) | 0;
    result = imul(result, 31) + this.pff_1 | 0;
    result = imul(result, 31) + this.qff_1 | 0;
    result = imul(result, 31) + this.rff_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.sff_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.tff_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.uff_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextConfig ? other : THROW_CCE();
    if (!(this.gff_1 === tmp0_other_with_cast.gff_1))
      return false;
    if (!(this.hff_1 === tmp0_other_with_cast.hff_1))
      return false;
    if (!(this.iff_1 === tmp0_other_with_cast.iff_1))
      return false;
    if (!this.jff_1.equals(tmp0_other_with_cast.jff_1))
      return false;
    if (!equals(this.kff_1, tmp0_other_with_cast.kff_1))
      return false;
    if (!equals(this.lff_1, tmp0_other_with_cast.lff_1))
      return false;
    if (!(this.mff_1 === tmp0_other_with_cast.mff_1))
      return false;
    if (!equals(this.nff_1, tmp0_other_with_cast.nff_1))
      return false;
    if (!equals(this.off_1, tmp0_other_with_cast.off_1))
      return false;
    if (!(this.pff_1 === tmp0_other_with_cast.pff_1))
      return false;
    if (!(this.qff_1 === tmp0_other_with_cast.qff_1))
      return false;
    if (!this.rff_1.equals(tmp0_other_with_cast.rff_1))
      return false;
    if (!equals(this.sff_1, tmp0_other_with_cast.sff_1))
      return false;
    if (!equals(this.tff_1, tmp0_other_with_cast.tff_1))
      return false;
    if (!equals(this.uff_1, tmp0_other_with_cast.uff_1))
      return false;
    return true;
  }
  static vff(seen0, name, text, fontName, layerTag, x, y, screenCoordinates, width, height, textRangeEnd, layerIndex, tint, alpha, horizontalAlign, verticalAlign, serializationConstructorMarker) {
    Companion_getInstance_77();
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_66().eff_1);
    }
    var $this = createThis(this);
    $this.gff_1 = name;
    $this.hff_1 = text;
    $this.iff_1 = fontName;
    $this.jff_1 = layerTag;
    if (0 === (seen0 & 16))
      $this.kff_1 = 0.0;
    else
      $this.kff_1 = x;
    if (0 === (seen0 & 32))
      $this.lff_1 = 0.0;
    else
      $this.lff_1 = y;
    if (0 === (seen0 & 64))
      $this.mff_1 = false;
    else
      $this.mff_1 = screenCoordinates;
    if (0 === (seen0 & 128))
      $this.nff_1 = 0.0;
    else
      $this.nff_1 = width;
    if (0 === (seen0 & 256))
      $this.off_1 = 0.0;
    else
      $this.off_1 = height;
    if (0 === (seen0 & 512))
      $this.pff_1 = 2147483647;
    else
      $this.pff_1 = textRangeEnd;
    if (0 === (seen0 & 1024))
      $this.qff_1 = 1;
    else
      $this.qff_1 = layerIndex;
    if (0 === (seen0 & 2048))
      $this.rff_1 = Companion_getInstance_37().rev_1;
    else
      $this.rff_1 = tint;
    if (0 === (seen0 & 4096))
      $this.sff_1 = 1.0;
    else
      $this.sff_1 = alpha;
    if (0 === (seen0 & 8192))
      $this.tff_1 = Companion_getInstance_1().j6w_1;
    else
      $this.tff_1 = horizontalAlign;
    if (0 === (seen0 & 16384))
      $this.uff_1 = Companion_getInstance_2().o6w_1;
    else
      $this.uff_1 = verticalAlign;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_68 {}
class $serializer_66 {
  constructor() {
    $serializer_instance_66 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameStateConfig', this, 7);
    tmp0_serialDesc.m16('name', false);
    tmp0_serialDesc.m16('version', true);
    tmp0_serialDesc.m16('firstStart', true);
    tmp0_serialDesc.m16('world', false);
    tmp0_serialDesc.m16('level', false);
    tmp0_serialDesc.m16('special', false);
    tmp0_serialDesc.m16('startScript', false);
    this.wff_1 = tmp0_serialDesc;
  }
  xff(encoder, value) {
    var tmp0_desc = this.wff_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.yff_1);
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.zff_1 === 0)) {
      tmp1_output.i10(tmp0_desc, 1, value.zff_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.afg_1 === true)) {
      tmp1_output.f10(tmp0_desc, 2, value.afg_1);
    }
    tmp1_output.n10(tmp0_desc, 3, value.bfg_1);
    tmp1_output.n10(tmp0_desc, 4, value.cfg_1);
    tmp1_output.n10(tmp0_desc, 5, value.dfg_1);
    tmp1_output.n10(tmp0_desc, 6, value.efg_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.xff(encoder, value instanceof GameStateConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.wff_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.cz(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.zy(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.hz(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hz(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hz(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hz(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.cz(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.zy(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.hz(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hz(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hz(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hz(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return GameStateConfig.ffg(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.wff_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class GameStateConfig {
  constructor(name, version, firstStart, world, level, special, startScript) {
    version = version === VOID ? 0 : version;
    firstStart = firstStart === VOID ? true : firstStart;
    this.yff_1 = name;
    this.zff_1 = version;
    this.afg_1 = firstStart;
    this.bfg_1 = world;
    this.cfg_1 = level;
    this.dfg_1 = special;
    this.efg_1 = startScript;
  }
  toString() {
    return 'GameStateConfig(name=' + this.yff_1 + ', version=' + this.zff_1 + ', firstStart=' + this.afg_1 + ', world=' + this.bfg_1 + ', level=' + this.cfg_1 + ', special=' + this.dfg_1 + ', startScript=' + this.efg_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.yff_1);
    result = imul(result, 31) + this.zff_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.afg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bfg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cfg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.dfg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.efg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStateConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameStateConfig ? other : THROW_CCE();
    if (!(this.yff_1 === tmp0_other_with_cast.yff_1))
      return false;
    if (!(this.zff_1 === tmp0_other_with_cast.zff_1))
      return false;
    if (!(this.afg_1 === tmp0_other_with_cast.afg_1))
      return false;
    if (!(this.bfg_1 === tmp0_other_with_cast.bfg_1))
      return false;
    if (!(this.cfg_1 === tmp0_other_with_cast.cfg_1))
      return false;
    if (!(this.dfg_1 === tmp0_other_with_cast.dfg_1))
      return false;
    if (!(this.efg_1 === tmp0_other_with_cast.efg_1))
      return false;
    return true;
  }
  static ffg(seen0, name, version, firstStart, world, level, special, startScript, serializationConstructorMarker) {
    if (!(121 === (121 & seen0))) {
      throwMissingFieldException(seen0, 121, $serializer_getInstance_67().wff_1);
    }
    var $this = createThis(this);
    $this.yff_1 = name;
    if (0 === (seen0 & 2))
      $this.zff_1 = 0;
    else
      $this.zff_1 = version;
    if (0 === (seen0 & 4))
      $this.afg_1 = true;
    else
      $this.afg_1 = firstStart;
    $this.bfg_1 = world;
    $this.cfg_1 = level;
    $this.dfg_1 = special;
    $this.efg_1 = startScript;
    return $this;
  }
}
class GameStateManager {
  constructor() {
    GameStateManager_instance = this;
    this.ceh_1 = new AssetStore();
    this.deh_1 = new EntityConfigSerializer();
  }
  gfg(name, module_0) {
    this.deh_1.gfg(name, module_0);
  }
  hfg($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_initGameState__abk745.bind(VOID, this), $completion);
  }
  ifg(gameStateConfig, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadAssets__gde0f3_0.bind(VOID, this, gameStateConfig), $completion);
  }
  jfg(_this__u8e3s4, gameStateConfig, loadSnapshot) {
    if (loadSnapshot) {
      println('INFO: Loading save game');
    } else {
      if (EntityFactory_getInstance().n28(gameStateConfig.efg_1)) {
        println("INFO: Start game with asset config '" + gameStateConfig.bfg_1 + '_' + gameStateConfig.cfg_1 + '_' + gameStateConfig.dfg_1 + "' and start script '" + gameStateConfig.efg_1 + "'");
        createAndConfigureEntity(_this__u8e3s4, gameStateConfig.efg_1);
      } else {
        println("ERROR: Cannot start game! EntityConfig with name '" + gameStateConfig.efg_1 + "' does not exist!");
      }
    }
  }
}
class DebugRenderSystem extends View {
  static ofi(world, layerTag) {
    var $this = this.sc9();
    $this.kfi_1 = world;
    $this.lfi_1 = layerTag;
    var tmp = $this;
    tmp.mfi_1 = $this.kfi_1.p20(DebugRenderSystem$family$lambda($this));
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.kfi_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.nfi_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    $this.mb8_1 = toString_0($this.lfi_1);
    return $this;
  }
  sbt(ctx) {
    var camera = getMainCamera(this.kfi_1);
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.a9w_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.m9w_1 = null;
        // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.Family.forEach' call
        var this_3 = this.mfi_1;
        var entitiesForIteration = this_3.u1y();
        if (!this_3.h1w_1.t1v_1) {
          this_3.h1w_1.t1v_1 = true;
          this_3.m1w_1 = true;
          // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
          var inductionVariable = 0;
          var last = entitiesForIteration.v1s_1;
          if (inductionVariable < last)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
              // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>' call
              var entity = entitiesForIteration.u1s_1[i];
              // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
              var type = Companion_getInstance_36();
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_4 = this_3.i1v_1;
              if (this_4.u1t_1.j1s(type.m1t())) {
                var tmp = type.m1t();
                var tmp_0 = this_4.v1t();
                var tmp_1 = 0;
                var tmp_2 = this_4.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_3 = fillArrayVal(Array(tmp_2), null);
                while (tmp_1 < tmp_2) {
                  tmp_3[tmp_1] = null;
                  tmp_1 = tmp_1 + 1 | 0;
                }
                this_4.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
              }
              var tmp_4 = this_4.u1t_1.h1(type.m1t());
              var entityPosition = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
              var tmp_5;
              if (this_3.k1v(entity, ScreenCoordinatesTag_getInstance())) {
                tmp_5 = entityPosition;
              } else {
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                tmp_5 = entityPosition.aev(this.kfi_1, camera);
              }
              var position = tmp_5;
              if (this_3.k1v(entity, Companion_getInstance_43())) {
                // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                var type_0 = Companion_getInstance_43();
                // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                var this_5 = this_3.i1v_1;
                if (this_5.u1t_1.j1s(type_0.m1t())) {
                  var tmp_6 = type_0.m1t();
                  var tmp_7 = this_5.v1t();
                  var tmp_8 = 0;
                  var tmp_9 = this_5.v1t().g1s();
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp_10 = fillArrayVal(Array(tmp_9), null);
                  while (tmp_8 < tmp_9) {
                    tmp_10[tmp_8] = null;
                    tmp_8 = tmp_8 + 1 | 0;
                  }
                  this_5.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
                }
                var tmp_11 = this_5.u1t_1.h1(type_0.m1t());
                var _destruct__k2r9zo = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(entity);
                var name = _destruct__k2r9zo.em();
                var anchorX = _destruct__k2r9zo.fm();
                var anchorY = _destruct__k2r9zo.jt();
                var animation = _destruct__k2r9zo.zep();
                var frameIndex = _destruct__k2r9zo.aeq();
                var imageFrame = getImageFrame(this.nfi_1, name, animation, frameIndex);
                var imageData = this.nfi_1.xek(name);
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color = Colors_getInstance().a58_1;
                var m = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor = this_0.d9w_1;
                this_0.d9w_1 = color;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_6 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  this_6.a4z(position.peo_1 + position.reo_1 - anchorX, position.qeo_1 + position.seo_1 - anchorY, imageData.n6n_1, imageData.o6n_1);
                  this_0.s9w(this_6, m);
                }finally {
                  this_0.d9w_1 = oldColor;
                }
                // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
                var this_7 = imageFrame.s6l_1;
                var n = 0;
                while (n < this_7.g1()) {
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  var layer = this_7.h1((this_7.g1() - n | 0) - 1 | 0);
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  var color_0 = Colors_getInstance().b58_1;
                  var m_0 = this_0.m9w_1;
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                  var oldColor_0 = this_0.d9w_1;
                  this_0.d9w_1 = color_0;
                  try {
                    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                    // Inline function 'kotlin.apply' call
                    var this_8 = new VectorPath();
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    this_8.a4z(position.peo_1 + position.reo_1 + layer.x6l_1 - anchorX, position.qeo_1 + position.seo_1 + layer.y6l_1 - anchorY, layer.f3u(), layer.g3u());
                    this_0.s9w(this_8, m_0);
                  }finally {
                    this_0.d9w_1 = oldColor_0;
                  }
                  n = n + 1 | 0;
                }
              }
              if (this_3.k1v(entity, Companion_getInstance_47())) {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color_1 = Colors_getInstance().a58_1;
                var m_1 = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_1 = this_0.d9w_1;
                this_0.d9w_1 = color_1;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_9 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                  var type_1 = Companion_getInstance_47();
                  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                  var this_10 = this_3.i1v_1;
                  if (this_10.u1t_1.j1s(type_1.m1t())) {
                    var tmp_12 = type_1.m1t();
                    var tmp_13 = this_10.v1t();
                    var tmp_14 = 0;
                    var tmp_15 = this_10.v1t().g1s();
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp_16 = fillArrayVal(Array(tmp_15), null);
                    while (tmp_14 < tmp_15) {
                      tmp_16[tmp_14] = null;
                      tmp_14 = tmp_14 + 1 | 0;
                    }
                    this_10.u1t_1.h1s(tmp_12, new ComponentsHolder(tmp_13, type_1, tmp_16));
                  }
                  var tmp_17 = this_10.u1t_1.h1(type_1.m1t());
                  var _destruct__k2r9zo_0 = (tmp_17 instanceof ComponentsHolder ? tmp_17 : THROW_CCE()).p1u(entity);
                  var width = _destruct__k2r9zo_0.aeq();
                  var height = _destruct__k2r9zo_0.lf0();
                  this_9.a4z(position.peo_1 + position.reo_1, position.qeo_1 + position.seo_1, width, height);
                  this_0.s9w(this_9, m_1);
                }finally {
                  this_0.d9w_1 = oldColor_1;
                }
              }
              if (this_3.k1v(entity, Companion_getInstance_29())) {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color_2 = Colors_getInstance().a58_1;
                var m_2 = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_2 = this_0.d9w_1;
                this_0.d9w_1 = color_2;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_11 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                  var type_2 = Companion_getInstance_29();
                  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                  var this_12 = this_3.i1v_1;
                  if (this_12.u1t_1.j1s(type_2.m1t())) {
                    var tmp_18 = type_2.m1t();
                    var tmp_19 = this_12.v1t();
                    var tmp_20 = 0;
                    var tmp_21 = this_12.v1t().g1s();
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp_22 = fillArrayVal(Array(tmp_21), null);
                    while (tmp_20 < tmp_21) {
                      tmp_22[tmp_20] = null;
                      tmp_20 = tmp_20 + 1 | 0;
                    }
                    this_12.u1t_1.h1s(tmp_18, new ComponentsHolder(tmp_19, type_2, tmp_22));
                  }
                  var tmp_23 = this_12.u1t_1.h1(type_2.m1t());
                  var _destruct__k2r9zo_1 = (tmp_23 instanceof ComponentsHolder ? tmp_23 : THROW_CCE()).p1u(entity);
                  var width_0 = _destruct__k2r9zo_1.fm();
                  var height_0 = _destruct__k2r9zo_1.jt();
                  this_11.a4z(position.peo_1 + position.reo_1, position.qeo_1 + position.seo_1, width_0, height_0);
                  this_0.s9w(this_11, m_2);
                }finally {
                  this_0.d9w_1 = oldColor_2;
                }
              }
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              var color_3 = Colors_getInstance().o5d_1;
              var m_3 = this_0.m9w_1;
              // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
              var oldColor_3 = this_0.d9w_1;
              this_0.d9w_1 = color_3;
              try {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                // Inline function 'kotlin.apply' call
                var this_13 = new VectorPath();
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var x = position.peo_1 + position.reo_1;
                var y = position.qeo_1 + position.seo_1;
                this_13.d4z(Vector2D.m3q(x, y), 2);
                this_13.w4y(Vector2D.m3q(x - 3, y), Vector2D.m3q(x + 3, y));
                this_13.w4y(Vector2D.m3q(x, y - 3), Vector2D.m3q(x, y + 3));
                this_0.s9w(this_13, m_3);
              }finally {
                this_0.d9w_1 = oldColor_3;
              }
            }
             while (inductionVariable < last);
          this_3.m1w_1 = false;
          this_3.h1w_1.v1w();
        } else {
          var origIterating = this_3.m1w_1;
          this_3.m1w_1 = true;
          // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = entitiesForIteration.v1s_1;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
              // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>' call
              var entity_0 = entitiesForIteration.u1s_1[i_0];
              // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
              var type_3 = Companion_getInstance_36();
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_14 = this_3.i1v_1;
              if (this_14.u1t_1.j1s(type_3.m1t())) {
                var tmp_24 = type_3.m1t();
                var tmp_25 = this_14.v1t();
                var tmp_26 = 0;
                var tmp_27 = this_14.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_28 = fillArrayVal(Array(tmp_27), null);
                while (tmp_26 < tmp_27) {
                  tmp_28[tmp_26] = null;
                  tmp_26 = tmp_26 + 1 | 0;
                }
                this_14.u1t_1.h1s(tmp_24, new ComponentsHolder(tmp_25, type_3, tmp_28));
              }
              var tmp_29 = this_14.u1t_1.h1(type_3.m1t());
              var entityPosition_0 = (tmp_29 instanceof ComponentsHolder ? tmp_29 : THROW_CCE()).p1u(entity_0);
              var tmp_30;
              if (this_3.k1v(entity_0, ScreenCoordinatesTag_getInstance())) {
                tmp_30 = entityPosition_0;
              } else {
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                tmp_30 = entityPosition_0.aev(this.kfi_1, camera);
              }
              var position_0 = tmp_30;
              if (this_3.k1v(entity_0, Companion_getInstance_43())) {
                // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                var type_4 = Companion_getInstance_43();
                // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                var this_15 = this_3.i1v_1;
                if (this_15.u1t_1.j1s(type_4.m1t())) {
                  var tmp_31 = type_4.m1t();
                  var tmp_32 = this_15.v1t();
                  var tmp_33 = 0;
                  var tmp_34 = this_15.v1t().g1s();
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp_35 = fillArrayVal(Array(tmp_34), null);
                  while (tmp_33 < tmp_34) {
                    tmp_35[tmp_33] = null;
                    tmp_33 = tmp_33 + 1 | 0;
                  }
                  this_15.u1t_1.h1s(tmp_31, new ComponentsHolder(tmp_32, type_4, tmp_35));
                }
                var tmp_36 = this_15.u1t_1.h1(type_4.m1t());
                var _destruct__k2r9zo_2 = (tmp_36 instanceof ComponentsHolder ? tmp_36 : THROW_CCE()).p1u(entity_0);
                var name_0 = _destruct__k2r9zo_2.em();
                var anchorX_0 = _destruct__k2r9zo_2.fm();
                var anchorY_0 = _destruct__k2r9zo_2.jt();
                var animation_0 = _destruct__k2r9zo_2.zep();
                var frameIndex_0 = _destruct__k2r9zo_2.aeq();
                var imageFrame_0 = getImageFrame(this.nfi_1, name_0, animation_0, frameIndex_0);
                var imageData_0 = this.nfi_1.xek(name_0);
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color_4 = Colors_getInstance().a58_1;
                var m_4 = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_4 = this_0.d9w_1;
                this_0.d9w_1 = color_4;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_16 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  this_16.a4z(position_0.peo_1 + position_0.reo_1 - anchorX_0, position_0.qeo_1 + position_0.seo_1 - anchorY_0, imageData_0.n6n_1, imageData_0.o6n_1);
                  this_0.s9w(this_16, m_4);
                }finally {
                  this_0.d9w_1 = oldColor_4;
                }
                // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
                var this_17 = imageFrame_0.s6l_1;
                var n_0 = 0;
                while (n_0 < this_17.g1()) {
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  var layer_0 = this_17.h1((this_17.g1() - n_0 | 0) - 1 | 0);
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  var color_5 = Colors_getInstance().b58_1;
                  var m_5 = this_0.m9w_1;
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                  var oldColor_5 = this_0.d9w_1;
                  this_0.d9w_1 = color_5;
                  try {
                    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                    // Inline function 'kotlin.apply' call
                    var this_18 = new VectorPath();
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    this_18.a4z(position_0.peo_1 + position_0.reo_1 + layer_0.x6l_1 - anchorX_0, position_0.qeo_1 + position_0.seo_1 + layer_0.y6l_1 - anchorY_0, layer_0.f3u(), layer_0.g3u());
                    this_0.s9w(this_18, m_5);
                  }finally {
                    this_0.d9w_1 = oldColor_5;
                  }
                  n_0 = n_0 + 1 | 0;
                }
              }
              if (this_3.k1v(entity_0, Companion_getInstance_47())) {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color_6 = Colors_getInstance().a58_1;
                var m_6 = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_6 = this_0.d9w_1;
                this_0.d9w_1 = color_6;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_19 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                  var type_5 = Companion_getInstance_47();
                  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                  var this_20 = this_3.i1v_1;
                  if (this_20.u1t_1.j1s(type_5.m1t())) {
                    var tmp_37 = type_5.m1t();
                    var tmp_38 = this_20.v1t();
                    var tmp_39 = 0;
                    var tmp_40 = this_20.v1t().g1s();
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp_41 = fillArrayVal(Array(tmp_40), null);
                    while (tmp_39 < tmp_40) {
                      tmp_41[tmp_39] = null;
                      tmp_39 = tmp_39 + 1 | 0;
                    }
                    this_20.u1t_1.h1s(tmp_37, new ComponentsHolder(tmp_38, type_5, tmp_41));
                  }
                  var tmp_42 = this_20.u1t_1.h1(type_5.m1t());
                  var _destruct__k2r9zo_3 = (tmp_42 instanceof ComponentsHolder ? tmp_42 : THROW_CCE()).p1u(entity_0);
                  var width_1 = _destruct__k2r9zo_3.aeq();
                  var height_1 = _destruct__k2r9zo_3.lf0();
                  this_19.a4z(position_0.peo_1 + position_0.reo_1, position_0.qeo_1 + position_0.seo_1, width_1, height_1);
                  this_0.s9w(this_19, m_6);
                }finally {
                  this_0.d9w_1 = oldColor_6;
                }
              }
              if (this_3.k1v(entity_0, Companion_getInstance_29())) {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                var color_7 = Colors_getInstance().a58_1;
                var m_7 = this_0.m9w_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_7 = this_0.d9w_1;
                this_0.d9w_1 = color_7;
                try {
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                  // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                  // Inline function 'kotlin.apply' call
                  var this_21 = new VectorPath();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                  var type_6 = Companion_getInstance_29();
                  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                  var this_22 = this_3.i1v_1;
                  if (this_22.u1t_1.j1s(type_6.m1t())) {
                    var tmp_43 = type_6.m1t();
                    var tmp_44 = this_22.v1t();
                    var tmp_45 = 0;
                    var tmp_46 = this_22.v1t().g1s();
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp_47 = fillArrayVal(Array(tmp_46), null);
                    while (tmp_45 < tmp_46) {
                      tmp_47[tmp_45] = null;
                      tmp_45 = tmp_45 + 1 | 0;
                    }
                    this_22.u1t_1.h1s(tmp_43, new ComponentsHolder(tmp_44, type_6, tmp_47));
                  }
                  var tmp_48 = this_22.u1t_1.h1(type_6.m1t());
                  var _destruct__k2r9zo_4 = (tmp_48 instanceof ComponentsHolder ? tmp_48 : THROW_CCE()).p1u(entity_0);
                  var width_2 = _destruct__k2r9zo_4.fm();
                  var height_2 = _destruct__k2r9zo_4.jt();
                  this_21.a4z(position_0.peo_1 + position_0.reo_1, position_0.qeo_1 + position_0.seo_1, width_2, height_2);
                  this_0.s9w(this_21, m_7);
                }finally {
                  this_0.d9w_1 = oldColor_7;
                }
              }
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              var color_8 = Colors_getInstance().o5d_1;
              var m_8 = this_0.m9w_1;
              // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
              var oldColor_8 = this_0.d9w_1;
              this_0.d9w_1 = color_8;
              try {
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
                // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
                // Inline function 'kotlin.apply' call
                var this_23 = new VectorPath();
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.korge.fleks.renderSystems.DebugRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var x_0 = position_0.peo_1 + position_0.reo_1;
                var y_0 = position_0.qeo_1 + position_0.seo_1;
                this_23.d4z(Vector2D.m3q(x_0, y_0), 2);
                this_23.w4y(Vector2D.m3q(x_0 - 3, y_0), Vector2D.m3q(x_0 + 3, y_0));
                this_23.w4y(Vector2D.m3q(x_0, y_0 - 3), Vector2D.m3q(x_0, y_0 + 3));
                this_0.s9w(this_23, m_8);
              }finally {
                this_0.d9w_1 = oldColor_8;
              }
            }
             while (inductionVariable_0 < last_0);
          this_3.m1w_1 = origIterating;
        }
        break $l$block;
      }finally {
        mut.set(temp);
      }
    }
  }
  pbt() {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    this.kfi_1;
    return Companion_getInstance_7().k3q(0, 0, AppConfig_getInstance().iev_1, AppConfig_getInstance().jev_1);
  }
}
class FastSpriteRenderSystem extends View {
  static sfk(world, layerTag) {
    var $this = this.sc9();
    $this.pfk_1 = world;
    var tmp = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.pfk_1.y1t_1.e3(name);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var injectable = tmp_0;
    injectable.p21_1 = true;
    var tmp_1 = injectable.o21_1;
    tmp.rfk_1 = tmp_1 instanceof AssetStore ? tmp_1 : THROW_CCE();
    $this.mb8_1 = toString_0(layerTag);
    var tmp_2 = $this;
    tmp_2.qfk_1 = $this.pfk_1.p20(FastSpriteRenderSystem$lambda(layerTag));
    return $this;
  }
  sbt(ctx) {
    var camera = getMainCamera(this.pfk_1);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a9n_1;
    var this_1 = this_0.j9n_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    var this_2 = this.qfk_1;
    var entitiesForIteration = this_2.u1y();
    var tmp;
    if (!this_2.h1w_1.t1v_1) {
      this_2.h1w_1.t1v_1 = true;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          var it = entitiesForIteration.u1s_1[i];
          $l$block: {
            // Inline function 'korlibs.korge.fleks.renderSystems.FastSpriteRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type = Companion_getInstance_36();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_3 = this_2.i1v_1;
            if (this_3.u1t_1.j1s(type.m1t())) {
              var tmp_0 = type.m1t();
              var tmp_1 = this_3.v1t();
              var tmp_2 = 0;
              var tmp_3 = this_3.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_4 = fillArrayVal(Array(tmp_3), null);
              while (tmp_2 < tmp_3) {
                tmp_4[tmp_2] = null;
                tmp_2 = tmp_2 + 1 | 0;
              }
              this_3.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, type, tmp_4));
            }
            var tmp_5 = this_3.u1t_1.h1(type.m1t());
            var entityPosition = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).p1u(it);
            var tmp_6;
            if (this_2.k1v(it, ScreenCoordinatesTag_getInstance())) {
              tmp_6 = entityPosition;
            } else {
              // Inline function 'kotlin.run' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.fleks.renderSystems.FastSpriteRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              tmp_6 = entityPosition.aev(this.pfk_1, camera);
            }
            var position = tmp_6;
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_0 = Companion_getInstance_43();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_4 = this_2.i1v_1;
            if (this_4.u1t_1.j1s(type_0.m1t())) {
              var tmp_7 = type_0.m1t();
              var tmp_8 = this_4.v1t();
              var tmp_9 = 0;
              var tmp_10 = this_4.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                tmp_11[tmp_9] = null;
                tmp_9 = tmp_9 + 1 | 0;
              }
              this_4.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, type_0, tmp_11));
            }
            var tmp_12 = this_4.u1t_1.h1(type_0.m1t());
            var _destruct__k2r9zo = (tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE()).p1u(it);
            var name = _destruct__k2r9zo.em();
            var anchorX = _destruct__k2r9zo.fm();
            var anchorY = _destruct__k2r9zo.jt();
            var animation = _destruct__k2r9zo.zep();
            var frameIndex = _destruct__k2r9zo.aeq();
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_1 = Companion_getInstance_38();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_5 = this_2.i1v_1;
            if (this_5.u1t_1.j1s(type_1.m1t())) {
              var tmp_13 = type_1.m1t();
              var tmp_14 = this_5.v1t();
              var tmp_15 = 0;
              var tmp_16 = this_5.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_17 = fillArrayVal(Array(tmp_16), null);
              while (tmp_15 < tmp_16) {
                tmp_17[tmp_15] = null;
                tmp_15 = tmp_15 + 1 | 0;
              }
              this_5.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, type_1, tmp_17));
            }
            var tmp_18 = this_5.u1t_1.h1(type_1.m1t());
            var rgba = (tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE()).p1u(it).lew();
            var imageFrame = getImageFrame(this.rfk_1, name, animation, frameIndex);
            var tmp0_elvis_lhs = imageFrame.t6l_1;
            var tmp_19;
            if (tmp0_elvis_lhs == null) {
              break $l$block;
            } else {
              tmp_19 = tmp0_elvis_lhs;
            }
            var texture = tmp_19;
            this_0.q9o(ctx.p9o(texture.f6m_1), position.peo_1 + texture.x6l_1 - anchorX, position.qeo_1 + texture.y6l_1 - anchorY, VOID, VOID, VOID, false, rgba, VOID, null);
          }
        }
         while (inductionVariable < last);
      this_2.m1w_1 = false;
      this_2.h1w_1.v1w();
      tmp = Unit_instance;
    } else {
      var origIterating = this_2.m1w_1;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          var it_0 = entitiesForIteration.u1s_1[i_0];
          $l$block_0: {
            // Inline function 'korlibs.korge.fleks.renderSystems.FastSpriteRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_2 = Companion_getInstance_36();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_6 = this_2.i1v_1;
            if (this_6.u1t_1.j1s(type_2.m1t())) {
              var tmp_20 = type_2.m1t();
              var tmp_21 = this_6.v1t();
              var tmp_22 = 0;
              var tmp_23 = this_6.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_24 = fillArrayVal(Array(tmp_23), null);
              while (tmp_22 < tmp_23) {
                tmp_24[tmp_22] = null;
                tmp_22 = tmp_22 + 1 | 0;
              }
              this_6.u1t_1.h1s(tmp_20, new ComponentsHolder(tmp_21, type_2, tmp_24));
            }
            var tmp_25 = this_6.u1t_1.h1(type_2.m1t());
            var entityPosition_0 = (tmp_25 instanceof ComponentsHolder ? tmp_25 : THROW_CCE()).p1u(it_0);
            var tmp_26;
            if (this_2.k1v(it_0, ScreenCoordinatesTag_getInstance())) {
              tmp_26 = entityPosition_0;
            } else {
              // Inline function 'kotlin.run' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.fleks.renderSystems.FastSpriteRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              tmp_26 = entityPosition_0.aev(this.pfk_1, camera);
            }
            var position_0 = tmp_26;
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_3 = Companion_getInstance_43();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_7 = this_2.i1v_1;
            if (this_7.u1t_1.j1s(type_3.m1t())) {
              var tmp_27 = type_3.m1t();
              var tmp_28 = this_7.v1t();
              var tmp_29 = 0;
              var tmp_30 = this_7.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_31 = fillArrayVal(Array(tmp_30), null);
              while (tmp_29 < tmp_30) {
                tmp_31[tmp_29] = null;
                tmp_29 = tmp_29 + 1 | 0;
              }
              this_7.u1t_1.h1s(tmp_27, new ComponentsHolder(tmp_28, type_3, tmp_31));
            }
            var tmp_32 = this_7.u1t_1.h1(type_3.m1t());
            var _destruct__k2r9zo_0 = (tmp_32 instanceof ComponentsHolder ? tmp_32 : THROW_CCE()).p1u(it_0);
            var name_0 = _destruct__k2r9zo_0.em();
            var anchorX_0 = _destruct__k2r9zo_0.fm();
            var anchorY_0 = _destruct__k2r9zo_0.jt();
            var animation_0 = _destruct__k2r9zo_0.zep();
            var frameIndex_0 = _destruct__k2r9zo_0.aeq();
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_4 = Companion_getInstance_38();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_8 = this_2.i1v_1;
            if (this_8.u1t_1.j1s(type_4.m1t())) {
              var tmp_33 = type_4.m1t();
              var tmp_34 = this_8.v1t();
              var tmp_35 = 0;
              var tmp_36 = this_8.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_37 = fillArrayVal(Array(tmp_36), null);
              while (tmp_35 < tmp_36) {
                tmp_37[tmp_35] = null;
                tmp_35 = tmp_35 + 1 | 0;
              }
              this_8.u1t_1.h1s(tmp_33, new ComponentsHolder(tmp_34, type_4, tmp_37));
            }
            var tmp_38 = this_8.u1t_1.h1(type_4.m1t());
            var rgba_0 = (tmp_38 instanceof ComponentsHolder ? tmp_38 : THROW_CCE()).p1u(it_0).lew();
            var imageFrame_0 = getImageFrame(this.rfk_1, name_0, animation_0, frameIndex_0);
            var tmp0_elvis_lhs_0 = imageFrame_0.t6l_1;
            var tmp_39;
            if (tmp0_elvis_lhs_0 == null) {
              break $l$block_0;
            } else {
              tmp_39 = tmp0_elvis_lhs_0;
            }
            var texture_0 = tmp_39;
            this_0.q9o(ctx.p9o(texture_0.f6m_1), position_0.peo_1 + texture_0.x6l_1 - anchorX_0, position_0.qeo_1 + texture_0.y6l_1 - anchorY_0, VOID, VOID, VOID, false, rgba_0, VOID, null);
          }
        }
         while (inductionVariable_0 < last_0);
      this_2.m1w_1 = origIterating;
      tmp = Unit_instance;
    }
  }
  pbt() {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    this.pfk_1;
    return Companion_getInstance_7().k3q(0, 0, AppConfig_getInstance().iev_1, AppConfig_getInstance().jev_1);
  }
}
class LevelMapRenderSystem extends View {
  static xfm(world, layerTag, comparator) {
    var tmp;
    if (comparator === VOID) {
      tmp = compareEntity(world, LevelMapRenderSystem$_init_$lambda_xw0m9e);
    } else {
      tmp = comparator;
    }
    comparator = tmp;
    var $this = this.sc9();
    $this.tfm_1 = world;
    $this.ufm_1 = comparator;
    var tmp_0 = $this;
    tmp_0.vfm_1 = $this.tfm_1.p20(LevelMapRenderSystem$family$lambda(layerTag));
    var tmp_1 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.tfm_1.y1t_1.e3(name);
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var injectable = tmp_2;
    injectable.p21_1 = true;
    var tmp_3 = injectable.o21_1;
    tmp_1.wfm_1 = tmp_3 instanceof AssetStore ? tmp_3 : THROW_CCE();
    $this.mb8_1 = toString_0(layerTag);
    return $this;
  }
  sbt(ctx) {
    var camera = getMainCamera(this.tfm_1);
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.renderSystems.LevelMapRenderSystem.renderInternal.<anonymous>' call
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var this_0 = this.tfm_1;
    var type = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = this_0.i1v_1;
    if (this_1.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_1.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_1.u1t_1.h1(type.m1t());
    var cameraPosition = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(camera);
    this.vfm_1.a1t(this.ufm_1);
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var this_2 = this.vfm_1;
    var entitiesForIteration = this_2.u1y();
    if (!this_2.h1w_1.t1v_1) {
      this_2.h1w_1.t1v_1 = true;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.LevelMapRenderSystem.renderInternal.<anonymous>' call
          var entity = entitiesForIteration.u1s_1[i];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_0 = Companion_getInstance_38();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_3 = this_2.i1v_1;
          if (this_3.u1t_1.j1s(type_0.m1t())) {
            var tmp_5 = type_0.m1t();
            var tmp_6 = this_3.v1t();
            var tmp_7 = 0;
            var tmp_8 = this_3.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_9 = fillArrayVal(Array(tmp_8), null);
            while (tmp_7 < tmp_8) {
              tmp_9[tmp_7] = null;
              tmp_7 = tmp_7 + 1 | 0;
            }
            this_3.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
          }
          var tmp_10 = this_3.u1t_1.h1(type_0.m1t());
          var rgba = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity).lew();
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_1 = Companion_getInstance_26();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_4 = this_2.i1v_1;
          if (this_4.u1t_1.j1s(type_1.m1t())) {
            var tmp_11 = type_1.m1t();
            var tmp_12 = this_4.v1t();
            var tmp_13 = 0;
            var tmp_14 = this_4.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              tmp_15[tmp_13] = null;
              tmp_13 = tmp_13 + 1 | 0;
            }
            this_4.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
          }
          var tmp_16 = this_4.u1t_1.h1(type_1.m1t());
          var _destruct__k2r9zo = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(entity);
          var levelName = _destruct__k2r9zo.em();
          var layerNames = _destruct__k2r9zo.fm();
          var worldData = this.wfm_1.yek(levelName);
          var tileSize = worldData.neh_1;
          var viewPortPosX = cameraPosition.peo_1 + cameraPosition.reo_1 - AppConfig_getInstance().kev_1;
          var viewPortPosY = cameraPosition.qeo_1 + cameraPosition.seo_1 - AppConfig_getInstance().lev_1;
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator = layerNames.b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            // Inline function 'korlibs.korge.fleks.renderSystems.LevelMapRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            var levelMap = worldData.oem(element);
            var xStart = (numberToInt(viewPortPosX) / tileSize | 0) - 1 | 0;
            var xTiles = (AppConfig_getInstance().iev_1 / tileSize | 0) + 3 | 0;
            var yStart = (numberToInt(viewPortPosY) / tileSize | 0) - 1 | 0;
            var yTiles = (AppConfig_getInstance().jev_1 / tileSize | 0) + 3 | 0;
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_5 = ctx.a9n_1;
            var this_6 = this_5.j9n_1;
            if (!(this_6.e9n_1 === this_5)) {
              this_6.e9n_1 = this_5;
              this_6.o9o();
            }
            var tmp_17 = worldData.leh_1;
            var tmp_18 = worldData.meh_1;
            levelMap.nem(xStart, yStart, xTiles, yTiles, tmp_17, tmp_18, LevelMapRenderSystem$renderInternal$lambda(this_5, ctx, viewPortPosX, viewPortPosY, rgba));
          }
        }
         while (inductionVariable < last);
      this_2.m1w_1 = false;
      this_2.h1w_1.v1w();
    } else {
      var origIterating = this_2.m1w_1;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.LevelMapRenderSystem.renderInternal.<anonymous>' call
          var entity_0 = entitiesForIteration.u1s_1[i_0];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_2 = Companion_getInstance_38();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_7 = this_2.i1v_1;
          if (this_7.u1t_1.j1s(type_2.m1t())) {
            var tmp_19 = type_2.m1t();
            var tmp_20 = this_7.v1t();
            var tmp_21 = 0;
            var tmp_22 = this_7.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_23 = fillArrayVal(Array(tmp_22), null);
            while (tmp_21 < tmp_22) {
              tmp_23[tmp_21] = null;
              tmp_21 = tmp_21 + 1 | 0;
            }
            this_7.u1t_1.h1s(tmp_19, new ComponentsHolder(tmp_20, type_2, tmp_23));
          }
          var tmp_24 = this_7.u1t_1.h1(type_2.m1t());
          var rgba_0 = (tmp_24 instanceof ComponentsHolder ? tmp_24 : THROW_CCE()).p1u(entity_0).lew();
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_3 = Companion_getInstance_26();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_8 = this_2.i1v_1;
          if (this_8.u1t_1.j1s(type_3.m1t())) {
            var tmp_25 = type_3.m1t();
            var tmp_26 = this_8.v1t();
            var tmp_27 = 0;
            var tmp_28 = this_8.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_29 = fillArrayVal(Array(tmp_28), null);
            while (tmp_27 < tmp_28) {
              tmp_29[tmp_27] = null;
              tmp_27 = tmp_27 + 1 | 0;
            }
            this_8.u1t_1.h1s(tmp_25, new ComponentsHolder(tmp_26, type_3, tmp_29));
          }
          var tmp_30 = this_8.u1t_1.h1(type_3.m1t());
          var _destruct__k2r9zo_0 = (tmp_30 instanceof ComponentsHolder ? tmp_30 : THROW_CCE()).p1u(entity_0);
          var levelName_0 = _destruct__k2r9zo_0.em();
          var layerNames_0 = _destruct__k2r9zo_0.fm();
          var worldData_0 = this.wfm_1.yek(levelName_0);
          var tileSize_0 = worldData_0.neh_1;
          var viewPortPosX_0 = cameraPosition.peo_1 + cameraPosition.reo_1 - AppConfig_getInstance().kev_1;
          var viewPortPosY_0 = cameraPosition.qeo_1 + cameraPosition.seo_1 - AppConfig_getInstance().lev_1;
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator_0 = layerNames_0.b1();
          while (tmp0_iterator_0.c1()) {
            var element_0 = tmp0_iterator_0.d1();
            // Inline function 'korlibs.korge.fleks.renderSystems.LevelMapRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            var levelMap_0 = worldData_0.oem(element_0);
            var xStart_0 = (numberToInt(viewPortPosX_0) / tileSize_0 | 0) - 1 | 0;
            var xTiles_0 = (AppConfig_getInstance().iev_1 / tileSize_0 | 0) + 3 | 0;
            var yStart_0 = (numberToInt(viewPortPosY_0) / tileSize_0 | 0) - 1 | 0;
            var yTiles_0 = (AppConfig_getInstance().jev_1 / tileSize_0 | 0) + 3 | 0;
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_9 = ctx.a9n_1;
            var this_10 = this_9.j9n_1;
            if (!(this_10.e9n_1 === this_9)) {
              this_10.e9n_1 = this_9;
              this_10.o9o();
            }
            var tmp_31 = worldData_0.leh_1;
            var tmp_32 = worldData_0.meh_1;
            levelMap_0.nem(xStart_0, yStart_0, xTiles_0, yTiles_0, tmp_31, tmp_32, LevelMapRenderSystem$renderInternal$lambda_0(this_9, ctx, viewPortPosX_0, viewPortPosY_0, rgba_0));
          }
        }
         while (inductionVariable_0 < last_0);
      this_2.m1w_1 = origIterating;
    }
  }
  pbt() {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    this.tfm_1;
    return Companion_getInstance_7().k3q(0, 0, AppConfig_getInstance().iev_1, AppConfig_getInstance().jev_1);
  }
}
class ObjectRenderSystem extends View {
  static cfp(world, layerTag, comparator) {
    var tmp;
    if (comparator === VOID) {
      tmp = compareEntity(world, ObjectRenderSystem$_init_$lambda_nqlu61);
    } else {
      tmp = comparator;
    }
    comparator = tmp;
    var $this = this.sc9();
    $this.yfo_1 = world;
    $this.zfo_1 = comparator;
    var tmp_0 = $this;
    tmp_0.afp_1 = $this.yfo_1.p20(ObjectRenderSystem$family$lambda(layerTag));
    var tmp_1 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.yfo_1.y1t_1.e3(name);
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var injectable = tmp_2;
    injectable.p21_1 = true;
    var tmp_3 = injectable.o21_1;
    tmp_1.bfp_1 = tmp_3 instanceof AssetStore ? tmp_3 : THROW_CCE();
    $this.mb8_1 = toString_0(layerTag);
    return $this;
  }
  sbt(ctx) {
    var camera = getMainCamera(this.yfo_1);
    this.afp_1.a1t(this.zfo_1);
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var this_0 = this.afp_1;
    var entitiesForIteration = this_0.u1y();
    if (!this_0.h1w_1.t1v_1) {
      this_0.h1w_1.t1v_1 = true;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>' call
          var entity = entitiesForIteration.u1s_1[i];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type = Companion_getInstance_38();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_1 = this_0.i1v_1;
          if (this_1.u1t_1.j1s(type.m1t())) {
            var tmp = type.m1t();
            var tmp_0 = this_1.v1t();
            var tmp_1 = 0;
            var tmp_2 = this_1.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_3 = fillArrayVal(Array(tmp_2), null);
            while (tmp_1 < tmp_2) {
              tmp_3[tmp_1] = null;
              tmp_1 = tmp_1 + 1 | 0;
            }
            this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
          }
          var tmp_4 = this_1.u1t_1.h1(type.m1t());
          var rgba = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity).lew();
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_0 = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_2 = this_0.i1v_1;
          if (this_2.u1t_1.j1s(type_0.m1t())) {
            var tmp_5 = type_0.m1t();
            var tmp_6 = this_2.v1t();
            var tmp_7 = 0;
            var tmp_8 = this_2.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_9 = fillArrayVal(Array(tmp_8), null);
            while (tmp_7 < tmp_8) {
              tmp_9[tmp_7] = null;
              tmp_7 = tmp_7 + 1 | 0;
            }
            this_2.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
          }
          var tmp_10 = this_2.u1t_1.h1(type_0.m1t());
          var entityPosition = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
          var tmp_11;
          if (this_0.k1v(entity, ScreenCoordinatesTag_getInstance())) {
            tmp_11 = entityPosition;
          } else {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            tmp_11 = entityPosition.aev(this.yfo_1, camera);
          }
          var position = tmp_11;
          if (this_0.k1v(entity, Companion_getInstance_43())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_1 = Companion_getInstance_43();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_3 = this_0.i1v_1;
            if (this_3.u1t_1.j1s(type_1.m1t())) {
              var tmp_12 = type_1.m1t();
              var tmp_13 = this_3.v1t();
              var tmp_14 = 0;
              var tmp_15 = this_3.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_16 = fillArrayVal(Array(tmp_15), null);
              while (tmp_14 < tmp_15) {
                tmp_16[tmp_14] = null;
                tmp_14 = tmp_14 + 1 | 0;
              }
              this_3.u1t_1.h1s(tmp_12, new ComponentsHolder(tmp_13, type_1, tmp_16));
            }
            var tmp_17 = this_3.u1t_1.h1(type_1.m1t());
            var _destruct__k2r9zo = (tmp_17 instanceof ComponentsHolder ? tmp_17 : THROW_CCE()).p1u(entity);
            var name = _destruct__k2r9zo.em();
            var anchorX = _destruct__k2r9zo.fm();
            var anchorY = _destruct__k2r9zo.jt();
            var animation = _destruct__k2r9zo.zep();
            var frameIndex = _destruct__k2r9zo.aeq();
            var imageFrame = getImageFrame(this.bfp_1, name, animation, frameIndex);
            if (this_0.k1v(entity, Companion_getInstance_45())) {
              // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
              var type_2 = Companion_getInstance_45();
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_4 = this_0.i1v_1;
              if (this_4.u1t_1.j1s(type_2.m1t())) {
                var tmp_18 = type_2.m1t();
                var tmp_19 = this_4.v1t();
                var tmp_20 = 0;
                var tmp_21 = this_4.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_22 = fillArrayVal(Array(tmp_21), null);
                while (tmp_20 < tmp_21) {
                  tmp_22[tmp_20] = null;
                  tmp_20 = tmp_20 + 1 | 0;
                }
                this_4.u1t_1.h1s(tmp_18, new ComponentsHolder(tmp_19, type_2, tmp_22));
              }
              var tmp_23 = this_4.u1t_1.h1(type_2.m1t());
              var layerMap = (tmp_23 instanceof ComponentsHolder ? tmp_23 : THROW_CCE()).p1u(entity).em();
              // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
              // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
              var this_5 = ctx.a9n_1;
              var this_6 = this_5.j9n_1;
              if (!(this_6.e9n_1 === this_5)) {
                this_6.e9n_1 = this_5;
                this_6.o9o();
              }
              var this_7 = imageFrame.s6l_1;
              var n = 0;
              while (n < this_7.g1()) {
                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n;
                n = _unary__edvuaz + 1 | 0;
                var layerData = this_7.h1(_unary__edvuaz);
                var tmp0_elvis_lhs = layerData.w6l_1.n6l_1;
                var layerName = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
                var tmp1_safe_receiver = layerMap.e3(layerName);
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  this_5.q9o(ctx.p9o(layerData.f6m_1), position.peo_1 + layerData.x6l_1 - anchorX + tmp1_safe_receiver.zey_1, position.qeo_1 + layerData.y6l_1 - anchorY + tmp1_safe_receiver.aez_1, VOID, VOID, VOID, false, tmp1_safe_receiver.bez_1, VOID, null);
                }
              }
            } else {
              // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
              // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
              var this_8 = ctx.a9n_1;
              var this_9 = this_8.j9n_1;
              if (!(this_9.e9n_1 === this_8)) {
                this_9.e9n_1 = this_8;
                this_9.o9o();
              }
              var this_10 = imageFrame.s6l_1;
              var n_0 = 0;
              while (n_0 < this_10.g1()) {
                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var _unary__edvuaz_0 = n_0;
                n_0 = _unary__edvuaz_0 + 1 | 0;
                var layerData_0 = this_10.h1(_unary__edvuaz_0);
                var px = position.peo_1 + position.reo_1 + layerData_0.x6l_1 - anchorX;
                var py = position.qeo_1 + position.seo_1 + layerData_0.y6l_1 - anchorY;
                this_8.q9o(ctx.p9o(layerData_0.f6m_1), px, py, VOID, VOID, VOID, false, rgba, VOID, null);
              }
            }
          } else if (this_0.k1v(entity, Companion_getInstance_24())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_3 = Companion_getInstance_24();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_11 = this_0.i1v_1;
            if (this_11.u1t_1.j1s(type_3.m1t())) {
              var tmp_24 = type_3.m1t();
              var tmp_25 = this_11.v1t();
              var tmp_26 = 0;
              var tmp_27 = this_11.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_28 = fillArrayVal(Array(tmp_27), null);
              while (tmp_26 < tmp_27) {
                tmp_28[tmp_26] = null;
                tmp_26 = tmp_26 + 1 | 0;
              }
              this_11.u1t_1.h1s(tmp_24, new ComponentsHolder(tmp_25, type_3, tmp_28));
            }
            var tmp_29 = this_11.u1t_1.h1(type_3.m1t());
            var _destruct__k2r9zo_0 = (tmp_29 instanceof ComponentsHolder ? tmp_29 : THROW_CCE()).p1u(entity);
            var name_0 = _destruct__k2r9zo_0.em();
            var anchorX_0 = _destruct__k2r9zo_0.fm();
            var anchorY_0 = _destruct__k2r9zo_0.jt();
            var animation_0 = _destruct__k2r9zo_0.zep();
            var frameIndex_0 = _destruct__k2r9zo_0.aeq();
            var layerList = _destruct__k2r9zo_0.beq();
            var imageFrame_0 = getImageFrame(this.bfp_1, name_0, animation_0, frameIndex_0);
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_12 = ctx.a9n_1;
            var this_13 = this_12.j9n_1;
            if (!(this_13.e9n_1 === this_12)) {
              this_13.e9n_1 = this_12;
              this_13.o9o();
            }
            var n_1 = 0;
            while (n_1 < layerList.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index = n_1;
              var layer = layerList.h1(n_1);
              var image = imageFrame_0.s6l_1.h1(index);
              this_12.q9o(ctx.p9o(image.f6m_1), position.peo_1 + image.x6l_1 - anchorX_0 + layer.neo_1.peo_1 + layer.neo_1.reo_1, position.qeo_1 + image.y6l_1 - anchorY_0 + layer.neo_1.qeo_1 + layer.neo_1.seo_1, VOID, VOID, VOID, false, layer.oeo_1.ueo_1, VOID, null);
              n_1 = n_1 + 1 | 0;
            }
          } else if (this_0.k1v(entity, Companion_getInstance_47())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_4 = Companion_getInstance_47();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_14 = this_0.i1v_1;
            if (this_14.u1t_1.j1s(type_4.m1t())) {
              var tmp_30 = type_4.m1t();
              var tmp_31 = this_14.v1t();
              var tmp_32 = 0;
              var tmp_33 = this_14.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_34 = fillArrayVal(Array(tmp_33), null);
              while (tmp_32 < tmp_33) {
                tmp_34[tmp_32] = null;
                tmp_32 = tmp_32 + 1 | 0;
              }
              this_14.u1t_1.h1s(tmp_30, new ComponentsHolder(tmp_31, type_4, tmp_34));
            }
            var tmp_35 = this_14.u1t_1.h1(type_4.m1t());
            var _destruct__k2r9zo_1 = (tmp_35 instanceof ComponentsHolder ? tmp_35 : THROW_CCE()).p1u(entity);
            var text = _destruct__k2r9zo_1.em();
            var fontName = _destruct__k2r9zo_1.fm();
            var textRangeStart = _destruct__k2r9zo_1.jt();
            var textRangeEnd = _destruct__k2r9zo_1.zep();
            var width = _destruct__k2r9zo_1.aeq();
            var height = _destruct__k2r9zo_1.lf0();
            var wordWrap = _destruct__k2r9zo_1.mf0();
            var horizontalAlign = _destruct__k2r9zo_1.nf0();
            var verticalAlign = _destruct__k2r9zo_1.of0();
            var offset = Vector2D.m3q(position.reo_1, position.seo_1);
            // Inline function 'korlibs.korge.render.renderCtx2d' call
            // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            var batcher = ctx.a9n_1;
            if (!(ctx.e9n_1 === batcher)) {
              ctx.e9n_1 = batcher;
              ctx.o9o();
            }
            // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
            // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
            var context = ctx.c9n_1;
            // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
            $l$block_3: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
              var old = context.v9x_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
                $l$block_2: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
                  var oldBlendFactors = context.w9x_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
                    $l$block_1: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
                      var multiplyColor = context.x9x_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                        $l$block_0: {
                          // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                          var filtering = context.y9x_1;
                          try {
                            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                            $l$block: {
                              // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                              var size = context.t9x_1;
                              try {
                                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                                context.t9x_1 = Size2D.r3q(this.f3u(), this.g3u());
                                context.w9x_1 = this.sby();
                                context.x9x_1 = this.tby();
                                context.z9x(this.ube());
                                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>' call
                                var n_2 = 0;
                                // Inline function 'korlibs.datastructure.iterators.fastForEach' call
                                var this_15 = place(RichTextData.v6v(text, this.bfp_1.bel(fontName)), Companion_getInstance_7().l3q(position.peo_1, position.qeo_1, width, height), wordWrap, false, null, null, null, new TextAlignment(horizontalAlign, verticalAlign), true);
                                var n_3 = 0;
                                while (n_3 < this_15.g1()) {
                                  // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                                  var _unary__edvuaz_1 = n_3;
                                  n_3 = _unary__edvuaz_1 + 1 | 0;
                                  var it = this_15.h1(_unary__edvuaz_1);
                                  var tmp_36 = get_lazyBitmap(it.c6w_1);
                                  // Inline function 'korlibs.math.geom.Vector2D.plus' call
                                  var this_16 = it.a6w_1;
                                  var tmp$ret$33 = Vector2D.y3k(this_16.r3i_1 + offset.r3i_1, this_16.s3i_1 + offset.s3i_1);
                                  drawText(context, it.z6v_1, tmp_36, it.b6w_1, tmp$ret$33, rgba, true, textRangeStart - n_2 | 0, textRangeEnd - n_2 | 0, false);
                                  n_2 = n_2 + it.z6v_1.length | 0;
                                }
                                break $l$block;
                              }finally {
                                context.t9x_1 = size;
                              }
                            }
                            break $l$block_0;
                          }finally {
                            context.y9x_1 = filtering;
                          }
                        }
                        break $l$block_1;
                      }finally {
                        context.x9x_1 = multiplyColor;
                      }
                    }
                    break $l$block_2;
                  }finally {
                    context.w9x_1 = oldBlendFactors;
                  }
                }
                break $l$block_3;
              }finally {
                context.v9x_1 = old;
              }
            }
          } else if (this_0.k1v(entity, Companion_getInstance_29())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_5 = Companion_getInstance_29();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_17 = this_0.i1v_1;
            if (this_17.u1t_1.j1s(type_5.m1t())) {
              var tmp_37 = type_5.m1t();
              var tmp_38 = this_17.v1t();
              var tmp_39 = 0;
              var tmp_40 = this_17.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_41 = fillArrayVal(Array(tmp_40), null);
              while (tmp_39 < tmp_40) {
                tmp_41[tmp_39] = null;
                tmp_39 = tmp_39 + 1 | 0;
              }
              this_17.u1t_1.h1s(tmp_37, new ComponentsHolder(tmp_38, type_5, tmp_41));
            }
            var tmp_42 = this_17.u1t_1.h1(type_5.m1t());
            var _destruct__k2r9zo_2 = (tmp_42 instanceof ComponentsHolder ? tmp_42 : THROW_CCE()).p1u(entity);
            var name_1 = _destruct__k2r9zo_2.em();
            var width_0 = _destruct__k2r9zo_2.fm();
            var height_0 = _destruct__k2r9zo_2.jt();
            var ninePatch = this.bfp_1.zek(name_1);
            var numQuads = ninePatch.p5l_1.l5m();
            // Inline function 'korlibs.korge.render.Companion.quadIndices' call
            Companion_getInstance_5();
            var indices = TEXTURED_ARRAY_quadIndices(numQuads);
            var tva = new TexturedVertexArray(imul(numQuads, 4), indices);
            var index_0 = {_v: 0};
            var viewBounds = RectangleInt.j3r(numberToInt(position.peo_1), numberToInt(position.qeo_1), numberToInt(width_0), numberToInt(height_0));
            ninePatch.p5l_1.p5m(viewBounds, VOID, ObjectRenderSystem$renderInternal$lambda(ninePatch, tva, index_0, rgba));
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_18 = ctx.a9n_1;
            var this_19 = this_18.j9n_1;
            if (!(this_19.e9n_1 === this_18)) {
              this_19.e9n_1 = this_18;
              this_19.o9o();
            }
            var tex = ctx.e9x(get_bmp(ninePatch.o5l_1));
            var blendMode = this.nb8_1;
            var vcount = tva.i9u_1;
            var icount = tva.j9u_1;
            var matrix = Companion_getInstance_8().a3m_1;
            $l$block_4: {
              // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
              var tex_0 = tex.m9r_1;
              this_18.b9u(icount, vcount);
              var pprogram = null == null ? Companion_getInstance_6().l9t_1 : null;
              if (this_18.q9u(tex_0, false, blendMode, pprogram)) {
                break $l$block_4;
              }
              this_18.t9t();
              if (!contains_0(this_18.z9n_1, tex_0)) {
                this_18.y9n_1 = 0;
                this_18.z9n_1[0] = tex_0;
              }
              this_18.a9o_1 = false;
              this_18.b9o_1 = blendMode;
              this_18.c9o_1 = pprogram;
            }
            this_18.n9u(tva, matrix, vcount, icount);
          }
        }
         while (inductionVariable < last);
      this_0.m1w_1 = false;
      this_0.h1w_1.v1w();
    } else {
      var origIterating = this_0.m1w_1;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>' call
          var entity_0 = entitiesForIteration.u1s_1[i_0];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_6 = Companion_getInstance_38();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_20 = this_0.i1v_1;
          if (this_20.u1t_1.j1s(type_6.m1t())) {
            var tmp_43 = type_6.m1t();
            var tmp_44 = this_20.v1t();
            var tmp_45 = 0;
            var tmp_46 = this_20.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_47 = fillArrayVal(Array(tmp_46), null);
            while (tmp_45 < tmp_46) {
              tmp_47[tmp_45] = null;
              tmp_45 = tmp_45 + 1 | 0;
            }
            this_20.u1t_1.h1s(tmp_43, new ComponentsHolder(tmp_44, type_6, tmp_47));
          }
          var tmp_48 = this_20.u1t_1.h1(type_6.m1t());
          var rgba_0 = (tmp_48 instanceof ComponentsHolder ? tmp_48 : THROW_CCE()).p1u(entity_0).lew();
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_7 = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_21 = this_0.i1v_1;
          if (this_21.u1t_1.j1s(type_7.m1t())) {
            var tmp_49 = type_7.m1t();
            var tmp_50 = this_21.v1t();
            var tmp_51 = 0;
            var tmp_52 = this_21.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_53 = fillArrayVal(Array(tmp_52), null);
            while (tmp_51 < tmp_52) {
              tmp_53[tmp_51] = null;
              tmp_51 = tmp_51 + 1 | 0;
            }
            this_21.u1t_1.h1s(tmp_49, new ComponentsHolder(tmp_50, type_7, tmp_53));
          }
          var tmp_54 = this_21.u1t_1.h1(type_7.m1t());
          var entityPosition_0 = (tmp_54 instanceof ComponentsHolder ? tmp_54 : THROW_CCE()).p1u(entity_0);
          var tmp_55;
          if (this_0.k1v(entity_0, ScreenCoordinatesTag_getInstance())) {
            tmp_55 = entityPosition_0;
          } else {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>' call
            tmp_55 = entityPosition_0.aev(this.yfo_1, camera);
          }
          var position_0 = tmp_55;
          if (this_0.k1v(entity_0, Companion_getInstance_43())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_8 = Companion_getInstance_43();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_22 = this_0.i1v_1;
            if (this_22.u1t_1.j1s(type_8.m1t())) {
              var tmp_56 = type_8.m1t();
              var tmp_57 = this_22.v1t();
              var tmp_58 = 0;
              var tmp_59 = this_22.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_60 = fillArrayVal(Array(tmp_59), null);
              while (tmp_58 < tmp_59) {
                tmp_60[tmp_58] = null;
                tmp_58 = tmp_58 + 1 | 0;
              }
              this_22.u1t_1.h1s(tmp_56, new ComponentsHolder(tmp_57, type_8, tmp_60));
            }
            var tmp_61 = this_22.u1t_1.h1(type_8.m1t());
            var _destruct__k2r9zo_3 = (tmp_61 instanceof ComponentsHolder ? tmp_61 : THROW_CCE()).p1u(entity_0);
            var name_2 = _destruct__k2r9zo_3.em();
            var anchorX_1 = _destruct__k2r9zo_3.fm();
            var anchorY_1 = _destruct__k2r9zo_3.jt();
            var animation_1 = _destruct__k2r9zo_3.zep();
            var frameIndex_1 = _destruct__k2r9zo_3.aeq();
            var imageFrame_1 = getImageFrame(this.bfp_1, name_2, animation_1, frameIndex_1);
            if (this_0.k1v(entity_0, Companion_getInstance_45())) {
              // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
              var type_9 = Companion_getInstance_45();
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_23 = this_0.i1v_1;
              if (this_23.u1t_1.j1s(type_9.m1t())) {
                var tmp_62 = type_9.m1t();
                var tmp_63 = this_23.v1t();
                var tmp_64 = 0;
                var tmp_65 = this_23.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_66 = fillArrayVal(Array(tmp_65), null);
                while (tmp_64 < tmp_65) {
                  tmp_66[tmp_64] = null;
                  tmp_64 = tmp_64 + 1 | 0;
                }
                this_23.u1t_1.h1s(tmp_62, new ComponentsHolder(tmp_63, type_9, tmp_66));
              }
              var tmp_67 = this_23.u1t_1.h1(type_9.m1t());
              var layerMap_0 = (tmp_67 instanceof ComponentsHolder ? tmp_67 : THROW_CCE()).p1u(entity_0).em();
              // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
              // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
              var this_24 = ctx.a9n_1;
              var this_25 = this_24.j9n_1;
              if (!(this_25.e9n_1 === this_24)) {
                this_25.e9n_1 = this_24;
                this_25.o9o();
              }
              var this_26 = imageFrame_1.s6l_1;
              var n_4 = 0;
              while (n_4 < this_26.g1()) {
                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var _unary__edvuaz_2 = n_4;
                n_4 = _unary__edvuaz_2 + 1 | 0;
                var layerData_1 = this_26.h1(_unary__edvuaz_2);
                var tmp0_elvis_lhs_0 = layerData_1.w6l_1.n6l_1;
                var layerName_0 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
                var tmp1_safe_receiver_0 = layerMap_0.e3(layerName_0);
                if (tmp1_safe_receiver_0 == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  this_24.q9o(ctx.p9o(layerData_1.f6m_1), position_0.peo_1 + layerData_1.x6l_1 - anchorX_1 + tmp1_safe_receiver_0.zey_1, position_0.qeo_1 + layerData_1.y6l_1 - anchorY_1 + tmp1_safe_receiver_0.aez_1, VOID, VOID, VOID, false, tmp1_safe_receiver_0.bez_1, VOID, null);
                }
              }
            } else {
              // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
              // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
              var this_27 = ctx.a9n_1;
              var this_28 = this_27.j9n_1;
              if (!(this_28.e9n_1 === this_27)) {
                this_28.e9n_1 = this_27;
                this_28.o9o();
              }
              var this_29 = imageFrame_1.s6l_1;
              var n_5 = 0;
              while (n_5 < this_29.g1()) {
                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var _unary__edvuaz_3 = n_5;
                n_5 = _unary__edvuaz_3 + 1 | 0;
                var layerData_2 = this_29.h1(_unary__edvuaz_3);
                var px_0 = position_0.peo_1 + position_0.reo_1 + layerData_2.x6l_1 - anchorX_1;
                var py_0 = position_0.qeo_1 + position_0.seo_1 + layerData_2.y6l_1 - anchorY_1;
                this_27.q9o(ctx.p9o(layerData_2.f6m_1), px_0, py_0, VOID, VOID, VOID, false, rgba_0, VOID, null);
              }
            }
          } else if (this_0.k1v(entity_0, Companion_getInstance_24())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_10 = Companion_getInstance_24();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_30 = this_0.i1v_1;
            if (this_30.u1t_1.j1s(type_10.m1t())) {
              var tmp_68 = type_10.m1t();
              var tmp_69 = this_30.v1t();
              var tmp_70 = 0;
              var tmp_71 = this_30.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_72 = fillArrayVal(Array(tmp_71), null);
              while (tmp_70 < tmp_71) {
                tmp_72[tmp_70] = null;
                tmp_70 = tmp_70 + 1 | 0;
              }
              this_30.u1t_1.h1s(tmp_68, new ComponentsHolder(tmp_69, type_10, tmp_72));
            }
            var tmp_73 = this_30.u1t_1.h1(type_10.m1t());
            var _destruct__k2r9zo_4 = (tmp_73 instanceof ComponentsHolder ? tmp_73 : THROW_CCE()).p1u(entity_0);
            var name_3 = _destruct__k2r9zo_4.em();
            var anchorX_2 = _destruct__k2r9zo_4.fm();
            var anchorY_2 = _destruct__k2r9zo_4.jt();
            var animation_2 = _destruct__k2r9zo_4.zep();
            var frameIndex_2 = _destruct__k2r9zo_4.aeq();
            var layerList_0 = _destruct__k2r9zo_4.beq();
            var imageFrame_2 = getImageFrame(this.bfp_1, name_3, animation_2, frameIndex_2);
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_31 = ctx.a9n_1;
            var this_32 = this_31.j9n_1;
            if (!(this_32.e9n_1 === this_31)) {
              this_32.e9n_1 = this_31;
              this_32.o9o();
            }
            var n_6 = 0;
            while (n_6 < layerList_0.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_1 = n_6;
              var layer_0 = layerList_0.h1(n_6);
              var image_0 = imageFrame_2.s6l_1.h1(index_1);
              this_31.q9o(ctx.p9o(image_0.f6m_1), position_0.peo_1 + image_0.x6l_1 - anchorX_2 + layer_0.neo_1.peo_1 + layer_0.neo_1.reo_1, position_0.qeo_1 + image_0.y6l_1 - anchorY_2 + layer_0.neo_1.qeo_1 + layer_0.neo_1.seo_1, VOID, VOID, VOID, false, layer_0.oeo_1.ueo_1, VOID, null);
              n_6 = n_6 + 1 | 0;
            }
          } else if (this_0.k1v(entity_0, Companion_getInstance_47())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_11 = Companion_getInstance_47();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_33 = this_0.i1v_1;
            if (this_33.u1t_1.j1s(type_11.m1t())) {
              var tmp_74 = type_11.m1t();
              var tmp_75 = this_33.v1t();
              var tmp_76 = 0;
              var tmp_77 = this_33.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_78 = fillArrayVal(Array(tmp_77), null);
              while (tmp_76 < tmp_77) {
                tmp_78[tmp_76] = null;
                tmp_76 = tmp_76 + 1 | 0;
              }
              this_33.u1t_1.h1s(tmp_74, new ComponentsHolder(tmp_75, type_11, tmp_78));
            }
            var tmp_79 = this_33.u1t_1.h1(type_11.m1t());
            var _destruct__k2r9zo_5 = (tmp_79 instanceof ComponentsHolder ? tmp_79 : THROW_CCE()).p1u(entity_0);
            var text_0 = _destruct__k2r9zo_5.em();
            var fontName_0 = _destruct__k2r9zo_5.fm();
            var textRangeStart_0 = _destruct__k2r9zo_5.jt();
            var textRangeEnd_0 = _destruct__k2r9zo_5.zep();
            var width_1 = _destruct__k2r9zo_5.aeq();
            var height_1 = _destruct__k2r9zo_5.lf0();
            var wordWrap_0 = _destruct__k2r9zo_5.mf0();
            var horizontalAlign_0 = _destruct__k2r9zo_5.nf0();
            var verticalAlign_0 = _destruct__k2r9zo_5.of0();
            var offset_0 = Vector2D.m3q(position_0.reo_1, position_0.seo_1);
            // Inline function 'korlibs.korge.render.renderCtx2d' call
            // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            var batcher_0 = ctx.a9n_1;
            if (!(ctx.e9n_1 === batcher_0)) {
              ctx.e9n_1 = batcher_0;
              ctx.o9o();
            }
            // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
            // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
            var context_0 = ctx.c9n_1;
            // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
            $l$block_9: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
              var old_0 = context_0.v9x_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
                $l$block_8: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
                  var oldBlendFactors_0 = context_0.w9x_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
                    $l$block_7: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
                      var multiplyColor_0 = context_0.x9x_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                        $l$block_6: {
                          // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                          var filtering_0 = context_0.y9x_1;
                          try {
                            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                            $l$block_5: {
                              // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                              var size_0 = context_0.t9x_1;
                              try {
                                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                                context_0.t9x_1 = Size2D.r3q(this.f3u(), this.g3u());
                                context_0.w9x_1 = this.sby();
                                context_0.x9x_1 = this.tby();
                                context_0.z9x(this.ube());
                                // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>' call
                                var n_7 = 0;
                                // Inline function 'korlibs.datastructure.iterators.fastForEach' call
                                var this_34 = place(RichTextData.v6v(text_0, this.bfp_1.bel(fontName_0)), Companion_getInstance_7().l3q(position_0.peo_1, position_0.qeo_1, width_1, height_1), wordWrap_0, false, null, null, null, new TextAlignment(horizontalAlign_0, verticalAlign_0), true);
                                var n_8 = 0;
                                while (n_8 < this_34.g1()) {
                                  // Inline function 'korlibs.korge.fleks.renderSystems.ObjectRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                                  var _unary__edvuaz_4 = n_8;
                                  n_8 = _unary__edvuaz_4 + 1 | 0;
                                  var it_0 = this_34.h1(_unary__edvuaz_4);
                                  var tmp_80 = get_lazyBitmap(it_0.c6w_1);
                                  // Inline function 'korlibs.math.geom.Vector2D.plus' call
                                  var this_35 = it_0.a6w_1;
                                  var tmp$ret$86 = Vector2D.y3k(this_35.r3i_1 + offset_0.r3i_1, this_35.s3i_1 + offset_0.s3i_1);
                                  drawText(context_0, it_0.z6v_1, tmp_80, it_0.b6w_1, tmp$ret$86, rgba_0, true, textRangeStart_0 - n_7 | 0, textRangeEnd_0 - n_7 | 0, false);
                                  n_7 = n_7 + it_0.z6v_1.length | 0;
                                }
                                break $l$block_5;
                              }finally {
                                context_0.t9x_1 = size_0;
                              }
                            }
                            break $l$block_6;
                          }finally {
                            context_0.y9x_1 = filtering_0;
                          }
                        }
                        break $l$block_7;
                      }finally {
                        context_0.x9x_1 = multiplyColor_0;
                      }
                    }
                    break $l$block_8;
                  }finally {
                    context_0.w9x_1 = oldBlendFactors_0;
                  }
                }
                break $l$block_9;
              }finally {
                context_0.v9x_1 = old_0;
              }
            }
          } else if (this_0.k1v(entity_0, Companion_getInstance_29())) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var type_12 = Companion_getInstance_29();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_36 = this_0.i1v_1;
            if (this_36.u1t_1.j1s(type_12.m1t())) {
              var tmp_81 = type_12.m1t();
              var tmp_82 = this_36.v1t();
              var tmp_83 = 0;
              var tmp_84 = this_36.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_85 = fillArrayVal(Array(tmp_84), null);
              while (tmp_83 < tmp_84) {
                tmp_85[tmp_83] = null;
                tmp_83 = tmp_83 + 1 | 0;
              }
              this_36.u1t_1.h1s(tmp_81, new ComponentsHolder(tmp_82, type_12, tmp_85));
            }
            var tmp_86 = this_36.u1t_1.h1(type_12.m1t());
            var _destruct__k2r9zo_6 = (tmp_86 instanceof ComponentsHolder ? tmp_86 : THROW_CCE()).p1u(entity_0);
            var name_4 = _destruct__k2r9zo_6.em();
            var width_2 = _destruct__k2r9zo_6.fm();
            var height_2 = _destruct__k2r9zo_6.jt();
            var ninePatch_0 = this.bfp_1.zek(name_4);
            var numQuads_0 = ninePatch_0.p5l_1.l5m();
            // Inline function 'korlibs.korge.render.Companion.quadIndices' call
            Companion_getInstance_5();
            var indices_0 = TEXTURED_ARRAY_quadIndices(numQuads_0);
            var tva_0 = new TexturedVertexArray(imul(numQuads_0, 4), indices_0);
            var index_2 = {_v: 0};
            var viewBounds_0 = RectangleInt.j3r(numberToInt(position_0.peo_1), numberToInt(position_0.qeo_1), numberToInt(width_2), numberToInt(height_2));
            ninePatch_0.p5l_1.p5m(viewBounds_0, VOID, ObjectRenderSystem$renderInternal$lambda_0(ninePatch_0, tva_0, index_2, rgba_0));
            // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
            // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
            var this_37 = ctx.a9n_1;
            var this_38 = this_37.j9n_1;
            if (!(this_38.e9n_1 === this_37)) {
              this_38.e9n_1 = this_37;
              this_38.o9o();
            }
            var tex_1 = ctx.e9x(get_bmp(ninePatch_0.o5l_1));
            var blendMode_0 = this.nb8_1;
            var vcount_0 = tva_0.i9u_1;
            var icount_0 = tva_0.j9u_1;
            var matrix_0 = Companion_getInstance_8().a3m_1;
            $l$block_10: {
              // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
              var tex_2 = tex_1.m9r_1;
              this_37.b9u(icount_0, vcount_0);
              var pprogram_0 = null == null ? Companion_getInstance_6().l9t_1 : null;
              if (this_37.q9u(tex_2, false, blendMode_0, pprogram_0)) {
                break $l$block_10;
              }
              this_37.t9t();
              if (!contains_0(this_37.z9n_1, tex_2)) {
                this_37.y9n_1 = 0;
                this_37.z9n_1[0] = tex_2;
              }
              this_37.a9o_1 = false;
              this_37.b9o_1 = blendMode_0;
              this_37.c9o_1 = pprogram_0;
            }
            this_37.n9u(tva_0, matrix_0, vcount_0, icount_0);
          }
        }
         while (inductionVariable_0 < last_0);
      this_0.m1w_1 = origIterating;
    }
  }
  pbt() {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    this.yfo_1;
    return Companion_getInstance_7().k3q(0, 0, AppConfig_getInstance().iev_1, AppConfig_getInstance().jev_1);
  }
}
class ParallaxRenderSystem extends View {
  static gfr(world, layerTag) {
    var $this = this.sc9();
    $this.dfr_1 = world;
    var tmp = $this;
    tmp.efr_1 = $this.dfr_1.p20(ParallaxRenderSystem$family$lambda(layerTag));
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.dfr_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.ffr_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    $this.mb8_1 = toString_0(layerTag);
    return $this;
  }
  sbt(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a9n_1;
    var this_1 = this_0.j9n_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    var this_2 = this.efr_1;
    var entitiesForIteration = this_2.u1y();
    var tmp;
    if (!this_2.h1w_1.t1v_1) {
      this_2.h1w_1.t1v_1 = true;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>' call
          var entity = entitiesForIteration.u1s_1[i];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_3 = this_2.i1v_1;
          if (this_3.u1t_1.j1s(type.m1t())) {
            var tmp_0 = type.m1t();
            var tmp_1 = this_3.v1t();
            var tmp_2 = 0;
            var tmp_3 = this_3.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_4 = fillArrayVal(Array(tmp_3), null);
            while (tmp_2 < tmp_3) {
              tmp_4[tmp_2] = null;
              tmp_2 = tmp_2 + 1 | 0;
            }
            this_3.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, type, tmp_4));
          }
          var tmp_5 = this_3.u1t_1.h1(type.m1t());
          var globalPositionComponent = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).p1u(entity);
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_0 = Companion_getInstance_35();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_4 = this_2.i1v_1;
          if (this_4.u1t_1.j1s(type_0.m1t())) {
            var tmp_6 = type_0.m1t();
            var tmp_7 = this_4.v1t();
            var tmp_8 = 0;
            var tmp_9 = this_4.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_10 = fillArrayVal(Array(tmp_9), null);
            while (tmp_8 < tmp_9) {
              tmp_10[tmp_8] = null;
              tmp_8 = tmp_8 + 1 | 0;
            }
            this_4.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
          }
          var tmp_11 = this_4.u1t_1.h1(type_0.m1t());
          var _destruct__k2r9zo = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(entity);
          var configName = _destruct__k2r9zo.em();
          var backgroundLayers = _destruct__k2r9zo.fm();
          var parallaxPlane = _destruct__k2r9zo.jt();
          var foregroundLayers = _destruct__k2r9zo.zep();
          var parallaxDataContainer = this.ffr_1.ael(configName);
          var parallaxMode = parallaxDataContainer.del_1.lek_1;
          var tmp0_safe_receiver = parallaxDataContainer.eel_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s6n_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c6n_1;
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s6l_1;
          if (tmp3_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n = 0;
            while (n < tmp3_safe_receiver.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index = n;
              var layer = tmp3_safe_receiver.h1(n);
              backgroundLayers.h1(index).het_1.peo_1 = wrap$default(this, backgroundLayers.h1(index).het_1.peo_1, layer.f3u());
              backgroundLayers.h1(index).het_1.qeo_1 = wrap$default(this, backgroundLayers.h1(index).het_1.qeo_1, layer.g3u());
              var localRgba = backgroundLayers.h1(index).iet_1.ueo_1;
              drawLayer(this, globalPositionComponent, backgroundLayers.h1(index).het_1, ensureNotNull(parallaxDataContainer.del_1.mek_1).h1(index), layer, localRgba, this_0, ctx);
              n = n + 1 | 0;
            }
          }
          var tmp4_safe_receiver = parallaxDataContainer.hel_1;
          var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.s6n_1;
          var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.c6n_1;
          var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.s6l_1;
          if (tmp7_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_0 = 0;
            while (n_0 < tmp7_safe_receiver.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_0 = n_0;
              var layer_0 = tmp7_safe_receiver.h1(n_0);
              var layerConfig = ensureNotNull(ensureNotNull(parallaxDataContainer.del_1.nek_1).rel_1).h1(index_0);
              var layerSize = parallaxMode.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_0.f3u() : layer_0.g3u();
              if (layerConfig.aem_1) {
                parallaxPlane.ret_1.i3(index_0, wrap$default(this, parallaxPlane.ret_1.h1(index_0), layerSize));
              }
              var localRgba_0 = parallaxPlane.pet_1.ueo_1;
              drawParallaxPlaneLayer(this, globalPositionComponent, parallaxPlane.oet_1, parallaxPlane.ret_1.h1(index_0), parallaxMode, layerConfig.aem_1, layer_0, localRgba_0, this_0, ctx);
              n_0 = n_0 + 1 | 0;
            }
          }
          var tmp8_safe_receiver = parallaxDataContainer.iel_1;
          var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.y6n_1;
          if (tmp9_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_1 = 0;
            while (n_1 < tmp9_safe_receiver.g1()) {
              $l$block: {
                // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var index_1 = n_1;
                var tmp0_elvis_lhs = tmp9_safe_receiver.h1(n_1).s6n_1.c6n_1.t6l_1;
                var tmp_12;
                if (tmp0_elvis_lhs == null) {
                  break $l$block;
                } else {
                  tmp_12 = tmp0_elvis_lhs;
                }
                var layer_1 = tmp_12;
                var layerSize_0 = parallaxMode.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_1.f3u() : layer_1.g3u();
                parallaxPlane.qet_1.i3(index_1, wrap$default(this, parallaxPlane.qet_1.h1(index_1), layerSize_0));
                var localRgba_1 = parallaxPlane.pet_1.ueo_1;
                drawParallaxPlaneLayer(this, globalPositionComponent, parallaxPlane.oet_1, parallaxPlane.qet_1.h1(index_1), parallaxMode, true, layer_1, localRgba_1, this_0, ctx);
              }
              n_1 = n_1 + 1 | 0;
            }
          }
          var tmp10_safe_receiver = parallaxDataContainer.gel_1;
          var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.s6n_1;
          var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.c6n_1;
          var tmp13_safe_receiver = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.s6l_1;
          if (tmp13_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_2 = 0;
            while (n_2 < tmp13_safe_receiver.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_2 = n_2;
              var layer_2 = tmp13_safe_receiver.h1(n_2);
              var layerConfig_0 = ensureNotNull(ensureNotNull(parallaxDataContainer.del_1.nek_1).qel_1).h1(index_2);
              var layerSize_1 = parallaxMode.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_2.f3u() : layer_2.g3u();
              if (layerConfig_0.aem_1) {
                parallaxPlane.set_1.i3(index_2, wrap$default(this, parallaxPlane.set_1.h1(index_2), layerSize_1));
              }
              var localRgba_2 = parallaxPlane.pet_1.ueo_1;
              drawParallaxPlaneLayer(this, globalPositionComponent, parallaxPlane.oet_1, parallaxPlane.set_1.h1(index_2), parallaxMode, layerConfig_0.aem_1, layer_2, localRgba_2, this_0, ctx);
              n_2 = n_2 + 1 | 0;
            }
          }
          var tmp14_safe_receiver = parallaxDataContainer.fel_1;
          var tmp15_safe_receiver = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.s6n_1;
          var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.c6n_1;
          var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.s6l_1;
          if (tmp17_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_3 = 0;
            while (n_3 < tmp17_safe_receiver.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_3 = n_3;
              var layer_3 = tmp17_safe_receiver.h1(n_3);
              foregroundLayers.h1(index_3).het_1.peo_1 = wrap$default(this, foregroundLayers.h1(index_3).het_1.peo_1, layer_3.f3u());
              foregroundLayers.h1(index_3).het_1.qeo_1 = wrap$default(this, foregroundLayers.h1(index_3).het_1.qeo_1, layer_3.g3u());
              var localRgba_3 = foregroundLayers.h1(index_3).iet_1.ueo_1;
              drawLayer(this, globalPositionComponent, foregroundLayers.h1(index_3).het_1, ensureNotNull(parallaxDataContainer.del_1.oek_1).h1(index_3), layer_3, localRgba_3, this_0, ctx);
              n_3 = n_3 + 1 | 0;
            }
          }
        }
         while (inductionVariable < last);
      this_2.m1w_1 = false;
      this_2.h1w_1.v1w();
      tmp = Unit_instance;
    } else {
      var origIterating = this_2.m1w_1;
      this_2.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>' call
          var entity_0 = entitiesForIteration.u1s_1[i_0];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_1 = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_5 = this_2.i1v_1;
          if (this_5.u1t_1.j1s(type_1.m1t())) {
            var tmp_13 = type_1.m1t();
            var tmp_14 = this_5.v1t();
            var tmp_15 = 0;
            var tmp_16 = this_5.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_17 = fillArrayVal(Array(tmp_16), null);
            while (tmp_15 < tmp_16) {
              tmp_17[tmp_15] = null;
              tmp_15 = tmp_15 + 1 | 0;
            }
            this_5.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, type_1, tmp_17));
          }
          var tmp_18 = this_5.u1t_1.h1(type_1.m1t());
          var globalPositionComponent_0 = (tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE()).p1u(entity_0);
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_2 = Companion_getInstance_35();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_6 = this_2.i1v_1;
          if (this_6.u1t_1.j1s(type_2.m1t())) {
            var tmp_19 = type_2.m1t();
            var tmp_20 = this_6.v1t();
            var tmp_21 = 0;
            var tmp_22 = this_6.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_23 = fillArrayVal(Array(tmp_22), null);
            while (tmp_21 < tmp_22) {
              tmp_23[tmp_21] = null;
              tmp_21 = tmp_21 + 1 | 0;
            }
            this_6.u1t_1.h1s(tmp_19, new ComponentsHolder(tmp_20, type_2, tmp_23));
          }
          var tmp_24 = this_6.u1t_1.h1(type_2.m1t());
          var _destruct__k2r9zo_0 = (tmp_24 instanceof ComponentsHolder ? tmp_24 : THROW_CCE()).p1u(entity_0);
          var configName_0 = _destruct__k2r9zo_0.em();
          var backgroundLayers_0 = _destruct__k2r9zo_0.fm();
          var parallaxPlane_0 = _destruct__k2r9zo_0.jt();
          var foregroundLayers_0 = _destruct__k2r9zo_0.zep();
          var parallaxDataContainer_0 = this.ffr_1.ael(configName_0);
          var parallaxMode_0 = parallaxDataContainer_0.del_1.lek_1;
          var tmp0_safe_receiver_0 = parallaxDataContainer_0.eel_1;
          var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.s6n_1;
          var tmp2_safe_receiver_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.c6n_1;
          var tmp3_safe_receiver_0 = tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.s6l_1;
          if (tmp3_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_4 = 0;
            while (n_4 < tmp3_safe_receiver_0.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_4 = n_4;
              var layer_4 = tmp3_safe_receiver_0.h1(n_4);
              backgroundLayers_0.h1(index_4).het_1.peo_1 = wrap$default(this, backgroundLayers_0.h1(index_4).het_1.peo_1, layer_4.f3u());
              backgroundLayers_0.h1(index_4).het_1.qeo_1 = wrap$default(this, backgroundLayers_0.h1(index_4).het_1.qeo_1, layer_4.g3u());
              var localRgba_4 = backgroundLayers_0.h1(index_4).iet_1.ueo_1;
              drawLayer(this, globalPositionComponent_0, backgroundLayers_0.h1(index_4).het_1, ensureNotNull(parallaxDataContainer_0.del_1.mek_1).h1(index_4), layer_4, localRgba_4, this_0, ctx);
              n_4 = n_4 + 1 | 0;
            }
          }
          var tmp4_safe_receiver_0 = parallaxDataContainer_0.hel_1;
          var tmp5_safe_receiver_0 = tmp4_safe_receiver_0 == null ? null : tmp4_safe_receiver_0.s6n_1;
          var tmp6_safe_receiver_0 = tmp5_safe_receiver_0 == null ? null : tmp5_safe_receiver_0.c6n_1;
          var tmp7_safe_receiver_0 = tmp6_safe_receiver_0 == null ? null : tmp6_safe_receiver_0.s6l_1;
          if (tmp7_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_5 = 0;
            while (n_5 < tmp7_safe_receiver_0.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_5 = n_5;
              var layer_5 = tmp7_safe_receiver_0.h1(n_5);
              var layerConfig_1 = ensureNotNull(ensureNotNull(parallaxDataContainer_0.del_1.nek_1).rel_1).h1(index_5);
              var layerSize_2 = parallaxMode_0.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_5.f3u() : layer_5.g3u();
              if (layerConfig_1.aem_1) {
                parallaxPlane_0.ret_1.i3(index_5, wrap$default(this, parallaxPlane_0.ret_1.h1(index_5), layerSize_2));
              }
              var localRgba_5 = parallaxPlane_0.pet_1.ueo_1;
              drawParallaxPlaneLayer(this, globalPositionComponent_0, parallaxPlane_0.oet_1, parallaxPlane_0.ret_1.h1(index_5), parallaxMode_0, layerConfig_1.aem_1, layer_5, localRgba_5, this_0, ctx);
              n_5 = n_5 + 1 | 0;
            }
          }
          var tmp8_safe_receiver_0 = parallaxDataContainer_0.iel_1;
          var tmp9_safe_receiver_0 = tmp8_safe_receiver_0 == null ? null : tmp8_safe_receiver_0.y6n_1;
          if (tmp9_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_6 = 0;
            while (n_6 < tmp9_safe_receiver_0.g1()) {
              $l$block_0: {
                // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
                var index_6 = n_6;
                var tmp0_elvis_lhs_0 = tmp9_safe_receiver_0.h1(n_6).s6n_1.c6n_1.t6l_1;
                var tmp_25;
                if (tmp0_elvis_lhs_0 == null) {
                  break $l$block_0;
                } else {
                  tmp_25 = tmp0_elvis_lhs_0;
                }
                var layer_6 = tmp_25;
                var layerSize_3 = parallaxMode_0.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_6.f3u() : layer_6.g3u();
                parallaxPlane_0.qet_1.i3(index_6, wrap$default(this, parallaxPlane_0.qet_1.h1(index_6), layerSize_3));
                var localRgba_6 = parallaxPlane_0.pet_1.ueo_1;
                drawParallaxPlaneLayer(this, globalPositionComponent_0, parallaxPlane_0.oet_1, parallaxPlane_0.qet_1.h1(index_6), parallaxMode_0, true, layer_6, localRgba_6, this_0, ctx);
              }
              n_6 = n_6 + 1 | 0;
            }
          }
          var tmp10_safe_receiver_0 = parallaxDataContainer_0.gel_1;
          var tmp11_safe_receiver_0 = tmp10_safe_receiver_0 == null ? null : tmp10_safe_receiver_0.s6n_1;
          var tmp12_safe_receiver_0 = tmp11_safe_receiver_0 == null ? null : tmp11_safe_receiver_0.c6n_1;
          var tmp13_safe_receiver_0 = tmp12_safe_receiver_0 == null ? null : tmp12_safe_receiver_0.s6l_1;
          if (tmp13_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_7 = 0;
            while (n_7 < tmp13_safe_receiver_0.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_7 = n_7;
              var layer_7 = tmp13_safe_receiver_0.h1(n_7);
              var layerConfig_2 = ensureNotNull(ensureNotNull(parallaxDataContainer_0.del_1.nek_1).qel_1).h1(index_7);
              var layerSize_4 = parallaxMode_0.equals(Mode_HORIZONTAL_PLANE_getInstance()) ? layer_7.f3u() : layer_7.g3u();
              if (layerConfig_2.aem_1) {
                parallaxPlane_0.set_1.i3(index_7, wrap$default(this, parallaxPlane_0.set_1.h1(index_7), layerSize_4));
              }
              var localRgba_7 = parallaxPlane_0.pet_1.ueo_1;
              drawParallaxPlaneLayer(this, globalPositionComponent_0, parallaxPlane_0.oet_1, parallaxPlane_0.set_1.h1(index_7), parallaxMode_0, layerConfig_2.aem_1, layer_7, localRgba_7, this_0, ctx);
              n_7 = n_7 + 1 | 0;
            }
          }
          var tmp14_safe_receiver_0 = parallaxDataContainer_0.fel_1;
          var tmp15_safe_receiver_0 = tmp14_safe_receiver_0 == null ? null : tmp14_safe_receiver_0.s6n_1;
          var tmp16_safe_receiver_0 = tmp15_safe_receiver_0 == null ? null : tmp15_safe_receiver_0.c6n_1;
          var tmp17_safe_receiver_0 = tmp16_safe_receiver_0 == null ? null : tmp16_safe_receiver_0.s6l_1;
          if (tmp17_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
            var n_8 = 0;
            while (n_8 < tmp17_safe_receiver_0.g1()) {
              // Inline function 'korlibs.korge.fleks.renderSystems.ParallaxRenderSystem.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
              var index_8 = n_8;
              var layer_8 = tmp17_safe_receiver_0.h1(n_8);
              foregroundLayers_0.h1(index_8).het_1.peo_1 = wrap$default(this, foregroundLayers_0.h1(index_8).het_1.peo_1, layer_8.f3u());
              foregroundLayers_0.h1(index_8).het_1.qeo_1 = wrap$default(this, foregroundLayers_0.h1(index_8).het_1.qeo_1, layer_8.g3u());
              var localRgba_8 = foregroundLayers_0.h1(index_8).iet_1.ueo_1;
              drawLayer(this, globalPositionComponent_0, foregroundLayers_0.h1(index_8).het_1, ensureNotNull(parallaxDataContainer_0.del_1.oek_1).h1(index_8), layer_8, localRgba_8, this_0, ctx);
              n_8 = n_8 + 1 | 0;
            }
          }
        }
         while (inductionVariable_0 < last_0);
      this_2.m1w_1 = origIterating;
      tmp = Unit_instance;
    }
  }
  pbt() {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    this.dfr_1;
    return Companion_getInstance_7().k3q(0, 0, AppConfig_getInstance().iev_1, AppConfig_getInstance().jev_1);
  }
}
class CameraSystem extends IteratingSystem {
  static hfr(worldToPixelRatio) {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(CameraSystem$_init_$lambda_ho8syf), VOID, VOID, EachFrame_instance);
    $this.oeu_1 = worldToPixelRatio;
    $this.peu_1 = 1.0 / $this.oeu_1;
    $this.qeu_1 = 0.05;
    $this.reu_1 = 0.0;
    $this.seu_1 = 0.0;
    $this.teu_1 = 0.0;
    $this.ueu_1 = 0.0;
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var followPosition = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var camera = getMainCamera(this.v1z_1);
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type_0 = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = this.i1v_1;
    if (this_1.u1t_1.j1s(type_0.m1t())) {
      var tmp_5 = type_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
    var cameraPosition = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(camera);
    var lastCameraPosX = cameraPosition.peo_1;
    var xDiff = followPosition.peo_1 - cameraPosition.peo_1;
    var yDiff = followPosition.qeo_1 - cameraPosition.qeo_1;
    var newCameraPositionX = cameraPosition.peo_1 + xDiff * this.qeu_1;
    var newCameraPositionY = cameraPosition.qeo_1 + yDiff * this.qeu_1;
    var leftBound = AppConfig_getInstance().kev_1 + this.oeu_1;
    var rightBound = this.seu_1 - AppConfig_getInstance().kev_1 - this.oeu_1;
    var topBound = AppConfig_getInstance().lev_1 + this.oeu_1;
    var bottomBound = this.reu_1 - AppConfig_getInstance().lev_1 - this.oeu_1;
    cameraPosition.peo_1 = newCameraPositionX < leftBound ? leftBound : newCameraPositionX > rightBound ? rightBound : newCameraPositionX;
    cameraPosition.qeo_1 = newCameraPositionY < topBound ? topBound : newCameraPositionY > bottomBound ? bottomBound : newCameraPositionY;
    var cameraDistX = cameraPosition.peo_1 - lastCameraPosX;
    var parallaxFamily = this.v1z_1.p20(CameraSystem$onTickEntity$lambda);
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var entitiesForIteration = parallaxFamily.u1y();
    if (!parallaxFamily.h1w_1.t1v_1) {
      parallaxFamily.h1w_1.t1v_1 = true;
      parallaxFamily.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.systems.CameraSystem.onTickEntity.<anonymous>' call
          var parallaxEntity = entitiesForIteration.u1s_1[i];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_1 = Companion_getInstance_28();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_2 = parallaxFamily.i1v_1;
          if (this_2.u1t_1.j1s(type_1.m1t())) {
            var tmp_11 = type_1.m1t();
            var tmp_12 = this_2.v1t();
            var tmp_13 = 0;
            var tmp_14 = this_2.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              tmp_15[tmp_13] = null;
              tmp_13 = tmp_13 + 1 | 0;
            }
            this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
          }
          var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
          var motion = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(parallaxEntity);
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_2 = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_3 = parallaxFamily.i1v_1;
          if (this_3.u1t_1.j1s(type_2.m1t())) {
            var tmp_17 = type_2.m1t();
            var tmp_18 = this_3.v1t();
            var tmp_19 = 0;
            var tmp_20 = this_3.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_21 = fillArrayVal(Array(tmp_20), null);
            while (tmp_19 < tmp_20) {
              tmp_21[tmp_19] = null;
              tmp_19 = tmp_19 + 1 | 0;
            }
            this_3.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, type_2, tmp_21));
          }
          var tmp_22 = this_3.u1t_1.h1(type_2.m1t());
          var position = (tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE()).p1u(parallaxEntity);
          var distanceInWorldUnits = cameraDistX * this.peu_1;
          motion.fer_1 = -distanceInWorldUnits / this.g20();
          var ratio = (cameraPosition.qeo_1 - AppConfig_getInstance().lev_1) / (this.reu_1 - AppConfig_getInstance().jev_1);
          var parallaxVerticalLength = AppConfig_getInstance().jev_1 - this.teu_1;
          var parallaxVerticalPosition = ratio * parallaxVerticalLength;
          position.qeo_1 = parallaxVerticalPosition - this.ueu_1;
        }
         while (inductionVariable < last);
      parallaxFamily.m1w_1 = false;
      parallaxFamily.h1w_1.v1w();
    } else {
      var origIterating = parallaxFamily.m1w_1;
      parallaxFamily.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'korlibs.korge.fleks.systems.CameraSystem.onTickEntity.<anonymous>' call
          var parallaxEntity_0 = entitiesForIteration.u1s_1[i_0];
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_3 = Companion_getInstance_28();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_4 = parallaxFamily.i1v_1;
          if (this_4.u1t_1.j1s(type_3.m1t())) {
            var tmp_23 = type_3.m1t();
            var tmp_24 = this_4.v1t();
            var tmp_25 = 0;
            var tmp_26 = this_4.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_27 = fillArrayVal(Array(tmp_26), null);
            while (tmp_25 < tmp_26) {
              tmp_27[tmp_25] = null;
              tmp_25 = tmp_25 + 1 | 0;
            }
            this_4.u1t_1.h1s(tmp_23, new ComponentsHolder(tmp_24, type_3, tmp_27));
          }
          var tmp_28 = this_4.u1t_1.h1(type_3.m1t());
          var motion_0 = (tmp_28 instanceof ComponentsHolder ? tmp_28 : THROW_CCE()).p1u(parallaxEntity_0);
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          var type_4 = Companion_getInstance_36();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_5 = parallaxFamily.i1v_1;
          if (this_5.u1t_1.j1s(type_4.m1t())) {
            var tmp_29 = type_4.m1t();
            var tmp_30 = this_5.v1t();
            var tmp_31 = 0;
            var tmp_32 = this_5.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_33 = fillArrayVal(Array(tmp_32), null);
            while (tmp_31 < tmp_32) {
              tmp_33[tmp_31] = null;
              tmp_31 = tmp_31 + 1 | 0;
            }
            this_5.u1t_1.h1s(tmp_29, new ComponentsHolder(tmp_30, type_4, tmp_33));
          }
          var tmp_34 = this_5.u1t_1.h1(type_4.m1t());
          var position_0 = (tmp_34 instanceof ComponentsHolder ? tmp_34 : THROW_CCE()).p1u(parallaxEntity_0);
          var distanceInWorldUnits_0 = cameraDistX * this.peu_1;
          motion_0.fer_1 = -distanceInWorldUnits_0 / this.g20();
          var ratio_0 = (cameraPosition.qeo_1 - AppConfig_getInstance().lev_1) / (this.reu_1 - AppConfig_getInstance().jev_1);
          var parallaxVerticalLength_0 = AppConfig_getInstance().jev_1 - this.teu_1;
          var parallaxVerticalPosition_0 = ratio_0 * parallaxVerticalLength_0;
          position_0.qeo_1 = parallaxVerticalPosition_0 - this.ueu_1;
        }
         while (inductionVariable_0 < last_0);
      parallaxFamily.m1w_1 = origIterating;
    }
  }
}
class EntityLinkSystem extends IteratingSystem {
  static rfr() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(EntityLinkSystem$_init_$lambda_8svj5t), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_19();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var _destruct__k2r9zo = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var linkedEntity = _destruct__k2r9zo.em();
    var moveWith = _destruct__k2r9zo.fm();
    if (moveWith) {
      if (this.k1v(entity, Companion_getInstance_36()) && this.k1v(linkedEntity, Companion_getInstance_36())) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_0 = Companion_getInstance_36();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_1 = this.i1v_1;
        if (this_1.u1t_1.j1s(type_0.m1t())) {
          var tmp_5 = type_0.m1t();
          var tmp_6 = this_1.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_1.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
        }
        var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
        var positionComponent = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_1 = Companion_getInstance_36();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this.i1v_1;
        if (this_2.u1t_1.j1s(type_1.m1t())) {
          var tmp_11 = type_1.m1t();
          var tmp_12 = this_2.v1t();
          var tmp_13 = 0;
          var tmp_14 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_15 = fillArrayVal(Array(tmp_14), null);
          while (tmp_13 < tmp_14) {
            tmp_15[tmp_13] = null;
            tmp_13 = tmp_13 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
        }
        var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
        var _destruct__k2r9zo_0 = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(linkedEntity);
        var x = _destruct__k2r9zo_0.em();
        var y = _destruct__k2r9zo_0.fm();
        positionComponent.peo_1 = x;
        positionComponent.qeo_1 = y;
      }
    }
  }
}
class EventSystem extends IteratingSystem {
  static cfs() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(EventSystem$_init_$lambda_zdyf36), VOID, VOID, EachFrame_instance);
    $this.bfs_1 = new BitArray();
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_20();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var _destruct__k2r9zo = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var publish = _destruct__k2r9zo.em();
    var subscribe = _destruct__k2r9zo.fm();
    var event = _destruct__k2r9zo.jt();
    var eventConfig = _destruct__k2r9zo.zep();
    if (publish) {
      this.bfs_1.p1s(event);
    }
    if (subscribe && this.bfs_1.h1(event)) {
      configureEntity(this.v1z_1, eventConfig, entity);
    }
  }
}
class LifeCycleSystem extends IteratingSystem {
  static qfs() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(LifeCycleSystem$_init_$lambda_od09iq), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_27();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var lifeCycle = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    if (lifeCycle.xeq_1 <= 0) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
      var type_0 = Companion_getInstance_18();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = this.i1v_1;
      if (this_1.u1t_1.j1s(type_0.m1t())) {
        var tmp_5 = type_0.m1t();
        var tmp_6 = this_1.v1t();
        var tmp_7 = 0;
        var tmp_8 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_9 = fillArrayVal(Array(tmp_8), null);
        while (tmp_7 < tmp_8) {
          tmp_9[tmp_7] = null;
          tmp_7 = tmp_7 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
      }
      var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
      var tmp0_safe_receiver = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).v1u(entity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ben_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = tmp1_safe_receiver.b1();
        while (tmp0_iterator.c1()) {
          var element = tmp0_iterator.d1();
          // Inline function 'korlibs.korge.fleks.systems.LifeCycleSystem.onTickEntity.<anonymous>' call
          this.v1z_1.o1u(element);
          debugPrint(this, element, 'sub');
        }
      }
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
      var type_1 = Companion_getInstance_24();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = this.i1v_1;
      if (this_2.u1t_1.j1s(type_1.m1t())) {
        var tmp_11 = type_1.m1t();
        var tmp_12 = this_2.v1t();
        var tmp_13 = 0;
        var tmp_14 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_15 = fillArrayVal(Array(tmp_14), null);
        while (tmp_13 < tmp_14) {
          tmp_15[tmp_13] = null;
          tmp_13 = tmp_13 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
      }
      var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
      var tmp2_safe_receiver = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).v1u(entity);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.qep_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = tmp3_safe_receiver.b1();
        while (tmp0_iterator_0.c1()) {
          var element_0 = tmp0_iterator_0.d1();
          // Inline function 'korlibs.korge.fleks.systems.LifeCycleSystem.onTickEntity.<anonymous>' call
          this.v1z_1.o1u(element_0.meo_1);
          debugPrint(this, element_0.meo_1, 'layer');
        }
      }
      this.v1z_1.o1u(entity);
      debugPrint(this, entity, 'base');
    }
  }
}
class ParallaxSystem extends IteratingSystem {
  static cft(worldToPixelRatio) {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(ParallaxSystem$_init_$lambda_lrn7iz), VOID, VOID, EachFrame_instance);
    $this.aft_1 = worldToPixelRatio;
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.v1z_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.bft_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_35();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var _destruct__k2r9zo = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var configName = _destruct__k2r9zo.em();
    var backgroundLayers = _destruct__k2r9zo.fm();
    var parallaxPlane = _destruct__k2r9zo.jt();
    var foregroundLayers = _destruct__k2r9zo.zep();
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type_0 = Companion_getInstance_28();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = this.i1v_1;
    if (this_1.u1t_1.j1s(type_0.m1t())) {
      var tmp_5 = type_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
    var _destruct__k2r9zo_0 = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
    var velocityX = _destruct__k2r9zo_0.jt();
    var velocityY = _destruct__k2r9zo_0.zep();
    var parallaxDataContainer = this.bft_1.ael(configName);
    var offset = parallaxDataContainer.del_1.kek_1;
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n = 0;
    while (n < backgroundLayers.g1()) {
      // Inline function 'korlibs.korge.fleks.systems.ParallaxSystem.onTickEntity.<anonymous>' call
      var index = n;
      var layer = backgroundLayers.h1(n);
      var speedFactor = ensureNotNull(parallaxDataContainer.del_1.mek_1).h1(index).wel_1;
      if (!(speedFactor == null)) {
        layer.het_1.peo_1 = speedFactor * velocityX * this.aft_1 * this.g20() + layer.het_1.peo_1;
        layer.het_1.qeo_1 = speedFactor * velocityY * this.aft_1 * this.g20() + layer.het_1.qeo_1;
      }
      n = n + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_2 = parallaxPlane.ret_1;
    var n_0 = 0;
    while (n_0 < this_2.g1()) {
      // Inline function 'korlibs.korge.fleks.systems.ParallaxSystem.onTickEntity.<anonymous>' call
      var index_0 = n_0;
      var position = this_2.h1(n_0);
      var plane = ensureNotNull(parallaxDataContainer.del_1.nek_1);
      var parallaxMode = parallaxDataContainer.del_1.lek_1;
      var texture = ensureNotNull(parallaxDataContainer.hel_1).s6n_1.c6n_1.s6l_1.h1(index_0);
      var attachTextureOffset = ensureNotNull(plane.rel_1).h1(index_0).bem_1 ? texture.g3u() : 0;
      if (parallaxMode.equals(Mode_HORIZONTAL_PLANE_getInstance())) {
        var lineIndex = (texture.y6l_1 - offset | 0) + attachTextureOffset | 0;
        var speedFactor_0 = plane.iem()[lineIndex];
        parallaxPlane.ret_1.i3(index_0, speedFactor_0 * velocityX * this.aft_1 * this.g20() + position);
      } else if (parallaxMode.equals(Mode_VERTICAL_PLANE_getInstance())) {
        var lineIndex_0 = (texture.x6l_1 - offset | 0) + attachTextureOffset | 0;
        var speedFactor_1 = plane.iem()[lineIndex_0];
        parallaxPlane.ret_1.i3(index_0, speedFactor_1 * velocityY * this.aft_1 * this.g20() + position);
      }
      n_0 = n_0 + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_3 = parallaxPlane.qet_1;
    var n_1 = 0;
    while (n_1 < this_3.g1()) {
      // Inline function 'korlibs.korge.fleks.systems.ParallaxSystem.onTickEntity.<anonymous>' call
      var index_1 = n_1;
      var position_0 = this_3.h1(n_1);
      var plane_0 = ensureNotNull(parallaxDataContainer.del_1.nek_1);
      var parallaxMode_0 = parallaxDataContainer.del_1.lek_1;
      if (parallaxMode_0.equals(Mode_HORIZONTAL_PLANE_getInstance())) {
        var lineIndex_1 = ensureNotNull(parallaxDataContainer.iel_1).y6n_1.h1(index_1).s6n_1.c6n_1.g6p() - offset | 0;
        var speedFactor_2 = plane_0.iem()[lineIndex_1];
        parallaxPlane.qet_1.i3(index_1, speedFactor_2 * velocityX * this.aft_1 * this.g20() + position_0);
      } else if (parallaxMode_0.equals(Mode_VERTICAL_PLANE_getInstance())) {
        var lineIndex_2 = ensureNotNull(parallaxDataContainer.iel_1).y6n_1.h1(index_1).s6n_1.c6n_1.f6p() - offset | 0;
        var speedFactor_3 = plane_0.iem()[lineIndex_2];
        parallaxPlane.qet_1.i3(index_1, speedFactor_3 * velocityY * this.aft_1 * this.g20() + position_0);
      }
      n_1 = n_1 + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_4 = parallaxPlane.set_1;
    var n_2 = 0;
    while (n_2 < this_4.g1()) {
      // Inline function 'korlibs.korge.fleks.systems.ParallaxSystem.onTickEntity.<anonymous>' call
      var index_2 = n_2;
      var position_1 = this_4.h1(n_2);
      var plane_1 = ensureNotNull(parallaxDataContainer.del_1.nek_1);
      var parallaxMode_1 = parallaxDataContainer.del_1.lek_1;
      var texture_0 = ensureNotNull(parallaxDataContainer.gel_1).s6n_1.c6n_1.s6l_1.h1(index_2);
      var attachTextureOffset_0 = ensureNotNull(plane_1.qel_1).h1(index_2).bem_1 ? texture_0.g3u() : 0;
      if (parallaxMode_1.equals(Mode_HORIZONTAL_PLANE_getInstance())) {
        var lineIndex_3 = (texture_0.y6l_1 - offset | 0) + attachTextureOffset_0 | 0;
        var speedFactor_4 = plane_1.iem()[lineIndex_3];
        parallaxPlane.set_1.i3(index_2, speedFactor_4 * velocityX * this.aft_1 * this.g20() + position_1);
      } else if (parallaxMode_1.equals(Mode_VERTICAL_PLANE_getInstance())) {
        var lineIndex_4 = (texture_0.x6l_1 - offset | 0) + attachTextureOffset_0 | 0;
        var speedFactor_5 = plane_1.iem()[lineIndex_4];
        parallaxPlane.set_1.i3(index_2, speedFactor_5 * velocityY * this.aft_1 * this.g20() + position_1);
      }
      n_2 = n_2 + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n_3 = 0;
    while (n_3 < foregroundLayers.g1()) {
      // Inline function 'korlibs.korge.fleks.systems.ParallaxSystem.onTickEntity.<anonymous>' call
      var index_3 = n_3;
      var layer_0 = foregroundLayers.h1(n_3);
      var tmp0_elvis_lhs = ensureNotNull(parallaxDataContainer.del_1.oek_1).h1(index_3).wel_1;
      var speedFactor_6 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var selfSpeedX = parallaxDataContainer.del_1.oek_1.h1(index_3).xel_1;
      var selfSpeedY = parallaxDataContainer.del_1.oek_1.h1(index_3).yel_1;
      layer_0.het_1.peo_1 = speedFactor_6 * velocityX * this.aft_1 * this.g20() + selfSpeedX * this.g20() + layer_0.het_1.peo_1;
      layer_0.het_1.qeo_1 = speedFactor_6 * velocityY * this.aft_1 * this.g20() + layer_0.het_1.qeo_1;
      n_3 = n_3 + 1 | 0;
    }
  }
}
class PositionSystem extends IteratingSystem {
  static mft() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(PositionSystem$_init_$lambda_vx7er1), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var positionComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    if (this.k1v(entity, Companion_getInstance_39()) && this.k1v(entity, Companion_getInstance_28())) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type_0 = Companion_getInstance_39();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = this.i1v_1;
      if (this_1.u1t_1.j1s(type_0.m1t())) {
        var tmp_5 = type_0.m1t();
        var tmp_6 = this_1.v1t();
        var tmp_7 = 0;
        var tmp_8 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_9 = fillArrayVal(Array(tmp_8), null);
        while (tmp_7 < tmp_8) {
          tmp_9[tmp_7] = null;
          tmp_7 = tmp_7 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
      }
      var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
      var rigidbody = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type_1 = Companion_getInstance_28();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = this.i1v_1;
      if (this_2.u1t_1.j1s(type_1.m1t())) {
        var tmp_11 = type_1.m1t();
        var tmp_12 = this_2.v1t();
        var tmp_13 = 0;
        var tmp_14 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_15 = fillArrayVal(Array(tmp_14), null);
        while (tmp_13 < tmp_14) {
          tmp_15[tmp_13] = null;
          tmp_13 = tmp_13 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
      }
      var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
      var _receiver__tnumb7 = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(entity);
      _receiver__tnumb7.eer_1 = _receiver__tnumb7.eer_1 + rigidbody.oew_1 * 9.81;
    }
    if (this.k1v(entity, Companion_getInstance_28())) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type_2 = Companion_getInstance_28();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_3 = this.i1v_1;
      if (this_3.u1t_1.j1s(type_2.m1t())) {
        var tmp_17 = type_2.m1t();
        var tmp_18 = this_3.v1t();
        var tmp_19 = 0;
        var tmp_20 = this_3.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_21 = fillArrayVal(Array(tmp_20), null);
        while (tmp_19 < tmp_20) {
          tmp_21[tmp_19] = null;
          tmp_19 = tmp_19 + 1 | 0;
        }
        this_3.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, type_2, tmp_21));
      }
      var tmp_22 = this_3.u1t_1.h1(type_2.m1t());
      var motion = (tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE()).p1u(entity);
      positionComponent.peo_1 = motion.der_1 * 0.5 * this.g20() * this.g20() + motion.fer_1 * this.g20() + positionComponent.peo_1;
      positionComponent.qeo_1 = motion.der_1 * 0.5 * this.g20() * this.g20() + motion.ger_1 * this.g20() + positionComponent.qeo_1;
    }
  }
}
class SnapshotSerializerSystem$loadGameState$slambda {
  constructor(this$0, $world) {
    this.afu_1 = this$0;
    this.bfu_1 = $world;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class SnapshotSerializerSystem$saveGameState$slambda {
  constructor($worldSnapshot) {
    this.hfu_1 = $worldSnapshot;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class SnapshotSerializerSystem extends IntervalSystem {
  static ifu(module_0) {
    var $this = this.y1z(new Fixed(1.0 / 30));
    var tmp = $this;
    tmp.sft_1 = $this.v1z_1.p20(SnapshotSerializerSystem$family$lambda);
    var tmp_0 = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = new SnapshotSerializer();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.snapshotSerializer.<anonymous>' call
    this_0.gfg('module', module_0);
    tmp_0.tft_1 = this_0;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.uft_1 = ArrayList.z();
    $this.vft_1 = 0;
    $this.wft_1 = true;
    $this.xft_1 = 900;
    $this.yft_1 = 0;
    $this.zft_1 = 0;
    return $this;
  }
  b20() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var snapshotCopy = LinkedHashMap.wc();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.v1z_1.t20().u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.onTick.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var entity = element.v1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.w1();
      // Inline function 'kotlin.collections.mutableListOf' call
      var componentsCopy = ArrayList.z();
      // Inline function 'kotlin.collections.mutableListOf' call
      var tagsCopy = ArrayList.z();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = value.a1w_1.b1();
      while (tmp0_iterator_0.c1()) {
        var element_0 = tmp0_iterator_0.d1();
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.onTick.<anonymous>.<anonymous>' call
        if (element_0 instanceof CloneableComponent)
          componentsCopy.h(element_0.z27());
        else {
          println("WARNING: Component '" + toString_0(element_0) + "' will not be serialized in SnapshotSerializerSystem! The component needs to derive from CloneableComponent<T>!");
        }
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = value.b1w_1.b1();
      while (tmp0_iterator_1.c1()) {
        var element_1 = tmp0_iterator_1.d1();
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.onTick.<anonymous>.<anonymous>' call
        tagsCopy.h(element_1);
      }
      // Inline function 'kotlin.collections.set' call
      var value_0 = wildcardSnapshotOf(componentsCopy, tagsCopy);
      snapshotCopy.k3(entity, value_0);
    }
    if (this.uft_1.g1() > this.xft_1) {
      if (this.yft_1 < 30) {
        this.uft_1.j3(this.zft_1);
        this.yft_1 = this.yft_1 + 1 | 0;
      } else {
        this.yft_1 = 0;
        this.xft_1 = this.xft_1 + 1 | 0;
        this.zft_1 = this.zft_1 + 1 | 0;
      }
    }
    this.uft_1.h(snapshotCopy);
    this.vft_1 = this.uft_1.g1() - 1 | 0;
  }
  jfu(world, coroutineContext) {
    launchImmediately(coroutineContext, SnapshotSerializerSystem$loadGameState$slambda_0(this, world));
  }
  kfu(world, coroutineContext) {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = this.tft_1.lfu(true);
    var value = world.t20();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(KtMap), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Entity), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Snapshot), arrayOf([]), false))]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var worldSnapshot = this_0.f1h(tmp$ret$1, value);
    launchImmediately(coroutineContext, SnapshotSerializerSystem$saveGameState$slambda_0(worldSnapshot));
  }
  mfu() {
    this.wft_1 = !this.wft_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.v1z_1.o20().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.triggerPause.<anonymous>' call
      if (element instanceof SoundSystem)
        element.xfu_1 = this.wft_1;
      else {
        element.f20(this.wft_1);
      }
    }
    if (this.wft_1) {
      while (this.vft_1 < this.uft_1.g1()) {
        removeLast(this.uft_1);
      }
      postProcessing(this);
    }
  }
  zfu(fast) {
    if (this.wft_1) {
      this.mfu();
    }
    if (!this.wft_1) {
      if (fast) {
        this.vft_1 = this.vft_1 - 4 | 0;
      } else {
        this.vft_1 = this.vft_1 - 1 | 0;
      }
      if (this.vft_1 < 0)
        this.vft_1 = 0;
      this.v1z_1.u20(this.uft_1.h1(this.vft_1));
    }
  }
  afv(fast) {
    if (this.wft_1) {
      this.mfu();
    }
    if (!this.wft_1) {
      if (fast) {
        this.vft_1 = this.vft_1 + 4 | 0;
      } else {
        this.vft_1 = this.vft_1 + 1 | 0;
      }
      if (this.vft_1 > (this.uft_1.g1() - 1 | 0))
        this.vft_1 = this.uft_1.g1() - 1 | 0;
      this.v1z_1.u20(this.uft_1.h1(this.vft_1));
    }
  }
}
class SoundSystem extends IteratingSystem {
  static bfv() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(SoundSystem$_init_$lambda_m13zl9), VOID, VOID, EachFrame_instance);
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.v1z_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.wfu_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    $this.xfu_1 = true;
    $this.yfu_1 = false;
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_41();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var soundComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var soundChannel = this.wfu_1.vek(soundComponent.eex_1);
    if (this.xfu_1 === this.yfu_1) {
      this.yfu_1 = !this.xfu_1;
      if (this.xfu_1) {
        if (soundComponent.jex_1) {
          // Inline function 'korlibs.time.milliseconds' call
          var this_1 = soundComponent.hex_1;
          var tmp$ret$4 = toDuration(this_1, DurationUnit_MILLISECONDS_getInstance());
          soundChannel.b7o(tmp$ret$4);
          soundChannel.q7o();
          println("SoundSystem: Resume sound '" + soundComponent.eex_1 + "' at position '" + soundComponent.hex_1 + "'");
        }
      } else {
        soundChannel.p7o();
        println("SoundSystem: Pause sound '" + soundComponent.eex_1 + "' at position '" + soundComponent.hex_1 + "'");
      }
    } else {
      if (soundComponent.gex_1) {
        if (!get_paused(soundChannel)) {
          soundChannel.p7o();
        }
        soundComponent.gex_1 = false;
        soundComponent.jex_1 = false;
      }
      if (soundComponent.fex_1) {
        soundChannel.u1w();
        soundChannel.q7o();
        println("SoundSystem: Start sound '" + soundComponent.eex_1 + "'");
        soundComponent.fex_1 = false;
        soundComponent.jex_1 = true;
      }
    }
    if (this.xfu_1)
      soundComponent.hex_1 = get_milliseconds(soundChannel.c7o());
  }
}
class SpawnerSystem extends IteratingSystem {
  static lfv() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(SpawnerSystem$_init_$lambda_8b96uk), VOID, VOID, new Fixed(1.0 / 60.0));
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_42();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var spawner = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    if (spawner.sex_1 > 0) {
      if (spawner.yex_1 <= 0) {
        var x = 0.0;
        var y = 0.0;
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
        var type_0 = Companion_getInstance_36();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_1 = this.i1v_1;
        if (this_1.u1t_1.j1s(type_0.m1t())) {
          var tmp_5 = type_0.m1t();
          var tmp_6 = this_1.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_1.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
        }
        var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
        var tmp0_safe_receiver = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).v1u(entity);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          x = tmp0_safe_receiver.peo_1 + tmp0_safe_receiver.reo_1;
          y = tmp0_safe_receiver.qeo_1 + tmp0_safe_receiver.seo_1;
        }
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
        var type_1 = Companion_getInstance_32();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this.i1v_1;
        if (this_2.u1t_1.j1s(type_1.m1t())) {
          var tmp_11 = type_1.m1t();
          var tmp_12 = this_2.v1t();
          var tmp_13 = 0;
          var tmp_14 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_15 = fillArrayVal(Array(tmp_14), null);
          while (tmp_13 < tmp_14) {
            tmp_15[tmp_13] = null;
            tmp_13 = tmp_13 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
        }
        var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
        var tmp1_safe_receiver = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).v1u(entity);
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
          var this_3 = tmp1_safe_receiver.zes_1;
          var type_2 = Companion_getInstance_43();
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_4 = this.i1v_1;
          if (this_4.u1t_1.j1s(type_2.m1t())) {
            var tmp_17 = type_2.m1t();
            var tmp_18 = this_4.v1t();
            var tmp_19 = 0;
            var tmp_20 = this_4.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_21 = fillArrayVal(Array(tmp_20), null);
            while (tmp_19 < tmp_20) {
              tmp_21[tmp_19] = null;
              tmp_19 = tmp_19 + 1 | 0;
            }
            this_4.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, type_2, tmp_21));
          }
          var tmp_22 = this_4.u1t_1.h1(type_2.m1t());
          var spriteComponent = (tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE()).v1u(this_3);
          var tmp1_elvis_lhs = spriteComponent == null ? null : spriteComponent.mey_1;
          var currentFrameIndex = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
          var tmp3_elvis_lhs = spriteComponent == null ? null : spriteComponent.ley_1;
          var animationName = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
          var tmp4_safe_receiver = tmp1_safe_receiver.aet_1.e3(animationName);
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.h1(currentFrameIndex);
          var tmp_23;
          if (tmp5_elvis_lhs == null) {
            var message = 'SpawnerSystem: Cannot get offset by frame index (entity: ' + entity.m1u_1 + ", animationName: '" + animationName + "', currentFrameIndex: " + currentFrameIndex + ')';
            throw IllegalStateException.h5(toString_0(message));
          } else {
            tmp_23 = tmp5_elvis_lhs;
          }
          var offset = tmp_23;
          x = x + offset.qes_1;
          y = y + offset.res_1;
        }
        var inductionVariable = 0;
        var last = spawner.rex_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var xx = x;
            var yy = y;
            var tmp_24;
            if (spawner.vex_1.equals(Companion_getInstance_4().x1s_1)) {
              // Inline function 'com.github.quillraven.fleks.World.entity' call
              // Inline function 'com.github.quillraven.fleks.EntityService.create' call
              var this_5 = this.v1z_1.a1u_1;
              // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
              var entity_0 = this_5.m1v_1.a1x();
              if (entity_0.m1u_1 >= this_5.o1v_1.f1s_1) {
                this_5.o1v_1.h1s(entity_0.m1u_1, new BitArray(64));
              }
              var prevCreateId = this_5.q1v_1;
              this_5.q1v_1 = entity_0.m1u_1;
              // Inline function 'korlibs.korge.fleks.systems.SpawnerSystem.onTickEntity.<anonymous>' call
              this_5.p1v_1;
              this_5.q1v_1 = prevCreateId;
              var compMask = this_5.o1v_1.h1(entity_0.m1u_1);
              // Inline function 'kotlin.collections.forEach' call
              var indexedObject = this_5.l1v_1.b1u_1;
              var inductionVariable_0 = 0;
              var last_0 = indexedObject.length;
              while (inductionVariable_0 < last_0) {
                var element = indexedObject[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
                element.w1y(entity_0, compMask);
              }
              var tmp0_safe_receiver_0 = this_5.v1v_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else
                tmp0_safe_receiver_0(this_5.l1v_1, entity_0);
              tmp_24 = entity_0;
            } else {
              tmp_24 = spawner.vex_1;
            }
            var newEntity = tmp_24;
            if (!(spawner.uex_1 === 0.0)) {
              xx = xx + random_0(rangeTo(-spawner.uex_1, spawner.uex_1));
              yy = yy + random_0(rangeTo(-spawner.uex_1, spawner.uex_1));
            }
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
            $l$block: {
              // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
              var this_6 = this.i1v_1.v1t().a1u_1;
              var skipFamilyNotify = this_6.s1v_1 === newEntity.m1u_1 || this_6.q1v_1 === newEntity.m1u_1;
              var prevUpdateId = this_6.s1v_1;
              this_6.s1v_1 = newEntity.m1u_1;
              // Inline function 'korlibs.korge.fleks.systems.SpawnerSystem.onTickEntity.<anonymous>' call
              // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
              var this_7 = this_6.r1v_1;
              var component = PositionComponent.teo(xx, yy);
              var compType = component.q1t();
              this_7.f1v_1.h1(newEntity.m1u_1).p1s(compType.m1t());
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_8 = this_7.i1v_1;
              if (this_8.u1t_1.j1s(compType.m1t())) {
                var tmp_25 = compType.m1t();
                var tmp_26 = this_8.v1t();
                var tmp_27 = 0;
                var tmp_28 = this_8.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_29 = fillArrayVal(Array(tmp_28), null);
                while (tmp_27 < tmp_28) {
                  tmp_29[tmp_27] = null;
                  tmp_27 = tmp_27 + 1 | 0;
                }
                this_8.u1t_1.h1s(tmp_25, new ComponentsHolder(tmp_26, compType, tmp_29));
              }
              var tmp_30 = this_8.u1t_1.h1(compType.m1t());
              var holder = tmp_30 instanceof ComponentsHolder ? tmp_30 : THROW_CCE();
              holder.l1u(newEntity, component);
              this_6.s1v_1 = prevUpdateId;
              if (skipFamilyNotify) {
                break $l$block;
              }
              var compMask_0 = this_6.o1v_1.h1(newEntity.m1u_1);
              // Inline function 'kotlin.collections.forEach' call
              var indexedObject_0 = this_6.l1v_1.b1u_1;
              var inductionVariable_1 = 0;
              var last_1 = indexedObject_0.length;
              while (inductionVariable_1 < last_1) {
                var element_0 = indexedObject_0[inductionVariable_1];
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
                element_0.p1w(newEntity, compMask_0);
              }
            }
            configureEntity(this.v1z_1, spawner.wex_1, newEntity);
          }
           while (inductionVariable < last);
        spawner.zex_1 = spawner.zex_1 + spawner.rex_1 | 0;
        spawner.yex_1 = spawner.sex_1;
        if (!(spawner.tex_1 === 0)) {
          var tmp_31 = spawner;
          var tmp_32 = spawner.yex_1;
          // Inline function 'kotlin.ranges.random' call
          var this_9 = numberRangeToNumber(-spawner.tex_1 | 0, spawner.tex_1);
          tmp_31.yex_1 = tmp_32 + random(this_9, Default_getInstance()) | 0;
        }
      } else {
        spawner.yex_1 = spawner.yex_1 - 1 | 0;
      }
    }
    if (spawner.xex_1 > 0 && spawner.zex_1 >= spawner.xex_1) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_10 = this.i1v_1.v1t().a1u_1;
        var skipFamilyNotify_0 = this_10.s1v_1 === entity.m1u_1 || this_10.q1v_1 === entity.m1u_1;
        var prevUpdateId_0 = this_10.s1v_1;
        this_10.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.SpawnerSystem.onTickEntity.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        var this_11 = this_10.r1v_1;
        var type_3 = Companion_getInstance_42();
        this_11.f1v_1.h1(entity.m1u_1).q1s(type_3.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_12 = this_11.i1v_1;
        if (this_12.u1t_1.j1s(type_3.m1t())) {
          var tmp_33 = type_3.m1t();
          var tmp_34 = this_12.v1t();
          var tmp_35 = 0;
          var tmp_36 = this_12.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_37 = fillArrayVal(Array(tmp_36), null);
          while (tmp_35 < tmp_36) {
            tmp_37[tmp_35] = null;
            tmp_35 = tmp_35 + 1 | 0;
          }
          this_12.u1t_1.h1s(tmp_33, new ComponentsHolder(tmp_34, type_3, tmp_37));
        }
        var tmp_38 = this_12.u1t_1.h1(type_3.m1t());
        (tmp_38 instanceof ComponentsHolder ? tmp_38 : THROW_CCE()).o1u(entity);
        this_10.s1v_1 = prevUpdateId_0;
        if (skipFamilyNotify_0) {
          break $l$block_0;
        }
        var compMask_1 = this_10.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_1 = this_10.l1v_1.b1u_1;
        var inductionVariable_2 = 0;
        var last_2 = indexedObject_1.length;
        while (inductionVariable_2 < last_2) {
          var element_1 = indexedObject_1[inductionVariable_2];
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element_1.p1w(entity, compMask_1);
        }
      }
    }
  }
}
class SpriteLayersSystem extends IteratingSystem {
  static vfv() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(SpriteLayersSystem$_init_$lambda_ej8h91), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_45();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var layerMap = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity).em();
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type_0 = Companion_getInstance_46();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = this.i1v_1;
    if (this_1.u1t_1.j1s(type_0.m1t())) {
      var tmp_5 = type_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
    var _destruct__k2r9zo = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
    var offVariance = _destruct__k2r9zo.em();
    var onVariance = _destruct__k2r9zo.fm();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = layerMap.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.systems.SpriteLayersSystem.onTickEntity.<anonymous>' call
      // Inline function 'kotlin.collections.component2' call
      var property = element.w1();
      var tmp_11;
      if (property.dez()) {
        tmp_11 = random_0(rangeTo(0.0, 1.0)) >= offVariance;
      } else {
        tmp_11 = random_0(rangeTo(0.0, 1.0)) <= onVariance;
      }
      property.fez(tmp_11);
    }
  }
}
class SpriteSystem extends IteratingSystem {
  static gfw() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(SpriteSystem$_init_$lambda_469gc7), VOID, VOID, EachFrame_instance);
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.v1z_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.ffw_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_43();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var spriteComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    if (spriteComponent.ney_1) {
      spriteComponent.rey_1 = spriteComponent.rey_1 - this.g20();
      if (spriteComponent.rey_1 <= 0.0) {
        var imageAnimation = getImageAnimation(this.ffw_1, spriteComponent.iey_1, spriteComponent.ley_1);
        var numFrames = imageAnimation.y6m_1.g1();
        spriteComponent.mey_1 = umod(spriteComponent.mey_1 + spriteComponent.qey_1 | 0, numFrames);
        if (spriteComponent.qey_1 === 0) {
          spriteComponent.ney_1 = false;
          if (spriteComponent.pey_1) {
            this.v1z_1.o1u(entity);
          }
        }
        var frame = imageAnimation.y6m_1.h1(spriteComponent.mey_1);
        spriteComponent.rey_1 = get_seconds(frame.h6p());
        var tmp_5 = spriteComponent;
        var tmp0_subject = spriteComponent.oey_1;
        var tmp_6;
        switch (tmp0_subject == null ? -1 : tmp0_subject.p3_1) {
          case 2:
            tmp_6 = 1;
            break;
          case 3:
            tmp_6 = -1;
            break;
          case 4:
            var tmp_7;
            var containsArg = spriteComponent.mey_1 + spriteComponent.qey_1 | 0;
            if (!(0 <= containsArg ? containsArg < numFrames : false)) {
              tmp_7 = -spriteComponent.qey_1 | 0;
            } else {
              tmp_7 = spriteComponent.qey_1;
            }

            tmp_6 = tmp_7;
            break;
          case 0:
            tmp_6 = spriteComponent.mey_1 < (numFrames - 1 | 0) ? 1 : 0;
            break;
          case 1:
            tmp_6 = spriteComponent.mey_1 === 0 ? 0 : -1;
            break;
          case -1:
            println('WARNING -- SpriteAnimationSystem: direction in SpriteAnimationComponent shall not be null!');
            tmp_6 = 0;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_5.qey_1 = tmp_6;
      }
    }
  }
}
class TouchInputSystem extends IteratingSystem {
  static xfw() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(TouchInputSystem$_init_$lambda_ngtbe9), VOID, VOID, EachFrame_instance);
    $this.qfw_1 = -1.0;
    $this.rfw_1 = -1.0;
    $this.sfw_1 = false;
    $this.tfw_1 = -1.0;
    $this.ufw_1 = -1.0;
    $this.vfw_1 = false;
    $this.wfw_1 = false;
    return $this;
  }
  yfw(x, y) {
    this.qfw_1 = x;
    this.rfw_1 = y;
    this.tfw_1 = x;
    this.ufw_1 = y;
    this.wfw_1 = true;
  }
  zfw(x, y) {
    if (this.wfw_1) {
      this.tfw_1 = x;
      this.ufw_1 = y;
    }
  }
  afx(x, y) {
    this.tfw_1 = x;
    this.ufw_1 = y;
    this.vfw_1 = true;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_49();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var inputTouch = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    if (inputTouch.yf0_1) {
      var tmp_5;
      if (this.vfw_1) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_0 = Companion_getInstance_36();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_1 = this.i1v_1;
        if (this_1.u1t_1.j1s(type_0.m1t())) {
          var tmp_6 = type_0.m1t();
          var tmp_7 = this_1.v1t();
          var tmp_8 = 0;
          var tmp_9 = this_1.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_10 = fillArrayVal(Array(tmp_9), null);
          while (tmp_8 < tmp_9) {
            tmp_10[tmp_8] = null;
            tmp_8 = tmp_8 + 1 | 0;
          }
          this_1.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
        }
        var tmp_11 = this_1.u1t_1.h1(type_0.m1t());
        var positionComponent = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(entity);
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_1 = Companion_getInstance_40();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this.i1v_1;
        if (this_2.u1t_1.j1s(type_1.m1t())) {
          var tmp_12 = type_1.m1t();
          var tmp_13 = this_2.v1t();
          var tmp_14 = 0;
          var tmp_15 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_16 = fillArrayVal(Array(tmp_15), null);
          while (tmp_14 < tmp_15) {
            tmp_16[tmp_14] = null;
            tmp_14 = tmp_14 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_12, new ComponentsHolder(tmp_13, type_1, tmp_16));
        }
        var tmp_17 = this_2.u1t_1.h1(type_1.m1t());
        var sizeComponent = (tmp_17 instanceof ComponentsHolder ? tmp_17 : THROW_CCE()).p1u(entity);
        tmp_5 = checkTouchInputInsideBounds(this, positionComponent.peo_1, positionComponent.qeo_1, positionComponent.peo_1 + sizeComponent.xew_1, positionComponent.qeo_1 + sizeComponent.yew_1);
      } else if (this.wfw_1 && inputTouch.cf1_1) {
        tmp_5 = true;
      } else {
        tmp_5 = false;
      }
      var touched = tmp_5;
      if (touched) {
        if (inputTouch.bf1_1) {
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
          var this_3 = inputTouch.zf0_1;
          $l$block: {
            // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
            var this_4 = this.i1v_1.v1t().a1u_1;
            var skipFamilyNotify = this_4.s1v_1 === this_3.m1u_1 || this_4.q1v_1 === this_3.m1u_1;
            var prevUpdateId = this_4.s1v_1;
            this_4.s1v_1 = this_3.m1u_1;
            // Inline function 'korlibs.korge.fleks.systems.TouchInputSystem.onTickEntity.<anonymous>' call
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            var this_5 = this_4.r1v_1;
            var type_2 = Companion_getInstance_36();
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_6 = this_5.i1v_1;
            if (this_6.u1t_1.j1s(type_2.m1t())) {
              var tmp_18 = type_2.m1t();
              var tmp_19 = this_6.v1t();
              var tmp_20 = 0;
              var tmp_21 = this_6.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_22 = fillArrayVal(Array(tmp_21), null);
              while (tmp_20 < tmp_21) {
                tmp_22[tmp_20] = null;
                tmp_20 = tmp_20 + 1 | 0;
              }
              this_6.u1t_1.h1s(tmp_18, new ComponentsHolder(tmp_19, type_2, tmp_22));
            }
            var tmp_23 = this_6.u1t_1.h1(type_2.m1t());
            var position = (tmp_23 instanceof ComponentsHolder ? tmp_23 : THROW_CCE()).p1u(this_3);
            position.peo_1 = this.tfw_1;
            position.qeo_1 = this.ufw_1;
            this_4.s1v_1 = prevUpdateId;
            if (skipFamilyNotify) {
              break $l$block;
            }
            var compMask = this_4.o1v_1.h1(this_3.m1u_1);
            // Inline function 'kotlin.collections.forEach' call
            var indexedObject = this_4.l1v_1.b1u_1;
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var element = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
              element.p1w(this_3, compMask);
            }
          }
        }
        execute(this.v1z_1, inputTouch.af1_1, inputTouch.zf0_1);
      }
    }
  }
  k20() {
    super.k20();
    if (this.vfw_1) {
      this.wfw_1 = false;
      this.vfw_1 = false;
    }
  }
}
class TweenRgbaSystem extends IteratingSystem {
  static xfx() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenRgbaSystem$_init_$lambda_tdafcz), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_38();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var rgbaComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty(this, entity, Companion_getInstance_50().qf1_1, alpha$factory(rgbaComponent));
    updateProperty_0(this, entity, Companion_getInstance_50().rf1_1, tint$factory(rgbaComponent));
  }
}
class TweenPositionSystem extends IteratingSystem {
  static hfy() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenPositionSystem$_init_$lambda_mcomd4), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_36();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var positionComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty(this, entity, Companion_getInstance_50().nf1_1, x$factory(positionComponent));
    updateProperty(this, entity, Companion_getInstance_50().of1_1, y$factory(positionComponent));
    updateProperty(this, entity, Companion_getInstance_50().lf1_1, offsetX$factory(positionComponent));
    updateProperty(this, entity, Companion_getInstance_50().mf1_1, offsetY$factory(positionComponent));
  }
}
class TweenMotionSystem extends IteratingSystem {
  static rfy() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenMotionSystem$_init_$lambda_joef45), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_28();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var motionComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty(this, entity, Companion_getInstance_50().pf1_1, velocityX$factory(motionComponent));
  }
}
class TweenSpawnerSystem extends IteratingSystem {
  static bfz() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenSpawnerSystem$_init_$lambda_uy5933), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_42();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var spawnerComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty_1(this, entity, Companion_getInstance_50().tf1_1, numberOfObjects$factory(spawnerComponent));
    var tmp_5 = Companion_getInstance_50().sf1_1;
    var tmp_6 = interval$factory(spawnerComponent);
    updateProperty_1(this, entity, tmp_5, tmp_6, TweenSpawnerSystem$onTickEntity$lambda(spawnerComponent));
    updateProperty_1(this, entity, Companion_getInstance_50().vf1_1, timeVariation$factory(spawnerComponent));
    updateProperty(this, entity, Companion_getInstance_50().uf1_1, positionVariation$factory(spawnerComponent));
  }
}
class TweenSpriteSystem extends IteratingSystem {
  static mfz() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(TweenSpriteSystem$_init_$lambda_3q3dlg), VOID, VOID, EachFrame_instance);
    var tmp_0 = $this;
    // Inline function 'com.github.quillraven.fleks.World.inject' call
    var name = 'AssetStore';
    var tmp1_elvis_lhs = $this.v1z_1.y1t_1.e3(name);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      throw FleksNoSuchInjectableException.f1x(name);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var injectable = tmp_1;
    injectable.p21_1 = true;
    var tmp_2 = injectable.o21_1;
    tmp_0.lfz_1 = tmp_2 instanceof AssetStore ? tmp_2 : THROW_CCE();
    return $this;
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_43();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var spriteComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    var tmp_5 = Companion_getInstance_50().wf1_1;
    var tmp_6 = animation$factory(spriteComponent);
    updateProperty_2(this, entity, tmp_5, tmp_6, TweenSpriteSystem$onTickEntity$lambda(spriteComponent, this));
    var tmp_7 = Companion_getInstance_50().xf1_1;
    var tmp_8 = direction$factory(spriteComponent);
    updateProperty_3(this, entity, tmp_7, tmp_8, TweenSpriteSystem$onTickEntity$lambda_0(spriteComponent, this));
    var tmp_9 = Companion_getInstance_50().zf1_1;
    var tmp_10 = running$factory(spriteComponent);
    updateProperty_4(this, entity, tmp_9, tmp_10, TweenSpriteSystem$onTickEntity$lambda_1(spriteComponent));
    updateProperty_4(this, entity, Companion_getInstance_50().yf1_1, destroyOnAnimationFinished$factory(spriteComponent));
  }
}
class TweenSwitchLayerVisibilitySystem extends IteratingSystem {
  static wfz() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenSwitchLayerVisibilitySystem$_init_$lambda_lxlimg), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_46();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var visibilityComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty(this, entity, Companion_getInstance_50().bf2_1, offVariance$factory(visibilityComponent));
    updateProperty(this, entity, Companion_getInstance_50().af2_1, onVariance$factory(visibilityComponent));
  }
}
class TweenSoundSystem extends IteratingSystem {
  static gg0() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenSoundSystem$_init_$lambda_x8dioo), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_41();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var sound = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty_4(this, entity, Companion_getInstance_50().cf2_1, startTrigger$factory(sound));
    updateProperty_4(this, entity, Companion_getInstance_50().df2_1, stopTrigger$factory(sound));
    updateProperty_5(this, entity, Companion_getInstance_50().ef2_1, position$factory(sound));
    updateProperty_5(this, entity, Companion_getInstance_50().ff2_1, volume$factory(sound));
  }
}
class TweenTextFieldSystem extends IteratingSystem {
  static qg0() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenTextFieldSystem$_init_$lambda_xtma1y), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_47();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var textFieldComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty_6(this, entity, Companion_getInstance_50().gf2_1, text$factory(textFieldComponent));
    updateProperty_1(this, entity, Companion_getInstance_50().hf2_1, textRangeStart$factory(textFieldComponent));
    updateProperty_1(this, entity, Companion_getInstance_50().if2_1, textRangeEnd$factory(textFieldComponent));
  }
}
class TweenEventSystem extends IteratingSystem {
  static bg1() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(TweenEventSystem$_init_$lambda_ofw3sj), VOID, VOID, EachFrame_instance);
    $this.ag1_1 = new BitArray();
    return $this;
  }
  c20(entity) {
    if (this.k1v(entity, Companion_getInstance_50().jf2_1)) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type = Companion_getInstance_50().jf2_1;
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_0 = this.i1v_1;
      if (this_0.u1t_1.j1s(type.m1t())) {
        var tmp = type.m1t();
        var tmp_0 = this_0.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_0.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
      }
      var tmp_4 = this_0.u1t_1.h1(type.m1t());
      var event = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity).jt();
      this.ag1_1.p1s(typeof event === 'number' ? event : THROW_CCE());
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = this.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.TweenEventSystem.onTickEntity.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        var this_2 = this_1.r1v_1;
        var type_0 = Companion_getInstance_50().jf2_1;
        this_2.f1v_1.h1(entity.m1u_1).q1s(type_0.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_3 = this_2.i1v_1;
        if (this_3.u1t_1.j1s(type_0.m1t())) {
          var tmp_5 = type_0.m1t();
          var tmp_6 = this_3.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_3.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_3.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
        }
        var tmp_10 = this_3.u1t_1.h1(type_0.m1t());
        (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    } else if (this.k1v(entity, Companion_getInstance_50().kf2_1)) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type_1 = Companion_getInstance_50().kf2_1;
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_4 = this.i1v_1;
      if (this_4.u1t_1.j1s(type_1.m1t())) {
        var tmp_11 = type_1.m1t();
        var tmp_12 = this_4.v1t();
        var tmp_13 = 0;
        var tmp_14 = this_4.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_15 = fillArrayVal(Array(tmp_14), null);
        while (tmp_13 < tmp_14) {
          tmp_15[tmp_13] = null;
          tmp_13 = tmp_13 + 1 | 0;
        }
        this_4.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
      }
      var tmp_16 = this_4.u1t_1.h1(type_1.m1t());
      var event_0 = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(entity).jt();
      this.ag1_1.q1s(typeof event_0 === 'number' ? event_0 : THROW_CCE());
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_5 = this.i1v_1.v1t().a1u_1;
        var skipFamilyNotify_0 = this_5.s1v_1 === entity.m1u_1 || this_5.q1v_1 === entity.m1u_1;
        var prevUpdateId_0 = this_5.s1v_1;
        this_5.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.TweenEventSystem.onTickEntity.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        var this_6 = this_5.r1v_1;
        var type_2 = Companion_getInstance_50().kf2_1;
        this_6.f1v_1.h1(entity.m1u_1).q1s(type_2.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_7 = this_6.i1v_1;
        if (this_7.u1t_1.j1s(type_2.m1t())) {
          var tmp_17 = type_2.m1t();
          var tmp_18 = this_7.v1t();
          var tmp_19 = 0;
          var tmp_20 = this_7.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_21 = fillArrayVal(Array(tmp_20), null);
          while (tmp_19 < tmp_20) {
            tmp_21[tmp_19] = null;
            tmp_19 = tmp_19 + 1 | 0;
          }
          this_7.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, type_2, tmp_21));
        }
        var tmp_22 = this_7.u1t_1.h1(type_2.m1t());
        (tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE()).o1u(entity);
        this_5.s1v_1 = prevUpdateId_0;
        if (skipFamilyNotify_0) {
          break $l$block_0;
        }
        var compMask_0 = this_5.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = this_5.l1v_1.b1u_1;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject_0.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element_0.p1w(entity, compMask_0);
        }
      }
    }
    if (this.k1v(entity, Companion_getInstance_50().lf2_1)) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
      var type_3 = Companion_getInstance_50().lf2_1;
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_8 = this.i1v_1;
      if (this_8.u1t_1.j1s(type_3.m1t())) {
        var tmp_23 = type_3.m1t();
        var tmp_24 = this_8.v1t();
        var tmp_25 = 0;
        var tmp_26 = this_8.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_27 = fillArrayVal(Array(tmp_26), null);
        while (tmp_25 < tmp_26) {
          tmp_27[tmp_25] = null;
          tmp_25 = tmp_25 + 1 | 0;
        }
        this_8.u1t_1.h1s(tmp_23, new ComponentsHolder(tmp_24, type_3, tmp_27));
      }
      var tmp_28 = this_8.u1t_1.h1(type_3.m1t());
      var event_1 = (tmp_28 instanceof ComponentsHolder ? tmp_28 : THROW_CCE()).p1u(entity).jt();
      if (this.ag1_1.h1(typeof event_1 === 'number' ? event_1 : THROW_CCE())) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_4 = Companion_getInstance_70();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_9 = this.i1v_1;
        if (this_9.u1t_1.j1s(type_4.m1t())) {
          var tmp_29 = type_4.m1t();
          var tmp_30 = this_9.v1t();
          var tmp_31 = 0;
          var tmp_32 = this_9.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_33 = fillArrayVal(Array(tmp_32), null);
          while (tmp_31 < tmp_32) {
            tmp_33[tmp_31] = null;
            tmp_31 = tmp_31 + 1 | 0;
          }
          this_9.u1t_1.h1s(tmp_29, new ComponentsHolder(tmp_30, type_4, tmp_33));
        }
        var tmp_34 = this_9.u1t_1.h1(type_4.m1t());
        var tweenSequence = (tmp_34 instanceof ComponentsHolder ? tmp_34 : THROW_CCE()).p1u(entity);
        tweenSequence.pfb_1 = 0.0;
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
        $l$block_1: {
          // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
          var this_10 = this.i1v_1.v1t().a1u_1;
          var skipFamilyNotify_1 = this_10.s1v_1 === entity.m1u_1 || this_10.q1v_1 === entity.m1u_1;
          var prevUpdateId_1 = this_10.s1v_1;
          this_10.s1v_1 = entity.m1u_1;
          // Inline function 'korlibs.korge.fleks.systems.TweenEventSystem.onTickEntity.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
          var this_11 = this_10.r1v_1;
          var type_5 = Companion_getInstance_50().lf2_1;
          this_11.f1v_1.h1(entity.m1u_1).q1s(type_5.m1t());
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_12 = this_11.i1v_1;
          if (this_12.u1t_1.j1s(type_5.m1t())) {
            var tmp_35 = type_5.m1t();
            var tmp_36 = this_12.v1t();
            var tmp_37 = 0;
            var tmp_38 = this_12.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_39 = fillArrayVal(Array(tmp_38), null);
            while (tmp_37 < tmp_38) {
              tmp_39[tmp_37] = null;
              tmp_37 = tmp_37 + 1 | 0;
            }
            this_12.u1t_1.h1s(tmp_35, new ComponentsHolder(tmp_36, type_5, tmp_39));
          }
          var tmp_40 = this_12.u1t_1.h1(type_5.m1t());
          (tmp_40 instanceof ComponentsHolder ? tmp_40 : THROW_CCE()).o1u(entity);
          this_10.s1v_1 = prevUpdateId_1;
          if (skipFamilyNotify_1) {
            break $l$block_1;
          }
          var compMask_1 = this_10.o1v_1.h1(entity.m1u_1);
          // Inline function 'kotlin.collections.forEach' call
          var indexedObject_1 = this_10.l1v_1.b1u_1;
          var inductionVariable_1 = 0;
          var last_1 = indexedObject_1.length;
          while (inductionVariable_1 < last_1) {
            var element_1 = indexedObject_1[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
            element_1.p1w(entity, compMask_1);
          }
        }
      }
    }
  }
}
class TweenTouchInputSystem extends IteratingSystem {
  static lg1() {
    var tmp = Companion_instance_0;
    return this.z1z(tmp.p20(TweenTouchInputSystem$_init_$lambda_dqa1wa), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_49();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var touchInputComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    updateProperty_4(this, entity, Companion_getInstance_50().mf2_1, enabled$factory(touchInputComponent));
  }
}
class TweenSequenceSystem extends IteratingSystem {
  static nfx() {
    var tmp = Companion_instance_0;
    var $this = this.z1z(tmp.p20(TweenSequenceSystem$_init_$lambda_10cvdc), VOID, VOID, new Fixed(1.0 / 60.0));
    $this.mfx_1 = new ParallelTweens();
    return $this;
  }
  c20(entity_0) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_70();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var tweenSequence = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity_0);
    if (tweenSequence.ofb_1 >= tweenSequence.pfb_1) {
      tweenSequence.ofb_1 = 0.0;
      var tmp_5;
      if (tweenSequence.nfb_1 >= tweenSequence.mfb_1.g1()) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
        $l$block: {
          // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
          var this_1 = this.i1v_1.v1t().a1u_1;
          var skipFamilyNotify = this_1.s1v_1 === entity_0.m1u_1 || this_1.q1v_1 === entity_0.m1u_1;
          var prevUpdateId = this_1.s1v_1;
          this_1.s1v_1 = entity_0.m1u_1;
          // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.onTickEntity.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
          var this_2 = this_1.r1v_1;
          var type_0 = Companion_getInstance_70();
          this_2.f1v_1.h1(entity_0.m1u_1).q1s(type_0.m1t());
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_3 = this_2.i1v_1;
          if (this_3.u1t_1.j1s(type_0.m1t())) {
            var tmp_6 = type_0.m1t();
            var tmp_7 = this_3.v1t();
            var tmp_8 = 0;
            var tmp_9 = this_3.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_10 = fillArrayVal(Array(tmp_9), null);
            while (tmp_8 < tmp_9) {
              tmp_10[tmp_8] = null;
              tmp_8 = tmp_8 + 1 | 0;
            }
            this_3.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
          }
          var tmp_11 = this_3.u1t_1.h1(type_0.m1t());
          (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).o1u(entity_0);
          this_1.s1v_1 = prevUpdateId;
          if (skipFamilyNotify) {
            break $l$block;
          }
          var compMask = this_1.o1v_1.h1(entity_0.m1u_1);
          // Inline function 'kotlin.collections.forEach' call
          var indexedObject = this_1.l1v_1.b1u_1;
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var element = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
            element.p1w(entity_0, compMask);
          }
        }
        return Unit_instance;
      } else if (tweenSequence.qfb_1) {
        tweenSequence.qfb_1 = false;
        tweenSequence.nfb_1 = tweenSequence.nfb_1 + 1 | 0;
        if (tweenSequence.nfb_1 >= tweenSequence.mfb_1.g1()) {
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
          $l$block_0: {
            // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
            var this_4 = this.i1v_1.v1t().a1u_1;
            var skipFamilyNotify_0 = this_4.s1v_1 === entity_0.m1u_1 || this_4.q1v_1 === entity_0.m1u_1;
            var prevUpdateId_0 = this_4.s1v_1;
            this_4.s1v_1 = entity_0.m1u_1;
            // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.onTickEntity.<anonymous>' call
            // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
            var this_5 = this_4.r1v_1;
            var type_1 = Companion_getInstance_70();
            this_5.f1v_1.h1(entity_0.m1u_1).q1s(type_1.m1t());
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_6 = this_5.i1v_1;
            if (this_6.u1t_1.j1s(type_1.m1t())) {
              var tmp_12 = type_1.m1t();
              var tmp_13 = this_6.v1t();
              var tmp_14 = 0;
              var tmp_15 = this_6.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_16 = fillArrayVal(Array(tmp_15), null);
              while (tmp_14 < tmp_15) {
                tmp_16[tmp_14] = null;
                tmp_14 = tmp_14 + 1 | 0;
              }
              this_6.u1t_1.h1s(tmp_12, new ComponentsHolder(tmp_13, type_1, tmp_16));
            }
            var tmp_17 = this_6.u1t_1.h1(type_1.m1t());
            (tmp_17 instanceof ComponentsHolder ? tmp_17 : THROW_CCE()).o1u(entity_0);
            this_4.s1v_1 = prevUpdateId_0;
            if (skipFamilyNotify_0) {
              break $l$block_0;
            }
            var compMask_0 = this_4.o1v_1.h1(entity_0.m1u_1);
            // Inline function 'kotlin.collections.forEach' call
            var indexedObject_0 = this_4.l1v_1.b1u_1;
            var inductionVariable_0 = 0;
            var last_0 = indexedObject_0.length;
            while (inductionVariable_0 < last_0) {
              var element_0 = indexedObject_0[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
              element_0.p1w(entity_0, compMask_0);
            }
          }
          return Unit_instance;
        }
        var currentTween = tweenSequence.mfb_1.h1(tweenSequence.nfb_1);
        var tmp_18 = tweenSequence;
        var tmp0_elvis_lhs = currentTween.uf9();
        tmp_18.pfb_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        if (!(tweenSequence.pfb_1 === 0.0))
          return Unit_instance;
        tmp_5 = currentTween;
      } else {
        tmp_5 = tweenSequence.mfb_1.h1(tweenSequence.nfb_1);
      }
      var currentTween_0 = tmp_5;
      tweenSequence.qfb_1 = true;
      var tmp_19 = tweenSequence;
      var tmp1_elvis_lhs = currentTween_0.wf9();
      tmp_19.pfb_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      if (currentTween_0 instanceof SpawnNewTweenSequence) {
        entity(this.v1z_1, 'SpawnNewTweenSequence', TweenSequenceSystem$onTickEntity$lambda(currentTween_0));
      } else {
        if (currentTween_0 instanceof Jump) {
          tweenSequence.nfb_1 = tweenSequence.nfb_1 + (currentTween_0.af5_1 - 1 | 0) | 0;
        } else {
          if (currentTween_0 instanceof ParallelTweens) {
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator = currentTween_0.uf3_1.b1();
            while (tmp0_iterator.c1()) {
              var element_1 = tmp0_iterator.d1();
              // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.onTickEntity.<anonymous>' call
              if (!(element_1.uf9() == null) && ensureNotNull(element_1.uf9()) > 0.0) {
                var tmp_20 = 'ParallelTween: ' + getKClassFromExpression(element_1).yf() + " for entity '" + element_1.tf9().m1u_1 + "'";
                entity(this.v1z_1, tmp_20, TweenSequenceSystem$onTickEntity$lambda_0(element_1, currentTween_0));
              } else {
                checkTween(this, entity_0, element_1, currentTween_0);
              }
            }
          } else {
            checkTween(this, entity_0, currentTween_0, this.mfx_1);
          }
        }
      }
    } else {
      tweenSequence.ofb_1 = tweenSequence.ofb_1 + this.g20();
    }
  }
}
class CameraFollowTag extends ComponentType {
  constructor() {
    CameraFollowTag_instance = null;
    super();
    CameraFollowTag_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ng1_1 = lazy(tmp_0, CameraFollowTag$_anonymous__l19eab);
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
  toString() {
    return 'CameraFollowTag';
  }
  hashCode() {
    return 481705194;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CameraFollowTag))
      return false;
    other instanceof CameraFollowTag || THROW_CCE();
    return true;
  }
}
class MainCameraTag extends ComponentType {
  constructor() {
    MainCameraTag_instance = null;
    super();
    MainCameraTag_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.pg1_1 = lazy(tmp_0, MainCameraTag$_anonymous__4etdwb);
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
  toString() {
    return 'MainCameraTag';
  }
  hashCode() {
    return -46836126;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MainCameraTag))
      return false;
    other instanceof MainCameraTag || THROW_CCE();
    return true;
  }
}
class Companion_69 {
  constructor() {
    Companion_instance_71 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.dfd_1 = lazy(tmp_0, RenderLayerTag$Companion$_anonymous__4rpxn4);
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
}
class RenderLayerTag extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.sg1_1 = entityTagOf();
  }
  m1t() {
    return this.sg1_1.m1t();
  }
}
class ScreenCoordinatesTag extends ComponentType {
  constructor() {
    ScreenCoordinatesTag_instance = null;
    super();
    ScreenCoordinatesTag_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ug1_1 = lazy(tmp_0, ScreenCoordinatesTag$_anonymous__9kp4x8);
  }
  q1j() {
    return _get_$cachedSerializer__te6jhj_2(this);
  }
  r17(typeParamsSerializers) {
    return this.q1j();
  }
  toString() {
    return 'ScreenCoordinatesTag';
  }
  hashCode() {
    return 1542009477;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScreenCoordinatesTag))
      return false;
    other instanceof ScreenCoordinatesTag || THROW_CCE();
    return true;
  }
}
class AppConfig {
  constructor() {
    AppConfig_instance = this;
    this.bev_1 = 16.0;
    this.cev_1 = 1.0 / this.bev_1;
    this.dev_1 = "jobe's Legacy";
    this.eev_1 = 384;
    this.fev_1 = 216;
    this.gev_1 = 384;
    this.hev_1 = 216;
    this.iev_1 = this.eev_1;
    this.jev_1 = this.fev_1;
    this.kev_1 = this.iev_1 / 2 | 0;
    this.lev_1 = this.jev_1 / 2 | 0;
    this.mev_1 = false;
    this.nev_1 = false;
    this.oev_1 = true;
    this.pev_1 = 1.0;
  }
  vg1(value) {
    this.eev_1 = value;
    this.iev_1 = value;
    this.kev_1 = value / 2 | 0;
  }
}
class EntityByName {
  constructor() {
    EntityByName_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.xen_1 = LinkedHashMap.wc();
  }
  yen(name, entity) {
    if (!this.xen_1.c3(name)) {
      // Inline function 'kotlin.collections.set' call
      this.xen_1.k3(name, entity);
    }
  }
  zen(name) {
    this.xen_1.l3(name);
  }
}
class EntityConfigSerializer {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.eeh_1 = LinkedHashMap.wc();
    this.geh_1 = true;
    var tmp_0 = this;
    // Inline function 'kotlinx.serialization.modules.SerializersModule' call
    var builder = new SerializersModuleBuilder();
    // Inline function 'korlibs.korge.fleks.utils.EntityConfigSerializer.internalModule.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.polymorphic' call
    var baseClass = getKClass(EntityConfig);
    var builder_0 = new PolymorphicModuleBuilder(baseClass, null);
    // Inline function 'korlibs.korge.fleks.utils.EntityConfigSerializer.internalModule.<anonymous>.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz = getKClass(DialogBoxConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_0(createKType(getKClass(DialogBoxConfig), arrayOf([]), false));
    var tmp$ret$2 = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
    builder_0.p1f(clazz, tmp$ret$2);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_0 = getKClass(RichTextConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer_0(createKType(getKClass(RichTextConfig), arrayOf([]), false));
    var tmp$ret$5 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    builder_0.p1f(clazz_0, tmp$ret$5);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_1 = getKClass(ParallaxEffectConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(createKType(getKClass(ParallaxEffectConfig), arrayOf([]), false));
    var tmp$ret$8 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    builder_0.p1f(clazz_1, tmp$ret$8);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_2 = getKClass(LogoEntityConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_3 = serializer_0(createKType(getKClass(LogoEntityConfig), arrayOf([]), false));
    var tmp$ret$11 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
    builder_0.p1f(clazz_2, tmp$ret$11);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_3 = getKClass(LevelMapConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer_0(createKType(getKClass(LevelMapConfig), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_4, KSerializer) ? this_4 : THROW_CCE();
    builder_0.p1f(clazz_3, tmp$ret$14);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_4 = getKClass(MovedSpawnerObjectConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer_0(createKType(getKClass(MovedSpawnerObjectConfig), arrayOf([]), false));
    var tmp$ret$17 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
    builder_0.p1f(clazz_4, tmp$ret$17);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_5 = getKClass(MainCameraConfig);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer_0(createKType(getKClass(MainCameraConfig), arrayOf([]), false));
    var tmp$ret$20 = isInterface(this_6, KSerializer) ? this_6 : THROW_CCE();
    builder_0.p1f(clazz_5, tmp$ret$20);
    builder_0.q1f(builder);
    tmp_0.heh_1 = builder.n14();
  }
  gfg(name, module_0) {
    // Inline function 'kotlin.collections.set' call
    this.eeh_1.k3(name, module_0);
    this.geh_1 = true;
  }
  ieh() {
    if (this.geh_1) {
      var modules = this.heh_1;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this.eeh_1.n3().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.fleks.utils.EntityConfigSerializer.yaml.<anonymous>' call
        modules = plus_0(modules, element);
      }
      var tmp = this;
      var tmp_0 = modules;
      var tmp0_singleLineStringStyle = SingleLineStringStyle_DoubleQuoted_getInstance();
      var tmp1_multiLineStringStyle = MultiLineStringStyle_DoubleQuoted_getInstance();
      var tmp2_polymorphismStyle = PolymorphismStyle_Property_getInstance();
      tmp.feh_1 = new Yaml(tmp_0, new YamlConfiguration(VOID, VOID, VOID, tmp2_polymorphismStyle, 'entityConfig', 4, VOID, VOID, tmp0_singleLineStringStyle, tmp1_multiLineStringStyle, VOID, VOID, true));
      this.geh_1 = false;
    }
    return _get_yaml__dgtvgk(this);
  }
}
class RGBAAsInt {
  constructor() {
    RGBAAsInt_instance = this;
    this.wg1_1 = PrimitiveSerialDescriptor('RGBAAsInt', INT_getInstance());
  }
  yu() {
    return this.wg1_1;
  }
  xg1(encoder, value) {
    return encoder.xz(_RGBA___get_value__impl__hhco8v(value));
  }
  zu(encoder, value) {
    return this.xg1(encoder, value instanceof RGBA ? value.o5p_1 : THROW_CCE());
  }
  yg1(decoder) {
    return _RGBA___init__impl__lqpay5(decoder.ny());
  }
  av(decoder) {
    return new RGBA(this.yg1(decoder));
  }
}
class SnapshotSerializer {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.cfu_1 = LinkedHashMap.wc();
    this.efu_1 = true;
    var tmp_0 = this;
    // Inline function 'kotlinx.serialization.modules.SerializersModule' call
    var builder = new SerializersModuleBuilder();
    // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.internalModule.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.polymorphic' call
    var baseClass = getKClass(CloneableData);
    var builder_0 = new PolymorphicModuleBuilder(baseClass, null);
    // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.internalModule.<anonymous>.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz = getKClass(Layer_0);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_0(createKType(getKClass(Layer_0), arrayOf([]), false));
    var tmp$ret$2 = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
    builder_0.p1f(clazz, tmp$ret$2);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_0 = getKClass(Plane);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer_0(createKType(getKClass(Plane), arrayOf([]), false));
    var tmp$ret$5 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    builder_0.p1f(clazz_0, tmp$ret$5);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_1 = getKClass(Rgb);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(createKType(getKClass(Rgb), arrayOf([]), false));
    var tmp$ret$8 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    builder_0.p1f(clazz_1, tmp$ret$8);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_2 = getKClass(Point);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_3 = serializer_0(createKType(getKClass(Point), arrayOf([]), false));
    var tmp$ret$11 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
    builder_0.p1f(clazz_2, tmp$ret$11);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_3 = getKClass(LayerProperties);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer_0(createKType(getKClass(LayerProperties), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_4, KSerializer) ? this_4 : THROW_CCE();
    builder_0.p1f(clazz_3, tmp$ret$14);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_4 = getKClass(Layer);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer_0(createKType(getKClass(Layer), arrayOf([]), false));
    var tmp$ret$17 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
    builder_0.p1f(clazz_4, tmp$ret$17);
    builder_0.q1f(builder);
    // Inline function 'kotlinx.serialization.modules.polymorphic' call
    var baseClass_0 = getKClass(Component);
    var builder_1 = new PolymorphicModuleBuilder(baseClass_0, null);
    // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.internalModule.<anonymous>.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_5 = getKClass(DebugComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer_0(createKType(getKClass(DebugComponent), arrayOf([]), false));
    var tmp$ret$20 = isInterface(this_6, KSerializer) ? this_6 : THROW_CCE();
    builder_1.p1f(clazz_5, tmp$ret$20);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_6 = getKClass(EntityLinkComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer_0(createKType(getKClass(EntityLinkComponent), arrayOf([]), false));
    var tmp$ret$23 = isInterface(this_7, KSerializer) ? this_7 : THROW_CCE();
    builder_1.p1f(clazz_6, tmp$ret$23);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_7 = getKClass(InfoComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_8 = serializer_0(createKType(getKClass(InfoComponent), arrayOf([]), false));
    var tmp$ret$26 = isInterface(this_8, KSerializer) ? this_8 : THROW_CCE();
    builder_1.p1f(clazz_7, tmp$ret$26);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_8 = getKClass(LayerComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer_0(createKType(getKClass(LayerComponent), arrayOf([]), false));
    var tmp$ret$29 = isInterface(this_9, KSerializer) ? this_9 : THROW_CCE();
    builder_1.p1f(clazz_8, tmp$ret$29);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_9 = getKClass(LayeredSpriteComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_10 = serializer_0(createKType(getKClass(LayeredSpriteComponent), arrayOf([]), false));
    var tmp$ret$32 = isInterface(this_10, KSerializer) ? this_10 : THROW_CCE();
    builder_1.p1f(clazz_9, tmp$ret$32);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_10 = getKClass(LayoutComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_11 = serializer_0(createKType(getKClass(LayoutComponent), arrayOf([]), false));
    var tmp$ret$35 = isInterface(this_11, KSerializer) ? this_11 : THROW_CCE();
    builder_1.p1f(clazz_10, tmp$ret$35);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_11 = getKClass(LevelMapComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_12 = serializer_0(createKType(getKClass(LevelMapComponent), arrayOf([]), false));
    var tmp$ret$38 = isInterface(this_12, KSerializer) ? this_12 : THROW_CCE();
    builder_1.p1f(clazz_11, tmp$ret$38);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_12 = getKClass(LifeCycleComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_13 = serializer_0(createKType(getKClass(LifeCycleComponent), arrayOf([]), false));
    var tmp$ret$41 = isInterface(this_13, KSerializer) ? this_13 : THROW_CCE();
    builder_1.p1f(clazz_12, tmp$ret$41);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_13 = getKClass(MotionComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_14 = serializer_0(createKType(getKClass(MotionComponent), arrayOf([]), false));
    var tmp$ret$44 = isInterface(this_14, KSerializer) ? this_14 : THROW_CCE();
    builder_1.p1f(clazz_13, tmp$ret$44);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_14 = getKClass(NinePatchComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_15 = serializer_0(createKType(getKClass(NinePatchComponent), arrayOf([]), false));
    var tmp$ret$47 = isInterface(this_15, KSerializer) ? this_15 : THROW_CCE();
    builder_1.p1f(clazz_14, tmp$ret$47);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_15 = getKClass(NoisyMoveComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_16 = serializer_0(createKType(getKClass(NoisyMoveComponent), arrayOf([]), false));
    var tmp$ret$50 = isInterface(this_16, KSerializer) ? this_16 : THROW_CCE();
    builder_1.p1f(clazz_15, tmp$ret$50);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_16 = getKClass(OffsetByFrameIndexComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_17 = serializer_0(createKType(getKClass(OffsetByFrameIndexComponent), arrayOf([]), false));
    var tmp$ret$53 = isInterface(this_17, KSerializer) ? this_17 : THROW_CCE();
    builder_1.p1f(clazz_16, tmp$ret$53);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_17 = getKClass(ParallaxComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_18 = serializer_0(createKType(getKClass(ParallaxComponent), arrayOf([]), false));
    var tmp$ret$56 = isInterface(this_18, KSerializer) ? this_18 : THROW_CCE();
    builder_1.p1f(clazz_17, tmp$ret$56);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_18 = getKClass(PositionComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_19 = serializer_0(createKType(getKClass(PositionComponent), arrayOf([]), false));
    var tmp$ret$59 = isInterface(this_19, KSerializer) ? this_19 : THROW_CCE();
    builder_1.p1f(clazz_18, tmp$ret$59);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_19 = getKClass(RgbaComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_20 = serializer_0(createKType(getKClass(RgbaComponent), arrayOf([]), false));
    var tmp$ret$62 = isInterface(this_20, KSerializer) ? this_20 : THROW_CCE();
    builder_1.p1f(clazz_19, tmp$ret$62);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_20 = getKClass(RigidbodyComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_21 = serializer_0(createKType(getKClass(RigidbodyComponent), arrayOf([]), false));
    var tmp$ret$65 = isInterface(this_21, KSerializer) ? this_21 : THROW_CCE();
    builder_1.p1f(clazz_20, tmp$ret$65);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_21 = getKClass(SizeComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_22 = serializer_0(createKType(getKClass(SizeComponent), arrayOf([]), false));
    var tmp$ret$68 = isInterface(this_22, KSerializer) ? this_22 : THROW_CCE();
    builder_1.p1f(clazz_21, tmp$ret$68);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_22 = getKClass(SoundComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_23 = serializer_0(createKType(getKClass(SoundComponent), arrayOf([]), false));
    var tmp$ret$71 = isInterface(this_23, KSerializer) ? this_23 : THROW_CCE();
    builder_1.p1f(clazz_22, tmp$ret$71);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_23 = getKClass(SpawnerComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_24 = serializer_0(createKType(getKClass(SpawnerComponent), arrayOf([]), false));
    var tmp$ret$74 = isInterface(this_24, KSerializer) ? this_24 : THROW_CCE();
    builder_1.p1f(clazz_23, tmp$ret$74);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_24 = getKClass(SpriteComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_25 = serializer_0(createKType(getKClass(SpriteComponent), arrayOf([]), false));
    var tmp$ret$77 = isInterface(this_25, KSerializer) ? this_25 : THROW_CCE();
    builder_1.p1f(clazz_24, tmp$ret$77);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_25 = getKClass(SpriteLayersComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_26 = serializer_0(createKType(getKClass(SpriteLayersComponent), arrayOf([]), false));
    var tmp$ret$80 = isInterface(this_26, KSerializer) ? this_26 : THROW_CCE();
    builder_1.p1f(clazz_25, tmp$ret$80);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_26 = getKClass(SubEntitiesComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_27 = serializer_0(createKType(getKClass(SubEntitiesComponent), arrayOf([]), false));
    var tmp$ret$83 = isInterface(this_27, KSerializer) ? this_27 : THROW_CCE();
    builder_1.p1f(clazz_26, tmp$ret$83);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_27 = getKClass(SwitchLayerVisibilityComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_28 = serializer_0(createKType(getKClass(SwitchLayerVisibilityComponent), arrayOf([]), false));
    var tmp$ret$86 = isInterface(this_28, KSerializer) ? this_28 : THROW_CCE();
    builder_1.p1f(clazz_27, tmp$ret$86);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_28 = getKClass(TextFieldComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_29 = serializer_0(createKType(getKClass(TextFieldComponent), arrayOf([]), false));
    var tmp$ret$89 = isInterface(this_29, KSerializer) ? this_29 : THROW_CCE();
    builder_1.p1f(clazz_28, tmp$ret$89);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_29 = getKClass(TiledLevelMapComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_30 = serializer_0(createKType(getKClass(TiledLevelMapComponent), arrayOf([]), false));
    var tmp$ret$92 = isInterface(this_30, KSerializer) ? this_30 : THROW_CCE();
    builder_1.p1f(clazz_29, tmp$ret$92);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_30 = getKClass(TouchInputComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_31 = serializer_0(createKType(getKClass(TouchInputComponent), arrayOf([]), false));
    var tmp$ret$95 = isInterface(this_31, KSerializer) ? this_31 : THROW_CCE();
    builder_1.p1f(clazz_30, tmp$ret$95);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_31 = getKClass(TweenPropertyComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_32 = serializer_0(createKType(getKClass(TweenPropertyComponent), arrayOf([]), false));
    var tmp$ret$98 = isInterface(this_32, KSerializer) ? this_32 : THROW_CCE();
    builder_1.p1f(clazz_31, tmp$ret$98);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_32 = getKClass(TweenSequenceComponent);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_33 = serializer_0(createKType(getKClass(TweenSequenceComponent), arrayOf([]), false));
    var tmp$ret$101 = isInterface(this_33, KSerializer) ? this_33 : THROW_CCE();
    builder_1.p1f(clazz_32, tmp$ret$101);
    builder_1.q1f(builder);
    // Inline function 'kotlinx.serialization.modules.polymorphic' call
    var baseClass_1 = getKClass(UniqueId);
    var builder_2 = new PolymorphicModuleBuilder(baseClass_1, null);
    // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.internalModule.<anonymous>.<anonymous>' call
    builder_2.p1f(getKClass(RenderLayerTag), new PolymorphicEnumSerializer(Companion_getInstance_79().q1j()));
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_33 = getKClass(ScreenCoordinatesTag);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_34 = serializer_0(createKType(getKClass(ScreenCoordinatesTag), arrayOf([]), false));
    var tmp$ret$104 = isInterface(this_34, KSerializer) ? this_34 : THROW_CCE();
    builder_2.p1f(clazz_33, tmp$ret$104);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_34 = getKClass(MainCameraTag);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_35 = serializer_0(createKType(getKClass(MainCameraTag), arrayOf([]), false));
    var tmp$ret$107 = isInterface(this_35, KSerializer) ? this_35 : THROW_CCE();
    builder_2.p1f(clazz_34, tmp$ret$107);
    builder_2.q1f(builder);
    // Inline function 'kotlinx.serialization.modules.polymorphic' call
    var baseClass_2 = getKClass(TweenBase);
    var builder_3 = new PolymorphicModuleBuilder(baseClass_2, null);
    // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.internalModule.<anonymous>.<anonymous>' call
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_35 = getKClass(SpawnNewTweenSequence);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_36 = serializer_0(createKType(getKClass(SpawnNewTweenSequence), arrayOf([]), false));
    var tmp$ret$110 = isInterface(this_36, KSerializer) ? this_36 : THROW_CCE();
    builder_3.p1f(clazz_35, tmp$ret$110);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_36 = getKClass(ParallelTweens);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_37 = serializer_0(createKType(getKClass(ParallelTweens), arrayOf([]), false));
    var tmp$ret$113 = isInterface(this_37, KSerializer) ? this_37 : THROW_CCE();
    builder_3.p1f(clazz_36, tmp$ret$113);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_37 = getKClass(Wait);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_38 = serializer_0(createKType(getKClass(Wait), arrayOf([]), false));
    var tmp$ret$116 = isInterface(this_38, KSerializer) ? this_38 : THROW_CCE();
    builder_3.p1f(clazz_37, tmp$ret$116);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_38 = getKClass(Jump);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_39 = serializer_0(createKType(getKClass(Jump), arrayOf([]), false));
    var tmp$ret$119 = isInterface(this_39, KSerializer) ? this_39 : THROW_CCE();
    builder_3.p1f(clazz_38, tmp$ret$119);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_39 = getKClass(SpawnEntity);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_40 = serializer_0(createKType(getKClass(SpawnEntity), arrayOf([]), false));
    var tmp$ret$122 = isInterface(this_40, KSerializer) ? this_40 : THROW_CCE();
    builder_3.p1f(clazz_39, tmp$ret$122);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_40 = getKClass(ExecuteConfigFunction);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_41 = serializer_0(createKType(getKClass(ExecuteConfigFunction), arrayOf([]), false));
    var tmp$ret$125 = isInterface(this_41, KSerializer) ? this_41 : THROW_CCE();
    builder_3.p1f(clazz_40, tmp$ret$125);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_41 = getKClass(DeleteEntity);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_42 = serializer_0(createKType(getKClass(DeleteEntity), arrayOf([]), false));
    var tmp$ret$128 = isInterface(this_42, KSerializer) ? this_42 : THROW_CCE();
    builder_3.p1f(clazz_41, tmp$ret$128);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_42 = getKClass(TweenRgba);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_43 = serializer_0(createKType(getKClass(TweenRgba), arrayOf([]), false));
    var tmp$ret$131 = isInterface(this_43, KSerializer) ? this_43 : THROW_CCE();
    builder_3.p1f(clazz_42, tmp$ret$131);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_43 = getKClass(TweenPosition);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_44 = serializer_0(createKType(getKClass(TweenPosition), arrayOf([]), false));
    var tmp$ret$134 = isInterface(this_44, KSerializer) ? this_44 : THROW_CCE();
    builder_3.p1f(clazz_43, tmp$ret$134);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_44 = getKClass(TweenMotion);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_45 = serializer_0(createKType(getKClass(TweenMotion), arrayOf([]), false));
    var tmp$ret$137 = isInterface(this_45, KSerializer) ? this_45 : THROW_CCE();
    builder_3.p1f(clazz_44, tmp$ret$137);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_45 = getKClass(TweenSprite);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_46 = serializer_0(createKType(getKClass(TweenSprite), arrayOf([]), false));
    var tmp$ret$140 = isInterface(this_46, KSerializer) ? this_46 : THROW_CCE();
    builder_3.p1f(clazz_45, tmp$ret$140);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_46 = getKClass(TweenSwitchLayerVisibility);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_47 = serializer_0(createKType(getKClass(TweenSwitchLayerVisibility), arrayOf([]), false));
    var tmp$ret$143 = isInterface(this_47, KSerializer) ? this_47 : THROW_CCE();
    builder_3.p1f(clazz_46, tmp$ret$143);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_47 = getKClass(TweenSpawner);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_48 = serializer_0(createKType(getKClass(TweenSpawner), arrayOf([]), false));
    var tmp$ret$146 = isInterface(this_48, KSerializer) ? this_48 : THROW_CCE();
    builder_3.p1f(clazz_47, tmp$ret$146);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_48 = getKClass(TweenSound);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_49 = serializer_0(createKType(getKClass(TweenSound), arrayOf([]), false));
    var tmp$ret$149 = isInterface(this_49, KSerializer) ? this_49 : THROW_CCE();
    builder_3.p1f(clazz_48, tmp$ret$149);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_49 = getKClass(TweenTextField);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_50 = serializer_0(createKType(getKClass(TweenTextField), arrayOf([]), false));
    var tmp$ret$152 = isInterface(this_50, KSerializer) ? this_50 : THROW_CCE();
    builder_3.p1f(clazz_49, tmp$ret$152);
    // Inline function 'kotlinx.serialization.modules.subclass' call
    var clazz_50 = getKClass(TweenTouchInput);
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_51 = serializer_0(createKType(getKClass(TweenTouchInput), arrayOf([]), false));
    var tmp$ret$155 = isInterface(this_51, KSerializer) ? this_51 : THROW_CCE();
    builder_3.p1f(clazz_50, tmp$ret$155);
    builder_3.q1f(builder);
    tmp_0.ffu_1 = builder.n14();
  }
  gfg(name, module_0) {
    // Inline function 'kotlin.collections.set' call
    this.cfu_1.k3(name, module_0);
    this.efu_1 = true;
  }
  lfu(pretty) {
    if (this.efu_1) {
      var modules = {_v: this.ffu_1};
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this.cfu_1.n3().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.fleks.utils.SnapshotSerializer.json.<anonymous>' call
        modules._v = plus_0(modules._v, element);
      }
      var tmp = this;
      tmp.dfu_1 = Json(VOID, SnapshotSerializer$json$lambda(pretty, modules));
      this.efu_1 = false;
    }
    return _get_json__d8whur(this);
  }
  gfu(pretty, $super) {
    pretty = pretty === VOID ? false : pretty;
    return $super === VOID ? this.lfu(pretty) : $super.lfu.call(this, pretty);
  }
}
class PolymorphicEnumSerializer {
  constructor(enumSerializer) {
    this.zg1_1 = enumSerializer;
    var tmp = this;
    var tmp_0 = this.zg1_1.yu().ax();
    tmp.ag2_1 = buildClassSerialDescriptor(tmp_0, [], PolymorphicEnumSerializer$descriptor$lambda(this));
  }
  yu() {
    return this.ag2_1;
  }
  av(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.ag2_1;
    var composite = decoder.xy(descriptor);
    // Inline function 'korlibs.korge.fleks.utils.PolymorphicEnumSerializer.deserialize.<anonymous>' call
    composite.oz(this.ag2_1);
    var result = composite.kz(this.ag2_1, 0, this.zg1_1);
    composite.yy(descriptor);
    return result;
  }
  w15(encoder, value) {
    var descriptor = this.ag2_1;
    var composite = encoder.xy(descriptor);
    // Inline function 'korlibs.korge.fleks.utils.PolymorphicEnumSerializer.serialize.<anonymous>' call
    composite.p10(this.ag2_1, 0, this.zg1_1, value);
    composite.yy(descriptor);
    return Unit_instance;
  }
  zu(encoder, value) {
    return this.w15(encoder, value instanceof Enum ? value : THROW_CCE());
  }
}
class HAlignAsString {
  constructor() {
    HAlignAsString_instance = this;
    this.bg2_1 = PrimitiveSerialDescriptor('HAlignAsString', STRING_getInstance());
  }
  yu() {
    return this.bg2_1;
  }
  cg2(encoder, value) {
    return encoder.c10(HorizontalAlign__toString_impl_toflc0(value));
  }
  zu(encoder, value) {
    return this.cg2(encoder, value instanceof HorizontalAlign ? value.x6w_1 : THROW_CCE());
  }
  dg2(decoder) {
    return Companion_getInstance_1().w6w(decoder.sy());
  }
  av(decoder) {
    return new HorizontalAlign(this.dg2(decoder));
  }
}
class VAlignAsString {
  constructor() {
    VAlignAsString_instance = this;
    this.eg2_1 = PrimitiveSerialDescriptor('VAlignAsString', STRING_getInstance());
  }
  yu() {
    return this.eg2_1;
  }
  fg2(encoder, value) {
    return encoder.c10(VerticalAlign__toString_impl_hcpnn2(value));
  }
  zu(encoder, value) {
    return this.fg2(encoder, value instanceof VerticalAlign ? value.v6w_1 : THROW_CCE());
  }
  gg2(decoder) {
    return Companion_getInstance_2().u6w(decoder.sy());
  }
  av(decoder) {
    return new VerticalAlign(this.gg2(decoder));
  }
}
class HorizontalAlignAsDouble {
  constructor() {
    HorizontalAlignAsDouble_instance = this;
    this.hg2_1 = PrimitiveSerialDescriptor('HorizontalAlignAsDouble', DOUBLE_getInstance());
  }
  yu() {
    return this.hg2_1;
  }
  cg2(encoder, value) {
    return encoder.a10(_HorizontalAlign___get_ratio__impl__x9wlea(value));
  }
  zu(encoder, value) {
    return this.cg2(encoder, value instanceof HorizontalAlign ? value.x6w_1 : THROW_CCE());
  }
  dg2(decoder) {
    return _HorizontalAlign___init__impl__ad654o(decoder.qy());
  }
  av(decoder) {
    return new HorizontalAlign(this.dg2(decoder));
  }
}
class VerticalAlignAsDouble {
  constructor() {
    VerticalAlignAsDouble_instance = this;
    this.ig2_1 = PrimitiveSerialDescriptor('VerticalAlignAsDouble', DOUBLE_getInstance());
  }
  yu() {
    return this.ig2_1;
  }
  fg2(encoder, value) {
    return encoder.a10(_VerticalAlign___get_ratio__impl__b3ilr8(value));
  }
  zu(encoder, value) {
    return this.fg2(encoder, value instanceof VerticalAlign ? value.v6w_1 : THROW_CCE());
  }
  gg2(decoder) {
    return _VerticalAlign___init__impl__f42kfq(decoder.qy());
  }
  av(decoder) {
    return new VerticalAlign(this.gg2(decoder));
  }
}
class ParallaxSpeedFactors {
  constructor() {
    ParallaxSpeedFactors_instance = this;
    this.jg2_1 = PrimitiveSerialDescriptor('ParallaxSpeedFactors', INT_getInstance());
  }
  yu() {
    return this.jg2_1;
  }
  kg2(encoder, value) {
    return encoder.xz(0);
  }
  zu(encoder, value) {
    return this.kg2(encoder, (!(value == null) ? isFloatArray(value) : false) ? value : THROW_CCE());
  }
  av(decoder) {
    // Inline function 'kotlin.floatArrayOf' call
    return new Float32Array([]);
  }
}
class Companion_70 {
  constructor() {
    Companion_instance_72 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.lg2_1 = [null, null, null, null, null, null, createSimpleEnumSerializer('korlibs.image.format.ImageAnimation.Direction', values())];
  }
  q1j() {
    return $serializer_getInstance_68();
  }
}
class $serializer_67 {
  constructor() {
    $serializer_instance_67 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.fleks.utils.AnySerializer.ContainerForAny', this, 7);
    tmp0_serialDesc.m16('double', true);
    tmp0_serialDesc.m16('float', true);
    tmp0_serialDesc.m16('int', true);
    tmp0_serialDesc.m16('string', true);
    tmp0_serialDesc.m16('boolean', true);
    tmp0_serialDesc.m16('rgb', true);
    tmp0_serialDesc.m16('direction', true);
    this.mg2_1 = tmp0_serialDesc;
  }
  ng2(encoder, value) {
    var tmp0_desc = this.mg2_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_80().lg2_1;
    if (tmp1_output.v10(tmp0_desc, 0) ? true : !(value.og2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 0, DoubleSerializer_getInstance(), value.og2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 1) ? true : !(value.pg2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 1, FloatSerializer_getInstance(), value.pg2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 2) ? true : !(value.qg2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 2, IntSerializer_getInstance(), value.qg2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 3) ? true : !(value.rg2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 3, StringSerializer_getInstance(), value.rg2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 4) ? true : !(value.sg2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 4, BooleanSerializer_getInstance(), value.sg2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 5) ? true : !(value.tg2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 5, $serializer_getInstance_26(), value.tg2_1);
    }
    if (tmp1_output.v10(tmp0_desc, 6) ? true : !(value.ug2_1 == null)) {
      tmp1_output.r10(tmp0_desc, 6, tmp2_cached[6], value.ug2_1);
    }
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ng2(encoder, value instanceof ContainerForAny ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.mg2_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.xy(tmp0_desc);
    var tmp12_cached = Companion_getInstance_80().lg2_1;
    if (tmp11_input.nz()) {
      tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, $serializer_getInstance_26(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.lz(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.lz(tmp0_desc, 1, FloatSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.lz(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.lz(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.lz(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.lz(tmp0_desc, 5, $serializer_getInstance_26(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.lz(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp11_input.yy(tmp0_desc);
    return ContainerForAny.vg2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  yu() {
    return this.mg2_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_80().lg2_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(DoubleSerializer_getInstance()), get_nullable(FloatSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_26()), get_nullable(tmp0_cached[6])];
  }
}
class ContainerForAny {
  constructor(double, float, int, string, boolean, rgb, direction) {
    Companion_getInstance_80();
    double = double === VOID ? null : double;
    float = float === VOID ? null : float;
    int = int === VOID ? null : int;
    string = string === VOID ? null : string;
    boolean = boolean === VOID ? null : boolean;
    rgb = rgb === VOID ? null : rgb;
    direction = direction === VOID ? null : direction;
    this.og2_1 = double;
    this.pg2_1 = float;
    this.qg2_1 = int;
    this.rg2_1 = string;
    this.sg2_1 = boolean;
    this.tg2_1 = rgb;
    this.ug2_1 = direction;
  }
  toString() {
    return 'ContainerForAny(double=' + this.og2_1 + ', float=' + this.pg2_1 + ', int=' + this.qg2_1 + ', string=' + this.rg2_1 + ', boolean=' + this.sg2_1 + ', rgb=' + toString(this.tg2_1) + ', direction=' + toString(this.ug2_1) + ')';
  }
  hashCode() {
    var result = this.og2_1 == null ? 0 : getNumberHashCode(this.og2_1);
    result = imul(result, 31) + (this.pg2_1 == null ? 0 : getNumberHashCode(this.pg2_1)) | 0;
    result = imul(result, 31) + (this.qg2_1 == null ? 0 : this.qg2_1) | 0;
    result = imul(result, 31) + (this.rg2_1 == null ? 0 : getStringHashCode(this.rg2_1)) | 0;
    result = imul(result, 31) + (this.sg2_1 == null ? 0 : getBooleanHashCode(this.sg2_1)) | 0;
    result = imul(result, 31) + (this.tg2_1 == null ? 0 : this.tg2_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ug2_1 == null ? 0 : this.ug2_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ContainerForAny))
      return false;
    var tmp0_other_with_cast = other instanceof ContainerForAny ? other : THROW_CCE();
    if (!equals(this.og2_1, tmp0_other_with_cast.og2_1))
      return false;
    if (!equals(this.pg2_1, tmp0_other_with_cast.pg2_1))
      return false;
    if (!(this.qg2_1 == tmp0_other_with_cast.qg2_1))
      return false;
    if (!(this.rg2_1 == tmp0_other_with_cast.rg2_1))
      return false;
    if (!(this.sg2_1 == tmp0_other_with_cast.sg2_1))
      return false;
    if (!equals(this.tg2_1, tmp0_other_with_cast.tg2_1))
      return false;
    if (!equals(this.ug2_1, tmp0_other_with_cast.ug2_1))
      return false;
    return true;
  }
  static vg2(seen0, double, float, int, string, boolean, rgb, direction, serializationConstructorMarker) {
    Companion_getInstance_80();
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_68().mg2_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.og2_1 = null;
    else
      $this.og2_1 = double;
    if (0 === (seen0 & 2))
      $this.pg2_1 = null;
    else
      $this.pg2_1 = float;
    if (0 === (seen0 & 4))
      $this.qg2_1 = null;
    else
      $this.qg2_1 = int;
    if (0 === (seen0 & 8))
      $this.rg2_1 = null;
    else
      $this.rg2_1 = string;
    if (0 === (seen0 & 16))
      $this.sg2_1 = null;
    else
      $this.sg2_1 = boolean;
    if (0 === (seen0 & 32))
      $this.tg2_1 = null;
    else
      $this.tg2_1 = rgb;
    if (0 === (seen0 & 64))
      $this.ug2_1 = null;
    else
      $this.ug2_1 = direction;
    return $this;
  }
}
class AnySerializer {
  constructor() {
    AnySerializer_instance = this;
    this.wg2_1 = Companion_getInstance_80().q1j().yu();
  }
  yu() {
    return this.wg2_1;
  }
  xg2(encoder, value) {
    if (typeof value === 'number') {
      Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(value));
    } else {
      if (typeof value === 'number') {
        Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, value));
      } else {
        if (typeof value === 'number') {
          Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, VOID, value));
        } else {
          if (typeof value === 'string') {
            Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, VOID, VOID, value));
          } else {
            if (typeof value === 'boolean') {
              Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, VOID, VOID, VOID, value));
            } else {
              if (value instanceof Rgb) {
                Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, VOID, VOID, VOID, VOID, value));
              } else {
                if (value instanceof Direction) {
                  Companion_getInstance_80().q1j().zu(encoder, new ContainerForAny(VOID, VOID, VOID, VOID, VOID, VOID, value));
                } else {
                  throw SerializationException.aw("AnySerializer: No rule to serialize type '" + toString_0(getKClassFromExpression(value)) + "'!");
                }
              }
            }
          }
        }
      }
    }
  }
  zu(encoder, value) {
    return this.xg2(encoder, !(value == null) ? value : THROW_CCE());
  }
  av(decoder) {
    var containerForAny = decoder.wy(Companion_getInstance_80().q1j());
    var tmp0_elvis_lhs = containerForAny.og2_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? containerForAny.pg2_1 : tmp0_elvis_lhs;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? containerForAny.qg2_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? containerForAny.rg2_1 : tmp2_elvis_lhs;
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? containerForAny.sg2_1 : tmp3_elvis_lhs;
    var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? containerForAny.tg2_1 : tmp4_elvis_lhs;
    var tmp6_elvis_lhs = tmp5_elvis_lhs == null ? containerForAny.ug2_1 : tmp5_elvis_lhs;
    var tmp;
    if (tmp6_elvis_lhs == null) {
      throw SerializationException.aw('AnySerializer: No non-null property in ContainerForAny found!');
    } else {
      tmp = tmp6_elvis_lhs;
    }
    return tmp;
  }
}
class EasingAsString {
  constructor() {
    EasingAsString_instance = this;
    this.yg2_1 = PrimitiveSerialDescriptor('EasingAsString', STRING_getInstance());
  }
  yu() {
    return this.yg2_1;
  }
  zg2(encoder, value) {
    return encoder.c10(substringAfter(toString_0(getKClassFromExpression(value)), _Char___init__impl__6a9atx(36)));
  }
  zu(encoder, value) {
    return this.zg2(encoder, (!(value == null) ? isInterface(value, Easing) : false) ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_elvis_lhs = get_ALL(Companion_getInstance_3()).e3(decoder.sy());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SerializationException.aw("EasingAsString: No Easing type for '" + decoder.sy() + "' found in decoder!");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
//endregion
function loadLevel($this, worldData, levelX, levelY, ldtkWorld, ldtkLevel) {
  var levelName = ldtkLevel.ld6_1;
  var tmp0_safe_receiver = ldtkLevel.nd6_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp0_safe_receiver.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>' call
      var layerName = element.cd7_1;
      var gridSize = element.bd7_1;
      // Inline function 'kotlin.collections.mutableListOf' call
      var entities = ArrayList.z();
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!element.kd7_1.j1()) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = element.kd7_1.b1();
        while (tmp0_iterator_0.c1()) {
          var element_0 = tmp0_iterator_0.d1();
          // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>' call
          var yamlString = StringBuilder.f();
          var tmp$ret$3;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator_1 = element_0.gcu_1.b1();
            while (tmp0_iterator_1.c1()) {
              var element_1 = tmp0_iterator_1.d1();
              // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
              if (element_1.oct_1 === 'entityConfig') {
                tmp$ret$3 = element_1;
                break $l$block;
              }
            }
            tmp$ret$3 = null;
          }
          if (!(tmp$ret$3 == null)) {
            var tmp$ret$5;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var tmp0_iterator_2 = element_0.dcu_1.b1();
              while (tmp0_iterator_2.c1()) {
                var element_2 = tmp0_iterator_2.d1();
                // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
                if (element_2 === 'unique') {
                  tmp$ret$5 = element_2;
                  break $l$block_0;
                }
              }
              tmp$ret$5 = null;
            }
            if (!(tmp$ret$5 == null)) {
              yamlString.gc('name: ' + element_0.acu_1 + '\n');
            } else {
              var _unary__edvuaz = $this.zeg_1;
              $this.zeg_1 = _unary__edvuaz + 1 | 0;
              yamlString.gc('name: ' + levelName + '_' + element_0.acu_1 + '_' + _unary__edvuaz + '\n');
            }
            var entityPosX = (imul($this.aeh_1, levelX) + imul(get_gridPos(element_0).s3r_1, gridSize) | 0) + numberToInt(element_0.bcu_1.h1(0) * gridSize) | 0;
            var entityPosY = (imul($this.beh_1, levelY) + imul(get_gridPos(element_0).t3r_1, gridSize) | 0) + numberToInt(element_0.bcu_1.h1(1) * gridSize) | 0;
            var tmp$ret$7;
            $l$block_1: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var tmp0_iterator_3 = element_0.dcu_1.b1();
              while (tmp0_iterator_3.c1()) {
                var element_3 = tmp0_iterator_3.d1();
                // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
                if (element_3 === 'positionable') {
                  tmp$ret$7 = element_3;
                  break $l$block_1;
                }
              }
              tmp$ret$7 = null;
            }
            if (tmp$ret$7 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
              yamlString.gc('x: ' + entityPosX + '\n');
              yamlString.gc('y: ' + entityPosY + '\n');
            }
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_4 = element_0.gcu_1.b1();
            while (tmp0_iterator_4.c1()) {
              var element_4 = tmp0_iterator_4.d1();
              // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
              if (!(element_4.oct_1 === 'EntityConfig')) {
                yamlString.gc(element_4.oct_1 + ': ' + toString(element_4.rct_1) + '\n');
              }
            }
            try {
              // Inline function 'kotlinx.serialization.decodeFromString' call
              var this_0 = GameStateManager_getInstance().deh_1.ieh();
              var string = yamlString.toString();
              // Inline function 'kotlinx.serialization.serializer' call
              var this_1 = this_0.mz();
              // Inline function 'kotlinx.serialization.internal.cast' call
              var this_2 = serializer(this_1, createKType(getKClass(EntityConfig), arrayOf([]), false));
              var tmp$ret$11 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
              var entityConfig = this_0.g1h(tmp$ret$11, string);
              entities.h(entityConfig.q3());
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                println('ERROR: Loading entity config - ' + e.toString());
              } else {
                throw $p;
              }
            }
          } else {
            println("ERROR: Game object with name '" + element_0.acu_1 + "' has no field entityConfig!");
          }
        }
      }
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_3 = worldData.oeh_1;
      if (!(isInterface(this_3, KtMap) ? this_3 : THROW_CCE()).c3(layerName)) {
        var gridWidth = (numberToInt(worldData.jeh_1) / $this.aeh_1 | 0) + 1 | 0;
        var gridHeight = (numberToInt(worldData.keh_1) / $this.beh_1 | 0) + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var this_4 = worldData.oeh_1;
        // Inline function 'kotlin.collections.List' call
        // Inline function 'kotlin.collections.MutableList' call
        var list = ArrayList.w(gridWidth);
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < gridWidth)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.MutableList.<anonymous>' call
            // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var list_0 = ArrayList.w(gridHeight);
            // Inline function 'kotlin.repeat' call
            // Inline function 'kotlin.contracts.contract' call
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < gridHeight)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.collections.MutableList.<anonymous>' call
                // Inline function 'korlibs.korge.fleks.assets.AssetLevelData.loadLevel.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$15 = new LevelData();
                list_0.h(tmp$ret$15);
              }
               while (inductionVariable_0 < gridHeight);
            list.h(list_0);
          }
           while (inductionVariable < gridWidth);
        var value = new LevelMap(list);
        this_4.k3(layerName, value);
      }
      var levelData = ensureNotNull(worldData.oeh_1.e3(layerName)).peh_1.h1(levelX).h1(levelY);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!entities.j1()) {
        levelData.qeh_1 = entities;
      } else {
        // Inline function 'kotlin.collections.get' call
        var this_5 = ldtkWorld.qdb_1;
        var key = element.gd7_1;
        if (!((isInterface(this_5, KtMap) ? this_5 : THROW_CCE()).e3(key) == null)) {
          // Inline function 'kotlin.collections.get' call
          var this_6 = ldtkWorld.qdb_1;
          var key_0 = element.gd7_1;
          var tmp$ret$23 = (isInterface(this_6, KtMap) ? this_6 : THROW_CCE()).e3(key_0);
          storeTiles($this, levelData, element, ensureNotNull(tmp$ret$23));
        } else {
          println("WARNING: Layer '" + layerName + "' of level '" + levelName + "' has no tile set or entities!");
        }
      }
    }
  }
}
function storeTiles($this, levelData, ldtkLayer, tilesetExt) {
  var tileMapData = TileMapData.n6y(ldtkLayer.ad7_1, ldtkLayer.zd6_1, !(tilesetExt.ddc_1 == null) ? ensureNotNull(tilesetExt.ddc_1) : Companion_getInstance().i6j_1);
  var gridSize = tilesetExt.cdc_1.jd1_1;
  var tilesetWidth = tilesetExt.cdc_1.dd1_1;
  var cellsTilesPerRow = tilesetWidth / gridSize | 0;
  var _iterator__ex2g4s = plus(ldtkLayer.jd7_1, ldtkLayer.ld7_1).b1();
  while (_iterator__ex2g4s.c1()) {
    var tile = _iterator__ex2g4s.d1();
    var _destruct__k2r9zo = tile.bd8_1;
    // Inline function 'kotlin.collections.component1' call
    var px = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var py = _destruct__k2r9zo[1];
    var x = px / gridSize | 0;
    var y = py / gridSize | 0;
    var _destruct__k2r9zo_0 = tile.cd8_1;
    // Inline function 'kotlin.collections.component1' call
    var tileX = _destruct__k2r9zo_0[0];
    // Inline function 'kotlin.collections.component2' call
    var tileY = _destruct__k2r9zo_0[1];
    var dx = px % gridSize | 0;
    var dy = py % gridSize | 0;
    var tx = tileX / gridSize | 0;
    var ty = tileY / gridSize | 0;
    var tileId = imul(ty, cellsTilesPerRow) + tx | 0;
    var flipX = hasBitSet(tile.ad8_1, 0);
    var flipY = hasBitSet(tile.ad8_1, 1);
    if (dx === 0 && dy === 0) {
      var stackLevel = tileMapData.i6y_1.u43(x, y);
      tileMapData.i6y_1.h44(x, y, stackLevel, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().f6y(tileId, dx, dy, flipX, flipY, false)));
    } else if (dx === 0 && !(dy === 0)) {
      // Inline function 'kotlin.math.max' call
      var a = tileMapData.i6y_1.u43(x, y);
      var b = tileMapData.i6y_1.u43(x, y + 1 | 0);
      var stackLevel_0 = Math.max(a, b);
      tileMapData.i6y_1.h44(x, y, stackLevel_0, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().f6y(tileId, dx, dy, flipX, flipY, false)));
      tileMapData.i6y_1.h44(x, y + 1 | 0, stackLevel_0, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().c6y_1));
    } else if (!(dx === 0) && dy === 0) {
      // Inline function 'kotlin.math.max' call
      var a_0 = tileMapData.i6y_1.u43(x, y);
      var b_0 = tileMapData.i6y_1.u43(x + 1 | 0, y);
      var stackLevel_1 = Math.max(a_0, b_0);
      tileMapData.i6y_1.h44(x, y, stackLevel_1, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().f6y(tileId, dx, dy, flipX, flipY, false)));
      tileMapData.i6y_1.h44(x + 1 | 0, y, stackLevel_1, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().c6y_1));
    } else {
      var stackLevel_2 = max(tileMapData.i6y_1.u43(x, y), tileMapData.i6y_1.u43(x, y + 1 | 0), tileMapData.i6y_1.u43(x + 1 | 0, y), tileMapData.i6y_1.u43(x + 1 | 0, y + 1 | 0));
      tileMapData.i6y_1.h44(x, y, stackLevel_2, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().f6y(tileId, dx, dy, flipX, flipY, false)));
      tileMapData.i6y_1.h44(x, y + 1 | 0, stackLevel_2, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().c6y_1));
      tileMapData.i6y_1.h44(x + 1 | 0, y, stackLevel_2, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().c6y_1));
      tileMapData.i6y_1.h44(x + 1 | 0, y + 1 | 0, stackLevel_2, _Tile___get_raw__impl__kp6cq8(Companion_getInstance_0().c6y_1));
    }
  }
  levelData.reh_1 = tileMapData;
}
var Companion_instance_1;
function Companion_getInstance_9() {
  return Companion_instance_1;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
var Companion_instance_2;
function Companion_getInstance_10() {
  return Companion_instance_2;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
var Companion_instance_3;
function Companion_getInstance_11() {
  if (Companion_instance_3 === VOID)
    new Companion_1();
  return Companion_instance_3;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
function *_generator_configureResourceDirWatcher__g7sbg1(_this__u8e3s4, cfg, $completion) {
  if (Companion_instance_4.qei_1 == null) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ResourceDirWatcherConfiguration();
    // Inline function 'kotlin.contracts.contract' call
    cfg(this_0);
    var tmp = this_0.wei(_this__u8e3s4, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var resourceDirWatcher = tmp;
    Companion_instance_4.qei_1 = resourceDirWatcher;
  } else {
    // Inline function 'kotlin.apply' call
    var this_1 = ensureNotNull(Companion_instance_4.qei_1);
    // Inline function 'kotlin.contracts.contract' call
    cfg(this_1);
    var tmp_0 = this_1.wei(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function configureResourceDirWatcher(_this__u8e3s4, cfg, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureResourceDirWatcher__g7sbg1.bind(VOID, _this__u8e3s4, cfg), $completion);
}
function *_generator_invoke__zhh2q8($this, it, $completion) {
  if (it.s3f_1.equals(Kind_MODIFIED_getInstance())) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.hd();
    var tmp = checkAssetFolders($this.xei_1, $this.yei_1, it.t3f_1, $this.zei_1, $this.aej_1, tmp$ret$0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = delay(new Long(500, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var assetName = $this.bej_1.v1();
  // Inline function 'kotlin.collections.set' call
  var this_0 = $this.cej_1.qej_1;
  var tmp_0 = $this.dej_1.sej_1;
  var tmp_1 = readBitmapFont(get_resourcesVfs().cj($this.eej_1.iei_1 + '/' + $this.bej_1.w1()), VOID, VOID, null, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var value = new Pair(tmp_0, tmp_1);
  this_0.k3(assetName, value);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = delay(new Long(500, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var assetName = $this.zej_1.v1();
  // Inline function 'kotlin.collections.set' call
  var this_0 = $this.aek_1.pej_1;
  var tmp_0 = $this.bek_1.sej_1;
  var tmp_1;
  if ($this.zej_1.w1().xeh_1 == null) {
    var tmp_2 = readImageDataContainer(get_resourcesVfs().cj($this.cek_1.iei_1 + '/' + $this.zej_1.w1().weh_1), toProps(ASE_getInstance()), null, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1 = tmp_2;
  } else {
    var props = toProps(ASE_getInstance());
    setExtra(props, 'layers', $this.zej_1.w1().xeh_1);
    var tmp_3 = readImageDataContainer(get_resourcesVfs().cj($this.cek_1.iei_1 + '/' + $this.zej_1.w1().weh_1), props, null, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_1 = tmp_3;
  }
  var value = new Pair(tmp_0, tmp_1);
  this_0.k3(assetName, value);
  var tmp_4 = delay(new Long(100, 0), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  $this.dek_1.vei_1 = false;
  println('Finished');
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.bek_1.vej_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>.<anonymous>.<anonymous>' call
    element();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = delay(new Long(100, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var assetName = $this.eek_1.v1();
  // Inline function 'kotlin.collections.set' call
  var this_0 = $this.fek_1.oej_1;
  var tmp_0 = $this.gek_1.sej_1;
  var tmp_1 = readParallaxDataContainer(get_resourcesVfs().cj($this.hek_1.iei_1 + '/' + $this.eek_1.w1().jek_1), $this.eek_1.w1(), ASE_getInstance(), null, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var value = new Pair(tmp_0, tmp_1);
  this_0.k3(assetName, value);
  println('\nTriggering asset change for: ' + assetName);
  var tmp_2 = delay(new Long(100, 0), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.iek_1.vei_1 = false;
  println('Finished');
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.gek_1.xej_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>.<anonymous>.<anonymous>' call
    element();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = delay(new Long(500, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = readLDTKWorld(get_resourcesVfs().cj($this.pek_1.iei_1 + '/' + $this.qek_1.w1().bei_1), true, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var ldtkWorld = tmp_0;
  println('\nTriggering asset change for LDtk: ' + $this.qek_1.w1().bei_1);
  var tmp0_safe_receiver = $this.rek_1.nej_1.e3($this.qek_1.v1());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.om_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.teh(ldtkWorld);
  }
  var tmp_1 = delay(new Long(100, 0), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.sek_1.vei_1 = false;
  println('Finished');
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.tek_1.yej_1.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>.<anonymous>.<anonymous>' call
    element();
  }
  return Unit_instance;
}
function *_generator_configure__qaq7w2($this, assetStore, $completion) {
  var tmp = enableAssetWatcher($this, assetStore, $this.rei_1, assetStore.jej_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = enableAssetWatcher($this, assetStore, $this.sei_1, assetStore.kej_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = enableAssetWatcher($this, assetStore, $this.tei_1, assetStore.lej_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = enableAssetWatcher($this, assetStore, $this.uei_1, assetStore.mej_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return $this;
}
function *_generator_enableAssetWatcher__5sv97r($this, assetStore, assetUpdater, assetConfig, $completion) {
  if (!assetUpdater.uej_1 && assetUpdater.tej_1) {
    assetUpdater.uej_1 = true;
    assetUpdater.tej_1 = false;
    // Inline function 'kotlin.apply' call
    var this_0 = get_resourcesVfs().cj(assetConfig.iei_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.enableAssetWatcher.<anonymous>' call
    var tmp = this_0.c3g($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (tmp.s3e_1) {
      println("Add watcher for '" + this_0.b3e_1 + "'");
      var tmp_0 = this_0.e3g(ResourceDirWatcherConfiguration$enableAssetWatcher$slambda_0($this, assetStore, assetUpdater, assetConfig), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  }
  return Unit_instance;
}
function enableAssetWatcher($this, assetStore, assetUpdater, assetConfig, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_enableAssetWatcher__5sv97r.bind(VOID, $this, assetStore, assetUpdater, assetConfig), $completion);
}
function *_generator_checkAssetFolders__nhctqh($this, assetStore, file, assetUpdater, assetConfig, assetReloadContext, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = assetConfig.nei_1.u1().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>' call
    if (contains(get_fullName(file), removeSuffix(element.w1(), '.fnt')) && !$this.vei_1) {
      $this.vei_1 = true;
      println('Reloading ' + assetConfig.iei_1 + '/' + element.w1() + ' for changes in ' + get_fullName(file) + ' ... ');
      launchImmediately(assetReloadContext, ResourceDirWatcherConfiguration$checkAssetFolders$slambda_3(element, assetStore, assetUpdater, assetConfig));
      var tmp = delay(new Long(100, 0), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      $this.vei_1 = false;
      println('Finished');
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = assetUpdater.wej_1.b1();
      while (tmp0_iterator_0.c1()) {
        var element_0 = tmp0_iterator_0.d1();
        // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>.<anonymous>' call
        element_0();
      }
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_1 = assetConfig.mei_1.u1().b1();
  while (tmp0_iterator_1.c1()) {
    var element_1 = tmp0_iterator_1.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>' call
    if (contains(get_fullName(file), element_1.w1().weh_1) && !$this.vei_1) {
      $this.vei_1 = true;
      println('Reloading ' + get_fullName(file) + '... ');
      launchImmediately(assetReloadContext, ResourceDirWatcherConfiguration$checkAssetFolders$slambda_4(element_1, assetStore, assetUpdater, assetConfig, $this));
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_2 = assetConfig.lei_1.u1().b1();
  while (tmp0_iterator_2.c1()) {
    var element_2 = tmp0_iterator_2.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>' call
    if (contains(get_fullName(file), element_2.w1().jek_1) && !$this.vei_1) {
      $this.vei_1 = true;
      println('Reloading ' + get_fullName(file) + '... ');
      launchImmediately(assetReloadContext, ResourceDirWatcherConfiguration$checkAssetFolders$slambda_5(element_2, assetStore, assetUpdater, assetConfig, $this));
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_3 = assetConfig.oei_1.u1().b1();
  while (tmp0_iterator_3.c1()) {
    var element_3 = tmp0_iterator_3.d1();
    // Inline function 'korlibs.korge.fleks.assets.ResourceDirWatcherConfiguration.checkAssetFolders.<anonymous>' call
    if (contains(get_fullName(file), element_3.w1().bei_1) && !$this.vei_1) {
      $this.vei_1 = true;
      println('Reloading ' + get_fullName(file) + '... ');
      launchImmediately(assetReloadContext, ResourceDirWatcherConfiguration$checkAssetFolders$slambda_6(assetConfig, element_3, assetStore, $this, assetUpdater));
    }
  }
  return Unit_instance;
}
function checkAssetFolders($this, assetStore, file, assetUpdater, assetConfig, assetReloadContext, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_checkAssetFolders__nhctqh.bind(VOID, $this, assetStore, file, assetUpdater, assetConfig, assetReloadContext), $completion);
}
var Companion_instance_4;
function Companion_getInstance_12() {
  return Companion_instance_4;
}
function ResourceDirWatcherConfiguration$enableAssetWatcher$slambda_0(this$0, $assetStore, $assetUpdater, $assetConfig) {
  var i = new ResourceDirWatcherConfiguration$enableAssetWatcher$slambda(this$0, $assetStore, $assetUpdater, $assetConfig);
  var l = function (it, $completion) {
    return i.h3g(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function ResourceDirWatcherConfiguration$checkAssetFolders$slambda_3($config, $assetStore, $assetUpdater, $assetConfig) {
  var i = new ResourceDirWatcherConfiguration$checkAssetFolders$slambda($config, $assetStore, $assetUpdater, $assetConfig);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function ResourceDirWatcherConfiguration$checkAssetFolders$slambda_4($config, $assetStore, $assetUpdater, $assetConfig, this$0) {
  var i = new ResourceDirWatcherConfiguration$checkAssetFolders$slambda_0($config, $assetStore, $assetUpdater, $assetConfig, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function ResourceDirWatcherConfiguration$checkAssetFolders$slambda_5($config, $assetStore, $assetUpdater, $assetConfig, this$0) {
  var i = new ResourceDirWatcherConfiguration$checkAssetFolders$slambda_1($config, $assetStore, $assetUpdater, $assetConfig, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function ResourceDirWatcherConfiguration$checkAssetFolders$slambda_6($assetConfig, $config, $assetStore, this$0, $assetUpdater) {
  var i = new ResourceDirWatcherConfiguration$checkAssetFolders$slambda_2($assetConfig, $config, $assetStore, this$0, $assetUpdater);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_loadAssets__gde0f3($this, type, assetConfig, $completion) {
  var assetLoaded = false;
  var tmp;
  switch (type.p3_1) {
    case 0:
      var tmp1_safe_receiver = prepareCurrentAssets($this, type, assetConfig, $this.jej_1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
        $this.jej_1 = tmp1_safe_receiver;
        assetLoaded = true;
      }

      tmp = $this.fej_1;
      break;
    case 1:
      var tmp2_safe_receiver = prepareCurrentAssets($this, type, assetConfig, $this.kej_1);
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
        $this.kej_1 = tmp2_safe_receiver;
        assetLoaded = true;
      }

      tmp = $this.gej_1;
      break;
    case 2:
      var tmp3_safe_receiver = prepareCurrentAssets($this, type, assetConfig, $this.lej_1);
      if (tmp3_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
        $this.lej_1 = tmp3_safe_receiver;
        assetLoaded = true;
      }

      tmp = $this.hej_1;
      break;
    case 3:
      var tmp4_safe_receiver = prepareCurrentAssets($this, type, assetConfig, $this.mej_1);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
        $this.mej_1 = tmp4_safe_receiver;
        assetLoaded = true;
      }

      tmp = $this.iej_1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var atlas = tmp;
  if (assetLoaded) {
    var sw = (new Stopwatch()).v2f();
    println('AssetStore: Start loading [' + type.o3_1 + "] resources from '" + assetConfig.iei_1 + "'...");
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = assetConfig.oei_1.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
      var tmp_0 = readLDTKWorld(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element.w1().bei_1), true, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var ldtkWorld = tmp_0;
      var levelData = new AssetLevelData();
      levelData.seh(ldtkWorld);
      // Inline function 'kotlin.collections.set' call
      var this_0 = $this.nej_1;
      var key = element.v1();
      var value = new Pair(type, levelData);
      this_0.k3(key, value);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = assetConfig.kei_1.u1().b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
      var tmp_1 = readSound(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element_0.w1()), new AudioDecodingProps(true), true, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var soundFile = tmp_1;
      var tmp_2 = soundFile.t7o(VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      var soundChannel = tmp_2;
      soundChannel.p7o();
      // Inline function 'kotlin.collections.set' call
      var this_1 = $this.rej_1;
      var key_0 = element_0.v1();
      var value_0 = new Pair(type, soundChannel);
      this_1.k3(key_0, value_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_1 = assetConfig.lei_1.u1().b1();
    while (tmp0_iterator_1.c1()) {
      var element_1 = tmp0_iterator_1.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var this_2 = $this.oej_1;
      var key_1 = element_1.v1();
      var tmp_3 = readParallaxDataContainer(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element_1.w1().jek_1), element_1.w1(), ASE_getInstance(), atlas, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var value_1 = new Pair(type, tmp_3);
      this_2.k3(key_1, value_1);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = assetConfig.mei_1.u1().b1();
    while (tmp0_iterator_2.c1()) {
      var element_2 = tmp0_iterator_2.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var this_3 = $this.pej_1;
      var key_2 = element_2.v1();
      var tmp_4;
      if (element_2.w1().xeh_1 == null) {
        var tmp_5 = readImageDataContainer(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element_2.w1().weh_1), toProps(ASE_getInstance()), atlas, $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5;
      } else {
        var props = toProps(ASE_getInstance());
        setExtra(props, 'layers', element_2.w1().xeh_1);
        var tmp_6 = readImageDataContainer(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element_2.w1().weh_1), props, atlas, $completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        tmp_4 = tmp_6;
      }
      var value_2 = new Pair(type, tmp_4);
      this_3.k3(key_2, value_2);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = assetConfig.nei_1.u1().b1();
    while (tmp0_iterator_3.c1()) {
      var element_3 = tmp0_iterator_3.d1();
      // Inline function 'korlibs.korge.fleks.assets.AssetStore.loadAssets.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var this_4 = $this.qej_1;
      var key_3 = element_3.v1();
      var tmp_7 = readBitmapFont(get_resourcesVfs().cj(assetConfig.iei_1 + '/' + element_3.w1()), VOID, VOID, atlas, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      var value_3 = new Pair(type, tmp_7);
      this_4.k3(key_3, value_3);
    }
    println('Assets: Loaded resources in ' + Duration__toString_impl_8d916b(sw.f7t()));
    if (assetConfig.jei_1) {
      var tmp_8 = configureResourceDirWatcher($this, AssetStore$loadAssets$lambda(type), $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
    }
  }
  return Unit_instance;
}
function prepareCurrentAssets($this, type, newAssetConfig, currentAssetConfig) {
  var tmp0_subject = currentAssetConfig.iei_1;
  var tmp;
  if (tmp0_subject === '') {
    tmp = newAssetConfig;
  } else if (tmp0_subject === newAssetConfig.iei_1) {
    var tmp_0;
    if (newAssetConfig.jei_1) {
      println('INFO: Reload ' + type.toString() + " assets '" + newAssetConfig.iei_1 + "'.");
      tmp_0 = newAssetConfig;
    } else {
      println('INFO: ' + type.toString() + " assets '" + newAssetConfig.iei_1 + "' already loaded! No reload is happening!");
      tmp_0 = null;
    }
    tmp = tmp_0;
  } else {
    println('INFO: Remove old ' + type.toString() + ' assets and load new ones!');
    removeAssets($this, type);
    tmp = newAssetConfig;
  }
  return tmp;
}
function removeAssets($this, type) {
  var tmp = $this.oej_1.n3();
  removeAll(tmp, AssetStore$removeAssets$lambda(type));
  var tmp_0 = $this.pej_1.n3();
  removeAll(tmp_0, AssetStore$removeAssets$lambda_0(type));
  var tmp_1 = $this.qej_1.n3();
  removeAll(tmp_1, AssetStore$removeAssets$lambda_1(type));
  var tmp_2 = $this.rej_1.n3();
  removeAll(tmp_2, AssetStore$removeAssets$lambda_2(type));
  var tmp_3 = $this.nej_1.n3();
  removeAll(tmp_3, AssetStore$removeAssets$lambda_3(type));
}
function AssetStore$loadAssets$lambda$lambda($this$addAssetWatcher) {
  return Unit_instance;
}
function AssetStore$loadAssets$lambda($type) {
  return function ($this$configureResourceDirWatcher) {
    $this$configureResourceDirWatcher.uek($type, AssetStore$loadAssets$lambda$lambda);
    return Unit_instance;
  };
}
function AssetStore$removeAssets$lambda($type) {
  return function (it) {
    return it.nm_1.equals($type);
  };
}
function AssetStore$removeAssets$lambda_0($type) {
  return function (it) {
    return it.nm_1.equals($type);
  };
}
function AssetStore$removeAssets$lambda_1($type) {
  return function (it) {
    return it.nm_1.equals($type);
  };
}
function AssetStore$removeAssets$lambda_2($type) {
  return function (it) {
    return it.nm_1.equals($type);
  };
}
function AssetStore$removeAssets$lambda_3($type) {
  return function (it) {
    return it.nm_1.equals($type);
  };
}
var AssetType_COMMON_instance;
var AssetType_WORLD_instance;
var AssetType_LEVEL_instance;
var AssetType_SPECIAL_instance;
var AssetType_entriesInitialized;
function AssetType_initEntries() {
  if (AssetType_entriesInitialized)
    return Unit_instance;
  AssetType_entriesInitialized = true;
  AssetType_COMMON_instance = new AssetType('COMMON', 0);
  AssetType_WORLD_instance = new AssetType('WORLD', 1);
  AssetType_LEVEL_instance = new AssetType('LEVEL', 2);
  AssetType_SPECIAL_instance = new AssetType('SPECIAL', 3);
}
function AssetType_COMMON_getInstance() {
  AssetType_initEntries();
  return AssetType_COMMON_instance;
}
function AssetType_WORLD_getInstance() {
  AssetType_initEntries();
  return AssetType_WORLD_instance;
}
function AssetType_LEVEL_getInstance() {
  AssetType_initEntries();
  return AssetType_LEVEL_instance;
}
function AssetType_SPECIAL_getInstance() {
  AssetType_initEntries();
  return AssetType_SPECIAL_instance;
}
var Mode_HORIZONTAL_PLANE_instance;
var Mode_VERTICAL_PLANE_instance;
var Mode_NO_PLANE_instance;
function values_0() {
  return [Mode_HORIZONTAL_PLANE_getInstance(), Mode_VERTICAL_PLANE_getInstance(), Mode_NO_PLANE_getInstance()];
}
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_HORIZONTAL_PLANE_instance = new Mode('HORIZONTAL_PLANE', 0);
  Mode_VERTICAL_PLANE_instance = new Mode('VERTICAL_PLANE', 1);
  Mode_NO_PLANE_instance = new Mode('NO_PLANE', 2);
}
var Companion_instance_5;
function Companion_getInstance_13() {
  if (Companion_instance_5 === VOID)
    new Companion_3();
  return Companion_instance_5;
}
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
function Mode_HORIZONTAL_PLANE_getInstance() {
  Mode_initEntries();
  return Mode_HORIZONTAL_PLANE_instance;
}
function Mode_VERTICAL_PLANE_getInstance() {
  Mode_initEntries();
  return Mode_VERTICAL_PLANE_instance;
}
function Mode_NO_PLANE_getInstance() {
  Mode_initEntries();
  return Mode_NO_PLANE_instance;
}
function *_generator_readParallaxDataContainer__r0i8qe(_this__u8e3s4, config, format, atlas, $completion) {
  format = format === VOID ? ASE_getInstance() : format;
  atlas = atlas === VOID ? null : atlas;
  var props = new ImageDecodingProps(get_baseName(_this__u8e3s4), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, ExtraTypeCreate());
  var tmp;
  if (!(config.mek_1 == null)) {
    setExtra(props, 'layers', joinToString(config.mek_1, ',', VOID, VOID, VOID, VOID, readParallaxDataContainer$lambda));
    setExtra(props, 'disableSlicing', true);
    var tmp_0 = readAsSyncStream(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var out = format.i6m(tmp_0, props);
    tmp = !(atlas == null) ? packInMutableAtlas(out, atlas) : out;
  } else {
    tmp = null;
  }
  var backgroundLayers = tmp;
  var tmp_1;
  if (!(config.oek_1 == null)) {
    setExtra(props, 'layers', joinToString(config.oek_1, ',', VOID, VOID, VOID, VOID, readParallaxDataContainer$lambda_0));
    setExtra(props, 'disableSlicing', true);
    var tmp_2 = readAsSyncStream(_this__u8e3s4, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var out_0 = format.i6m(tmp_2, props);
    tmp_1 = !(atlas == null) ? packInMutableAtlas(out_0, atlas) : out_0;
  } else {
    tmp_1 = null;
  }
  var foregroundLayers = tmp_1;
  var tmp_3;
  var tmp0_safe_receiver = config.nek_1;
  if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qel_1) == null)) {
    setExtra(props, 'layers', joinToString(config.nek_1.qel_1, ',', VOID, VOID, VOID, VOID, readParallaxDataContainer$lambda_1));
    setExtra(props, 'disableSlicing', true);
    var tmp_4 = readAsSyncStream(_this__u8e3s4, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var out_1 = format.i6m(tmp_4, props);
    tmp_3 = !(atlas == null) ? packInMutableAtlas(out_1, atlas) : out_1;
  } else {
    tmp_3 = null;
  }
  var attachedLayersFront = tmp_3;
  var tmp_5;
  var tmp1_safe_receiver = config.nek_1;
  if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rel_1) == null)) {
    setExtra(props, 'layers', joinToString(config.nek_1.rel_1, ',', VOID, VOID, VOID, VOID, readParallaxDataContainer$lambda_2));
    setExtra(props, 'disableSlicing', true);
    var tmp_6 = readAsSyncStream(_this__u8e3s4, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var out_2 = format.i6m(tmp_6, props);
    tmp_5 = !(atlas == null) ? packInMutableAtlas(out_2, atlas) : out_2;
  } else {
    tmp_5 = null;
  }
  var attachedLayersRear = tmp_5;
  var tmp_7;
  if (!(config.nek_1 == null)) {
    setExtra(props, 'layers', config.nek_1.nel_1);
    setExtra(props, 'disableSlicing', false);
    setExtra(props, 'useSlicePosition', true);
    var tmp_8 = readAsSyncStream(_this__u8e3s4, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    var out_3 = format.r6k(tmp_8, props);
    tmp_7 = !(atlas == null) ? packInMutableAtlas_0(out_3, atlas) : out_3;
  } else {
    tmp_7 = null;
  }
  var parallaxPlane = tmp_7;
  var tmp2_safe_receiver = config.mek_1;
  var tmp_9;
  if (tmp2_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp2_safe_receiver, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = tmp2_safe_receiver.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var tmp$ret$0 = element.tel_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp_9 = destination;
  }
  var backgroundLayerMap = tmp_9;
  var tmp4_safe_receiver = backgroundLayers == null ? null : backgroundLayers.s6n_1;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.b6n_1;
  if (tmp5_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n = 0;
    while (n < tmp5_safe_receiver.g1()) {
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var index = n;
      var layerData = tmp5_safe_receiver.h1(n);
      if (!(config.mek_1 == null)) {
        var tmp0_elvis_lhs = layerData.n6l_1;
        var tmp_10;
        if (tmp0_elvis_lhs == null) {
          var message = 'readParallaxDataContainer: Background layer does not have a name in Aseprite file!';
          throw IllegalStateException.h5(toString_0(message));
        } else {
          tmp_10 = tmp0_elvis_lhs;
        }
        var layerName = tmp_10;
        var tmp2_elvis_lhs = backgroundLayerMap == null ? null : backgroundLayerMap.e3(layerName);
        var tmp_11;
        if (tmp2_elvis_lhs == null) {
          var message_0 = "readParallaxDataContainer: Background layer name '" + layerData.n6l_1 + "' not consistent between config and Aseprite file!";
          throw IllegalStateException.h5(toString_0(message_0));
        } else {
          tmp_11 = tmp2_elvis_lhs;
        }
        config.mek_1.i3(index, tmp_11);
      } else {
        // Inline function 'kotlin.error' call
        var message_1 = "readParallaxDataContainer: Background layer empty for layer '" + layerData.n6l_1 + "'!";
        throw IllegalStateException.h5(toString_0(message_1));
      }
      n = n + 1 | 0;
    }
  }
  var tmp6_safe_receiver = config.oek_1;
  var tmp_12;
  if (tmp6_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp6_safe_receiver, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.xc(capacity_0);
    var tmp0_iterator_0 = tmp6_safe_receiver.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var tmp$ret$3 = element_0.tel_1;
      destination_0.k3(tmp$ret$3, element_0);
    }
    tmp_12 = destination_0;
  }
  var foregroundLayerMap = tmp_12;
  var tmp8_safe_receiver = foregroundLayers == null ? null : foregroundLayers.s6n_1;
  var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.b6n_1;
  if (tmp9_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n_0 = 0;
    while (n_0 < tmp9_safe_receiver.g1()) {
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var index_0 = n_0;
      var layerData_0 = tmp9_safe_receiver.h1(n_0);
      if (!(config.oek_1 == null)) {
        var tmp0_elvis_lhs_0 = layerData_0.n6l_1;
        var tmp_13;
        if (tmp0_elvis_lhs_0 == null) {
          var message_2 = 'readParallaxDataContainer: Foreground layer does not have a name in Aseprite file!';
          throw IllegalStateException.h5(toString_0(message_2));
        } else {
          tmp_13 = tmp0_elvis_lhs_0;
        }
        var layerName_0 = tmp_13;
        var tmp2_elvis_lhs_0 = foregroundLayerMap == null ? null : foregroundLayerMap.e3(layerName_0);
        var tmp_14;
        if (tmp2_elvis_lhs_0 == null) {
          var message_3 = "readParallaxDataContainer: Foreground layer name '" + layerData_0.n6l_1 + "' not consistent between config and Aseprite file!";
          throw IllegalStateException.h5(toString_0(message_3));
        } else {
          tmp_14 = tmp2_elvis_lhs_0;
        }
        config.oek_1.i3(index_0, tmp_14);
      } else {
        // Inline function 'kotlin.error' call
        var message_4 = "readParallaxDataContainer: Foreground layer empty for layer '" + layerData_0.n6l_1 + "'!";
        throw IllegalStateException.h5(toString_0(message_4));
      }
      n_0 = n_0 + 1 | 0;
    }
  }
  var tmp10_safe_receiver = config.nek_1;
  var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.qel_1;
  var tmp_15;
  if (tmp11_safe_receiver == null) {
    tmp_15 = null;
  } else {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp11_safe_receiver, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap.xc(capacity_1);
    var tmp0_iterator_1 = tmp11_safe_receiver.b1();
    while (tmp0_iterator_1.c1()) {
      var element_1 = tmp0_iterator_1.d1();
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var tmp$ret$6 = element_1.zel_1;
      destination_1.k3(tmp$ret$6, element_1);
    }
    tmp_15 = destination_1;
  }
  var attachedLayerFrontMap = tmp_15;
  var tmp13_safe_receiver = attachedLayersFront == null ? null : attachedLayersFront.s6n_1;
  var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.b6n_1;
  if (tmp14_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n_1 = 0;
    while (n_1 < tmp14_safe_receiver.g1()) {
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var index_1 = n_1;
      var layerData_1 = tmp14_safe_receiver.h1(n_1);
      var tmp3_safe_receiver = config.nek_1;
      if (!((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.qel_1) == null)) {
        var tmp0_elvis_lhs_1 = layerData_1.n6l_1;
        var tmp_16;
        if (tmp0_elvis_lhs_1 == null) {
          var message_5 = 'readParallaxDataContainer: Attached front layer does not have a name in Aseprite file!';
          throw IllegalStateException.h5(toString_0(message_5));
        } else {
          tmp_16 = tmp0_elvis_lhs_1;
        }
        var layerName_1 = tmp_16;
        var tmp2_elvis_lhs_1 = attachedLayerFrontMap == null ? null : attachedLayerFrontMap.e3(layerName_1);
        var tmp_17;
        if (tmp2_elvis_lhs_1 == null) {
          var message_6 = "readParallaxDataContainer: Attached front layer name '" + layerData_1.n6l_1 + "' not consistent between config and Aseprite file!";
          throw IllegalStateException.h5(toString_0(message_6));
        } else {
          tmp_17 = tmp2_elvis_lhs_1;
        }
        config.nek_1.qel_1.i3(index_1, tmp_17);
      } else {
        var message_7 = "readParallaxDataContainer: Attached front layer empty for layer '" + layerData_1.n6l_1 + "'!";
        throw IllegalStateException.h5(toString_0(message_7));
      }
      n_1 = n_1 + 1 | 0;
    }
  }
  var tmp15_safe_receiver = config.nek_1;
  var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.rel_1;
  var tmp_18;
  if (tmp16_safe_receiver == null) {
    tmp_18 = null;
  } else {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp16_safe_receiver, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_2 = LinkedHashMap.xc(capacity_2);
    var tmp0_iterator_2 = tmp16_safe_receiver.b1();
    while (tmp0_iterator_2.c1()) {
      var element_2 = tmp0_iterator_2.d1();
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var tmp$ret$9 = element_2.zel_1;
      destination_2.k3(tmp$ret$9, element_2);
    }
    tmp_18 = destination_2;
  }
  var attachedLayerRearMap = tmp_18;
  var tmp18_safe_receiver = attachedLayersRear == null ? null : attachedLayersRear.s6n_1;
  var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.b6n_1;
  if (tmp19_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n_2 = 0;
    while (n_2 < tmp19_safe_receiver.g1()) {
      // Inline function 'korlibs.korge.fleks.assets.readParallaxDataContainer.<anonymous>' call
      var index_2 = n_2;
      var layerData_2 = tmp19_safe_receiver.h1(n_2);
      var tmp3_safe_receiver_0 = config.nek_1;
      if (!((tmp3_safe_receiver_0 == null ? null : tmp3_safe_receiver_0.rel_1) == null)) {
        var tmp0_elvis_lhs_2 = layerData_2.n6l_1;
        var tmp_19;
        if (tmp0_elvis_lhs_2 == null) {
          var message_8 = 'readParallaxDataContainer: Attached rear layer does not have a name in Aseprite file!';
          throw IllegalStateException.h5(toString_0(message_8));
        } else {
          tmp_19 = tmp0_elvis_lhs_2;
        }
        var layerName_2 = tmp_19;
        var tmp2_elvis_lhs_2 = attachedLayerRearMap == null ? null : attachedLayerRearMap.e3(layerName_2);
        var tmp_20;
        if (tmp2_elvis_lhs_2 == null) {
          var message_9 = "readParallaxDataContainer: Attached rear layer name '" + layerData_2.n6l_1 + "' not consistent between config and Aseprite file!";
          throw IllegalStateException.h5(toString_0(message_9));
        } else {
          tmp_20 = tmp2_elvis_lhs_2;
        }
        config.nek_1.rel_1.i3(index_2, tmp_20);
      } else {
        var message_10 = "readParallaxDataContainer: Attached rear layer empty for layer '" + layerData_2.n6l_1 + "'!";
        throw IllegalStateException.h5(toString_0(message_10));
      }
      n_2 = n_2 + 1 | 0;
    }
  }
  var tmp_21;
  switch (config.lek_1.p3_1) {
    case 0:
      var tmp22_elvis_lhs = backgroundLayers == null ? null : backgroundLayers.o6n_1;
      var tmp_22;
      if (tmp22_elvis_lhs == null) {
        tmp_22 = foregroundLayers == null ? null : foregroundLayers.o6n_1;
      } else {
        tmp_22 = tmp22_elvis_lhs;
      }

      var tmp24_elvis_lhs = tmp_22;
      var tmp_23;
      if (tmp24_elvis_lhs == null) {
        tmp_23 = attachedLayersFront == null ? null : attachedLayersFront.o6n_1;
      } else {
        tmp_23 = tmp24_elvis_lhs;
      }

      var tmp26_elvis_lhs = tmp_23;
      var tmp_24;
      if (tmp26_elvis_lhs == null) {
        tmp_24 = attachedLayersRear == null ? null : attachedLayersRear.o6n_1;
      } else {
        tmp_24 = tmp26_elvis_lhs;
      }

      var tmp28_elvis_lhs = tmp_24;
      tmp_21 = (tmp28_elvis_lhs == null ? 0 : tmp28_elvis_lhs) - config.kek_1 | 0;
      break;
    case 1:
      var tmp30_elvis_lhs = backgroundLayers == null ? null : backgroundLayers.n6n_1;
      var tmp_25;
      if (tmp30_elvis_lhs == null) {
        tmp_25 = foregroundLayers == null ? null : foregroundLayers.n6n_1;
      } else {
        tmp_25 = tmp30_elvis_lhs;
      }

      var tmp32_elvis_lhs = tmp_25;
      var tmp_26;
      if (tmp32_elvis_lhs == null) {
        tmp_26 = attachedLayersFront == null ? null : attachedLayersFront.n6n_1;
      } else {
        tmp_26 = tmp32_elvis_lhs;
      }

      var tmp34_elvis_lhs = tmp_26;
      var tmp_27;
      if (tmp34_elvis_lhs == null) {
        tmp_27 = attachedLayersRear == null ? null : attachedLayersRear.o6n_1;
      } else {
        tmp_27 = tmp34_elvis_lhs;
      }

      var tmp36_elvis_lhs = tmp_27;
      tmp_21 = (tmp36_elvis_lhs == null ? 0 : tmp36_elvis_lhs) - config.kek_1 | 0;
      break;
    case 2:
      tmp_21 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var parallaxLayerSize = tmp_21;
  var tmp37_safe_receiver = config.nek_1;
  if (tmp37_safe_receiver == null)
    null;
  else {
    var tmp_28 = tmp37_safe_receiver;
    var tmp_29 = 0;
    var tmp_30 = new Float32Array(parallaxLayerSize);
    while (tmp_29 < parallaxLayerSize) {
      var tmp_31 = tmp_29;
      var midPoint = parallaxLayerSize * 0.5;
      tmp_30[tmp_31] = ensureNotNull(config.nek_1).oel_1 * (tmp_31 < midPoint ? 1.0 - tmp_31 / midPoint : (tmp_31 - midPoint + 1.0) / midPoint);
      tmp_29 = tmp_29 + 1 | 0;
    }
    tmp_28.sel_1 = tmp_30;
  }
  return new ParallaxDataContainer(config, backgroundLayers, foregroundLayers, attachedLayersFront, attachedLayersRear, parallaxPlane);
}
function readParallaxDataContainer(_this__u8e3s4, config, format, atlas, $completion) {
  format = format === VOID ? ASE_getInstance() : format;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readParallaxDataContainer__r0i8qe.bind(VOID, _this__u8e3s4, config, format, atlas), $completion);
}
var Companion_instance_6;
function Companion_getInstance_14() {
  return Companion_instance_6;
}
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
var Companion_instance_7;
function Companion_getInstance_15() {
  if (Companion_instance_7 === VOID)
    new Companion_5();
  return Companion_instance_7;
}
var $serializer_instance_4;
function $serializer_getInstance_5() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
var Companion_instance_8;
function Companion_getInstance_16() {
  return Companion_instance_8;
}
var $serializer_instance_5;
function $serializer_getInstance_6() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
function readParallaxDataContainer$lambda(it) {
  return it.tel_1;
}
function readParallaxDataContainer$lambda_0(it) {
  return it.tel_1;
}
function readParallaxDataContainer$lambda_1(it) {
  return it.zel_1;
}
function readParallaxDataContainer$lambda_2(it) {
  return it.zel_1;
}
function processTiles($this, gridX, gridY, xStart, yStart, xEnd, yEnd, levelWidth, levelHeight, renderCall) {
  var tmp0_safe_receiver = $this.peh_1.h1(gridX).h1(gridY).reh_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tileSet = tmp0_safe_receiver.j6y_1;
    var tileWidth = tileSet.m6z_1;
    var tileHeight = tileSet.n6z_1;
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.r43();
    if (inductionVariable < last)
      do {
        var l = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = xStart;
        if (inductionVariable_0 < xEnd)
          do {
            var tx = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var inductionVariable_1 = yStart;
            if (inductionVariable_1 < yEnd)
              do {
                var ty = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var tile = tmp0_safe_receiver.s6y(tx, ty, l);
                var tileInfo = tileSet.u6z(_Tile___get_tile__impl__nfq1aw(tile));
                if (!(tileInfo == null)) {
                  var px = (imul(tx, tileWidth) + _Tile___get_offsetX__impl__qwhdsd(tile) | 0) + imul(imul(gridX, levelWidth), tileWidth) | 0;
                  var py = (imul(ty, tileHeight) + _Tile___get_offsetY__impl__1x539u(tile) | 0) + imul(imul(gridY, levelHeight), tileHeight) | 0;
                  renderCall(tileInfo.a6z_1, px, py);
                }
              }
               while (inductionVariable_1 < yEnd);
          }
           while (inductionVariable_0 < xEnd);
      }
       while (inductionVariable < last);
  }
}
var Companion_instance_9;
function Companion_getInstance_17() {
  if (Companion_instance_9 === VOID)
    new Companion_7();
  return Companion_instance_9;
}
var $serializer_instance_6;
function $serializer_getInstance_7() {
  if ($serializer_instance_6 === VOID)
    new $serializer_6();
  return $serializer_instance_6;
}
var Companion_instance_10;
function Companion_getInstance_18() {
  if (Companion_instance_10 === VOID)
    new Companion_8();
  return Companion_instance_10;
}
var $serializer_instance_7;
function $serializer_getInstance_8() {
  if ($serializer_instance_7 === VOID)
    new $serializer_7();
  return $serializer_instance_7;
}
var Companion_instance_11;
function Companion_getInstance_19() {
  if (Companion_instance_11 === VOID)
    new Companion_9();
  return Companion_instance_11;
}
var $serializer_instance_8;
function $serializer_getInstance_9() {
  if ($serializer_instance_8 === VOID)
    new $serializer_8();
  return $serializer_instance_8;
}
var Companion_instance_12;
function Companion_getInstance_20() {
  if (Companion_instance_12 === VOID)
    new Companion_10();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_21() {
  if (Companion_instance_13 === VOID)
    new Companion_11();
  return Companion_instance_13;
}
var $serializer_instance_9;
function $serializer_getInstance_10() {
  if ($serializer_instance_9 === VOID)
    new $serializer_9();
  return $serializer_instance_9;
}
var Companion_instance_14;
function Companion_getInstance_22() {
  if (Companion_instance_14 === VOID)
    new Companion_12();
  return Companion_instance_14;
}
var $serializer_instance_10;
function $serializer_getInstance_11() {
  if ($serializer_instance_10 === VOID)
    new $serializer_10();
  return $serializer_instance_10;
}
var Companion_instance_15;
function Companion_getInstance_23() {
  return Companion_instance_15;
}
var $serializer_instance_11;
function $serializer_getInstance_12() {
  if ($serializer_instance_11 === VOID)
    new $serializer_11();
  return $serializer_instance_11;
}
var Companion_instance_16;
function Companion_getInstance_24() {
  if (Companion_instance_16 === VOID)
    new Companion_14();
  return Companion_instance_16;
}
var $serializer_instance_12;
function $serializer_getInstance_13() {
  if ($serializer_instance_12 === VOID)
    new $serializer_12();
  return $serializer_instance_12;
}
function LayeredSpriteComponent$onAdd$lambda($layer) {
  return function ($this$entity, it) {
    var component = $layer.neo_1;
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = $this$entity.i1v_1;
    if (this_0.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    var component_0 = $layer.oeo_1;
    var compType_0 = component_0.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType_0.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType_0.m1t())) {
      var tmp_5 = compType_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(compType_0.m1t());
    var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
    holder_0.l1u(it, component_0);
    return Unit_instance;
  };
}
var Companion_instance_17;
function Companion_getInstance_25() {
  if (Companion_instance_17 === VOID)
    new Companion_15();
  return Companion_instance_17;
}
var $serializer_instance_13;
function $serializer_getInstance_14() {
  if ($serializer_instance_13 === VOID)
    new $serializer_13();
  return $serializer_instance_13;
}
var Companion_instance_18;
function Companion_getInstance_26() {
  if (Companion_instance_18 === VOID)
    new Companion_16();
  return Companion_instance_18;
}
var $serializer_instance_14;
function $serializer_getInstance_15() {
  if ($serializer_instance_14 === VOID)
    new $serializer_14();
  return $serializer_instance_14;
}
var Companion_instance_19;
function Companion_getInstance_27() {
  if (Companion_instance_19 === VOID)
    new Companion_17();
  return Companion_instance_19;
}
var $serializer_instance_15;
function $serializer_getInstance_16() {
  if ($serializer_instance_15 === VOID)
    new $serializer_15();
  return $serializer_instance_15;
}
var Companion_instance_20;
function Companion_getInstance_28() {
  if (Companion_instance_20 === VOID)
    new Companion_18();
  return Companion_instance_20;
}
var $serializer_instance_16;
function $serializer_getInstance_17() {
  if ($serializer_instance_16 === VOID)
    new $serializer_16();
  return $serializer_instance_16;
}
var Companion_instance_21;
function Companion_getInstance_29() {
  if (Companion_instance_21 === VOID)
    new Companion_19();
  return Companion_instance_21;
}
var $serializer_instance_17;
function $serializer_getInstance_18() {
  if ($serializer_instance_17 === VOID)
    new $serializer_17();
  return $serializer_instance_17;
}
var Companion_instance_22;
function Companion_getInstance_30() {
  if (Companion_instance_22 === VOID)
    new Companion_20();
  return Companion_instance_22;
}
var $serializer_instance_18;
function $serializer_getInstance_19() {
  if ($serializer_instance_18 === VOID)
    new $serializer_18();
  return $serializer_instance_18;
}
var Companion_instance_23;
function Companion_getInstance_31() {
  return Companion_instance_23;
}
var $serializer_instance_19;
function $serializer_getInstance_20() {
  if ($serializer_instance_19 === VOID)
    new $serializer_19();
  return $serializer_instance_19;
}
var Companion_instance_24;
function Companion_getInstance_32() {
  if (Companion_instance_24 === VOID)
    new Companion_22();
  return Companion_instance_24;
}
var $serializer_instance_20;
function $serializer_getInstance_21() {
  if ($serializer_instance_20 === VOID)
    new $serializer_20();
  return $serializer_instance_20;
}
var Companion_instance_25;
function Companion_getInstance_33() {
  return Companion_instance_25;
}
var $serializer_instance_21;
function $serializer_getInstance_22() {
  if ($serializer_instance_21 === VOID)
    new $serializer_21();
  return $serializer_instance_21;
}
var Companion_instance_26;
function Companion_getInstance_34() {
  if (Companion_instance_26 === VOID)
    new Companion_24();
  return Companion_instance_26;
}
var $serializer_instance_22;
function $serializer_getInstance_23() {
  if ($serializer_instance_22 === VOID)
    new $serializer_22();
  return $serializer_instance_22;
}
var Companion_instance_27;
function Companion_getInstance_35() {
  if (Companion_instance_27 === VOID)
    new Companion_25();
  return Companion_instance_27;
}
var $serializer_instance_23;
function $serializer_getInstance_24() {
  if ($serializer_instance_23 === VOID)
    new $serializer_23();
  return $serializer_instance_23;
}
function ParallaxComponent$onAdd$lambda($layer) {
  return function ($this$entity, it) {
    var component = $layer.het_1;
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = $this$entity.i1v_1;
    if (this_0.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    var component_0 = $layer.iet_1;
    var compType_0 = component_0.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType_0.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType_0.m1t())) {
      var tmp_5 = compType_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(compType_0.m1t());
    var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
    holder_0.l1u(it, component_0);
    return Unit_instance;
  };
}
function ParallaxComponent$onAdd$lambda_0($layer) {
  return function ($this$entity, it) {
    var component = $layer.het_1;
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = $this$entity.i1v_1;
    if (this_0.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    var component_0 = $layer.iet_1;
    var compType_0 = component_0.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType_0.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType_0.m1t())) {
      var tmp_5 = compType_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(compType_0.m1t());
    var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
    holder_0.l1u(it, component_0);
    return Unit_instance;
  };
}
function ParallaxComponent$onAdd$lambda_1(this$0) {
  return function ($this$entity, it) {
    var component = this$0.aeu_1.oet_1;
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = $this$entity.i1v_1;
    if (this_0.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    var component_0 = this$0.aeu_1.pet_1;
    var compType_0 = component_0.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType_0.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType_0.m1t())) {
      var tmp_5 = compType_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(compType_0.m1t());
    var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
    holder_0.l1u(it, component_0);
    return Unit_instance;
  };
}
var Companion_instance_28;
function Companion_getInstance_36() {
  if (Companion_instance_28 === VOID)
    new Companion_26();
  return Companion_instance_28;
}
var $serializer_instance_24;
function $serializer_getInstance_25() {
  if ($serializer_instance_24 === VOID)
    new $serializer_24();
  return $serializer_instance_24;
}
var Companion_instance_29;
function Companion_getInstance_37() {
  if (Companion_instance_29 === VOID)
    new Companion_27();
  return Companion_instance_29;
}
var $serializer_instance_25;
function $serializer_getInstance_26() {
  if ($serializer_instance_25 === VOID)
    new $serializer_25();
  return $serializer_instance_25;
}
var Companion_instance_30;
function Companion_getInstance_38() {
  if (Companion_instance_30 === VOID)
    new Companion_28();
  return Companion_instance_30;
}
var $serializer_instance_26;
function $serializer_getInstance_27() {
  if ($serializer_instance_26 === VOID)
    new $serializer_26();
  return $serializer_instance_26;
}
var Companion_instance_31;
function Companion_getInstance_39() {
  if (Companion_instance_31 === VOID)
    new Companion_29();
  return Companion_instance_31;
}
var $serializer_instance_27;
function $serializer_getInstance_28() {
  if ($serializer_instance_27 === VOID)
    new $serializer_27();
  return $serializer_instance_27;
}
var Companion_instance_32;
function Companion_getInstance_40() {
  if (Companion_instance_32 === VOID)
    new Companion_30();
  return Companion_instance_32;
}
var $serializer_instance_28;
function $serializer_getInstance_29() {
  if ($serializer_instance_28 === VOID)
    new $serializer_28();
  return $serializer_instance_28;
}
var Companion_instance_33;
function Companion_getInstance_41() {
  if (Companion_instance_33 === VOID)
    new Companion_31();
  return Companion_instance_33;
}
var $serializer_instance_29;
function $serializer_getInstance_30() {
  if ($serializer_instance_29 === VOID)
    new $serializer_29();
  return $serializer_instance_29;
}
var Companion_instance_34;
function Companion_getInstance_42() {
  if (Companion_instance_34 === VOID)
    new Companion_32();
  return Companion_instance_34;
}
var $serializer_instance_30;
function $serializer_getInstance_31() {
  if ($serializer_instance_30 === VOID)
    new $serializer_30();
  return $serializer_instance_30;
}
var Companion_instance_35;
function Companion_getInstance_43() {
  if (Companion_instance_35 === VOID)
    new Companion_33();
  return Companion_instance_35;
}
var $serializer_instance_31;
function $serializer_getInstance_32() {
  if ($serializer_instance_31 === VOID)
    new $serializer_31();
  return $serializer_instance_31;
}
function getAnimationNumberOfFrames(_this__u8e3s4, name, animation) {
  animation = animation === VOID ? null : animation;
  return getImageAnimation(_this__u8e3s4, name, animation).y6m_1.g1();
}
function getAnimationFrameDuration(_this__u8e3s4, name, animation, frameIndex) {
  animation = animation === VOID ? null : animation;
  return get_seconds(getImageFrame(_this__u8e3s4, name, animation, frameIndex).h6p());
}
function getAnimationDirection(_this__u8e3s4, name, animation) {
  animation = animation === VOID ? null : animation;
  return getImageAnimation(_this__u8e3s4, name, animation).z6m_1;
}
function getImageAnimation(_this__u8e3s4, name, animation) {
  animation = animation === VOID ? null : animation;
  var tmp;
  if (!(animation == null)) {
    var spriteAnimations = _this__u8e3s4.xek(name).t6n_1;
    var tmp_0;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(spriteAnimations, KtMap) ? spriteAnimations : THROW_CCE()).c3(animation)) {
      tmp_0 = ensureNotNull(spriteAnimations.e3(animation));
    } else {
      var message = "AssetStore: Image animation '" + animation + "' not found!";
      throw IllegalStateException.h5(toString_0(message));
    }
    tmp = tmp_0;
  } else {
    tmp = _this__u8e3s4.xek(name).s6n_1;
  }
  return tmp;
}
function getImageFrame(_this__u8e3s4, name, animation, frameIndex) {
  animation = animation === VOID ? null : animation;
  frameIndex = frameIndex === VOID ? 0 : frameIndex;
  var tmp;
  if (!(animation == null)) {
    var spriteAnimations = _this__u8e3s4.xek(name).t6n_1;
    var tmp_0;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(spriteAnimations, KtMap) ? spriteAnimations : THROW_CCE()).c3(animation)) {
      tmp_0 = ensureNotNull(spriteAnimations.e3(animation)).y6m_1;
    } else {
      println("WARNING -- AssetStore: Image animation '" + animation + "' not found!");
      return ImageFrame.u6l(0);
    }
    tmp = tmp_0;
  } else {
    tmp = _this__u8e3s4.xek(name).s6n_1.y6m_1;
  }
  var animationFrames = tmp;
  var tmp_1;
  if (animationFrames.g1() > frameIndex) {
    tmp_1 = animationFrames.h1(frameIndex);
  } else {
    println("WARNING -- AssetStore: Image animation frame '" + frameIndex + "' out of bounds!");
    tmp_1 = ImageFrame.u6l(0);
  }
  return tmp_1;
}
var Companion_instance_36;
function Companion_getInstance_44() {
  return Companion_instance_36;
}
var $serializer_instance_32;
function $serializer_getInstance_33() {
  if ($serializer_instance_32 === VOID)
    new $serializer_32();
  return $serializer_instance_32;
}
var Companion_instance_37;
function Companion_getInstance_45() {
  if (Companion_instance_37 === VOID)
    new Companion_35();
  return Companion_instance_37;
}
var $serializer_instance_33;
function $serializer_getInstance_34() {
  if ($serializer_instance_33 === VOID)
    new $serializer_33();
  return $serializer_instance_33;
}
var Companion_instance_38;
function Companion_getInstance_46() {
  if (Companion_instance_38 === VOID)
    new Companion_36();
  return Companion_instance_38;
}
var $serializer_instance_34;
function $serializer_getInstance_35() {
  if ($serializer_instance_34 === VOID)
    new $serializer_34();
  return $serializer_instance_34;
}
var Companion_instance_39;
function Companion_getInstance_47() {
  if (Companion_instance_39 === VOID)
    new Companion_37();
  return Companion_instance_39;
}
var $serializer_instance_35;
function $serializer_getInstance_36() {
  if ($serializer_instance_35 === VOID)
    new $serializer_35();
  return $serializer_instance_35;
}
var Companion_instance_40;
function Companion_getInstance_48() {
  if (Companion_instance_40 === VOID)
    new Companion_38();
  return Companion_instance_40;
}
var $serializer_instance_36;
function $serializer_getInstance_37() {
  if ($serializer_instance_36 === VOID)
    new $serializer_36();
  return $serializer_instance_36;
}
var Companion_instance_41;
function Companion_getInstance_49() {
  if (Companion_instance_41 === VOID)
    new Companion_39();
  return Companion_instance_41;
}
var $serializer_instance_37;
function $serializer_getInstance_38() {
  if ($serializer_instance_37 === VOID)
    new $serializer_37();
  return $serializer_instance_37;
}
var TweenProperty_PositionOffsetX_instance;
var TweenProperty_PositionOffsetY_instance;
var TweenProperty_PositionX_instance;
var TweenProperty_PositionY_instance;
var TweenProperty_MotionVelocityX_instance;
var TweenProperty_RgbaAlpha_instance;
var TweenProperty_RgbaTint_instance;
var TweenProperty_SpawnerInterval_instance;
var TweenProperty_SpawnerNumberOfObjects_instance;
var TweenProperty_SpawnerPositionVariation_instance;
var TweenProperty_SpawnerTimeVariation_instance;
var TweenProperty_SpriteRunning_instance;
var TweenProperty_SpriteDirection_instance;
var TweenProperty_SpriteDestroyOnPlayingFinished_instance;
var TweenProperty_SpriteAnimation_instance;
var TweenProperty_SwitchLayerVisibilityOnVariance_instance;
var TweenProperty_SwitchLayerVisibilityOffVariance_instance;
var TweenProperty_SoundStartTrigger_instance;
var TweenProperty_SoundStopTrigger_instance;
var TweenProperty_SoundPosition_instance;
var TweenProperty_SoundVolume_instance;
var TweenProperty_TextFieldText_instance;
var TweenProperty_TextFieldTextRangeStart_instance;
var TweenProperty_TextFieldTextRangeEnd_instance;
var TweenProperty_EventPublish_instance;
var TweenProperty_EventReset_instance;
var TweenProperty_EventSubscribe_instance;
var TweenProperty_TouchInputEnable_instance;
function values_1() {
  return [TweenProperty_PositionOffsetX_getInstance(), TweenProperty_PositionOffsetY_getInstance(), TweenProperty_PositionX_getInstance(), TweenProperty_PositionY_getInstance(), TweenProperty_MotionVelocityX_getInstance(), TweenProperty_RgbaAlpha_getInstance(), TweenProperty_RgbaTint_getInstance(), TweenProperty_SpawnerInterval_getInstance(), TweenProperty_SpawnerNumberOfObjects_getInstance(), TweenProperty_SpawnerPositionVariation_getInstance(), TweenProperty_SpawnerTimeVariation_getInstance(), TweenProperty_SpriteRunning_getInstance(), TweenProperty_SpriteDirection_getInstance(), TweenProperty_SpriteDestroyOnPlayingFinished_getInstance(), TweenProperty_SpriteAnimation_getInstance(), TweenProperty_SwitchLayerVisibilityOnVariance_getInstance(), TweenProperty_SwitchLayerVisibilityOffVariance_getInstance(), TweenProperty_SoundStartTrigger_getInstance(), TweenProperty_SoundStopTrigger_getInstance(), TweenProperty_SoundPosition_getInstance(), TweenProperty_SoundVolume_getInstance(), TweenProperty_TextFieldText_getInstance(), TweenProperty_TextFieldTextRangeStart_getInstance(), TweenProperty_TextFieldTextRangeEnd_getInstance(), TweenProperty_EventPublish_getInstance(), TweenProperty_EventReset_getInstance(), TweenProperty_EventSubscribe_getInstance(), TweenProperty_TouchInputEnable_getInstance()];
}
var TweenProperty_entriesInitialized;
function TweenProperty_initEntries() {
  if (TweenProperty_entriesInitialized)
    return Unit_instance;
  TweenProperty_entriesInitialized = true;
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$0 = new _no_name_provided__qut3iv();
  TweenProperty_PositionOffsetX_instance = new TweenProperty('PositionOffsetX', 0, tmp$ret$0);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$1 = new _no_name_provided__qut3iv_0();
  TweenProperty_PositionOffsetY_instance = new TweenProperty('PositionOffsetY', 1, tmp$ret$1);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$2 = new _no_name_provided__qut3iv_1();
  TweenProperty_PositionX_instance = new TweenProperty('PositionX', 2, tmp$ret$2);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$3 = new _no_name_provided__qut3iv_2();
  TweenProperty_PositionY_instance = new TweenProperty('PositionY', 3, tmp$ret$3);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$4 = new _no_name_provided__qut3iv_3();
  TweenProperty_MotionVelocityX_instance = new TweenProperty('MotionVelocityX', 4, tmp$ret$4);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$5 = new _no_name_provided__qut3iv_4();
  TweenProperty_RgbaAlpha_instance = new TweenProperty('RgbaAlpha', 5, tmp$ret$5);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$6 = new _no_name_provided__qut3iv_5();
  TweenProperty_RgbaTint_instance = new TweenProperty('RgbaTint', 6, tmp$ret$6);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$7 = new _no_name_provided__qut3iv_6();
  TweenProperty_SpawnerInterval_instance = new TweenProperty('SpawnerInterval', 7, tmp$ret$7);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$8 = new _no_name_provided__qut3iv_7();
  TweenProperty_SpawnerNumberOfObjects_instance = new TweenProperty('SpawnerNumberOfObjects', 8, tmp$ret$8);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$9 = new _no_name_provided__qut3iv_8();
  TweenProperty_SpawnerPositionVariation_instance = new TweenProperty('SpawnerPositionVariation', 9, tmp$ret$9);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$10 = new _no_name_provided__qut3iv_9();
  TweenProperty_SpawnerTimeVariation_instance = new TweenProperty('SpawnerTimeVariation', 10, tmp$ret$10);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$11 = new _no_name_provided__qut3iv_10();
  TweenProperty_SpriteRunning_instance = new TweenProperty('SpriteRunning', 11, tmp$ret$11);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$12 = new _no_name_provided__qut3iv_11();
  TweenProperty_SpriteDirection_instance = new TweenProperty('SpriteDirection', 12, tmp$ret$12);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$13 = new _no_name_provided__qut3iv_12();
  TweenProperty_SpriteDestroyOnPlayingFinished_instance = new TweenProperty('SpriteDestroyOnPlayingFinished', 13, tmp$ret$13);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$14 = new _no_name_provided__qut3iv_13();
  TweenProperty_SpriteAnimation_instance = new TweenProperty('SpriteAnimation', 14, tmp$ret$14);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$15 = new _no_name_provided__qut3iv_14();
  TweenProperty_SwitchLayerVisibilityOnVariance_instance = new TweenProperty('SwitchLayerVisibilityOnVariance', 15, tmp$ret$15);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$16 = new _no_name_provided__qut3iv_15();
  TweenProperty_SwitchLayerVisibilityOffVariance_instance = new TweenProperty('SwitchLayerVisibilityOffVariance', 16, tmp$ret$16);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$17 = new _no_name_provided__qut3iv_16();
  TweenProperty_SoundStartTrigger_instance = new TweenProperty('SoundStartTrigger', 17, tmp$ret$17);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$18 = new _no_name_provided__qut3iv_17();
  TweenProperty_SoundStopTrigger_instance = new TweenProperty('SoundStopTrigger', 18, tmp$ret$18);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$19 = new _no_name_provided__qut3iv_18();
  TweenProperty_SoundPosition_instance = new TweenProperty('SoundPosition', 19, tmp$ret$19);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$20 = new _no_name_provided__qut3iv_19();
  TweenProperty_SoundVolume_instance = new TweenProperty('SoundVolume', 20, tmp$ret$20);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$21 = new _no_name_provided__qut3iv_20();
  TweenProperty_TextFieldText_instance = new TweenProperty('TextFieldText', 21, tmp$ret$21);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$22 = new _no_name_provided__qut3iv_21();
  TweenProperty_TextFieldTextRangeStart_instance = new TweenProperty('TextFieldTextRangeStart', 22, tmp$ret$22);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$23 = new _no_name_provided__qut3iv_22();
  TweenProperty_TextFieldTextRangeEnd_instance = new TweenProperty('TextFieldTextRangeEnd', 23, tmp$ret$23);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$24 = new _no_name_provided__qut3iv_23();
  TweenProperty_EventPublish_instance = new TweenProperty('EventPublish', 24, tmp$ret$24);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$25 = new _no_name_provided__qut3iv_24();
  TweenProperty_EventReset_instance = new TweenProperty('EventReset', 25, tmp$ret$25);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$26 = new _no_name_provided__qut3iv_25();
  TweenProperty_EventSubscribe_instance = new TweenProperty('EventSubscribe', 26, tmp$ret$26);
  // Inline function 'com.github.quillraven.fleks.componentTypeOf' call
  var tmp$ret$27 = new _no_name_provided__qut3iv_26();
  TweenProperty_TouchInputEnable_instance = new TweenProperty('TouchInputEnable', 27, tmp$ret$27);
}
var Companion_instance_42;
function Companion_getInstance_50() {
  if (Companion_instance_42 === VOID)
    new Companion_40();
  return Companion_instance_42;
}
var $serializer_instance_38;
function $serializer_getInstance_39() {
  if ($serializer_instance_38 === VOID)
    new $serializer_38();
  return $serializer_instance_38;
}
function TweenProperty_PositionOffsetX_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_PositionOffsetX_instance;
}
function TweenProperty_PositionOffsetY_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_PositionOffsetY_instance;
}
function TweenProperty_PositionX_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_PositionX_instance;
}
function TweenProperty_PositionY_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_PositionY_instance;
}
function TweenProperty_MotionVelocityX_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_MotionVelocityX_instance;
}
function TweenProperty_RgbaAlpha_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_RgbaAlpha_instance;
}
function TweenProperty_RgbaTint_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_RgbaTint_instance;
}
function TweenProperty_SpawnerInterval_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpawnerInterval_instance;
}
function TweenProperty_SpawnerNumberOfObjects_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpawnerNumberOfObjects_instance;
}
function TweenProperty_SpawnerPositionVariation_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpawnerPositionVariation_instance;
}
function TweenProperty_SpawnerTimeVariation_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpawnerTimeVariation_instance;
}
function TweenProperty_SpriteRunning_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpriteRunning_instance;
}
function TweenProperty_SpriteDirection_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpriteDirection_instance;
}
function TweenProperty_SpriteDestroyOnPlayingFinished_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpriteDestroyOnPlayingFinished_instance;
}
function TweenProperty_SpriteAnimation_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SpriteAnimation_instance;
}
function TweenProperty_SwitchLayerVisibilityOnVariance_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SwitchLayerVisibilityOnVariance_instance;
}
function TweenProperty_SwitchLayerVisibilityOffVariance_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SwitchLayerVisibilityOffVariance_instance;
}
function TweenProperty_SoundStartTrigger_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SoundStartTrigger_instance;
}
function TweenProperty_SoundStopTrigger_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SoundStopTrigger_instance;
}
function TweenProperty_SoundPosition_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SoundPosition_instance;
}
function TweenProperty_SoundVolume_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_SoundVolume_instance;
}
function TweenProperty_TextFieldText_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_TextFieldText_instance;
}
function TweenProperty_TextFieldTextRangeStart_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_TextFieldTextRangeStart_instance;
}
function TweenProperty_TextFieldTextRangeEnd_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_TextFieldTextRangeEnd_instance;
}
function TweenProperty_EventPublish_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_EventPublish_instance;
}
function TweenProperty_EventReset_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_EventReset_instance;
}
function TweenProperty_EventSubscribe_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_EventSubscribe_instance;
}
function TweenProperty_TouchInputEnable_getInstance() {
  TweenProperty_initEntries();
  return TweenProperty_TouchInputEnable_instance;
}
var Companion_instance_43;
function Companion_getInstance_51() {
  if (Companion_instance_43 === VOID)
    new Companion_41();
  return Companion_instance_43;
}
var $serializer_instance_39;
function $serializer_getInstance_40() {
  if ($serializer_instance_39 === VOID)
    new $serializer_39();
  return $serializer_instance_39;
}
var Companion_instance_44;
function Companion_getInstance_52() {
  if (Companion_instance_44 === VOID)
    new Companion_42();
  return Companion_instance_44;
}
var $serializer_instance_40;
function $serializer_getInstance_41() {
  if ($serializer_instance_40 === VOID)
    new $serializer_40();
  return $serializer_instance_40;
}
var Companion_instance_45;
function Companion_getInstance_53() {
  if (Companion_instance_45 === VOID)
    new Companion_43();
  return Companion_instance_45;
}
var $serializer_instance_41;
function $serializer_getInstance_42() {
  if ($serializer_instance_41 === VOID)
    new $serializer_41();
  return $serializer_instance_41;
}
var Companion_instance_46;
function Companion_getInstance_54() {
  return Companion_instance_46;
}
var $serializer_instance_42;
function $serializer_getInstance_43() {
  if ($serializer_instance_42 === VOID)
    new $serializer_42();
  return $serializer_instance_42;
}
var Companion_instance_47;
function Companion_getInstance_55() {
  return Companion_instance_47;
}
var $serializer_instance_43;
function $serializer_getInstance_44() {
  if ($serializer_instance_43 === VOID)
    new $serializer_43();
  return $serializer_instance_43;
}
var Companion_instance_48;
function Companion_getInstance_56() {
  return Companion_instance_48;
}
var $serializer_instance_44;
function $serializer_getInstance_45() {
  if ($serializer_instance_44 === VOID)
    new $serializer_44();
  return $serializer_instance_44;
}
var Companion_instance_49;
function Companion_getInstance_57() {
  return Companion_instance_49;
}
var $serializer_instance_45;
function $serializer_getInstance_46() {
  if ($serializer_instance_45 === VOID)
    new $serializer_45();
  return $serializer_instance_45;
}
var Companion_instance_50;
function Companion_getInstance_58() {
  return Companion_instance_50;
}
var $serializer_instance_46;
function $serializer_getInstance_47() {
  if ($serializer_instance_46 === VOID)
    new $serializer_46();
  return $serializer_instance_46;
}
var Companion_instance_51;
function Companion_getInstance_59() {
  return Companion_instance_51;
}
var $serializer_instance_47;
function $serializer_getInstance_48() {
  if ($serializer_instance_47 === VOID)
    new $serializer_47();
  return $serializer_instance_47;
}
var Companion_instance_52;
function Companion_getInstance_60() {
  return Companion_instance_52;
}
var $serializer_instance_48;
function $serializer_getInstance_49() {
  if ($serializer_instance_48 === VOID)
    new $serializer_48();
  return $serializer_instance_48;
}
var Companion_instance_53;
function Companion_getInstance_61() {
  return Companion_instance_53;
}
var $serializer_instance_49;
function $serializer_getInstance_50() {
  if ($serializer_instance_49 === VOID)
    new $serializer_49();
  return $serializer_instance_49;
}
var Companion_instance_54;
function Companion_getInstance_62() {
  return Companion_instance_54;
}
var $serializer_instance_50;
function $serializer_getInstance_51() {
  if ($serializer_instance_50 === VOID)
    new $serializer_50();
  return $serializer_instance_50;
}
var Companion_instance_55;
function Companion_getInstance_63() {
  return Companion_instance_55;
}
var $serializer_instance_51;
function $serializer_getInstance_52() {
  if ($serializer_instance_51 === VOID)
    new $serializer_51();
  return $serializer_instance_51;
}
var Companion_instance_56;
function Companion_getInstance_64() {
  return Companion_instance_56;
}
var $serializer_instance_52;
function $serializer_getInstance_53() {
  if ($serializer_instance_52 === VOID)
    new $serializer_52();
  return $serializer_instance_52;
}
var Companion_instance_57;
function Companion_getInstance_65() {
  if (Companion_instance_57 === VOID)
    new Companion_55();
  return Companion_instance_57;
}
var $serializer_instance_53;
function $serializer_getInstance_54() {
  if ($serializer_instance_53 === VOID)
    new $serializer_53();
  return $serializer_instance_53;
}
var Companion_instance_58;
function Companion_getInstance_66() {
  return Companion_instance_58;
}
var $serializer_instance_54;
function $serializer_getInstance_55() {
  if ($serializer_instance_54 === VOID)
    new $serializer_54();
  return $serializer_instance_54;
}
var Companion_instance_59;
function Companion_getInstance_67() {
  return Companion_instance_59;
}
var $serializer_instance_55;
function $serializer_getInstance_56() {
  if ($serializer_instance_55 === VOID)
    new $serializer_55();
  return $serializer_instance_55;
}
var Companion_instance_60;
function Companion_getInstance_68() {
  return Companion_instance_60;
}
var $serializer_instance_56;
function $serializer_getInstance_57() {
  if ($serializer_instance_56 === VOID)
    new $serializer_56();
  return $serializer_instance_56;
}
var Companion_instance_61;
function Companion_getInstance_69() {
  return Companion_instance_61;
}
var $serializer_instance_57;
function $serializer_getInstance_58() {
  if ($serializer_instance_57 === VOID)
    new $serializer_57();
  return $serializer_instance_57;
}
var Companion_instance_62;
function Companion_getInstance_70() {
  if (Companion_instance_62 === VOID)
    new Companion_60();
  return Companion_instance_62;
}
var $serializer_instance_58;
function $serializer_getInstance_59() {
  if ($serializer_instance_58 === VOID)
    new $serializer_58();
  return $serializer_instance_58;
}
var EntityFactory_instance;
function EntityFactory_getInstance() {
  if (EntityFactory_instance === VOID)
    new EntityFactory();
  return EntityFactory_instance;
}
var Companion_instance_63;
function Companion_getInstance_71() {
  return Companion_instance_63;
}
var $serializer_instance_59;
function $serializer_getInstance_60() {
  if ($serializer_instance_59 === VOID)
    new $serializer_59();
  return $serializer_instance_59;
}
var AvatarPosition_LEFT_TOP_instance;
var AvatarPosition_RIGHT_TOP_instance;
function values_2() {
  return [AvatarPosition_LEFT_TOP_getInstance(), AvatarPosition_RIGHT_TOP_getInstance()];
}
var AvatarPosition_entriesInitialized;
function AvatarPosition_initEntries() {
  if (AvatarPosition_entriesInitialized)
    return Unit_instance;
  AvatarPosition_entriesInitialized = true;
  AvatarPosition_LEFT_TOP_instance = new AvatarPosition('LEFT_TOP', 0);
  AvatarPosition_RIGHT_TOP_instance = new AvatarPosition('RIGHT_TOP', 1);
}
function hAlign($this, h, width, viewPortWidth) {
  if (_HorizontalAlign___get_ratio__impl__x9wlea(h) * viewPortWidth < 10)
    return 10.0;
  if (_HorizontalAlign___get_ratio__impl__x9wlea(h) * viewPortWidth > viewPortWidth - 10)
    return viewPortWidth - width - 10;
  return _HorizontalAlign___get_ratio__impl__x9wlea(h) * viewPortWidth;
}
function vAlign($this, v, height, viewPortHeight) {
  if (_VerticalAlign___get_ratio__impl__b3ilr8(v) * viewPortHeight < 34)
    return 34.0;
  if (_VerticalAlign___get_ratio__impl__b3ilr8(v) * viewPortHeight > viewPortHeight - 10)
    return viewPortHeight - height - 10;
  return _VerticalAlign___get_ratio__impl__b3ilr8(v) * viewPortHeight;
}
var Companion_instance_64;
function Companion_getInstance_72() {
  if (Companion_instance_64 === VOID)
    new Companion_62();
  return Companion_instance_64;
}
var $serializer_instance_60;
function $serializer_getInstance_61() {
  if ($serializer_instance_60 === VOID)
    new $serializer_60();
  return $serializer_instance_60;
}
function AvatarPosition_LEFT_TOP_getInstance() {
  AvatarPosition_initEntries();
  return AvatarPosition_LEFT_TOP_instance;
}
function AvatarPosition_RIGHT_TOP_getInstance() {
  AvatarPosition_initEntries();
  return AvatarPosition_RIGHT_TOP_instance;
}
var Companion_instance_65;
function Companion_getInstance_73() {
  if (Companion_instance_65 === VOID)
    new Companion_63();
  return Companion_instance_65;
}
var $serializer_instance_61;
function $serializer_getInstance_62() {
  if ($serializer_instance_61 === VOID)
    new $serializer_61();
  return $serializer_instance_61;
}
var Companion_instance_66;
function Companion_getInstance_74() {
  if (Companion_instance_66 === VOID)
    new Companion_64();
  return Companion_instance_66;
}
var $serializer_instance_62;
function $serializer_getInstance_63() {
  if ($serializer_instance_62 === VOID)
    new $serializer_62();
  return $serializer_instance_62;
}
var Companion_instance_67;
function Companion_getInstance_75() {
  return Companion_instance_67;
}
var $serializer_instance_63;
function $serializer_getInstance_64() {
  if ($serializer_instance_63 === VOID)
    new $serializer_63();
  return $serializer_instance_63;
}
var Companion_instance_68;
function Companion_getInstance_76() {
  if (Companion_instance_68 === VOID)
    new Companion_66();
  return Companion_instance_68;
}
var $serializer_instance_64;
function $serializer_getInstance_65() {
  if ($serializer_instance_64 === VOID)
    new $serializer_64();
  return $serializer_instance_64;
}
var Companion_instance_69;
function Companion_getInstance_77() {
  if (Companion_instance_69 === VOID)
    new Companion_67();
  return Companion_instance_69;
}
var $serializer_instance_65;
function $serializer_getInstance_66() {
  if ($serializer_instance_65 === VOID)
    new $serializer_65();
  return $serializer_instance_65;
}
var Companion_instance_70;
function Companion_getInstance_78() {
  return Companion_instance_70;
}
var $serializer_instance_66;
function $serializer_getInstance_67() {
  if ($serializer_instance_66 === VOID)
    new $serializer_66();
  return $serializer_instance_66;
}
function *_generator_initGameState__abk745($this, $completion) {
  var vfs = get_resourcesVfs().cj('common/config.yaml');
  var tmp = vfs.e3h(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var gameConfigString = tmp;
  try {
    // Inline function 'kotlinx.serialization.decodeFromString' call
    var this_0 = $this.deh_1.ieh();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(AssetModel), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var commonConfig = this_0.g1h(tmp$ret$1, gameConfigString);
    var tmp_0 = $this.ceh_1.cel(AssetType_COMMON_getInstance(), commonConfig, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      println('ERROR: Loading common assets - ' + e.toString());
    } else {
      throw $p;
    }
  }
  var gameStateConfigVfs = get_resourcesVfs().cj('game_config.yaml');
  var tmp_1 = gameStateConfigVfs.e3h(VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var gameStateConfigString = tmp_1;
  var tmp_2;
  try {
    // Inline function 'kotlinx.serialization.decodeFromString' call
    var this_3 = $this.deh_1.ieh();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(GameStateConfig), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
    tmp_2 = this_3.g1h(tmp$ret$4, gameStateConfigString);
  } catch ($p) {
    var tmp_3;
    if ($p instanceof Error) {
      var e_0 = $p;
      println('ERROR: Loading game state config - ' + e_0.toString());
      tmp_3 = new GameStateConfig('jobesLegacy', 0, true, 'world_1', 'level_1', 'intro', 'start_intro');
    } else {
      throw $p;
    }
    tmp_2 = tmp_3;
  }
  return tmp_2;
}
function *_generator_loadAssets__gde0f3_0($this, gameStateConfig, $completion) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = gameStateConfig.bfg_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = true;
  } else {
    // Inline function 'kotlin.text.isEmpty' call
    var this_1 = gameStateConfig.cfg_1;
    tmp = charSequenceLength(this_1) === 0;
  }
  if (tmp) {
    println('ERROR: World or level string is empty in game config! Cannot load game data!');
    return Unit_instance;
  }
  var worldVfs = get_resourcesVfs().cj(gameStateConfig.bfg_1 + '/config.yaml');
  var tmp_0 = worldVfs.e3h(VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var gameConfigString = tmp_0;
  try {
    // Inline function 'kotlinx.serialization.decodeFromString' call
    var this_2 = $this.deh_1.ieh();
    var string = gameConfigString;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(AssetModel), arrayOf([]), false));
    var tmp$ret$3 = isInterface(this_4, KSerializer) ? this_4 : THROW_CCE();
    var worldConfig = this_2.g1h(tmp$ret$3, string);
    var tmp_1 = $this.ceh_1.cel(AssetType_WORLD_getInstance(), worldConfig, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      println('ERROR: Loading world assets - ' + e.toString());
    } else {
      throw $p;
    }
  }
  var levelVfs = get_resourcesVfs().cj(gameStateConfig.bfg_1 + '/' + gameStateConfig.cfg_1 + '/config.yaml');
  var tmp_2 = levelVfs.e3h(VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  gameConfigString = tmp_2;
  try {
    // Inline function 'kotlinx.serialization.decodeFromString' call
    var this_5 = $this.deh_1.ieh();
    var string_0 = gameConfigString;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(AssetModel), arrayOf([]), false));
    var tmp$ret$6 = isInterface(this_7, KSerializer) ? this_7 : THROW_CCE();
    var worldConfig_0 = this_5.g1h(tmp$ret$6, string_0);
    var tmp_3 = $this.ceh_1.cel(AssetType_LEVEL_getInstance(), worldConfig_0, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } catch ($p) {
    if ($p instanceof Error) {
      var e_0 = $p;
      println('ERROR: Loading level assets - ' + e_0.toString());
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_8 = gameStateConfig.cfg_1;
  if (charSequenceLength(this_8) > 0) {
    var vfs = get_resourcesVfs().cj(gameStateConfig.bfg_1 + '/' + gameStateConfig.cfg_1 + '/' + gameStateConfig.dfg_1 + '/config.yaml');
    var tmp_4 = vfs.e3h(VOID, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    gameConfigString = tmp_4;
    try {
      // Inline function 'kotlinx.serialization.decodeFromString' call
      var this_9 = $this.deh_1.ieh();
      var string_1 = gameConfigString;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_10 = this_9.mz();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_11 = serializer(this_10, createKType(getKClass(AssetModel), arrayOf([]), false));
      var tmp$ret$10 = isInterface(this_11, KSerializer) ? this_11 : THROW_CCE();
      var specialConfig = this_9.g1h(tmp$ret$10, string_1);
      var tmp_5 = $this.ceh_1.cel(AssetType_SPECIAL_getInstance(), specialConfig, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('ERROR: Loading special assets - ' + e_1.toString());
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
var GameStateManager_instance;
function GameStateManager_getInstance() {
  if (GameStateManager_instance === VOID)
    new GameStateManager();
  return GameStateManager_instance;
}
function DebugRenderSystem$family$lambda(this$0) {
  return function ($this$family) {
    $this$family.a1z([this$0.lfi_1]).c1z([Companion_getInstance_36(), Companion_getInstance_43(), Companion_getInstance_24(), Companion_getInstance_47(), Companion_getInstance_29()]);
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.m9w_1;
  }, function (value) {
    $b0.m9w_1 = value;
    return Unit_instance;
  });
}
function FastSpriteRenderSystem$lambda($layerTag) {
  return function ($this$family) {
    $this$family.a1z([$layerTag, Companion_getInstance_36(), Companion_getInstance_43(), Companion_getInstance_38()]);
    return Unit_instance;
  };
}
function LevelMapRenderSystem$_init_$lambda_xw0m9e($this$compareEntity, entA, entB) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
  var type = Companion_getInstance_22();
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = $this$compareEntity.i1v_1;
  if (this_0.u1t_1.j1s(type.m1t())) {
    var tmp = type.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(type.m1t());
  var tmp_5 = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entA).eeo_1;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
  var type_0 = Companion_getInstance_22();
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_1 = $this$compareEntity.i1v_1;
  if (this_1.u1t_1.j1s(type_0.m1t())) {
    var tmp_6 = type_0.m1t();
    var tmp_7 = this_1.v1t();
    var tmp_8 = 0;
    var tmp_9 = this_1.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(tmp_9), null);
    while (tmp_8 < tmp_9) {
      tmp_10[tmp_8] = null;
      tmp_8 = tmp_8 + 1 | 0;
    }
    this_1.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
  }
  var tmp_11 = this_1.u1t_1.h1(type_0.m1t());
  var tmp$ret$7 = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(entB);
  return compareTo(tmp_5, tmp$ret$7.eeo_1);
}
function LevelMapRenderSystem$family$lambda($layerTag) {
  return function ($this$family) {
    $this$family.a1z([$layerTag, Companion_getInstance_22(), Companion_getInstance_26()]);
    return Unit_instance;
  };
}
function LevelMapRenderSystem$renderInternal$lambda($batch, $ctx, $viewPortPosX, $viewPortPosY, $rgba) {
  return function (slice, px, py) {
    $batch.q9o($ctx.p9o(slice), px - $viewPortPosX, py - $viewPortPosY, VOID, VOID, VOID, false, $rgba, VOID, null);
    return Unit_instance;
  };
}
function LevelMapRenderSystem$renderInternal$lambda_0($batch, $ctx, $viewPortPosX, $viewPortPosY, $rgba) {
  return function (slice, px, py) {
    $batch.q9o($ctx.p9o(slice), px - $viewPortPosX, py - $viewPortPosY, VOID, VOID, VOID, false, $rgba, VOID, null);
    return Unit_instance;
  };
}
function ObjectRenderSystem$_init_$lambda_nqlu61($this$compareEntity, entA, entB) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
  var type = Companion_getInstance_22();
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = $this$compareEntity.i1v_1;
  if (this_0.u1t_1.j1s(type.m1t())) {
    var tmp = type.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(type.m1t());
  var tmp_5 = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entA).eeo_1;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
  var type_0 = Companion_getInstance_22();
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_1 = $this$compareEntity.i1v_1;
  if (this_1.u1t_1.j1s(type_0.m1t())) {
    var tmp_6 = type_0.m1t();
    var tmp_7 = this_1.v1t();
    var tmp_8 = 0;
    var tmp_9 = this_1.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(tmp_9), null);
    while (tmp_8 < tmp_9) {
      tmp_10[tmp_8] = null;
      tmp_8 = tmp_8 + 1 | 0;
    }
    this_1.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, type_0, tmp_10));
  }
  var tmp_11 = this_1.u1t_1.h1(type_0.m1t());
  var tmp$ret$7 = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(entB);
  return compareTo(tmp_5, tmp$ret$7.eeo_1);
}
function ObjectRenderSystem$family$lambda($layerTag) {
  return function ($this$family) {
    $this$family.a1z([$layerTag, Companion_getInstance_36(), Companion_getInstance_22(), Companion_getInstance_38()]).c1z([Companion_getInstance_36(), Companion_getInstance_22(), Companion_getInstance_43(), Companion_getInstance_24(), Companion_getInstance_47(), Companion_getInstance_45(), Companion_getInstance_29()]);
    return Unit_instance;
  };
}
function ObjectRenderSystem$renderInternal$lambda($ninePatch, $tva, $index, $rgba) {
  return function (segment, xx, yy, ww, hh) {
    var bmpSlice = $ninePatch.r5l(segment);
    var _unary__edvuaz = $index._v;
    $index._v = _unary__edvuaz + 1 | 0;
    $tva.p9z(imul(_unary__edvuaz, 4), xx, yy, ww, hh, Companion_getInstance_8().z3l_1, bmpSlice, $rgba);
    return Unit_instance;
  };
}
function ObjectRenderSystem$renderInternal$lambda_0($ninePatch, $tva, $index, $rgba) {
  return function (segment, xx, yy, ww, hh) {
    var bmpSlice = $ninePatch.r5l(segment);
    var _unary__edvuaz = $index._v;
    $index._v = _unary__edvuaz + 1 | 0;
    $tva.p9z(imul(_unary__edvuaz, 4), xx, yy, ww, hh, Companion_getInstance_8().z3l_1, bmpSlice, $rgba);
    return Unit_instance;
  };
}
function drawLayer($this, global, local, config, layer, rgba, batch, ctx) {
  var countH = config.uel_1 ? AppConfig_getInstance().iev_1 / layer.f3u() | 0 : 0;
  var countV = config.vel_1 ? AppConfig_getInstance().jev_1 / layer.g3u() | 0 : 0;
  var x = !(countH === 0) && !(config.wel_1 == null) ? global.peo_1 : global.peo_1 + layer.x6l_1;
  var y = !(countV === 0) && !(config.wel_1 == null) ? global.qeo_1 : global.qeo_1 + layer.y6l_1;
  var xStart = countH > 0 ? -1 : 0;
  var yStart = countV > 0 ? -1 : 0;
  var inductionVariable = xStart;
  var last = countH + 1 | 0;
  if (inductionVariable < last)
    do {
      var xIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = yStart;
      var last_0 = countV + 1 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var yIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          batch.q9o(ctx.p9o(layer.f6m_1), x + imul(xIndex, layer.f3u()) + local.peo_1 + local.reo_1, y + imul(yIndex, layer.g3u()) + local.qeo_1 + local.seo_1, VOID, VOID, $this.ube(), false, rgba);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function drawParallaxPlaneLayer($this, global, local, localScroll, parallaxMode, repeat, layer, rgba, batch, ctx) {
  switch (parallaxMode.p3_1) {
    case 0:
      var countH = repeat ? AppConfig_getInstance().iev_1 / layer.f3u() | 0 : 0;
      var x = !(countH === 0) ? global.peo_1 : global.peo_1 + layer.x6l_1;
      var inductionVariable = -1 - countH | 0;
      var last = countH + 1 | 0;
      if (inductionVariable < last)
        do {
          var xIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          batch.q9o(ctx.p9o(layer.f6m_1), x + imul(xIndex, layer.f3u()) + AppConfig_getInstance().iev_1 * 0.5 + localScroll, global.qeo_1 + layer.y6l_1 + local.seo_1, VOID, VOID, $this.ube(), false, rgba);
        }
         while (inductionVariable < last);
      break;
    case 1:
      var countV = repeat ? AppConfig_getInstance().jev_1 / layer.g3u() | 0 : 0;
      var y = !(countV === 0) ? global.qeo_1 : global.qeo_1 + layer.y6l_1;
      var inductionVariable_0 = -1 - countV | 0;
      var last_0 = countV + 1 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var yIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          batch.q9o(ctx.p9o(layer.f6m_1), global.peo_1 + layer.x6l_1 + local.reo_1, y + imul(yIndex, layer.g3u()) + AppConfig_getInstance().jev_1 * 0.5 + localScroll, VOID, VOID, $this.ube(), false, rgba);
        }
         while (inductionVariable_0 < last_0);
      break;
    case 2:
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function wrap($this, value, max, min) {
  return value >= max ? value - max : value < min ? value + max : value;
}
function wrap$default($this, value, max, min, $super) {
  min = min === VOID ? 0 : min;
  return wrap($this, value, max, min);
}
function ParallaxRenderSystem$family$lambda($layerTag) {
  return function ($this$family) {
    $this$family.a1z([$layerTag, Companion_getInstance_36(), Companion_getInstance_35()]);
    return Unit_instance;
  };
}
function CameraSystem$_init_$lambda_ho8syf($this$family) {
  $this$family.a1z([CameraFollowTag_getInstance()]);
  return Unit_instance;
}
function CameraSystem$onTickEntity$lambda($this$family) {
  $this$family.a1z([Companion_getInstance_35(), Companion_getInstance_28()]);
  return Unit_instance;
}
function EntityLinkSystem$_init_$lambda_8svj5t($this$family) {
  $this$family.a1z([Companion_getInstance_19()]).c1z([Companion_getInstance_19(), Companion_getInstance_36()]);
  return Unit_instance;
}
function EventSystem$_init_$lambda_zdyf36($this$family) {
  $this$family.a1z([Companion_getInstance_20()]);
  return Unit_instance;
}
function debugPrint($this, entity, type) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  var type_0 = Companion_getInstance_21();
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = $this.i1v_1;
  if (this_0.u1t_1.j1s(type_0.m1t())) {
    var tmp = type_0.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type_0, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(type_0.m1t());
  var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sen_1;
  var name = tmp1_elvis_lhs == null ? 'no name' : tmp1_elvis_lhs;
}
function LifeCycleSystem$_init_$lambda_od09iq($this$family) {
  $this$family.a1z([Companion_getInstance_27()]);
  return Unit_instance;
}
function ParallaxSystem$_init_$lambda_lrn7iz($this$family) {
  $this$family.a1z([Companion_getInstance_35(), Companion_getInstance_28()]);
  return Unit_instance;
}
function PositionSystem$_init_$lambda_vx7er1($this$family) {
  $this$family.a1z([Companion_getInstance_36()]).c1z([Companion_getInstance_28(), Companion_getInstance_39()]).b1z([Companion_getInstance_35()]);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var vfs = get_resourcesVfs().cj('save_game.json');
  var tmp = vfs.h3h($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    var tmp_0 = vfs.e3h(VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var worldSnapshot = tmp_0;
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var this_0 = $this.afu_1.tft_1.gfu();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.mz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(KtMap), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Entity), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Snapshot), arrayOf([]), false))]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var snapshot = this_0.g1h(tmp$ret$1, worldSnapshot);
    $this.bfu_1.u20(snapshot);
    println('snapshot loaded!');
    postProcessing($this.afu_1);
  } else {
    println('WARNING: Cannot find snapshot file. Snapshot was not loaded!');
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var vfs = get_resourcesVfs().cj('save_game.json');
  var tmp = vfs.g3h($this.hfu_1, [], VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  println('Snapshot saved!');
  return Unit_instance;
}
function postProcessing($this) {
  // Inline function 'com.github.quillraven.fleks.Family.forEach' call
  var this_0 = $this.sft_1;
  var entitiesForIteration = this_0.u1y();
  if (!this_0.h1w_1.t1v_1) {
    this_0.h1w_1.t1v_1 = true;
    this_0.m1w_1 = true;
    // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
    var inductionVariable = 0;
    var last = entitiesForIteration.v1s_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.postProcessing.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var this_1 = entitiesForIteration.u1s_1[i];
        var type = Companion_getInstance_35();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this_0.i1v_1;
        if (this_2.u1t_1.j1s(type.m1t())) {
          var tmp = type.m1t();
          var tmp_0 = this_2.v1t();
          var tmp_1 = 0;
          var tmp_2 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = null;
            tmp_1 = tmp_1 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
        }
        var tmp_4 = this_2.u1t_1.h1(type.m1t());
        var parallaxComponent = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(this_1);
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        parallaxComponent.xep($this.v1z_1);
      }
       while (inductionVariable < last);
    this_0.m1w_1 = false;
    this_0.h1w_1.v1w();
  } else {
    var origIterating = this_0.m1w_1;
    this_0.m1w_1 = true;
    // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = entitiesForIteration.v1s_1;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.postProcessing.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var this_3 = entitiesForIteration.u1s_1[i_0];
        var type_0 = Companion_getInstance_35();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_4 = this_0.i1v_1;
        if (this_4.u1t_1.j1s(type_0.m1t())) {
          var tmp_5 = type_0.m1t();
          var tmp_6 = this_4.v1t();
          var tmp_7 = 0;
          var tmp_8 = this_4.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_9 = fillArrayVal(Array(tmp_8), null);
          while (tmp_7 < tmp_8) {
            tmp_9[tmp_7] = null;
            tmp_7 = tmp_7 + 1 | 0;
          }
          this_4.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
        }
        var tmp_10 = this_4.u1t_1.h1(type_0.m1t());
        var parallaxComponent_0 = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(this_3);
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        parallaxComponent_0.xep($this.v1z_1);
      }
       while (inductionVariable_0 < last_0);
    this_0.m1w_1 = origIterating;
  }
  // Inline function 'com.github.quillraven.fleks.Family.forEach' call
  var this_5 = $this.v1z_1.p20(SnapshotSerializerSystem$postProcessing$lambda);
  var entitiesForIteration_0 = this_5.u1y();
  if (!this_5.h1w_1.t1v_1) {
    this_5.h1w_1.t1v_1 = true;
    this_5.m1w_1 = true;
    // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
    var inductionVariable_1 = 0;
    var last_1 = entitiesForIteration_0.v1s_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.postProcessing.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var this_6 = entitiesForIteration_0.u1s_1[i_1];
        var type_1 = Companion_getInstance_24();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_7 = this_5.i1v_1;
        if (this_7.u1t_1.j1s(type_1.m1t())) {
          var tmp_11 = type_1.m1t();
          var tmp_12 = this_7.v1t();
          var tmp_13 = 0;
          var tmp_14 = this_7.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_15 = fillArrayVal(Array(tmp_14), null);
          while (tmp_13 < tmp_14) {
            tmp_15[tmp_13] = null;
            tmp_13 = tmp_13 + 1 | 0;
          }
          this_7.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
        }
        var tmp_16 = this_7.u1t_1.h1(type_1.m1t());
        var layeredSpriteComponent = (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(this_6);
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        layeredSpriteComponent.xep($this.v1z_1);
      }
       while (inductionVariable_1 < last_1);
    this_5.m1w_1 = false;
    this_5.h1w_1.v1w();
  } else {
    var origIterating_0 = this_5.m1w_1;
    this_5.m1w_1 = true;
    // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
    var inductionVariable_2 = 0;
    var last_2 = entitiesForIteration_0.v1s_1;
    if (inductionVariable_2 < last_2)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
        // Inline function 'korlibs.korge.fleks.systems.SnapshotSerializerSystem.postProcessing.<anonymous>' call
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var this_8 = entitiesForIteration_0.u1s_1[i_2];
        var type_2 = Companion_getInstance_24();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_9 = this_5.i1v_1;
        if (this_9.u1t_1.j1s(type_2.m1t())) {
          var tmp_17 = type_2.m1t();
          var tmp_18 = this_9.v1t();
          var tmp_19 = 0;
          var tmp_20 = this_9.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_21 = fillArrayVal(Array(tmp_20), null);
          while (tmp_19 < tmp_20) {
            tmp_21[tmp_19] = null;
            tmp_19 = tmp_19 + 1 | 0;
          }
          this_9.u1t_1.h1s(tmp_17, new ComponentsHolder(tmp_18, type_2, tmp_21));
        }
        var tmp_22 = this_9.u1t_1.h1(type_2.m1t());
        var layeredSpriteComponent_0 = (tmp_22 instanceof ComponentsHolder ? tmp_22 : THROW_CCE()).p1u(this_8);
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        layeredSpriteComponent_0.xep($this.v1z_1);
      }
       while (inductionVariable_2 < last_2);
    this_5.m1w_1 = origIterating_0;
  }
}
function SnapshotSerializerSystem$family$lambda($this$family) {
  $this$family.a1z([Companion_getInstance_35()]);
  return Unit_instance;
}
function SnapshotSerializerSystem$loadGameState$slambda_0(this$0, $world) {
  var i = new SnapshotSerializerSystem$loadGameState$slambda(this$0, $world);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SnapshotSerializerSystem$saveGameState$slambda_0($worldSnapshot) {
  var i = new SnapshotSerializerSystem$saveGameState$slambda($worldSnapshot);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SnapshotSerializerSystem$postProcessing$lambda($this$family) {
  $this$family.a1z([Companion_getInstance_24()]);
  return Unit_instance;
}
function SoundSystem$_init_$lambda_m13zl9($this$family) {
  $this$family.a1z([Companion_getInstance_41()]);
  return Unit_instance;
}
function SpawnerSystem$_init_$lambda_8b96uk($this$family) {
  $this$family.a1z([Companion_getInstance_42()]);
  return Unit_instance;
}
function SpriteLayersSystem$_init_$lambda_ej8h91($this$family) {
  $this$family.a1z([Companion_getInstance_45(), Companion_getInstance_46()]);
  return Unit_instance;
}
function SpriteSystem$_init_$lambda_469gc7($this$family) {
  $this$family.a1z([Companion_getInstance_43()]);
  return Unit_instance;
}
function checkTouchInputInsideBounds($this, left, top, right, bottom) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var containsArg = $this.qfw_1;
  if (left <= containsArg ? containsArg <= right : false) {
    var containsArg_0 = $this.rfw_1;
    tmp_1 = top <= containsArg_0 ? containsArg_0 <= bottom : false;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    var containsArg_1 = $this.tfw_1;
    tmp_0 = left <= containsArg_1 ? containsArg_1 <= right : false;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var containsArg_2 = $this.ufw_1;
    tmp = top <= containsArg_2 ? containsArg_2 <= bottom : false;
  } else {
    tmp = false;
  }
  return tmp;
}
function TouchInputSystem$_init_$lambda_ngtbe9($this$family) {
  $this$family.a1z([Companion_getInstance_49(), Companion_getInstance_36(), Companion_getInstance_40()]);
  return Unit_instance;
}
function setupTweenEngineSystems(_this__u8e3s4) {
  _this__u8e3s4.n21(TweenSequenceSystem.nfx());
  _this__u8e3s4.n21(TweenRgbaSystem.xfx());
  _this__u8e3s4.n21(TweenPositionSystem.hfy());
  _this__u8e3s4.n21(TweenMotionSystem.rfy());
  _this__u8e3s4.n21(TweenSpawnerSystem.bfz());
  _this__u8e3s4.n21(TweenSpriteSystem.mfz());
  _this__u8e3s4.n21(TweenSwitchLayerVisibilitySystem.wfz());
  _this__u8e3s4.n21(TweenSoundSystem.gg0());
  _this__u8e3s4.n21(TweenTextFieldSystem.qg0());
  _this__u8e3s4.n21(TweenEventSystem.bg1());
  _this__u8e3s4.n21(TweenTouchInputSystem.lg1());
}
function TweenRgbaSystem$_init_$lambda_tdafcz($this$family) {
  $this$family.a1z([Companion_getInstance_38()]).c1z([Companion_getInstance_50().qf1_1, Companion_getInstance_50().rf1_1]);
  return Unit_instance;
}
function TweenPositionSystem$_init_$lambda_mcomd4($this$family) {
  $this$family.a1z([Companion_getInstance_36()]).c1z([Companion_getInstance_50().nf1_1, Companion_getInstance_50().of1_1, Companion_getInstance_50().lf1_1, Companion_getInstance_50().mf1_1]);
  return Unit_instance;
}
function TweenMotionSystem$_init_$lambda_joef45($this$family) {
  $this$family.a1z([Companion_getInstance_28()]).c1z([Companion_getInstance_50().pf1_1]);
  return Unit_instance;
}
function TweenSpawnerSystem$_init_$lambda_uy5933($this$family) {
  $this$family.a1z([Companion_getInstance_42()]).c1z([Companion_getInstance_50().sf1_1, Companion_getInstance_50().tf1_1, Companion_getInstance_50().vf1_1, Companion_getInstance_50().uf1_1]);
  return Unit_instance;
}
function TweenSpawnerSystem$onTickEntity$lambda($spawnerComponent) {
  return function ($this$updateProperty) {
    $spawnerComponent.yex_1 = 0;
    return Unit_instance;
  };
}
function TweenSpriteSystem$_init_$lambda_3q3dlg($this$family) {
  $this$family.a1z([Companion_getInstance_43()]).c1z([Companion_getInstance_50().wf1_1, Companion_getInstance_50().zf1_1, Companion_getInstance_50().xf1_1, Companion_getInstance_50().yf1_1]);
  return Unit_instance;
}
function TweenSpriteSystem$onTickEntity$lambda($spriteComponent, this$0) {
  return function ($this$updateProperty) {
    $spriteComponent.uep(this$0.lfz_1);
    $spriteComponent.vep(this$0.lfz_1);
    return Unit_instance;
  };
}
function TweenSpriteSystem$onTickEntity$lambda_0($spriteComponent, this$0) {
  return function ($this$updateProperty) {
    $spriteComponent.uep(this$0.lfz_1);
    $spriteComponent.wep();
    return Unit_instance;
  };
}
function TweenSpriteSystem$onTickEntity$lambda_1($spriteComponent) {
  return function ($this$updateProperty) {
    $spriteComponent.wep();
    return Unit_instance;
  };
}
function TweenSwitchLayerVisibilitySystem$_init_$lambda_lxlimg($this$family) {
  $this$family.a1z([Companion_getInstance_46()]).c1z([Companion_getInstance_50().af2_1, Companion_getInstance_50().bf2_1]);
  return Unit_instance;
}
function TweenSoundSystem$_init_$lambda_x8dioo($this$family) {
  $this$family.a1z([Companion_getInstance_41()]).c1z([Companion_getInstance_50().cf2_1, Companion_getInstance_50().df2_1, Companion_getInstance_50().ef2_1, Companion_getInstance_50().ff2_1]);
  return Unit_instance;
}
function TweenTextFieldSystem$_init_$lambda_xtma1y($this$family) {
  $this$family.a1z([Companion_getInstance_47()]).c1z([Companion_getInstance_50().gf2_1, Companion_getInstance_50().hf2_1, Companion_getInstance_50().if2_1]);
  return Unit_instance;
}
function TweenEventSystem$_init_$lambda_ofw3sj($this$family) {
  $this$family.a1z([Companion_getInstance_70()]).c1z([Companion_getInstance_50().jf2_1, Companion_getInstance_50().kf2_1, Companion_getInstance_50().lf2_1]);
  return Unit_instance;
}
function TweenTouchInputSystem$_init_$lambda_dqa1wa($this$family) {
  $this$family.a1z([Companion_getInstance_49()]).c1z([Companion_getInstance_50().mf2_1]);
  return Unit_instance;
}
function updateProperty(_this__u8e3s4, entity, component, value) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp = component.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, component, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_5 = tmp0_safe_receiver.qf2_1;
        var tmp_6 = typeof tmp_5 === 'number' ? tmp_5 : THROW_CCE();
        var tmp_7 = tmp0_safe_receiver.rf2_1;
        value.set(tmp_6 + (typeof tmp_7 === 'number' ? tmp_7 : THROW_CCE()));
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_8 = component.m1t();
          var tmp_9 = this_2.v1t();
          var tmp_10 = 0;
          var tmp_11 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_12 = fillArrayVal(Array(tmp_11), null);
          while (tmp_10 < tmp_11) {
            tmp_12[tmp_10] = null;
            tmp_10 = tmp_10 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_8, new ComponentsHolder(tmp_9, component, tmp_12));
        }
        var tmp_13 = this_2.u1t_1.h1(component.m1t());
        (tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    } else {
      var time = tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1;
      var tmp_14 = tmp0_safe_receiver.qf2_1;
      var tmp_15 = (typeof tmp_14 === 'number' ? tmp_14 : THROW_CCE()) * tmp0_safe_receiver.uf2_1.i27(time);
      var tmp_16 = tmp0_safe_receiver.rf2_1;
      value.set(tmp_15 + (typeof tmp_16 === 'number' ? tmp_16 : THROW_CCE()));
      tmp0_safe_receiver.tf2_1 = tmp0_safe_receiver.tf2_1 + _this__u8e3s4.g20();
    }
  }
}
function updateProperty_0(_this__u8e3s4, entity, component, value) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp = component.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, component, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_5 = tmp0_safe_receiver.qf2_1;
        var tmp_6 = tmp_5 instanceof Rgb ? tmp_5 : THROW_CCE();
        var tmp_7 = tmp0_safe_receiver.rf2_1;
        value.set(tmp_6.bew(tmp_7 instanceof Rgb ? tmp_7 : THROW_CCE()));
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_8 = component.m1t();
          var tmp_9 = this_2.v1t();
          var tmp_10 = 0;
          var tmp_11 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_12 = fillArrayVal(Array(tmp_11), null);
          while (tmp_10 < tmp_11) {
            tmp_12[tmp_10] = null;
            tmp_10 = tmp_10 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_8, new ComponentsHolder(tmp_9, component, tmp_12));
        }
        var tmp_13 = this_2.u1t_1.h1(component.m1t());
        (tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    } else {
      var time = tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1;
      var tmp_14 = tmp0_safe_receiver.qf2_1;
      var tmp_15 = (tmp_14 instanceof Rgb ? tmp_14 : THROW_CCE()).u3s(tmp0_safe_receiver.uf2_1.i27(time));
      var tmp_16 = tmp0_safe_receiver.rf2_1;
      value.set(tmp_15.bew(tmp_16 instanceof Rgb ? tmp_16 : THROW_CCE()));
      tmp0_safe_receiver.tf2_1 = tmp0_safe_receiver.tf2_1 + _this__u8e3s4.g20();
    }
  }
}
function updateProperty_1(_this__u8e3s4, entity, component, value, block) {
  var tmp;
  if (block === VOID) {
    tmp = updateProperty$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp_0 = component.m1t();
    var tmp_1 = this_0.v1t();
    var tmp_2 = 0;
    var tmp_3 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, component, tmp_4));
  }
  var tmp_5 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_6 = tmp0_safe_receiver.qf2_1;
        var tmp_7 = typeof tmp_6 === 'number' ? tmp_6 : THROW_CCE();
        var tmp_8 = tmp0_safe_receiver.rf2_1;
        value.set(tmp_7 + (typeof tmp_8 === 'number' ? tmp_8 : THROW_CCE()) | 0);
        block($this$configure);
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_9 = component.m1t();
          var tmp_10 = this_2.v1t();
          var tmp_11 = 0;
          var tmp_12 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_13 = fillArrayVal(Array(tmp_12), null);
          while (tmp_11 < tmp_12) {
            tmp_13[tmp_11] = null;
            tmp_11 = tmp_11 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_9, new ComponentsHolder(tmp_10, component, tmp_13));
        }
        var tmp_14 = this_2.u1t_1.h1(component.m1t());
        (tmp_14 instanceof ComponentsHolder ? tmp_14 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    } else {
      var time = tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1;
      var tmp_15 = tmp0_safe_receiver.qf2_1;
      var tmp_16 = numberToInt((typeof tmp_15 === 'number' ? tmp_15 : THROW_CCE()) * tmp0_safe_receiver.uf2_1.i27(time));
      var tmp_17 = tmp0_safe_receiver.rf2_1;
      value.set(tmp_16 + (typeof tmp_17 === 'number' ? tmp_17 : THROW_CCE()) | 0);
      tmp0_safe_receiver.tf2_1 = tmp0_safe_receiver.tf2_1 + _this__u8e3s4.g20();
    }
  }
}
function updateProperty_2(_this__u8e3s4, entity, component, value, block) {
  var tmp;
  if (block === VOID) {
    tmp = updateProperty$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp_0 = component.m1t();
    var tmp_1 = this_0.v1t();
    var tmp_2 = 0;
    var tmp_3 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, component, tmp_4));
  }
  var tmp_5 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1 || tmp0_safe_receiver.uf2_1.i27(tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1) > 0.5) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_6 = tmp0_safe_receiver.rf2_1;
        value.set(typeof tmp_6 === 'string' ? tmp_6 : THROW_CCE());
        block($this$configure);
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_7 = component.m1t();
          var tmp_8 = this_2.v1t();
          var tmp_9 = 0;
          var tmp_10 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_11 = fillArrayVal(Array(tmp_10), null);
          while (tmp_9 < tmp_10) {
            tmp_11[tmp_9] = null;
            tmp_9 = tmp_9 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, component, tmp_11));
        }
        var tmp_12 = this_2.u1t_1.h1(component.m1t());
        (tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    }
  }
}
function updateProperty_3(_this__u8e3s4, entity, component, value, block) {
  var tmp;
  if (block === VOID) {
    tmp = updateProperty$lambda_1;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp_0 = component.m1t();
    var tmp_1 = this_0.v1t();
    var tmp_2 = 0;
    var tmp_3 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, component, tmp_4));
  }
  var tmp_5 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1 || tmp0_safe_receiver.uf2_1.i27(tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1) > 0.5) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_6 = tmp0_safe_receiver.rf2_1;
        value.set(tmp_6 instanceof Direction ? tmp_6 : THROW_CCE());
        block($this$configure);
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_7 = component.m1t();
          var tmp_8 = this_2.v1t();
          var tmp_9 = 0;
          var tmp_10 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_11 = fillArrayVal(Array(tmp_10), null);
          while (tmp_9 < tmp_10) {
            tmp_11[tmp_9] = null;
            tmp_9 = tmp_9 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, component, tmp_11));
        }
        var tmp_12 = this_2.u1t_1.h1(component.m1t());
        (tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    }
  }
}
function updateProperty_4(_this__u8e3s4, entity, component, value, block) {
  var tmp;
  if (block === VOID) {
    tmp = updateProperty$lambda_2;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp_0 = component.m1t();
    var tmp_1 = this_0.v1t();
    var tmp_2 = 0;
    var tmp_3 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, component, tmp_4));
  }
  var tmp_5 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1 || tmp0_safe_receiver.uf2_1.i27(tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1) > 0.5) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_6 = tmp0_safe_receiver.rf2_1;
        value.set(typeof tmp_6 === 'boolean' ? tmp_6 : THROW_CCE());
        block($this$configure);
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_7 = component.m1t();
          var tmp_8 = this_2.v1t();
          var tmp_9 = 0;
          var tmp_10 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_11 = fillArrayVal(Array(tmp_10), null);
          while (tmp_9 < tmp_10) {
            tmp_11[tmp_9] = null;
            tmp_9 = tmp_9 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_7, new ComponentsHolder(tmp_8, component, tmp_11));
        }
        var tmp_12 = this_2.u1t_1.h1(component.m1t());
        (tmp_12 instanceof ComponentsHolder ? tmp_12 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    }
  }
}
function updateProperty_5(_this__u8e3s4, entity, component, value) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp = component.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, component, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_5 = tmp0_safe_receiver.qf2_1;
        var tmp_6 = typeof tmp_5 === 'number' ? tmp_5 : THROW_CCE();
        var tmp_7 = tmp0_safe_receiver.rf2_1;
        value.set(tmp_6 + (typeof tmp_7 === 'number' ? tmp_7 : THROW_CCE()));
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_8 = component.m1t();
          var tmp_9 = this_2.v1t();
          var tmp_10 = 0;
          var tmp_11 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_12 = fillArrayVal(Array(tmp_11), null);
          while (tmp_10 < tmp_11) {
            tmp_12[tmp_10] = null;
            tmp_10 = tmp_10 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_8, new ComponentsHolder(tmp_9, component, tmp_12));
        }
        var tmp_13 = this_2.u1t_1.h1(component.m1t());
        (tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    } else {
      var time = tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1;
      var tmp_14 = tmp0_safe_receiver.qf2_1;
      var tmp_15 = (typeof tmp_14 === 'number' ? tmp_14 : THROW_CCE()) * tmp0_safe_receiver.uf2_1.i27(time);
      var tmp_16 = tmp0_safe_receiver.rf2_1;
      value.set(tmp_15 + (typeof tmp_16 === 'number' ? tmp_16 : THROW_CCE()));
      tmp0_safe_receiver.tf2_1 = tmp0_safe_receiver.tf2_1 + _this__u8e3s4.g20();
    }
  }
}
function updateProperty_6(_this__u8e3s4, entity, component, value) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
  var this_0 = _this__u8e3s4.i1v_1;
  if (this_0.u1t_1.j1s(component.m1t())) {
    var tmp = component.m1t();
    var tmp_0 = this_0.v1t();
    var tmp_1 = 0;
    var tmp_2 = this_0.v1t().g1s();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      tmp_3[tmp_1] = null;
      tmp_1 = tmp_1 + 1 | 0;
    }
    this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, component, tmp_3));
  }
  var tmp_4 = this_0.u1t_1.h1(component.m1t());
  var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_safe_receiver.tf2_1 >= tmp0_safe_receiver.sf2_1 || tmp0_safe_receiver.uf2_1.i27(tmp0_safe_receiver.tf2_1 / tmp0_safe_receiver.sf2_1) > 0.5) {
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
        var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
        var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
        var prevUpdateId = this_1.s1v_1;
        this_1.s1v_1 = entity.m1u_1;
        // Inline function 'korlibs.korge.fleks.systems.updateProperty.<anonymous>.<anonymous>' call
        var $this$configure = this_1.r1v_1;
        var tmp_5 = tmp0_safe_receiver.rf2_1;
        value.set(typeof tmp_5 === 'string' ? tmp_5 : THROW_CCE());
        // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.minusAssign' call
        $this$configure.f1v_1.h1(entity.m1u_1).q1s(component.m1t());
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = $this$configure.i1v_1;
        if (this_2.u1t_1.j1s(component.m1t())) {
          var tmp_6 = component.m1t();
          var tmp_7 = this_2.v1t();
          var tmp_8 = 0;
          var tmp_9 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_10 = fillArrayVal(Array(tmp_9), null);
          while (tmp_8 < tmp_9) {
            tmp_10[tmp_8] = null;
            tmp_8 = tmp_8 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, component, tmp_10));
        }
        var tmp_11 = this_2.u1t_1.h1(component.m1t());
        (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).o1u(entity);
        this_1.s1v_1 = prevUpdateId;
        if (skipFamilyNotify) {
          break $l$block;
        }
        var compMask = this_1.o1v_1.h1(entity.m1u_1);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this_1.l1v_1.b1u_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
          element.p1w(entity, compMask);
        }
      }
    }
  }
}
function updateProperty$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function updateProperty$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
function updateProperty$lambda_1(_this__u8e3s4) {
  return Unit_instance;
}
function updateProperty$lambda_2(_this__u8e3s4) {
  return Unit_instance;
}
function alpha$factory($b0) {
  return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
    return $b0.few();
  }, function (value) {
    return $b0.iew(value);
  });
}
function tint$factory($b0) {
  return getPropertyCallableRef('tint', 0, KMutableProperty0, function () {
    return $b0.gew();
  }, function (value) {
    return $b0.jew(value);
  });
}
function x$factory($b0) {
  return getPropertyCallableRef('x', 0, KMutableProperty0, function () {
    return $b0.peo_1;
  }, function (value) {
    $b0.peo_1 = value;
    return Unit_instance;
  });
}
function y$factory($b0) {
  return getPropertyCallableRef('y', 0, KMutableProperty0, function () {
    return $b0.qeo_1;
  }, function (value) {
    $b0.qeo_1 = value;
    return Unit_instance;
  });
}
function offsetX$factory($b0) {
  return getPropertyCallableRef('offsetX', 0, KMutableProperty0, function () {
    return $b0.reo_1;
  }, function (value) {
    $b0.reo_1 = value;
    return Unit_instance;
  });
}
function offsetY$factory($b0) {
  return getPropertyCallableRef('offsetY', 0, KMutableProperty0, function () {
    return $b0.seo_1;
  }, function (value) {
    $b0.seo_1 = value;
    return Unit_instance;
  });
}
function velocityX$factory($b0) {
  return getPropertyCallableRef('velocityX', 0, KMutableProperty0, function () {
    return $b0.fer_1;
  }, function (value) {
    $b0.fer_1 = value;
    return Unit_instance;
  });
}
function numberOfObjects$factory($b0) {
  return getPropertyCallableRef('numberOfObjects', 0, KMutableProperty0, function () {
    return $b0.rex_1;
  }, function (value) {
    $b0.rex_1 = value;
    return Unit_instance;
  });
}
function interval$factory($b0) {
  return getPropertyCallableRef('interval', 0, KMutableProperty0, function () {
    return $b0.sex_1;
  }, function (value) {
    $b0.sex_1 = value;
    return Unit_instance;
  });
}
function timeVariation$factory($b0) {
  return getPropertyCallableRef('timeVariation', 0, KMutableProperty0, function () {
    return $b0.tex_1;
  }, function (value) {
    $b0.tex_1 = value;
    return Unit_instance;
  });
}
function positionVariation$factory($b0) {
  return getPropertyCallableRef('positionVariation', 0, KMutableProperty0, function () {
    return $b0.uex_1;
  }, function (value) {
    $b0.uex_1 = value;
    return Unit_instance;
  });
}
function animation$factory($b0) {
  return getPropertyCallableRef('animation', 0, KMutableProperty0, function () {
    return $b0.ley_1;
  }, function (value) {
    $b0.ley_1 = value;
    return Unit_instance;
  });
}
function direction$factory($b0) {
  return getPropertyCallableRef('direction', 0, KMutableProperty0, function () {
    return $b0.oey_1;
  }, function (value) {
    $b0.oey_1 = value;
    return Unit_instance;
  });
}
function running$factory($b0) {
  return getPropertyCallableRef('running', 0, KMutableProperty0, function () {
    return $b0.ney_1;
  }, function (value) {
    $b0.ney_1 = value;
    return Unit_instance;
  });
}
function destroyOnAnimationFinished$factory($b0) {
  return getPropertyCallableRef('destroyOnAnimationFinished', 0, KMutableProperty0, function () {
    return $b0.pey_1;
  }, function (value) {
    $b0.pey_1 = value;
    return Unit_instance;
  });
}
function offVariance$factory($b0) {
  return getPropertyCallableRef('offVariance', 0, KMutableProperty0, function () {
    return $b0.sez_1;
  }, function (value) {
    $b0.sez_1 = value;
    return Unit_instance;
  });
}
function onVariance$factory($b0) {
  return getPropertyCallableRef('onVariance', 0, KMutableProperty0, function () {
    return $b0.tez_1;
  }, function (value) {
    $b0.tez_1 = value;
    return Unit_instance;
  });
}
function startTrigger$factory($b0) {
  return getPropertyCallableRef('startTrigger', 0, KMutableProperty0, function () {
    return $b0.fex_1;
  }, function (value) {
    $b0.fex_1 = value;
    return Unit_instance;
  });
}
function stopTrigger$factory($b0) {
  return getPropertyCallableRef('stopTrigger', 0, KMutableProperty0, function () {
    return $b0.gex_1;
  }, function (value) {
    $b0.gex_1 = value;
    return Unit_instance;
  });
}
function position$factory($b0) {
  return getPropertyCallableRef('position', 0, KMutableProperty0, function () {
    return $b0.hex_1;
  }, function (value) {
    $b0.hex_1 = value;
    return Unit_instance;
  });
}
function volume$factory($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.iex_1;
  }, function (value) {
    $b0.iex_1 = value;
    return Unit_instance;
  });
}
function text$factory($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.zez_1;
  }, function (value) {
    $b0.zez_1 = value;
    return Unit_instance;
  });
}
function textRangeStart$factory($b0) {
  return getPropertyCallableRef('textRangeStart', 0, KMutableProperty0, function () {
    return $b0.bf0_1;
  }, function (value) {
    $b0.bf0_1 = value;
    return Unit_instance;
  });
}
function textRangeEnd$factory($b0) {
  return getPropertyCallableRef('textRangeEnd', 0, KMutableProperty0, function () {
    return $b0.cf0_1;
  }, function (value) {
    $b0.cf0_1 = value;
    return Unit_instance;
  });
}
function enabled$factory($b0) {
  return getPropertyCallableRef('enabled', 0, KMutableProperty0, function () {
    return $b0.yf0_1;
  }, function (value) {
    $b0.yf0_1 = value;
    return Unit_instance;
  });
}
function _get_currentTween__xb6s61($this) {
  var tmp = $this.kfx_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('currentTween');
  }
}
function _get_currentParentTween__20kwyr($this) {
  var tmp = $this.lfx_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('currentParentTween');
  }
}
function checkTween($this, baseEntity, tween, parentTween) {
  $this.kfx_1 = tween;
  $this.lfx_1 = parentTween;
  if (tween instanceof TweenRgba) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
      var this_0 = tween.vf6_1;
      var componentType = Companion_getInstance_38();
      if ($this.k1v(this_0, componentType)) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_1 = $this.i1v_1;
        if (this_1.u1t_1.j1s(componentType.m1t())) {
          var tmp = componentType.m1t();
          var tmp_0 = this_1.v1t();
          var tmp_1 = 0;
          var tmp_2 = this_1.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = null;
            tmp_1 = tmp_1 + 1 | 0;
          }
          this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, componentType, tmp_3));
        }
        var tmp_4 = this_1.u1t_1.h1(componentType.m1t());
        tmp$ret$4 = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(this_0);
        break $l$block_0;
      } else {
        println("WARNING - TweenSequenceSystem: Entity '" + this_0.m1u_1 + "' (" + nameOf($this.v1z_1, this_0) + ") does not contain component type '" + toString_0(componentType) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_0).toString()));
        tmp$ret$4 = null;
        break $l$block_0;
      }
    }
    var tmp1_safe_receiver = tmp$ret$4;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
      var tmp0_safe_receiver = tween.sf6_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        createTweenPropertyComponent($this, TweenProperty_RgbaAlpha_getInstance(), tmp1_safe_receiver.few(), tmp0_safe_receiver - tmp1_safe_receiver.few());
      }
      var tmp1_safe_receiver_0 = tween.tf6_1;
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        createTweenPropertyComponent($this, TweenProperty_RgbaTint_getInstance(), tmp1_safe_receiver.gew(), new Rgb(tmp1_safe_receiver_0.xev_1 - tmp1_safe_receiver.gew().xev_1 | 0, tmp1_safe_receiver_0.yev_1 - tmp1_safe_receiver.gew().yev_1 | 0, tmp1_safe_receiver_0.zev_1 - tmp1_safe_receiver.gew().zev_1 | 0));
      }
      var tmp2_safe_receiver = tween.uf6_1;
      var tmp_5;
      if (tmp2_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        createTweenPropertyComponent($this, TweenProperty_RgbaAlpha_getInstance(), tmp2_safe_receiver ? 1.0 : 0.0, 0.0);
        tmp_5 = Unit_instance;
      }
    }
  } else {
    if (tween instanceof TweenPosition) {
      var tmp$ret$14;
      $l$block_2: {
        // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
        var this_2 = tween.gf7_1;
        var componentType_0 = Companion_getInstance_36();
        if ($this.k1v(this_2, componentType_0)) {
          // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
          // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
          var this_3 = $this.i1v_1;
          if (this_3.u1t_1.j1s(componentType_0.m1t())) {
            var tmp_6 = componentType_0.m1t();
            var tmp_7 = this_3.v1t();
            var tmp_8 = 0;
            var tmp_9 = this_3.v1t().g1s();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_10 = fillArrayVal(Array(tmp_9), null);
            while (tmp_8 < tmp_9) {
              tmp_10[tmp_8] = null;
              tmp_8 = tmp_8 + 1 | 0;
            }
            this_3.u1t_1.h1s(tmp_6, new ComponentsHolder(tmp_7, componentType_0, tmp_10));
          }
          var tmp_11 = this_3.u1t_1.h1(componentType_0.m1t());
          tmp$ret$14 = (tmp_11 instanceof ComponentsHolder ? tmp_11 : THROW_CCE()).p1u(this_2);
          break $l$block_2;
        } else {
          println("WARNING - TweenSequenceSystem: Entity '" + this_2.m1u_1 + "' (" + nameOf($this.v1z_1, this_2) + ") does not contain component type '" + toString_0(componentType_0) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_2).toString()));
          tmp$ret$14 = null;
          break $l$block_2;
        }
      }
      var tmp2_safe_receiver_0 = tmp$ret$14;
      if (tmp2_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
        var tmp0_safe_receiver_0 = tween.cf7_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          createTweenPropertyComponent($this, TweenProperty_PositionX_getInstance(), tmp2_safe_receiver_0.peo_1, tmp0_safe_receiver_0 - tmp2_safe_receiver_0.peo_1);
        }
        var tmp1_safe_receiver_1 = tween.df7_1;
        if (tmp1_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          createTweenPropertyComponent($this, TweenProperty_PositionY_getInstance(), tmp2_safe_receiver_0.qeo_1, tmp1_safe_receiver_1 - tmp2_safe_receiver_0.qeo_1);
        }
        var tmp2_safe_receiver_1 = tween.ef7_1;
        if (tmp2_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          createTweenPropertyComponent($this, TweenProperty_PositionOffsetX_getInstance(), tmp2_safe_receiver_0.reo_1, tmp2_safe_receiver_1 - tmp2_safe_receiver_0.reo_1);
        }
        var tmp3_safe_receiver = tween.ff7_1;
        var tmp_12;
        if (tmp3_safe_receiver == null) {
          tmp_12 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          createTweenPropertyComponent($this, TweenProperty_PositionOffsetY_getInstance(), tmp2_safe_receiver_0.seo_1, tmp3_safe_receiver - tmp2_safe_receiver_0.seo_1);
          tmp_12 = Unit_instance;
        }
      }
    } else {
      if (tween instanceof TweenMotion) {
        var tmp$ret$25;
        $l$block_4: {
          // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
          var this_4 = tween.of7_1;
          var componentType_1 = Companion_getInstance_28();
          if ($this.k1v(this_4, componentType_1)) {
            // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
            // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
            var this_5 = $this.i1v_1;
            if (this_5.u1t_1.j1s(componentType_1.m1t())) {
              var tmp_13 = componentType_1.m1t();
              var tmp_14 = this_5.v1t();
              var tmp_15 = 0;
              var tmp_16 = this_5.v1t().g1s();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_17 = fillArrayVal(Array(tmp_16), null);
              while (tmp_15 < tmp_16) {
                tmp_17[tmp_15] = null;
                tmp_15 = tmp_15 + 1 | 0;
              }
              this_5.u1t_1.h1s(tmp_13, new ComponentsHolder(tmp_14, componentType_1, tmp_17));
            }
            var tmp_18 = this_5.u1t_1.h1(componentType_1.m1t());
            tmp$ret$25 = (tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE()).p1u(this_4);
            break $l$block_4;
          } else {
            println("WARNING - TweenSequenceSystem: Entity '" + this_4.m1u_1 + "' (" + nameOf($this.v1z_1, this_4) + ") does not contain component type '" + toString_0(componentType_1) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_4).toString()));
            tmp$ret$25 = null;
            break $l$block_4;
          }
        }
        var tmp3_safe_receiver_0 = tmp$ret$25;
        if (tmp3_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
          var tmp0_safe_receiver_1 = tween.nf7_1;
          var tmp_19;
          if (tmp0_safe_receiver_1 == null) {
            tmp_19 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            createTweenPropertyComponent($this, TweenProperty_MotionVelocityX_getInstance(), tmp3_safe_receiver_0.fer_1, tmp0_safe_receiver_1 - tmp3_safe_receiver_0.fer_1);
            tmp_19 = Unit_instance;
          }
        }
      } else {
        if (tween instanceof TweenSprite) {
          var tmp$ret$33;
          $l$block_6: {
            // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
            var this_6 = tween.af8_1;
            var componentType_2 = Companion_getInstance_43();
            if ($this.k1v(this_6, componentType_2)) {
              // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
              // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
              var this_7 = $this.i1v_1;
              if (this_7.u1t_1.j1s(componentType_2.m1t())) {
                var tmp_20 = componentType_2.m1t();
                var tmp_21 = this_7.v1t();
                var tmp_22 = 0;
                var tmp_23 = this_7.v1t().g1s();
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp_24 = fillArrayVal(Array(tmp_23), null);
                while (tmp_22 < tmp_23) {
                  tmp_24[tmp_22] = null;
                  tmp_22 = tmp_22 + 1 | 0;
                }
                this_7.u1t_1.h1s(tmp_20, new ComponentsHolder(tmp_21, componentType_2, tmp_24));
              }
              var tmp_25 = this_7.u1t_1.h1(componentType_2.m1t());
              tmp$ret$33 = (tmp_25 instanceof ComponentsHolder ? tmp_25 : THROW_CCE()).p1u(this_6);
              break $l$block_6;
            } else {
              println("WARNING - TweenSequenceSystem: Entity '" + this_6.m1u_1 + "' (" + nameOf($this.v1z_1, this_6) + ") does not contain component type '" + toString_0(componentType_2) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_6).toString()));
              tmp$ret$33 = null;
              break $l$block_6;
            }
          }
          if (tmp$ret$33 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
            var tmp0_safe_receiver_2 = tween.wf7_1;
            if (tmp0_safe_receiver_2 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              createTweenPropertyComponent$default($this, TweenProperty_SpriteAnimation_getInstance(), tmp0_safe_receiver_2);
            }
            var tmp1_safe_receiver_2 = tween.xf7_1;
            if (tmp1_safe_receiver_2 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              createTweenPropertyComponent$default($this, TweenProperty_SpriteRunning_getInstance(), tmp1_safe_receiver_2);
            }
            var tmp2_safe_receiver_2 = tween.yf7_1;
            if (tmp2_safe_receiver_2 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              createTweenPropertyComponent$default($this, TweenProperty_SpriteDirection_getInstance(), tmp2_safe_receiver_2);
            }
            var tmp3_safe_receiver_1 = tween.zf7_1;
            var tmp_26;
            if (tmp3_safe_receiver_1 == null) {
              tmp_26 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              createTweenPropertyComponent$default($this, TweenProperty_SpriteDestroyOnPlayingFinished_getInstance(), tmp3_safe_receiver_1);
              tmp_26 = Unit_instance;
            }
          }
        } else {
          if (tween instanceof TweenSwitchLayerVisibility) {
            var tmp$ret$44;
            $l$block_8: {
              // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
              var this_8 = tween.jf8_1;
              var componentType_3 = Companion_getInstance_46();
              if ($this.k1v(this_8, componentType_3)) {
                // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                var this_9 = $this.i1v_1;
                if (this_9.u1t_1.j1s(componentType_3.m1t())) {
                  var tmp_27 = componentType_3.m1t();
                  var tmp_28 = this_9.v1t();
                  var tmp_29 = 0;
                  var tmp_30 = this_9.v1t().g1s();
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp_31 = fillArrayVal(Array(tmp_30), null);
                  while (tmp_29 < tmp_30) {
                    tmp_31[tmp_29] = null;
                    tmp_29 = tmp_29 + 1 | 0;
                  }
                  this_9.u1t_1.h1s(tmp_27, new ComponentsHolder(tmp_28, componentType_3, tmp_31));
                }
                var tmp_32 = this_9.u1t_1.h1(componentType_3.m1t());
                tmp$ret$44 = (tmp_32 instanceof ComponentsHolder ? tmp_32 : THROW_CCE()).p1u(this_8);
                break $l$block_8;
              } else {
                println("WARNING - TweenSequenceSystem: Entity '" + this_8.m1u_1 + "' (" + nameOf($this.v1z_1, this_8) + ") does not contain component type '" + toString_0(componentType_3) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_8).toString()));
                tmp$ret$44 = null;
                break $l$block_8;
              }
            }
            var tmp5_safe_receiver = tmp$ret$44;
            if (tmp5_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
              var tmp0_safe_receiver_3 = tween.hf8_1;
              if (tmp0_safe_receiver_3 == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                createTweenPropertyComponent($this, TweenProperty_SwitchLayerVisibilityOffVariance_getInstance(), tmp5_safe_receiver.sez_1, tmp0_safe_receiver_3 - tmp5_safe_receiver.sez_1);
              }
              var tmp1_safe_receiver_3 = tween.if8_1;
              var tmp_33;
              if (tmp1_safe_receiver_3 == null) {
                tmp_33 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                createTweenPropertyComponent($this, TweenProperty_SwitchLayerVisibilityOnVariance_getInstance(), tmp5_safe_receiver.tez_1, tmp1_safe_receiver_3 - tmp5_safe_receiver.tez_1);
                tmp_33 = Unit_instance;
              }
            }
          } else {
            if (tween instanceof TweenSpawner) {
              var tmp$ret$53;
              $l$block_10: {
                // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
                var this_10 = tween.uf8_1;
                var componentType_4 = Companion_getInstance_42();
                if ($this.k1v(this_10, componentType_4)) {
                  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                  // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                  var this_11 = $this.i1v_1;
                  if (this_11.u1t_1.j1s(componentType_4.m1t())) {
                    var tmp_34 = componentType_4.m1t();
                    var tmp_35 = this_11.v1t();
                    var tmp_36 = 0;
                    var tmp_37 = this_11.v1t().g1s();
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp_38 = fillArrayVal(Array(tmp_37), null);
                    while (tmp_36 < tmp_37) {
                      tmp_38[tmp_36] = null;
                      tmp_36 = tmp_36 + 1 | 0;
                    }
                    this_11.u1t_1.h1s(tmp_34, new ComponentsHolder(tmp_35, componentType_4, tmp_38));
                  }
                  var tmp_39 = this_11.u1t_1.h1(componentType_4.m1t());
                  tmp$ret$53 = (tmp_39 instanceof ComponentsHolder ? tmp_39 : THROW_CCE()).p1u(this_10);
                  break $l$block_10;
                } else {
                  println("WARNING - TweenSequenceSystem: Entity '" + this_10.m1u_1 + "' (" + nameOf($this.v1z_1, this_10) + ") does not contain component type '" + toString_0(componentType_4) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_10).toString()));
                  tmp$ret$53 = null;
                  break $l$block_10;
                }
              }
              var tmp6_safe_receiver = tmp$ret$53;
              if (tmp6_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
                var tmp0_safe_receiver_4 = tween.qf8_1;
                if (tmp0_safe_receiver_4 == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  createTweenPropertyComponent($this, TweenProperty_SpawnerNumberOfObjects_getInstance(), tmp6_safe_receiver.rex_1, tmp0_safe_receiver_4 - tmp6_safe_receiver.rex_1 | 0);
                }
                var tmp1_safe_receiver_4 = tween.rf8_1;
                if (tmp1_safe_receiver_4 == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  createTweenPropertyComponent($this, TweenProperty_SpawnerInterval_getInstance(), tmp6_safe_receiver.sex_1, tmp1_safe_receiver_4 - tmp6_safe_receiver.sex_1 | 0);
                }
                var tmp2_safe_receiver_3 = tween.sf8_1;
                if (tmp2_safe_receiver_3 == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  createTweenPropertyComponent($this, TweenProperty_SpawnerTimeVariation_getInstance(), tmp6_safe_receiver.tex_1, tmp2_safe_receiver_3 - tmp6_safe_receiver.tex_1 | 0);
                }
                var tmp3_safe_receiver_2 = tween.tf8_1;
                var tmp_40;
                if (tmp3_safe_receiver_2 == null) {
                  tmp_40 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  createTweenPropertyComponent($this, TweenProperty_SpawnerPositionVariation_getInstance(), tmp6_safe_receiver.uex_1, tmp3_safe_receiver_2 - tmp6_safe_receiver.uex_1);
                  tmp_40 = Unit_instance;
                }
              }
            } else {
              if (tween instanceof TweenSound) {
                var tmp$ret$64;
                $l$block_12: {
                  // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
                  var this_12 = tween.ff9_1;
                  var componentType_5 = Companion_getInstance_41();
                  if ($this.k1v(this_12, componentType_5)) {
                    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                    var this_13 = $this.i1v_1;
                    if (this_13.u1t_1.j1s(componentType_5.m1t())) {
                      var tmp_41 = componentType_5.m1t();
                      var tmp_42 = this_13.v1t();
                      var tmp_43 = 0;
                      var tmp_44 = this_13.v1t().g1s();
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp_45 = fillArrayVal(Array(tmp_44), null);
                      while (tmp_43 < tmp_44) {
                        tmp_45[tmp_43] = null;
                        tmp_43 = tmp_43 + 1 | 0;
                      }
                      this_13.u1t_1.h1s(tmp_41, new ComponentsHolder(tmp_42, componentType_5, tmp_45));
                    }
                    var tmp_46 = this_13.u1t_1.h1(componentType_5.m1t());
                    tmp$ret$64 = (tmp_46 instanceof ComponentsHolder ? tmp_46 : THROW_CCE()).p1u(this_12);
                    break $l$block_12;
                  } else {
                    println("WARNING - TweenSequenceSystem: Entity '" + this_12.m1u_1 + "' (" + nameOf($this.v1z_1, this_12) + ") does not contain component type '" + toString_0(componentType_5) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_12).toString()));
                    tmp$ret$64 = null;
                    break $l$block_12;
                  }
                }
                var tmp7_safe_receiver = tmp$ret$64;
                if (tmp7_safe_receiver == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
                  var tmp0_safe_receiver_5 = tween.bf9_1;
                  if (tmp0_safe_receiver_5 == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    createTweenPropertyComponent$default($this, TweenProperty_SoundStartTrigger_getInstance(), tmp0_safe_receiver_5);
                  }
                  var tmp1_safe_receiver_5 = tween.cf9_1;
                  if (tmp1_safe_receiver_5 == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    createTweenPropertyComponent$default($this, TweenProperty_SoundStopTrigger_getInstance(), tmp1_safe_receiver_5);
                  }
                  var tmp2_safe_receiver_4 = tween.df9_1;
                  if (tmp2_safe_receiver_4 == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    createTweenPropertyComponent($this, TweenProperty_SoundPosition_getInstance(), tmp7_safe_receiver.hex_1, tmp2_safe_receiver_4 - tmp7_safe_receiver.hex_1);
                  }
                  var tmp3_safe_receiver_3 = tween.ef9_1;
                  var tmp_47;
                  if (tmp3_safe_receiver_3 == null) {
                    tmp_47 = null;
                  } else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    createTweenPropertyComponent($this, TweenProperty_SoundVolume_getInstance(), tmp7_safe_receiver.iex_1, tmp3_safe_receiver_3 - tmp7_safe_receiver.iex_1);
                    tmp_47 = Unit_instance;
                  }
                }
              } else {
                if (tween instanceof TweenTextField) {
                  var tmp$ret$75;
                  $l$block_14: {
                    // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
                    var this_14 = tween.lf6_1;
                    var componentType_6 = Companion_getInstance_47();
                    if ($this.k1v(this_14, componentType_6)) {
                      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                      var this_15 = $this.i1v_1;
                      if (this_15.u1t_1.j1s(componentType_6.m1t())) {
                        var tmp_48 = componentType_6.m1t();
                        var tmp_49 = this_15.v1t();
                        var tmp_50 = 0;
                        var tmp_51 = this_15.v1t().g1s();
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp_52 = fillArrayVal(Array(tmp_51), null);
                        while (tmp_50 < tmp_51) {
                          tmp_52[tmp_50] = null;
                          tmp_50 = tmp_50 + 1 | 0;
                        }
                        this_15.u1t_1.h1s(tmp_48, new ComponentsHolder(tmp_49, componentType_6, tmp_52));
                      }
                      var tmp_53 = this_15.u1t_1.h1(componentType_6.m1t());
                      tmp$ret$75 = (tmp_53 instanceof ComponentsHolder ? tmp_53 : THROW_CCE()).p1u(this_14);
                      break $l$block_14;
                    } else {
                      println("WARNING - TweenSequenceSystem: Entity '" + this_14.m1u_1 + "' (" + nameOf($this.v1z_1, this_14) + ") does not contain component type '" + toString_0(componentType_6) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_14).toString()));
                      tmp$ret$75 = null;
                      break $l$block_14;
                    }
                  }
                  var tmp8_safe_receiver = tmp$ret$75;
                  if (tmp8_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
                    var tmp0_safe_receiver_6 = tween.if6_1;
                    if (tmp0_safe_receiver_6 == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      // Inline function 'kotlin.contracts.contract' call
                      createTweenPropertyComponent$default($this, TweenProperty_TextFieldText_getInstance(), tmp0_safe_receiver_6);
                    }
                    var tmp1_safe_receiver_6 = tween.jf6_1;
                    if (tmp1_safe_receiver_6 == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      // Inline function 'kotlin.contracts.contract' call
                      createTweenPropertyComponent($this, TweenProperty_TextFieldTextRangeStart_getInstance(), tmp8_safe_receiver.bf0_1, tmp1_safe_receiver_6 - tmp8_safe_receiver.bf0_1 | 0);
                    }
                    var tmp2_safe_receiver_5 = tween.kf6_1;
                    var tmp_54;
                    if (tmp2_safe_receiver_5 == null) {
                      tmp_54 = null;
                    } else {
                      // Inline function 'kotlin.let' call
                      // Inline function 'kotlin.contracts.contract' call
                      createTweenPropertyComponent($this, TweenProperty_TextFieldTextRangeEnd_getInstance(), tmp8_safe_receiver.cf0_1, tmp2_safe_receiver_5 - tmp8_safe_receiver.cf0_1 | 0);
                      tmp_54 = Unit_instance;
                    }
                  }
                } else {
                  if (tween instanceof TweenTouchInput) {
                    var tmp$ret$85;
                    $l$block_16: {
                      // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.getOrWarning' call
                      var this_16 = tween.nf9_1;
                      var componentType_7 = Companion_getInstance_49();
                      if ($this.k1v(this_16, componentType_7)) {
                        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
                        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
                        var this_17 = $this.i1v_1;
                        if (this_17.u1t_1.j1s(componentType_7.m1t())) {
                          var tmp_55 = componentType_7.m1t();
                          var tmp_56 = this_17.v1t();
                          var tmp_57 = 0;
                          var tmp_58 = this_17.v1t().g1s();
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp_59 = fillArrayVal(Array(tmp_58), null);
                          while (tmp_57 < tmp_58) {
                            tmp_59[tmp_57] = null;
                            tmp_57 = tmp_57 + 1 | 0;
                          }
                          this_17.u1t_1.h1s(tmp_55, new ComponentsHolder(tmp_56, componentType_7, tmp_59));
                        }
                        var tmp_60 = this_17.u1t_1.h1(componentType_7.m1t());
                        tmp$ret$85 = (tmp_60 instanceof ComponentsHolder ? tmp_60 : THROW_CCE()).p1u(this_16);
                        break $l$block_16;
                      } else {
                        println("WARNING - TweenSequenceSystem: Entity '" + this_16.m1u_1 + "' (" + nameOf($this.v1z_1, this_16) + ") does not contain component type '" + toString_0(componentType_7) + "'!\n" + ('Entity snapshot: \n' + $this.v1z_1.q20(this_16).toString()));
                        tmp$ret$85 = null;
                        break $l$block_16;
                      }
                    }
                    if (tmp$ret$85 == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      // Inline function 'kotlin.contracts.contract' call
                      // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.checkTween.<anonymous>' call
                      var tmp0_safe_receiver_7 = tween.mf9_1;
                      var tmp_61;
                      if (tmp0_safe_receiver_7 == null) {
                        tmp_61 = null;
                      } else {
                        // Inline function 'kotlin.let' call
                        // Inline function 'kotlin.contracts.contract' call
                        createTweenPropertyComponent$default($this, TweenProperty_TouchInputEnable_getInstance(), tmp0_safe_receiver_7);
                        tmp_61 = Unit_instance;
                      }
                    }
                  } else {
                    if (tween instanceof SpawnEntity) {
                      var spawnedEntity = tween.tf5_1.equals(Companion_getInstance_4().x1s_1) ? entity($this.v1z_1, 'SpawnEntity: ' + tween.qf5_1) : tween.tf5_1;
                      EntityFactory_getInstance().zfb(tween.qf5_1, $this.v1z_1, spawnedEntity);
                    } else {
                      if (tween instanceof DeleteEntity) {
                        deleteViaLifeCycle($this.v1z_1, tween.jf5_1);
                      } else {
                        if (tween instanceof ExecuteConfigFunction)
                          EntityFactory_getInstance().zfb(tween.af6_1, $this.v1z_1, tween.bf6_1);
                        else {
                          if (tween instanceof Wait) {
                            var tmp10_safe_receiver = tween.tf4_1;
                            if (tmp10_safe_receiver == null)
                              null;
                            else {
                              // Inline function 'kotlin.let' call
                              // Inline function 'kotlin.contracts.contract' call
                              _get_currentTween__xb6s61($this).sf9(baseEntity);
                              createTweenPropertyComponent$default($this, TweenProperty_EventSubscribe_getInstance(), tmp10_safe_receiver);
                            }
                          } else {
                            if (tween instanceof SendEvent) {
                              _get_currentTween__xb6s61($this).sf9(baseEntity);
                              createTweenPropertyComponent$default($this, TweenProperty_EventPublish_getInstance(), tween.cf4_1);
                            } else {
                              if (tween instanceof ResetEvent) {
                                _get_currentTween__xb6s61($this).sf9(baseEntity);
                                createTweenPropertyComponent$default($this, TweenProperty_EventReset_getInstance(), tween.kf4_1);
                              } else {
                                if (tween instanceof SpawnNewTweenSequence) {
                                  println('WARNING - TweenSequenceSystem: "SpawnNewTweenSequence" not allowed in ParallelTweens!');
                                } else {
                                  if (tween instanceof LoopTweens) {
                                    println('WARNING - TweenSequenceSystem: "LoopTweens" not allowed in ParallelTweens!');
                                  } else {
                                    if (tween instanceof Jump) {
                                      println('WARNING - TweenSequenceSystem: "Jump" not allowed in ParallelTweens!');
                                    } else {
                                      println("WARNING - TweenSequenceSystem: Tween function for tween '" + toString_0(tween) + "' not implemented!");
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function createTweenPropertyComponent($this, componentProperty, value, change) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
  var this_0 = _get_currentTween__xb6s61($this).tf9();
  $l$block_0: {
    // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
    var this_1 = $this.i1v_1.v1t().a1u_1;
    var skipFamilyNotify = this_1.s1v_1 === this_0.m1u_1 || this_1.q1v_1 === this_0.m1u_1;
    var prevUpdateId = this_1.s1v_1;
    this_1.s1v_1 = this_0.m1u_1;
    // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.createTweenPropertyComponent.<anonymous>' call
    var $this$configure = this_1.r1v_1;
    // Inline function 'kotlin.also' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.getOrAdd' call
      var type = componentProperty.jf1_1;
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = $this$configure.i1v_1;
      if (this_2.u1t_1.j1s(type.m1t())) {
        var tmp = type.m1t();
        var tmp_0 = this_2.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
      }
      var tmp_4 = this_2.u1t_1.h1(type.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      var existingCmp = holder.v1u(this_0);
      if (!(existingCmp == null)) {
        tmp$ret$3 = existingCmp;
        break $l$block;
      }
      $this$configure.f1v_1.h1(this_0.m1u_1).p1s(type.m1t());
      // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.createTweenPropertyComponent.<anonymous>.<anonymous>' call
      var newCmp = TweenPropertyComponent.wf2(componentProperty);
      holder.l1u(this_0, newCmp);
      tmp$ret$3 = newCmp;
    }
    var this_3 = tmp$ret$3;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.createTweenPropertyComponent.<anonymous>.<anonymous>' call
    this_3.qf2_1 = change;
    this_3.rf2_1 = value;
    var tmp_5 = this_3;
    var tmp0_elvis_lhs = _get_currentTween__xb6s61($this).wf9();
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _get_currentParentTween__20kwyr($this).xf3_1 : tmp0_elvis_lhs;
    tmp_5.sf2_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    this_3.tf2_1 = 0.0;
    var tmp_6 = this_3;
    var tmp2_elvis_lhs = _get_currentTween__xb6s61($this).yf9();
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? _get_currentParentTween__20kwyr($this).yf3_1 : tmp2_elvis_lhs;
    tmp_6.uf2_1 = tmp3_elvis_lhs == null ? Companion_getInstance_3().m27_1 : tmp3_elvis_lhs;
    this_1.s1v_1 = prevUpdateId;
    if (skipFamilyNotify) {
      break $l$block_0;
    }
    var compMask = this_1.o1v_1.h1(this_0.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this_1.l1v_1.b1u_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      element.p1w(this_0, compMask);
    }
  }
}
function createTweenPropertyComponent$default($this, componentProperty, value, change, $super) {
  change = change === VOID ? Unit_instance : change;
  return createTweenPropertyComponent($this, componentProperty, value, change);
}
function TweenSequenceSystem$_init_$lambda_10cvdc($this$family) {
  $this$family.a1z([Companion_getInstance_70()]);
  return Unit_instance;
}
function TweenSequenceSystem$onTickEntity$lambda($currentTween) {
  return function ($this$entity, it) {
    var component = TweenSequenceComponent.tfb($currentTween.cf3_1);
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = $this$entity.i1v_1;
    if (this_0.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    return Unit_instance;
  };
}
function TweenSequenceSystem$onTickEntity$lambda_0($tween, $currentTween) {
  return function ($this$entity, it) {
    // Inline function 'kotlin.also' call
    var this_0 = $tween;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.systems.TweenSequenceSystem.onTickEntity.<anonymous>.<anonymous>.<anonymous>' call
    if (this_0.wf9() == null) {
      var tmp0_elvis_lhs = $currentTween.xf3_1;
      this_0.vf9(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    if (this_0.yf9() == null) {
      var tmp1_elvis_lhs = $currentTween.yf3_1;
      this_0.xf9(tmp1_elvis_lhs == null ? Companion_getInstance_3().m27_1 : tmp1_elvis_lhs);
    }
    var component = TweenSequenceComponent.tfb(listOf([this_0, new DeleteEntity(it)]));
    var compType = component.q1t();
    $this$entity.f1v_1.h1(it.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = $this$entity.i1v_1;
    if (this_1.u1t_1.j1s(compType.m1t())) {
      var tmp = compType.m1t();
      var tmp_0 = this_1.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
    }
    var tmp_4 = this_1.u1t_1.h1(compType.m1t());
    var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
    holder.l1u(it, component);
    return Unit_instance;
  };
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.ng1_1.w1();
}
function CameraFollowTag$_anonymous__l19eab() {
  var tmp = CameraFollowTag_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer.q17('CameraFollow', tmp, tmp$ret$2);
}
var CameraFollowTag_instance;
function CameraFollowTag_getInstance() {
  if (CameraFollowTag_instance === VOID)
    new CameraFollowTag();
  return CameraFollowTag_instance;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.pg1_1.w1();
}
function MainCameraTag$_anonymous__4etdwb() {
  var tmp = MainCameraTag_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer.q17('MainCamera', tmp, tmp$ret$2);
}
var MainCameraTag_instance;
function MainCameraTag_getInstance() {
  if (MainCameraTag_instance === VOID)
    new MainCameraTag();
  return MainCameraTag_instance;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.dfd_1.w1();
}
function RenderLayerTag$Companion$_anonymous__4rpxn4() {
  var tmp = values_3();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [null, null, null, null, null, null, null, null, null, null];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null, null, null, null, null, null, null, null, null];
  return createAnnotatedEnumSerializer('RenderLayer', tmp, tmp_0, tmp$ret$5, null);
}
var RenderLayerTag_BG_LEVELMAP_instance;
var RenderLayerTag_BG_PARALLAX_instance;
var RenderLayerTag_MAIN_LEVELMAP_instance;
var RenderLayerTag_MAIN_SPRITES_instance;
var RenderLayerTag_MAIN_EFFECTS_instance;
var RenderLayerTag_MAIN_FOREGROUND_instance;
var RenderLayerTag_FG_LEVELMAP_instance;
var RenderLayerTag_FG_PARALLAX_instance;
var RenderLayerTag_FG_DIALOGS_instance;
var RenderLayerTag_DEBUG_instance;
function values_3() {
  return [RenderLayerTag_BG_LEVELMAP_getInstance(), RenderLayerTag_BG_PARALLAX_getInstance(), RenderLayerTag_MAIN_LEVELMAP_getInstance(), RenderLayerTag_MAIN_SPRITES_getInstance(), RenderLayerTag_MAIN_EFFECTS_getInstance(), RenderLayerTag_MAIN_FOREGROUND_getInstance(), RenderLayerTag_FG_LEVELMAP_getInstance(), RenderLayerTag_FG_PARALLAX_getInstance(), RenderLayerTag_FG_DIALOGS_getInstance(), RenderLayerTag_DEBUG_getInstance()];
}
var Companion_instance_71;
function Companion_getInstance_79() {
  RenderLayerTag_initEntries();
  if (Companion_instance_71 === VOID)
    new Companion_69();
  return Companion_instance_71;
}
var RenderLayerTag_entriesInitialized;
function RenderLayerTag_initEntries() {
  if (RenderLayerTag_entriesInitialized)
    return Unit_instance;
  RenderLayerTag_entriesInitialized = true;
  RenderLayerTag_BG_LEVELMAP_instance = new RenderLayerTag('BG_LEVELMAP', 0);
  RenderLayerTag_BG_PARALLAX_instance = new RenderLayerTag('BG_PARALLAX', 1);
  RenderLayerTag_MAIN_LEVELMAP_instance = new RenderLayerTag('MAIN_LEVELMAP', 2);
  RenderLayerTag_MAIN_SPRITES_instance = new RenderLayerTag('MAIN_SPRITES', 3);
  RenderLayerTag_MAIN_EFFECTS_instance = new RenderLayerTag('MAIN_EFFECTS', 4);
  RenderLayerTag_MAIN_FOREGROUND_instance = new RenderLayerTag('MAIN_FOREGROUND', 5);
  RenderLayerTag_FG_LEVELMAP_instance = new RenderLayerTag('FG_LEVELMAP', 6);
  RenderLayerTag_FG_PARALLAX_instance = new RenderLayerTag('FG_PARALLAX', 7);
  RenderLayerTag_FG_DIALOGS_instance = new RenderLayerTag('FG_DIALOGS', 8);
  RenderLayerTag_DEBUG_instance = new RenderLayerTag('DEBUG', 9);
  Companion_getInstance_79();
}
function RenderLayerTag_BG_LEVELMAP_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_BG_LEVELMAP_instance;
}
function RenderLayerTag_BG_PARALLAX_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_BG_PARALLAX_instance;
}
function RenderLayerTag_MAIN_LEVELMAP_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_MAIN_LEVELMAP_instance;
}
function RenderLayerTag_MAIN_SPRITES_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_MAIN_SPRITES_instance;
}
function RenderLayerTag_MAIN_EFFECTS_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_MAIN_EFFECTS_instance;
}
function RenderLayerTag_MAIN_FOREGROUND_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_MAIN_FOREGROUND_instance;
}
function RenderLayerTag_FG_LEVELMAP_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_FG_LEVELMAP_instance;
}
function RenderLayerTag_FG_PARALLAX_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_FG_PARALLAX_instance;
}
function RenderLayerTag_FG_DIALOGS_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_FG_DIALOGS_instance;
}
function RenderLayerTag_DEBUG_getInstance() {
  RenderLayerTag_initEntries();
  return RenderLayerTag_DEBUG_instance;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.ug1_1.w1();
}
function ScreenCoordinatesTag$_anonymous__9kp4x8() {
  var tmp = ScreenCoordinatesTag_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer.q17('ScreenCoordinates', tmp, tmp$ret$2);
}
var ScreenCoordinatesTag_instance;
function ScreenCoordinatesTag_getInstance() {
  if (ScreenCoordinatesTag_instance === VOID)
    new ScreenCoordinatesTag();
  return ScreenCoordinatesTag_instance;
}
var AppConfig_instance;
function AppConfig_getInstance() {
  if (AppConfig_instance === VOID)
    new AppConfig();
  return AppConfig_instance;
}
var EntityByName_instance;
function EntityByName_getInstance() {
  if (EntityByName_instance === VOID)
    new EntityByName();
  return EntityByName_instance;
}
function _get_yaml__dgtvgk($this) {
  var tmp = $this.feh_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('yaml');
  }
}
function clone(_this__u8e3s4) {
  return new Entity(_this__u8e3s4.m1u_1, _this__u8e3s4.n1u_1);
}
var RGBAAsInt_instance;
function RGBAAsInt_getInstance() {
  if (RGBAAsInt_instance === VOID)
    new RGBAAsInt();
  return RGBAAsInt_instance;
}
function _get_json__d8whur($this) {
  var tmp = $this.dfu_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('json');
  }
}
function SnapshotSerializer$json$lambda($pretty, $modules) {
  return function ($this$Json) {
    $this$Json.a1i_1 = $pretty;
    $this$Json.n1i_1 = $modules._v;
    $this$Json.l1i_1 = true;
    return Unit_instance;
  };
}
function PolymorphicEnumSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.jv('value', this$0.zg1_1.yu());
    return Unit_instance;
  };
}
var HAlignAsString_instance;
function HAlignAsString_getInstance() {
  if (HAlignAsString_instance === VOID)
    new HAlignAsString();
  return HAlignAsString_instance;
}
var VAlignAsString_instance;
function VAlignAsString_getInstance() {
  if (VAlignAsString_instance === VOID)
    new VAlignAsString();
  return VAlignAsString_instance;
}
var HorizontalAlignAsDouble_instance;
function HorizontalAlignAsDouble_getInstance() {
  if (HorizontalAlignAsDouble_instance === VOID)
    new HorizontalAlignAsDouble();
  return HorizontalAlignAsDouble_instance;
}
var VerticalAlignAsDouble_instance;
function VerticalAlignAsDouble_getInstance() {
  if (VerticalAlignAsDouble_instance === VOID)
    new VerticalAlignAsDouble();
  return VerticalAlignAsDouble_instance;
}
var ParallaxSpeedFactors_instance;
function ParallaxSpeedFactors_getInstance() {
  if (ParallaxSpeedFactors_instance === VOID)
    new ParallaxSpeedFactors();
  return ParallaxSpeedFactors_instance;
}
var Companion_instance_72;
function Companion_getInstance_80() {
  if (Companion_instance_72 === VOID)
    new Companion_70();
  return Companion_instance_72;
}
var $serializer_instance_67;
function $serializer_getInstance_68() {
  if ($serializer_instance_67 === VOID)
    new $serializer_67();
  return $serializer_instance_67;
}
var AnySerializer_instance;
function AnySerializer_getInstance() {
  if (AnySerializer_instance === VOID)
    new AnySerializer();
  return AnySerializer_instance;
}
var EasingAsString_instance;
function EasingAsString_getInstance() {
  if (EasingAsString_instance === VOID)
    new EasingAsString();
  return EasingAsString_instance;
}
function random_0(_this__u8e3s4) {
  return Default_getInstance().xp(_this__u8e3s4.o1(), _this__u8e3s4.p1());
}
function cloneRgba(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function clone_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var mapCopy = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = _this__u8e3s4.u1().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.utils.clone.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.v1();
    // Inline function 'kotlin.collections.component2' call
    var value = element.w1();
    // Inline function 'kotlin.collections.set' call
    var value_0 = clone_4(value);
    mapCopy.k3(key, value_0);
  }
  return mapCopy;
}
function clone_1(_this__u8e3s4) {
  return _HorizontalAlign___init__impl__ad654o(_HorizontalAlign___get_ratio__impl__x9wlea(_this__u8e3s4));
}
function clone_2(_this__u8e3s4) {
  return _VerticalAlign___init__impl__f42kfq(_VerticalAlign___get_ratio__impl__b3ilr8(_this__u8e3s4));
}
function clone_3(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listCopy = ArrayList.z();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.utils.clone.<anonymous>' call
    listCopy.h(clone(element));
  }
  return listCopy;
}
function clone_4(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listCopy = ArrayList.z();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.utils.clone.<anonymous>' call
    listCopy.h(element.z27());
  }
  return listCopy;
}
function clone_5(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var mapCopy = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = _this__u8e3s4.u1().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.utils.clone.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.v1();
    // Inline function 'kotlin.collections.component2' call
    var value = element.w1();
    // Inline function 'kotlin.collections.set' call
    var value_0 = value.z27();
    mapCopy.k3(key, value_0);
  }
  return mapCopy;
}
function clone_6(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listCopy = ArrayList.z();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.korge.fleks.utils.clone.<anonymous>' call
    listCopy.h(element);
  }
  return listCopy;
}
function createAndConfigureEntity(_this__u8e3s4, entityConfig) {
  return EntityFactory_getInstance().yfb(entityConfig, _this__u8e3s4);
}
function entity(_this__u8e3s4, name, configuration) {
  var tmp;
  if (configuration === VOID) {
    tmp = entity$lambda;
  } else {
    tmp = configuration;
  }
  configuration = tmp;
  // Inline function 'kotlin.apply' call
  // Inline function 'com.github.quillraven.fleks.World.entity' call
  // Inline function 'com.github.quillraven.fleks.EntityService.create' call
  var this_0 = _this__u8e3s4.a1u_1;
  // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
  var entity = this_0.m1v_1.a1x();
  if (entity.m1u_1 >= this_0.o1v_1.f1s_1) {
    this_0.o1v_1.h1s(entity.m1u_1, new BitArray(64));
  }
  var prevCreateId = this_0.q1v_1;
  this_0.q1v_1 = entity.m1u_1;
  configuration(this_0.p1v_1, entity);
  this_0.q1v_1 = prevCreateId;
  var compMask = this_0.o1v_1.h1(entity.m1u_1);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this_0.l1v_1.b1u_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
    element.w1y(entity, compMask);
  }
  var tmp0_safe_receiver = this_0.v1v_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver(this_0.l1v_1, entity);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.utils.entity.<anonymous>' call
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
  $l$block: {
    // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
    var this_1 = _this__u8e3s4.i1v_1.v1t().a1u_1;
    var skipFamilyNotify = this_1.s1v_1 === entity.m1u_1 || this_1.q1v_1 === entity.m1u_1;
    var prevUpdateId = this_1.s1v_1;
    this_1.s1v_1 = entity.m1u_1;
    // Inline function 'korlibs.korge.fleks.utils.entity.<anonymous>.<anonymous>' call
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var this_2 = this_1.r1v_1;
    var component = InfoComponent.wen(name);
    var compType = component.q1t();
    this_2.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_3 = this_2.i1v_1;
    if (this_3.u1t_1.j1s(compType.m1t())) {
      var tmp_0 = compType.m1t();
      var tmp_1 = this_3.v1t();
      var tmp_2 = 0;
      var tmp_3 = this_3.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_4 = fillArrayVal(Array(tmp_3), null);
      while (tmp_2 < tmp_3) {
        tmp_4[tmp_2] = null;
        tmp_2 = tmp_2 + 1 | 0;
      }
      this_3.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, compType, tmp_4));
    }
    var tmp_5 = this_3.u1t_1.h1(compType.m1t());
    var holder = tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE();
    holder.l1u(entity, component);
    this_1.s1v_1 = prevUpdateId;
    if (skipFamilyNotify) {
      break $l$block;
    }
    var compMask_0 = this_1.o1v_1.h1(entity.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = this_1.l1v_1.b1u_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      element_0.p1w(entity, compMask_0);
    }
  }
  return entity;
}
function execute(_this__u8e3s4, entityConfig, entity) {
  return configureEntity(_this__u8e3s4, entityConfig, entity);
}
function configureEntity(_this__u8e3s4, entityConfig, entity) {
  return EntityFactory_getInstance().zfb(entityConfig, _this__u8e3s4, entity);
}
function getMainCamera(_this__u8e3s4) {
  var cameraFamily = _this__u8e3s4.p20(getMainCamera$lambda);
  var tmp0_elvis_lhs = cameraFamily.nl();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'No main camera found in world!';
    throw IllegalStateException.h5(toString_0(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function deleteViaLifeCycle(_this__u8e3s4, entity) {
  // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
  $l$block_0: {
    // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
    var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
    var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
    var prevUpdateId = this_0.s1v_1;
    this_0.s1v_1 = entity.m1u_1;
    // Inline function 'korlibs.korge.fleks.utils.deleteViaLifeCycle.<anonymous>' call
    var $this$configure = this_0.r1v_1;
    // Inline function 'kotlin.apply' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityUpdateContext.getOrAdd' call
      var type = Companion_getInstance_27();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(type.m1t())) {
        var tmp = type.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(type.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      var existingCmp = holder.v1u(entity);
      if (!(existingCmp == null)) {
        tmp$ret$3 = existingCmp;
        break $l$block;
      }
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(type.m1t());
      // Inline function 'korlibs.korge.fleks.utils.deleteViaLifeCycle.<anonymous>.<anonymous>' call
      var newCmp = LifeCycleComponent.zeq();
      holder.l1u(entity, newCmp);
      tmp$ret$3 = newCmp;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.fleks.utils.deleteViaLifeCycle.<anonymous>.<anonymous>' call
    tmp$ret$3.xeq_1 = 0;
    this_0.s1v_1 = prevUpdateId;
    if (skipFamilyNotify) {
      break $l$block_0;
    }
    var compMask = this_0.o1v_1.h1(entity.m1u_1);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this_0.l1v_1.b1u_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      element.p1w(entity, compMask);
    }
  }
}
function nameOf(_this__u8e3s4, entity) {
  var tmp;
  if (_this__u8e3s4.k1v(entity, Companion_getInstance_21())) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_21();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = _this__u8e3s4.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp_0 = type.m1t();
      var tmp_1 = this_0.v1t();
      var tmp_2 = 0;
      var tmp_3 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_4 = fillArrayVal(Array(tmp_3), null);
      while (tmp_2 < tmp_3) {
        tmp_4[tmp_2] = null;
        tmp_2 = tmp_2 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp_0, new ComponentsHolder(tmp_1, type, tmp_4));
    }
    var tmp_5 = this_0.u1t_1.h1(type.m1t());
    tmp = (tmp_5 instanceof ComponentsHolder ? tmp_5 : THROW_CCE()).p1u(entity).sen_1;
  } else {
    tmp = 'noName';
  }
  return tmp;
}
function entity$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function getMainCamera$lambda($this$family) {
  $this$family.a1z([MainCameraTag_getInstance(), Companion_getInstance_36()]);
  return Unit_instance;
}
//region block: post-declaration
initMetadataForClass(AssetLevelData, 'AssetLevelData', AssetLevelData);
initMetadataForCompanion(Companion);
protoOf($serializer).e17 = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_0);
protoOf($serializer_0).e17 = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ImageDataConfig, 'ImageDataConfig', ImageDataConfig, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(TileMapConfig, 'TileMapConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_1);
protoOf($serializer_1).e17 = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AssetModel, 'AssetModel', AssetModel, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_2);
initMetadataForLambda(ResourceDirWatcherConfiguration$enableAssetWatcher$slambda, VOID, VOID, [1]);
initMetadataForLambda(ResourceDirWatcherConfiguration$checkAssetFolders$slambda, VOID, VOID, [0]);
initMetadataForLambda(ResourceDirWatcherConfiguration$checkAssetFolders$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(ResourceDirWatcherConfiguration$checkAssetFolders$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(ResourceDirWatcherConfiguration$checkAssetFolders$slambda_2, VOID, VOID, [0]);
initMetadataForClass(ResourceDirWatcherConfiguration, 'ResourceDirWatcherConfiguration', ResourceDirWatcherConfiguration, VOID, VOID, [1, 3, 5]);
initMetadataForClass(AssetUpdaterConfiguration, 'AssetUpdaterConfiguration');
initMetadataForClass(AssetStore, 'AssetStore', AssetStore, VOID, VOID, [2]);
initMetadataForClass(AssetType, 'AssetType');
initMetadataForClass(ParallaxDataContainer, 'ParallaxDataContainer');
initMetadataForClass(Mode, 'Mode');
initMetadataForCompanion(Companion_3);
protoOf($serializer_2).e17 = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxConfig, 'ParallaxConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_4);
protoOf($serializer_3).e17 = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxLayerConfig, 'ParallaxLayerConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_5);
protoOf($serializer_4).e17 = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxPlaneConfig, 'ParallaxPlaneConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_6);
protoOf($serializer_5).e17 = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxAttachedLayerConfig, 'ParallaxAttachedLayerConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForClass(LevelMap, 'LevelMap', LevelMap);
initMetadataForClass(LevelData, 'LevelData', LevelData);
initMetadataForClass(WorldData, 'WorldData', WorldData);
initMetadataForCompanion(Companion_7);
protoOf($serializer_6).e17 = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
protoOf(CloneableComponent).r1t = onAdd;
protoOf(CloneableComponent).s1t = onRemove;
initMetadataForClass(CloneableComponent, 'CloneableComponent', VOID, VOID, [Component]);
initMetadataForClass(DebugComponent, 'DebugComponent', DebugComponent.tem, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_8);
protoOf($serializer_7).e17 = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SubEntitiesComponent, 'SubEntitiesComponent', SubEntitiesComponent.fen, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_9);
protoOf($serializer_8).e17 = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EntityLinkComponent, 'EntityLinkComponent', EntityLinkComponent.nen, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_10);
initMetadataForCompanion(Companion_11);
protoOf($serializer_9).e17 = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(InfoComponent, 'InfoComponent', InfoComponent.wen, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_12);
protoOf($serializer_10).e17 = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayerComponent, 'LayerComponent', LayerComponent.geo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_13);
protoOf($serializer_11).e17 = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(CloneableData, 'CloneableData');
initMetadataForClass(Layer, 'Layer', VOID, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_14);
protoOf($serializer_12).e17 = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayeredSpriteComponent, 'LayeredSpriteComponent', LayeredSpriteComponent.tep, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_15);
protoOf($serializer_13).e17 = typeParametersSerializers;
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayoutComponent, 'LayoutComponent', LayoutComponent.keq, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_16);
protoOf($serializer_14).e17 = typeParametersSerializers;
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LevelMapComponent, 'LevelMapComponent', LevelMapComponent.ueq, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_17);
protoOf($serializer_15).e17 = typeParametersSerializers;
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LifeCycleComponent, 'LifeCycleComponent', LifeCycleComponent.zeq, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForCompanion(Companion_18);
protoOf($serializer_16).e17 = typeParametersSerializers;
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MotionComponent, 'MotionComponent', MotionComponent.ier, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_19);
protoOf($serializer_17).e17 = typeParametersSerializers;
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(NinePatchComponent, 'NinePatchComponent', NinePatchComponent.rer, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForCompanion(Companion_20);
protoOf($serializer_18).e17 = typeParametersSerializers;
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(NoisyMoveComponent, 'NoisyMoveComponent', NoisyMoveComponent.les, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForCompanion(Companion_21);
protoOf($serializer_19).e17 = typeParametersSerializers;
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Point, 'Point', Point, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForCompanion(Companion_22);
protoOf($serializer_20).e17 = typeParametersSerializers;
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(OffsetByFrameIndexComponent, 'OffsetByFrameIndexComponent', OffsetByFrameIndexComponent.cet, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
initMetadataForCompanion(Companion_23);
protoOf($serializer_21).e17 = typeParametersSerializers;
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_24);
protoOf($serializer_22).e17 = typeParametersSerializers;
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Layer_0, 'Layer', Layer_0, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_22});
initMetadataForClass(Plane, 'Plane', Plane, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_23});
initMetadataForCompanion(Companion_25);
protoOf($serializer_23).e17 = typeParametersSerializers;
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxComponent, 'ParallaxComponent', ParallaxComponent.eeu, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
initMetadataForCompanion(Companion_26);
protoOf($serializer_24).e17 = typeParametersSerializers;
initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PositionComponent, 'PositionComponent', PositionComponent.teo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
initMetadataForCompanion(Companion_27);
protoOf($serializer_25).e17 = typeParametersSerializers;
initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Rgb, 'Rgb', Rgb, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_26});
initMetadataForCompanion(Companion_28);
protoOf($serializer_26).e17 = typeParametersSerializers;
initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RgbaComponent, 'RgbaComponent', RgbaComponent.xeo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
initMetadataForCompanion(Companion_29);
protoOf($serializer_27).e17 = typeParametersSerializers;
initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RigidbodyComponent, 'RigidbodyComponent', RigidbodyComponent.sew, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
initMetadataForCompanion(Companion_30);
protoOf($serializer_28).e17 = typeParametersSerializers;
initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SizeComponent, 'SizeComponent', SizeComponent.aex, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
initMetadataForCompanion(Companion_31);
protoOf($serializer_29).e17 = typeParametersSerializers;
initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SoundComponent, 'SoundComponent', SoundComponent.mex, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
initMetadataForCompanion(Companion_32);
protoOf($serializer_30).e17 = typeParametersSerializers;
initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SpawnerComponent, 'SpawnerComponent', SpawnerComponent.bey, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
initMetadataForCompanion(Companion_33);
protoOf($serializer_31).e17 = typeParametersSerializers;
initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SpriteComponent, 'SpriteComponent', SpriteComponent.uey, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
initMetadataForCompanion(Companion_34);
protoOf($serializer_32).e17 = typeParametersSerializers;
initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LayerProperties, 'LayerProperties', LayerProperties, VOID, [CloneableData], VOID, VOID, {0: $serializer_getInstance_33});
initMetadataForCompanion(Companion_35);
protoOf($serializer_33).e17 = typeParametersSerializers;
initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SpriteLayersComponent, 'SpriteLayersComponent', SpriteLayersComponent.oez, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
initMetadataForCompanion(Companion_36);
protoOf($serializer_34).e17 = typeParametersSerializers;
initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SwitchLayerVisibilityComponent, 'SwitchLayerVisibilityComponent', SwitchLayerVisibilityComponent.vez, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
initMetadataForCompanion(Companion_37);
protoOf($serializer_35).e17 = typeParametersSerializers;
initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TextFieldComponent, 'TextFieldComponent', TextFieldComponent.jf0, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
initMetadataForCompanion(Companion_38);
protoOf($serializer_36).e17 = typeParametersSerializers;
initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TiledLevelMapComponent, 'TiledLevelMapComponent', TiledLevelMapComponent.uf0, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
initMetadataForCompanion(Companion_39);
protoOf($serializer_37).e17 = typeParametersSerializers;
initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TouchInputComponent, 'TouchInputComponent', TouchInputComponent.ef1, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
initMetadataForClass(_no_name_provided__qut3iv);
initMetadataForClass(_no_name_provided__qut3iv_0);
initMetadataForClass(_no_name_provided__qut3iv_1);
initMetadataForClass(_no_name_provided__qut3iv_2);
initMetadataForClass(_no_name_provided__qut3iv_3);
initMetadataForClass(_no_name_provided__qut3iv_4);
initMetadataForClass(_no_name_provided__qut3iv_5);
initMetadataForClass(_no_name_provided__qut3iv_6);
initMetadataForClass(_no_name_provided__qut3iv_7);
initMetadataForClass(_no_name_provided__qut3iv_8);
initMetadataForClass(_no_name_provided__qut3iv_9);
initMetadataForClass(_no_name_provided__qut3iv_10);
initMetadataForClass(_no_name_provided__qut3iv_11);
initMetadataForClass(_no_name_provided__qut3iv_12);
initMetadataForClass(_no_name_provided__qut3iv_13);
initMetadataForClass(_no_name_provided__qut3iv_14);
initMetadataForClass(_no_name_provided__qut3iv_15);
initMetadataForClass(_no_name_provided__qut3iv_16);
initMetadataForClass(_no_name_provided__qut3iv_17);
initMetadataForClass(_no_name_provided__qut3iv_18);
initMetadataForClass(_no_name_provided__qut3iv_19);
initMetadataForClass(_no_name_provided__qut3iv_20);
initMetadataForClass(_no_name_provided__qut3iv_21);
initMetadataForClass(_no_name_provided__qut3iv_22);
initMetadataForClass(_no_name_provided__qut3iv_23);
initMetadataForClass(_no_name_provided__qut3iv_24);
initMetadataForClass(_no_name_provided__qut3iv_25);
initMetadataForClass(_no_name_provided__qut3iv_26);
initMetadataForClass(TweenProperty, 'TweenProperty');
initMetadataForCompanion(Companion_40);
protoOf($serializer_38).e17 = typeParametersSerializers;
initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TweenPropertyComponent, 'TweenPropertyComponent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
initMetadataForCompanion(Companion_41);
protoOf($serializer_39).e17 = typeParametersSerializers;
initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_42);
protoOf($serializer_40).e17 = typeParametersSerializers;
initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_43);
protoOf($serializer_41).e17 = typeParametersSerializers;
initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_44);
protoOf($serializer_42).e17 = typeParametersSerializers;
initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_45);
protoOf($serializer_43).e17 = typeParametersSerializers;
initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_46);
protoOf($serializer_44).e17 = typeParametersSerializers;
initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_47);
protoOf($serializer_45).e17 = typeParametersSerializers;
initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_48);
protoOf($serializer_46).e17 = typeParametersSerializers;
initMetadataForObject($serializer_46, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_49);
protoOf($serializer_47).e17 = typeParametersSerializers;
initMetadataForObject($serializer_47, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_50);
protoOf($serializer_48).e17 = typeParametersSerializers;
initMetadataForObject($serializer_48, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_51);
protoOf($serializer_49).e17 = typeParametersSerializers;
initMetadataForObject($serializer_49, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_52);
protoOf($serializer_50).e17 = typeParametersSerializers;
initMetadataForObject($serializer_50, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_53);
protoOf($serializer_51).e17 = typeParametersSerializers;
initMetadataForObject($serializer_51, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_54);
protoOf($serializer_52).e17 = typeParametersSerializers;
initMetadataForObject($serializer_52, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_55);
protoOf($serializer_53).e17 = typeParametersSerializers;
initMetadataForObject($serializer_53, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_56);
protoOf($serializer_54).e17 = typeParametersSerializers;
initMetadataForObject($serializer_54, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_57);
protoOf($serializer_55).e17 = typeParametersSerializers;
initMetadataForObject($serializer_55, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_58);
protoOf($serializer_56).e17 = typeParametersSerializers;
initMetadataForObject($serializer_56, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_59);
protoOf($serializer_57).e17 = typeParametersSerializers;
initMetadataForObject($serializer_57, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(TweenBase, 'TweenBase');
initMetadataForClass(SpawnNewTweenSequence, 'SpawnNewTweenSequence', SpawnNewTweenSequence, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_40});
initMetadataForClass(LoopTweens, 'LoopTweens', LoopTweens, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_41});
initMetadataForClass(ParallelTweens, 'ParallelTweens', ParallelTweens, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_42});
initMetadataForClass(SendEvent, 'SendEvent', SendEvent, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_43});
initMetadataForClass(ResetEvent, 'ResetEvent', ResetEvent, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_44});
initMetadataForClass(Wait, 'Wait', Wait, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_45});
initMetadataForClass(Jump, 'Jump', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_46});
initMetadataForClass(DeleteEntity, 'DeleteEntity', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_47});
initMetadataForClass(SpawnEntity, 'SpawnEntity', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_48});
initMetadataForClass(ExecuteConfigFunction, 'ExecuteConfigFunction', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_49});
initMetadataForClass(TweenTextField, 'TweenTextField', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_50});
initMetadataForClass(TweenRgba, 'TweenRgba', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_51});
initMetadataForClass(TweenPosition, 'TweenPosition', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_52});
initMetadataForClass(TweenMotion, 'TweenMotion', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_53});
initMetadataForClass(TweenSprite, 'TweenSprite', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_54});
initMetadataForClass(TweenSwitchLayerVisibility, 'TweenSwitchLayerVisibility', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_55});
initMetadataForClass(TweenSpawner, 'TweenSpawner', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_56});
initMetadataForClass(TweenSound, 'TweenSound', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_57});
initMetadataForClass(TweenTouchInput, 'TweenTouchInput', VOID, VOID, [TweenBase], VOID, VOID, {0: $serializer_getInstance_58});
initMetadataForCompanion(Companion_60);
protoOf($serializer_58).e17 = typeParametersSerializers;
initMetadataForObject($serializer_58, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TweenSequenceComponent, 'TweenSequenceComponent', TweenSequenceComponent.tfb, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_59});
initMetadataForObject(EntityFactory, 'EntityFactory');
initMetadataForCompanion(Companion_61);
protoOf($serializer_59).e17 = typeParametersSerializers;
initMetadataForObject($serializer_59, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(EntityConfig, 'EntityConfig');
initMetadataForClass(MainCameraConfig, 'MainCameraConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_60});
initMetadataForClass(AvatarPosition, 'AvatarPosition');
initMetadataForCompanion(Companion_62);
protoOf($serializer_60).e17 = typeParametersSerializers;
initMetadataForObject($serializer_60, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(DialogBoxConfig, 'DialogBoxConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_61});
initMetadataForCompanion(Companion_63);
protoOf($serializer_61).e17 = typeParametersSerializers;
initMetadataForObject($serializer_61, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LevelMapConfig, 'LevelMapConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_62});
initMetadataForCompanion(Companion_64);
protoOf($serializer_62).e17 = typeParametersSerializers;
initMetadataForObject($serializer_62, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LogoEntityConfig, 'LogoEntityConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_63});
initMetadataForCompanion(Companion_65);
protoOf($serializer_63).e17 = typeParametersSerializers;
initMetadataForObject($serializer_63, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovedSpawnerObjectConfig, 'MovedSpawnerObjectConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_64});
initMetadataForCompanion(Companion_66);
protoOf($serializer_64).e17 = typeParametersSerializers;
initMetadataForObject($serializer_64, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ParallaxEffectConfig, 'ParallaxEffectConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_65});
initMetadataForCompanion(Companion_67);
protoOf($serializer_65).e17 = typeParametersSerializers;
initMetadataForObject($serializer_65, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RichTextConfig, 'RichTextConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_66});
initMetadataForCompanion(Companion_68);
protoOf($serializer_66).e17 = typeParametersSerializers;
initMetadataForObject($serializer_66, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameStateConfig, 'GameStateConfig', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_67});
initMetadataForObject(GameStateManager, 'GameStateManager', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(DebugRenderSystem, 'DebugRenderSystem');
initMetadataForClass(FastSpriteRenderSystem, 'FastSpriteRenderSystem');
initMetadataForClass(LevelMapRenderSystem, 'LevelMapRenderSystem');
initMetadataForClass(ObjectRenderSystem, 'ObjectRenderSystem');
initMetadataForClass(ParallaxRenderSystem, 'ParallaxRenderSystem');
initMetadataForClass(CameraSystem, 'CameraSystem');
initMetadataForClass(EntityLinkSystem, 'EntityLinkSystem', EntityLinkSystem.rfr);
initMetadataForClass(EventSystem, 'EventSystem', EventSystem.cfs);
initMetadataForClass(LifeCycleSystem, 'LifeCycleSystem', LifeCycleSystem.qfs);
initMetadataForClass(ParallaxSystem, 'ParallaxSystem');
initMetadataForClass(PositionSystem, 'PositionSystem', PositionSystem.mft);
initMetadataForLambda(SnapshotSerializerSystem$loadGameState$slambda, VOID, VOID, [0]);
initMetadataForLambda(SnapshotSerializerSystem$saveGameState$slambda, VOID, VOID, [0]);
initMetadataForClass(SnapshotSerializerSystem, 'SnapshotSerializerSystem');
initMetadataForClass(SoundSystem, 'SoundSystem', SoundSystem.bfv);
initMetadataForClass(SpawnerSystem, 'SpawnerSystem', SpawnerSystem.lfv);
initMetadataForClass(SpriteLayersSystem, 'SpriteLayersSystem', SpriteLayersSystem.vfv);
initMetadataForClass(SpriteSystem, 'SpriteSystem', SpriteSystem.gfw);
initMetadataForClass(TouchInputSystem, 'TouchInputSystem', TouchInputSystem.xfw);
initMetadataForClass(TweenRgbaSystem, 'TweenRgbaSystem', TweenRgbaSystem.xfx);
initMetadataForClass(TweenPositionSystem, 'TweenPositionSystem', TweenPositionSystem.hfy);
initMetadataForClass(TweenMotionSystem, 'TweenMotionSystem', TweenMotionSystem.rfy);
initMetadataForClass(TweenSpawnerSystem, 'TweenSpawnerSystem', TweenSpawnerSystem.bfz);
initMetadataForClass(TweenSpriteSystem, 'TweenSpriteSystem', TweenSpriteSystem.mfz);
initMetadataForClass(TweenSwitchLayerVisibilitySystem, 'TweenSwitchLayerVisibilitySystem', TweenSwitchLayerVisibilitySystem.wfz);
initMetadataForClass(TweenSoundSystem, 'TweenSoundSystem', TweenSoundSystem.gg0);
initMetadataForClass(TweenTextFieldSystem, 'TweenTextFieldSystem', TweenTextFieldSystem.qg0);
initMetadataForClass(TweenEventSystem, 'TweenEventSystem', TweenEventSystem.bg1);
initMetadataForClass(TweenTouchInputSystem, 'TweenTouchInputSystem', TweenTouchInputSystem.lg1);
initMetadataForClass(TweenSequenceSystem, 'TweenSequenceSystem', TweenSequenceSystem.nfx);
initMetadataForObject(CameraFollowTag, 'CameraFollowTag', VOID, VOID, [ComponentType, SerializerFactory], VOID, VOID, {0: CameraFollowTag_getInstance});
initMetadataForObject(MainCameraTag, 'MainCameraTag', VOID, VOID, [ComponentType, SerializerFactory], VOID, VOID, {0: MainCameraTag_getInstance});
initMetadataForCompanion(Companion_69, VOID, [SerializerFactory]);
initMetadataForClass(RenderLayerTag, 'RenderLayerTag', VOID, VOID, [UniqueId, Enum], VOID, VOID, {0: Companion_getInstance_79});
initMetadataForObject(ScreenCoordinatesTag, 'ScreenCoordinatesTag', VOID, VOID, [ComponentType, SerializerFactory], VOID, VOID, {0: ScreenCoordinatesTag_getInstance});
initMetadataForObject(AppConfig, 'AppConfig');
initMetadataForObject(EntityByName, 'EntityByName');
initMetadataForClass(EntityConfigSerializer, 'EntityConfigSerializer', EntityConfigSerializer);
initMetadataForObject(RGBAAsInt, 'RGBAAsInt', VOID, VOID, [KSerializer]);
initMetadataForClass(SnapshotSerializer, 'SnapshotSerializer', SnapshotSerializer);
initMetadataForClass(PolymorphicEnumSerializer, 'PolymorphicEnumSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(HAlignAsString, 'HAlignAsString', VOID, VOID, [KSerializer]);
initMetadataForObject(VAlignAsString, 'VAlignAsString', VOID, VOID, [KSerializer]);
initMetadataForObject(HorizontalAlignAsDouble, 'HorizontalAlignAsDouble', VOID, VOID, [KSerializer]);
initMetadataForObject(VerticalAlignAsDouble, 'VerticalAlignAsDouble', VOID, VOID, [KSerializer]);
initMetadataForObject(ParallaxSpeedFactors, 'ParallaxSpeedFactors', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_70);
protoOf($serializer_67).e17 = typeParametersSerializers;
initMetadataForObject($serializer_67, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ContainerForAny, 'ContainerForAny', ContainerForAny, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_68});
initMetadataForObject(AnySerializer, 'AnySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(EasingAsString, 'EasingAsString', VOID, VOID, [KSerializer]);
//endregion
//region block: init
Companion_instance_1 = new Companion();
Companion_instance_2 = new Companion_0();
Companion_instance_4 = new Companion_2();
Companion_instance_6 = new Companion_4();
Companion_instance_8 = new Companion_6();
Companion_instance_15 = new Companion_13();
Companion_instance_23 = new Companion_21();
Companion_instance_25 = new Companion_23();
Companion_instance_36 = new Companion_34();
Companion_instance_46 = new Companion_44();
Companion_instance_47 = new Companion_45();
Companion_instance_48 = new Companion_46();
Companion_instance_49 = new Companion_47();
Companion_instance_50 = new Companion_48();
Companion_instance_51 = new Companion_49();
Companion_instance_52 = new Companion_50();
Companion_instance_53 = new Companion_51();
Companion_instance_54 = new Companion_52();
Companion_instance_55 = new Companion_53();
Companion_instance_56 = new Companion_54();
Companion_instance_58 = new Companion_56();
Companion_instance_59 = new Companion_57();
Companion_instance_60 = new Companion_58();
Companion_instance_61 = new Companion_59();
Companion_instance_63 = new Companion_61();
Companion_instance_67 = new Companion_65();
Companion_instance_70 = new Companion_68();
//endregion
//region block: exports
export {
  RenderLayerTag_BG_LEVELMAP_getInstance as RenderLayerTag_BG_LEVELMAP_getInstance195ziw5gjkqu0,
  RenderLayerTag_BG_PARALLAX_getInstance as RenderLayerTag_BG_PARALLAX_getInstance8ulikrnambqi,
  RenderLayerTag_DEBUG_getInstance as RenderLayerTag_DEBUG_getInstanceifd6twswramv,
  RenderLayerTag_FG_DIALOGS_getInstance as RenderLayerTag_FG_DIALOGS_getInstance3ort1eibhniyl,
  RenderLayerTag_FG_LEVELMAP_getInstance as RenderLayerTag_FG_LEVELMAP_getInstance2rsr38glvclvm,
  RenderLayerTag_FG_PARALLAX_getInstance as RenderLayerTag_FG_PARALLAX_getInstancelt42tzynu7ll,
  RenderLayerTag_MAIN_EFFECTS_getInstance as RenderLayerTag_MAIN_EFFECTS_getInstance1f27yxfigi0h6,
  RenderLayerTag_MAIN_FOREGROUND_getInstance as RenderLayerTag_MAIN_FOREGROUND_getInstance3o9xszxyu9hbm,
  RenderLayerTag_MAIN_LEVELMAP_getInstance as RenderLayerTag_MAIN_LEVELMAP_getInstance3glsvtee6zxl8,
  RenderLayerTag_MAIN_SPRITES_getInstance as RenderLayerTag_MAIN_SPRITES_getInstance1lj095pfo57zh,
  Companion_getInstance_28 as Companion_getInstance1aim057llt5i9,
  Companion_getInstance_36 as Companion_getInstance8hth28t0k7pa,
  EntityFactory_getInstance as EntityFactory_getInstancep4a2f1ep043g,
  GameStateManager_getInstance as GameStateManager_getInstance1fpt9jruxa4c2,
  ScreenCoordinatesTag_getInstance as ScreenCoordinatesTag_getInstance1lh3lt6foghi4,
  AppConfig_getInstance as AppConfig_getInstance1f4nxms5l1ldq,
  MotionComponent as MotionComponent3lz37123ywot7,
  PositionComponent as PositionComponentscvaqlhnjb16,
  RgbaComponent as RgbaComponent41z7yfk527ta,
  SpawnerComponent as SpawnerComponentd0wzbt1zedb2,
  SpriteComponent as SpriteComponent2140p6pfvjw8n,
  MainCameraConfig as MainCameraConfigg07380lg3ml5,
  DebugRenderSystem as DebugRenderSystem1qi9g8v19vpbn,
  FastSpriteRenderSystem as FastSpriteRenderSystem1k9sase7ue9hi,
  LevelMapRenderSystem as LevelMapRenderSystem3bjvd6084qpb9,
  ObjectRenderSystem as ObjectRenderSystemrd9rm545jqct,
  ParallaxRenderSystem as ParallaxRenderSystem1rwzodtr9we9f,
  CameraSystem as CameraSystemweu4j27n4fgl,
  EntityLinkSystem as EntityLinkSystem193xnv7pgyuoh,
  EventSystem as EventSystem2tgxno94diwbi,
  LifeCycleSystem as LifeCycleSystem35by66p9u1fxf,
  ParallaxSystem as ParallaxSystemd4t1w9mv91sj,
  PositionSystem as PositionSystem29e3c8tkzjlgc,
  SnapshotSerializerSystem as SnapshotSerializerSystem1ir98idbxkus2,
  SoundSystem as SoundSystem3ludlxmbypqlt,
  SpawnerSystem as SpawnerSystem3ioo3mvn45zad,
  SpriteLayersSystem as SpriteLayersSystem3dtz0gln12159,
  SpriteSystem as SpriteSystemypw20c7q75b8,
  TouchInputSystem as TouchInputSystemms13khz9uiv8,
  setupTweenEngineSystems as setupTweenEngineSystemsc1anv2j1mxaa,
  CloneableData as CloneableData2v7u5lweslfj0,
  EntityConfig as EntityConfig1odzalh8twrio,
  createAndConfigureEntity as createAndConfigureEntity2ecw769f7mzc1,
};
//endregion
